(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0148"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0148"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("asv94", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $711901935a81715b$export$2e2bcd8739ae039; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
var $eq3vT = parcelRequire("eq3vT");

var $c9klK = parcelRequire("c9klK");

var $ja4LQ = parcelRequire("ja4LQ");

var $lkkMv = parcelRequire("lkkMv");

var $bM33f = parcelRequire("bM33f");

var $7iwy4 = parcelRequire("7iwy4");

var $iuFuN = parcelRequire("iuFuN");

var $lFFGq = parcelRequire("lFFGq");
var $711901935a81715b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cUHxd.defineComponent)({
    __name: "page",
    async setup (__props, { expose: __expose }) {
        __expose();
        let __temp, __restore;
        function loadSelectorFromUrl(urlParams) {
            const start = urlParams["start"] ?? "";
            const end = urlParams["end"] ?? "";
            const kind = urlParams["kind"] ?? "raw";
            const stat = urlParams["stat"] ?? "min-wall-time";
            const benchmark = urlParams["benchmark"] ?? null;
            return {
                start: start,
                end: end,
                kind: kind,
                stat: stat,
                benchmark: benchmark
            };
        }
        function filterBenchmarks(data, filter) {
            const benchmarks = Object.fromEntries(Object.entries(data.benchmarks).filter(([key, _])=>filter(key)));
            return {
                ...data,
                benchmarks: benchmarks
            };
        }
        /*
 * Returns true if a specific subset of charts is selected by benchmark
 * name, profile or scenario. In that case, the regular aligned grid of charts
 * will not be shown.
 */ function hasSpecificSelection(selector) {
            return selector.benchmark !== null;
        }
        async function loadGraphData(selector, loading) {
            const graphData = await (0, $c9klK.withLoading)(loading, async ()=>await (0, $lFFGq.loadGraphs)(selector));
            // Wait for the UI to be updated, which also resets the plot HTML elements.
            // Then draw the plots.
            await (0, $cUHxd.nextTick)();
            const countGraphs = Object.keys(graphData.benchmarks).map((benchmark)=>Object.keys(graphData.benchmarks[benchmark]).length).reduce((sum, item)=>sum + item, 0);
            const parentWidth = wrapperRef.value.clientWidth;
            let columns = countGraphs === 1 ? 1 : 4;
            // Small display, reduce column count to 1
            if (parentWidth < 1000) columns = 1;
            // Calculate the width of each column.
            // Provide a 10px buffer to avoid wrapping if the size is just at the limit
            // of the parent.
            const width = Math.floor(wrapperRef.value.clientWidth / columns) - 10;
            const top = wrapperRef.value.getBoundingClientRect().top;
            const height = countGraphs === 1 ? window.innerHeight - top - 100 : 300;
            const opts = {
                width: width,
                height: height
            };
            // If we select a smaller subset of benchmarks, then just show them.
            if (hasSpecificSelection(selector)) (0, $bM33f.renderPlots)(graphData, selector, document.getElementById("charts"), opts);
            else {
                // If we select all of them, we expect that there will be a regular grid.
                // So, first render everything but the less important benchmarks about artifact sizes.
                // This keeps the grouping and alignment of 4 charts per row where all 4 charts are about a
                // given benchmark. So, we exclude the benchmarks ending in "-tiny".
                const inferenceOnly = filterBenchmarks(graphData, (benchName)=>benchName.startsWith("inference."));
                (0, $bM33f.renderPlots)(inferenceOnly, selector, document.getElementById("charts"), opts);
            // Then, render only the size-related ones in their own dedicated section as they are less
            // important than having the better grouping. So, we only include the benchmarks ending in
            // "-tiny" and render them in the appropriate section.
            // const onlyTiny = filterBenchmarks(graphData, (benchName) =>
            //   benchName.endsWith("-tiny")
            // );
            // renderPlots(
            //   onlyTiny,
            //   selector,
            //   document.getElementById("size-charts"),
            //   opts
            // );
            }
        }
        function updateSelection(params) {
            (0, $lkkMv.navigateToUrlParams)((0, $lkkMv.createUrlWithAppendedParams)({
                start: params.start,
                end: params.end,
                kind: params.kind,
                stat: params.stat
            }).searchParams);
        }
        const info = ([__temp, __restore] = (0, $cUHxd.withAsyncContext)(()=>(0, $7iwy4.loadBenchmarkInfo)()), __temp = await __temp, __restore(), __temp);
        const loading = (0, $eq3vT.ref)(true);
        const wrapperRef = (0, $eq3vT.ref)(null);
        const selector = loadSelectorFromUrl((0, $lkkMv.getUrlParams)());
        loadGraphData(selector, loading);
        const __returned__ = {
            loadSelectorFromUrl: loadSelectorFromUrl,
            filterBenchmarks: filterBenchmarks,
            hasSpecificSelection: hasSpecificSelection,
            loadGraphData: loadGraphData,
            updateSelection: updateSelection,
            info: info,
            loading: loading,
            wrapperRef: wrapperRef,
            selector: selector,
            DataSelector: $ja4LQ.default,
            AsOf: $iuFuN.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("VxqKT", function(module, exports) {
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("3gdWT")).createApp; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("3gdWT")).withModifiers; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("3gdWT")).vShow; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("3gdWT")).vModelText; });
$parcel$export(module.exports, "vModelCheckbox", function () { return (parcelRequire("3gdWT")).vModelCheckbox; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("eq3vT")).ref; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("cUHxd")).openBlock; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("cUHxd")).createBlock; });
$parcel$export(module.exports, "Suspense", function () { return (parcelRequire("cUHxd")).Suspense; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("cUHxd")).withCtx; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("cUHxd")).resolveDynamicComponent; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("cUHxd")).defineComponent; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("cUHxd")).pushScopeId; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("cUHxd")).popScopeId; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("cUHxd")).createElementVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("cUHxd")).createTextVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("cUHxd")).createElementBlock; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("cUHxd")).Fragment; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("cUHxd")).createVNode; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("cUHxd")).createCommentVNode; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("cUHxd")).computed; });
$parcel$export(module.exports, "withAsyncContext", function () { return (parcelRequire("cUHxd")).withAsyncContext; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("cUHxd")).renderList; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("jZXzE")).normalizeClass; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("cUHxd")).h; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("cUHxd")).onMounted; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("cUHxd")).nextTick; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("cUHxd")).renderSlot; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("cUHxd")).withDirectives; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("cUHxd")).watch; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("eq3vT")).toRaw; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("cUHxd")).onBeforeUnmount; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("cUHxd")).watchEffect; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("cUHxd")).initCustomFormatter; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("jZXzE")).toDisplayString; });
/**
* vue v3.4.30
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("3gdWT");
var $cUHxd = parcelRequire("cUHxd");parcelRequire("jZXzE");
function $0acf4198323634e8$var$initDev() {
    (0, $cUHxd.initCustomFormatter)();
}
const $0acf4198323634e8$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("3gdWT", function(module, exports) {
$parcel$export(module.exports, "ref", function () { return (parcelRequire("eq3vT")).ref; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("cUHxd")).openBlock; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("cUHxd")).createBlock; });
$parcel$export(module.exports, "Suspense", function () { return (parcelRequire("cUHxd")).Suspense; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("cUHxd")).withCtx; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("cUHxd")).resolveDynamicComponent; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("cUHxd")).defineComponent; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("cUHxd")).pushScopeId; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("cUHxd")).popScopeId; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("cUHxd")).createElementVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("cUHxd")).createTextVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("cUHxd")).createElementBlock; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("cUHxd")).Fragment; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("cUHxd")).createVNode; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("cUHxd")).createCommentVNode; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("cUHxd")).computed; });
$parcel$export(module.exports, "withAsyncContext", function () { return (parcelRequire("cUHxd")).withAsyncContext; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("cUHxd")).renderList; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("jZXzE")).normalizeClass; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("cUHxd")).h; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("cUHxd")).onMounted; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("cUHxd")).nextTick; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("cUHxd")).renderSlot; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("cUHxd")).withDirectives; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("cUHxd")).watch; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("eq3vT")).toRaw; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("cUHxd")).onBeforeUnmount; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("cUHxd")).watchEffect; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("cUHxd")).initCustomFormatter; });
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("cUHxd")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("cUHxd")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("cUHxd")).getCurrentInstance; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("cUHxd")).watchPostEffect; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("cUHxd")).onUnmounted; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("cUHxd")).Static; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("jZXzE")).camelize; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("cUHxd")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("cUHxd")).warn; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("cUHxd")).useTransitionState; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("cUHxd")).onUpdated; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("cUHxd")).setTransitionHooks; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("cUHxd")).resolveTransitionHooks; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("cUHxd")).getTransitionRawChildren; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("cUHxd")).createRenderer; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("cUHxd")).createHydrationRenderer; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("cUHxd")).isRuntimeOnly; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("jZXzE")).toDisplayString; });

$parcel$export(module.exports, "vShow", function () { return $25fdafaea7d62e94$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "vModelText", function () { return $25fdafaea7d62e94$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $25fdafaea7d62e94$export$8847c2e532b35714; });
$parcel$export(module.exports, "withModifiers", function () { return $25fdafaea7d62e94$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "createApp", function () { return $25fdafaea7d62e94$export$4e373c34abfa8c68; });
/**
* @vue/runtime-dom v3.4.30
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $cUHxd = parcelRequire("cUHxd");
var $eq3vT = parcelRequire("eq3vT");
var $jZXzE = parcelRequire("jZXzE");parcelRequire("jZXzE");

var $jZXzE = parcelRequire("jZXzE");
const $25fdafaea7d62e94$var$svgNS = "http://www.w3.org/2000/svg";
const $25fdafaea7d62e94$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $25fdafaea7d62e94$var$doc = typeof document !== "undefined" ? document : null;
const $25fdafaea7d62e94$var$templateContainer = $25fdafaea7d62e94$var$doc && /* @__PURE__ */ $25fdafaea7d62e94$var$doc.createElement("template");
const $25fdafaea7d62e94$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $25fdafaea7d62e94$var$doc.createElementNS($25fdafaea7d62e94$var$svgNS, tag) : namespace === "mathml" ? $25fdafaea7d62e94$var$doc.createElementNS($25fdafaea7d62e94$var$mathmlNS, tag) : is ? $25fdafaea7d62e94$var$doc.createElement(tag, {
            is: is
        }) : $25fdafaea7d62e94$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$25fdafaea7d62e94$var$doc.createTextNode(text),
    createComment: (text)=>$25fdafaea7d62e94$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$25fdafaea7d62e94$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $25fdafaea7d62e94$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $25fdafaea7d62e94$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $25fdafaea7d62e94$var$TRANSITION = "transition";
const $25fdafaea7d62e94$var$ANIMATION = "animation";
const $25fdafaea7d62e94$var$vtcKey = Symbol("_vtc");
const $25fdafaea7d62e94$export$be58926105124dd4 = (props, { slots: slots })=>(0, $cUHxd.h)((0, $cUHxd.BaseTransition), $25fdafaea7d62e94$var$resolveTransitionProps(props), slots);
$25fdafaea7d62e94$export$be58926105124dd4.displayName = "Transition";
const $25fdafaea7d62e94$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $25fdafaea7d62e94$var$TransitionPropsValidators = $25fdafaea7d62e94$export$be58926105124dd4.props = /* @__PURE__ */ (0, $jZXzE.extend)({}, (0, $cUHxd.BaseTransitionPropsValidators), $25fdafaea7d62e94$var$DOMTransitionPropsValidators);
const $25fdafaea7d62e94$var$callHook = (hook, args = [])=>{
    if ((0, $jZXzE.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $25fdafaea7d62e94$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $jZXzE.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $25fdafaea7d62e94$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $25fdafaea7d62e94$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $25fdafaea7d62e94$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $25fdafaea7d62e94$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $25fdafaea7d62e94$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $25fdafaea7d62e94$var$removeTransitionClass(el, leaveFromClass);
        $25fdafaea7d62e94$var$removeTransitionClass(el, leaveToClass);
        $25fdafaea7d62e94$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $25fdafaea7d62e94$var$callHook(hook, [
                el,
                resolve
            ]);
            $25fdafaea7d62e94$var$nextFrame(()=>{
                $25fdafaea7d62e94$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $25fdafaea7d62e94$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$25fdafaea7d62e94$var$hasExplicitCallback(hook)) $25fdafaea7d62e94$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $jZXzE.extend)(baseProps, {
        onBeforeEnter (el) {
            $25fdafaea7d62e94$var$callHook(onBeforeEnter, [
                el
            ]);
            $25fdafaea7d62e94$var$addTransitionClass(el, enterFromClass);
            $25fdafaea7d62e94$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $25fdafaea7d62e94$var$callHook(onBeforeAppear, [
                el
            ]);
            $25fdafaea7d62e94$var$addTransitionClass(el, appearFromClass);
            $25fdafaea7d62e94$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $25fdafaea7d62e94$var$addTransitionClass(el, leaveFromClass);
            $25fdafaea7d62e94$var$addTransitionClass(el, leaveActiveClass);
            $25fdafaea7d62e94$var$forceReflow();
            $25fdafaea7d62e94$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $25fdafaea7d62e94$var$removeTransitionClass(el, leaveFromClass);
                $25fdafaea7d62e94$var$addTransitionClass(el, leaveToClass);
                if (!$25fdafaea7d62e94$var$hasExplicitCallback(onLeave)) $25fdafaea7d62e94$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $25fdafaea7d62e94$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $25fdafaea7d62e94$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $25fdafaea7d62e94$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $25fdafaea7d62e94$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $25fdafaea7d62e94$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $jZXzE.isObject)(duration)) return [
        $25fdafaea7d62e94$var$NumberOf(duration.enter),
        $25fdafaea7d62e94$var$NumberOf(duration.leave)
    ];
    else {
        const n = $25fdafaea7d62e94$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $25fdafaea7d62e94$var$NumberOf(val) {
    const res = (0, $jZXzE.toNumber)(val);
    return res;
}
function $25fdafaea7d62e94$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$25fdafaea7d62e94$var$vtcKey] || (el[$25fdafaea7d62e94$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $25fdafaea7d62e94$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$25fdafaea7d62e94$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$25fdafaea7d62e94$var$vtcKey] = void 0;
    }
}
function $25fdafaea7d62e94$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $25fdafaea7d62e94$var$endId = 0;
function $25fdafaea7d62e94$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$25fdafaea7d62e94$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $25fdafaea7d62e94$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $25fdafaea7d62e94$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$25fdafaea7d62e94$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$25fdafaea7d62e94$var$TRANSITION}Duration`);
    const transitionTimeout = $25fdafaea7d62e94$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$25fdafaea7d62e94$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$25fdafaea7d62e94$var$ANIMATION}Duration`);
    const animationTimeout = $25fdafaea7d62e94$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $25fdafaea7d62e94$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $25fdafaea7d62e94$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $25fdafaea7d62e94$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $25fdafaea7d62e94$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $25fdafaea7d62e94$var$TRANSITION : $25fdafaea7d62e94$var$ANIMATION : null;
        propCount = type ? type === $25fdafaea7d62e94$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $25fdafaea7d62e94$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$25fdafaea7d62e94$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $25fdafaea7d62e94$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$25fdafaea7d62e94$var$toMs(d) + $25fdafaea7d62e94$var$toMs(delays[i])));
}
function $25fdafaea7d62e94$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $25fdafaea7d62e94$var$forceReflow() {
    return document.body.offsetHeight;
}
function $25fdafaea7d62e94$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$25fdafaea7d62e94$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $25fdafaea7d62e94$var$vShowOriginalDisplay = Symbol("_vod");
const $25fdafaea7d62e94$var$vShowHidden = Symbol("_vsh");
const $25fdafaea7d62e94$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$25fdafaea7d62e94$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $25fdafaea7d62e94$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $25fdafaea7d62e94$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $25fdafaea7d62e94$var$setDisplay(el, false);
            });
        } else $25fdafaea7d62e94$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $25fdafaea7d62e94$var$setDisplay(el, value);
    }
};
function $25fdafaea7d62e94$var$setDisplay(el, value) {
    el.style.display = value ? el[$25fdafaea7d62e94$var$vShowOriginalDisplay] : "none";
    el[$25fdafaea7d62e94$var$vShowHidden] = !value;
}
function $25fdafaea7d62e94$var$initVShowForSSR() {
    $25fdafaea7d62e94$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $25fdafaea7d62e94$var$CSS_VAR_TEXT = Symbol("");
function $25fdafaea7d62e94$export$ef28b76f07940108(getter) {
    const instance = (0, $cUHxd.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$25fdafaea7d62e94$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $25fdafaea7d62e94$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $cUHxd.onMounted)(()=>{
        (0, $cUHxd.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $cUHxd.onUnmounted)(()=>ob.disconnect());
    });
}
function $25fdafaea7d62e94$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $25fdafaea7d62e94$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $25fdafaea7d62e94$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $cUHxd.Fragment)) vnode.children.forEach((c)=>$25fdafaea7d62e94$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $cUHxd.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $25fdafaea7d62e94$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $25fdafaea7d62e94$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$25fdafaea7d62e94$var$CSS_VAR_TEXT] = cssText;
    }
}
const $25fdafaea7d62e94$var$displayRE = /(^|;)\s*display\s*:/;
function $25fdafaea7d62e94$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $jZXzE.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $jZXzE.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $25fdafaea7d62e94$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $25fdafaea7d62e94$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $25fdafaea7d62e94$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$25fdafaea7d62e94$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $25fdafaea7d62e94$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($25fdafaea7d62e94$var$vShowOriginalDisplay in el) {
        el[$25fdafaea7d62e94$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$25fdafaea7d62e94$var$vShowHidden]) style.display = "none";
    }
}
const $25fdafaea7d62e94$var$semicolonRE = /[^\\];\s*$/;
const $25fdafaea7d62e94$var$importantRE = /\s*!important$/;
function $25fdafaea7d62e94$var$setStyle(style, name, val) {
    if ((0, $jZXzE.isArray)(val)) val.forEach((v)=>$25fdafaea7d62e94$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $25fdafaea7d62e94$var$autoPrefix(style, name);
            if ($25fdafaea7d62e94$var$importantRE.test(val)) style.setProperty((0, $jZXzE.hyphenate)(prefixed), val.replace($25fdafaea7d62e94$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $25fdafaea7d62e94$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $25fdafaea7d62e94$var$prefixCache = {};
function $25fdafaea7d62e94$var$autoPrefix(style, rawName) {
    const cached = $25fdafaea7d62e94$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $jZXzE.camelize)(rawName);
    if (name !== "filter" && name in style) return $25fdafaea7d62e94$var$prefixCache[rawName] = name;
    name = (0, $jZXzE.capitalize)(name);
    for(let i = 0; i < $25fdafaea7d62e94$var$prefixes.length; i++){
        const prefixed = $25fdafaea7d62e94$var$prefixes[i] + name;
        if (prefixed in style) return $25fdafaea7d62e94$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $25fdafaea7d62e94$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $25fdafaea7d62e94$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $jZXzE.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($25fdafaea7d62e94$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($25fdafaea7d62e94$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $jZXzE.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $jZXzE.isSymbol)(value) ? String(value) : value);
}
function $25fdafaea7d62e94$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $jZXzE.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $25fdafaea7d62e94$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $25fdafaea7d62e94$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $25fdafaea7d62e94$var$veiKey = Symbol("_vei");
function $25fdafaea7d62e94$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$25fdafaea7d62e94$var$veiKey] || (el[$25fdafaea7d62e94$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $25fdafaea7d62e94$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $25fdafaea7d62e94$var$createInvoker(nextValue, instance);
            $25fdafaea7d62e94$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $25fdafaea7d62e94$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $25fdafaea7d62e94$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $25fdafaea7d62e94$var$parseName(name) {
    let options;
    if ($25fdafaea7d62e94$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($25fdafaea7d62e94$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $jZXzE.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $25fdafaea7d62e94$var$cachedNow = 0;
const $25fdafaea7d62e94$var$p = /* @__PURE__ */ Promise.resolve();
const $25fdafaea7d62e94$var$getNow = ()=>$25fdafaea7d62e94$var$cachedNow || ($25fdafaea7d62e94$var$p.then(()=>$25fdafaea7d62e94$var$cachedNow = 0), $25fdafaea7d62e94$var$cachedNow = Date.now());
function $25fdafaea7d62e94$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $cUHxd.callWithAsyncErrorHandling)($25fdafaea7d62e94$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $25fdafaea7d62e94$var$getNow();
    return invoker;
}
function $25fdafaea7d62e94$var$sanitizeEventValue(value, propName) {
    if ((0, $jZXzE.isFunction)(value) || (0, $jZXzE.isArray)(value)) return value;
    (0, $cUHxd.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $jZXzE.NOOP;
}
function $25fdafaea7d62e94$var$patchStopImmediatePropagation(e, value) {
    if ((0, $jZXzE.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $25fdafaea7d62e94$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $25fdafaea7d62e94$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $25fdafaea7d62e94$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $25fdafaea7d62e94$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $jZXzE.isOn)(key)) {
        if (!(0, $jZXzE.isModelListener)(key)) $25fdafaea7d62e94$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $25fdafaea7d62e94$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $25fdafaea7d62e94$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $25fdafaea7d62e94$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $25fdafaea7d62e94$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $25fdafaea7d62e94$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $25fdafaea7d62e94$var$isNativeOn(key) && (0, $jZXzE.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($25fdafaea7d62e94$var$isNativeOn(key) && (0, $jZXzE.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $25fdafaea7d62e94$export$a00e2346eabbdbef(options, extraOptions, hydrate2) {
    const Comp = (0, $cUHxd.defineComponent)(options, extraOptions);
    class VueCustomElement extends $25fdafaea7d62e94$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $25fdafaea7d62e94$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $25fdafaea7d62e94$export$a00e2346eabbdbef(options, extraOptions, $25fdafaea7d62e94$export$fa8d919ba61d84db);
};
const $25fdafaea7d62e94$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $25fdafaea7d62e94$export$b337c1a55163dbe3 extends $25fdafaea7d62e94$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $cUHxd.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                $25fdafaea7d62e94$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $jZXzE.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $jZXzE.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $jZXzE.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $jZXzE.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $jZXzE.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $jZXzE.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $jZXzE.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $jZXzE.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $jZXzE.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $jZXzE.hyphenate)(key));
            }
        }
    }
    _update() {
        $25fdafaea7d62e94$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $cUHxd.createVNode)(this._def, (0, $jZXzE.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $jZXzE.hyphenate)(event) !== event) dispatch((0, $jZXzE.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $25fdafaea7d62e94$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $25fdafaea7d62e94$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $cUHxd.getCurrentInstance)();
        if (!instance) return 0, $jZXzE.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $jZXzE.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $jZXzE.EMPTY_OBJ;
        return mod;
    }
}
const $25fdafaea7d62e94$var$positionMap = /* @__PURE__ */ new WeakMap();
const $25fdafaea7d62e94$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $25fdafaea7d62e94$var$moveCbKey = Symbol("_moveCb");
const $25fdafaea7d62e94$var$enterCbKey = Symbol("_enterCb");
const $25fdafaea7d62e94$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $jZXzE.extend)({}, $25fdafaea7d62e94$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $cUHxd.getCurrentInstance)();
        const state = (0, $cUHxd.useTransitionState)();
        let prevChildren;
        let children;
        (0, $cUHxd.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$25fdafaea7d62e94$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($25fdafaea7d62e94$var$callPendingCbs);
            prevChildren.forEach($25fdafaea7d62e94$var$recordPosition);
            const movedChildren = prevChildren.filter($25fdafaea7d62e94$var$applyTranslation);
            $25fdafaea7d62e94$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $25fdafaea7d62e94$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$25fdafaea7d62e94$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$25fdafaea7d62e94$var$moveCbKey] = null;
                        $25fdafaea7d62e94$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $eq3vT.toRaw)(props);
            const cssTransitionProps = $25fdafaea7d62e94$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $cUHxd.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $cUHxd.setTransitionHooks)(child, (0, $cUHxd.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $25fdafaea7d62e94$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $cUHxd.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $cUHxd.setTransitionHooks)(child, (0, $cUHxd.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $cUHxd.createVNode)(tag, null, children);
        };
    }
};
const $25fdafaea7d62e94$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $25fdafaea7d62e94$var$removeMode($25fdafaea7d62e94$var$TransitionGroupImpl.props);
const $25fdafaea7d62e94$export$19ffa8f511f7bc2e = $25fdafaea7d62e94$var$TransitionGroupImpl;
function $25fdafaea7d62e94$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$25fdafaea7d62e94$var$moveCbKey]) el[$25fdafaea7d62e94$var$moveCbKey]();
    if (el[$25fdafaea7d62e94$var$enterCbKey]) el[$25fdafaea7d62e94$var$enterCbKey]();
}
function $25fdafaea7d62e94$var$recordPosition(c) {
    $25fdafaea7d62e94$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $25fdafaea7d62e94$var$applyTranslation(c) {
    const oldPos = $25fdafaea7d62e94$var$positionMap.get(c);
    const newPos = $25fdafaea7d62e94$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $25fdafaea7d62e94$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$25fdafaea7d62e94$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $25fdafaea7d62e94$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $25fdafaea7d62e94$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $jZXzE.isArray)(fn) ? (value)=>(0, $jZXzE.invokeArrayFns)(fn, value) : fn;
};
function $25fdafaea7d62e94$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $25fdafaea7d62e94$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $25fdafaea7d62e94$var$assignKey = Symbol("_assign");
const $25fdafaea7d62e94$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $25fdafaea7d62e94$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $jZXzE.looseToNumber)(domValue);
            el[$25fdafaea7d62e94$var$assignKey](domValue);
        });
        if (trim) $25fdafaea7d62e94$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $25fdafaea7d62e94$var$addEventListener(el, "compositionstart", $25fdafaea7d62e94$var$onCompositionStart);
            $25fdafaea7d62e94$var$addEventListener(el, "compositionend", $25fdafaea7d62e94$var$onCompositionEnd);
            $25fdafaea7d62e94$var$addEventListener(el, "change", $25fdafaea7d62e94$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $jZXzE.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $25fdafaea7d62e94$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
        $25fdafaea7d62e94$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $25fdafaea7d62e94$var$getValue(el);
            const checked = el.checked;
            const assign = el[$25fdafaea7d62e94$var$assignKey];
            if ((0, $jZXzE.isArray)(modelValue)) {
                const index = (0, $jZXzE.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $jZXzE.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($25fdafaea7d62e94$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $25fdafaea7d62e94$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
        $25fdafaea7d62e94$var$setChecked(el, binding, vnode);
    }
};
function $25fdafaea7d62e94$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $jZXzE.isArray)(value)) el.checked = (0, $jZXzE.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $jZXzE.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $jZXzE.looseEqual)(value, $25fdafaea7d62e94$var$getCheckboxValue(el, true));
}
const $25fdafaea7d62e94$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $jZXzE.looseEqual)(value, vnode.props.value);
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
        $25fdafaea7d62e94$var$addEventListener(el, "change", ()=>{
            el[$25fdafaea7d62e94$var$assignKey]($25fdafaea7d62e94$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $jZXzE.looseEqual)(value, vnode.props.value);
    }
};
const $25fdafaea7d62e94$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $jZXzE.isSet)(value);
        $25fdafaea7d62e94$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $jZXzE.looseToNumber)($25fdafaea7d62e94$var$getValue(o)) : $25fdafaea7d62e94$var$getValue(o));
            el[$25fdafaea7d62e94$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $cUHxd.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $25fdafaea7d62e94$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$25fdafaea7d62e94$var$assignKey] = $25fdafaea7d62e94$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $25fdafaea7d62e94$var$setSelected(el, value);
    }
};
function $25fdafaea7d62e94$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $jZXzE.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $jZXzE.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $25fdafaea7d62e94$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $jZXzE.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $jZXzE.looseEqual)($25fdafaea7d62e94$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $25fdafaea7d62e94$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $25fdafaea7d62e94$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $25fdafaea7d62e94$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $25fdafaea7d62e94$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $25fdafaea7d62e94$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $25fdafaea7d62e94$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $25fdafaea7d62e94$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $25fdafaea7d62e94$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $25fdafaea7d62e94$export$87d227567b51ca39;
        case "TEXTAREA":
            return $25fdafaea7d62e94$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $25fdafaea7d62e94$export$8847c2e532b35714;
                case "radio":
                    return $25fdafaea7d62e94$export$b4356c59b38b7aa9;
                default:
                    return $25fdafaea7d62e94$export$f1f88689f5728478;
            }
    }
}
function $25fdafaea7d62e94$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $25fdafaea7d62e94$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $25fdafaea7d62e94$var$initVModelForSSR() {
    $25fdafaea7d62e94$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $25fdafaea7d62e94$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $jZXzE.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $25fdafaea7d62e94$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $jZXzE.isArray)(value)) {
            if (vnode.props && (0, $jZXzE.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $jZXzE.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $25fdafaea7d62e94$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $25fdafaea7d62e94$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $25fdafaea7d62e94$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $25fdafaea7d62e94$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$25fdafaea7d62e94$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $25fdafaea7d62e94$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $25fdafaea7d62e94$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $25fdafaea7d62e94$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $25fdafaea7d62e94$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $jZXzE.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $25fdafaea7d62e94$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $25fdafaea7d62e94$var$rendererOptions = /* @__PURE__ */ (0, $jZXzE.extend)({
    patchProp: $25fdafaea7d62e94$var$patchProp
}, $25fdafaea7d62e94$var$nodeOps);
let $25fdafaea7d62e94$var$renderer;
let $25fdafaea7d62e94$var$enabledHydration = false;
function $25fdafaea7d62e94$var$ensureRenderer() {
    return $25fdafaea7d62e94$var$renderer || ($25fdafaea7d62e94$var$renderer = (0, $cUHxd.createRenderer)($25fdafaea7d62e94$var$rendererOptions));
}
function $25fdafaea7d62e94$var$ensureHydrationRenderer() {
    $25fdafaea7d62e94$var$renderer = $25fdafaea7d62e94$var$enabledHydration ? $25fdafaea7d62e94$var$renderer : (0, $cUHxd.createHydrationRenderer)($25fdafaea7d62e94$var$rendererOptions);
    $25fdafaea7d62e94$var$enabledHydration = true;
    return $25fdafaea7d62e94$var$renderer;
}
const $25fdafaea7d62e94$export$b3890eb0ae9dca99 = (...args)=>{
    $25fdafaea7d62e94$var$ensureRenderer().render(...args);
};
const $25fdafaea7d62e94$export$fa8d919ba61d84db = (...args)=>{
    $25fdafaea7d62e94$var$ensureHydrationRenderer().hydrate(...args);
};
const $25fdafaea7d62e94$export$4e373c34abfa8c68 = (...args)=>{
    const app = $25fdafaea7d62e94$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $25fdafaea7d62e94$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $jZXzE.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $25fdafaea7d62e94$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $25fdafaea7d62e94$export$35800275c0037383 = (...args)=>{
    const app = $25fdafaea7d62e94$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $25fdafaea7d62e94$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $25fdafaea7d62e94$var$resolveRootNamespace(container));
    };
    return app;
};
function $25fdafaea7d62e94$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $25fdafaea7d62e94$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $jZXzE.isHTMLTag)(tag) || (0, $jZXzE.isSVGTag)(tag) || (0, $jZXzE.isMathMLTag)(tag),
        writable: false
    });
}
function $25fdafaea7d62e94$var$injectCompilerOptionsCheck(app) {
    if ((0, $cUHxd.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $cUHxd.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $cUHxd.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $cUHxd.warn)(msg);
            }
        });
    }
}
function $25fdafaea7d62e94$var$normalizeContainer(container) {
    if ((0, $jZXzE.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $25fdafaea7d62e94$var$ssrDirectiveInitialized = false;
const $25fdafaea7d62e94$export$800b28255aa678d9 = ()=>{
    if (!$25fdafaea7d62e94$var$ssrDirectiveInitialized) {
        $25fdafaea7d62e94$var$ssrDirectiveInitialized = true;
        $25fdafaea7d62e94$var$initVModelForSSR();
        $25fdafaea7d62e94$var$initVShowForSSR();
    }
};

});
parcelRegister("cUHxd", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $966c7c1b681b375a$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $966c7c1b681b375a$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $966c7c1b681b375a$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $966c7c1b681b375a$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $966c7c1b681b375a$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $966c7c1b681b375a$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $966c7c1b681b375a$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $966c7c1b681b375a$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $966c7c1b681b375a$export$b44c564a05ca975; });
$parcel$export(module.exports, "Suspense", function () { return $966c7c1b681b375a$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "openBlock", function () { return $966c7c1b681b375a$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "onMounted", function () { return $966c7c1b681b375a$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onUpdated", function () { return $966c7c1b681b375a$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $966c7c1b681b375a$export$40c420df62d2614; });
$parcel$export(module.exports, "onUnmounted", function () { return $966c7c1b681b375a$export$13348a43ccacfe58; });
$parcel$export(module.exports, "withDirectives", function () { return $966c7c1b681b375a$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "renderList", function () { return $966c7c1b681b375a$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "defineComponent", function () { return $966c7c1b681b375a$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "renderSlot", function () { return $966c7c1b681b375a$export$4abee4c34694ada1; });
$parcel$export(module.exports, "createBlock", function () { return $966c7c1b681b375a$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $966c7c1b681b375a$export$f13e630aa3915748; });
$parcel$export(module.exports, "withAsyncContext", function () { return $966c7c1b681b375a$export$d6d6f7369f1fb104; });
$parcel$export(module.exports, "computed", function () { return $966c7c1b681b375a$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "watch", function () { return $966c7c1b681b375a$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "createTextVNode", function () { return $966c7c1b681b375a$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $966c7c1b681b375a$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $966c7c1b681b375a$export$200524cf0d997ff0; });
$parcel$export(module.exports, "watchEffect", function () { return $966c7c1b681b375a$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $966c7c1b681b375a$export$b7f27ea67102d543; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $966c7c1b681b375a$export$7770a22486565649; });
$parcel$export(module.exports, "useTransitionState", function () { return $966c7c1b681b375a$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $966c7c1b681b375a$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $966c7c1b681b375a$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $966c7c1b681b375a$export$76ac1779589cd824; });
$parcel$export(module.exports, "BaseTransition", function () { return $966c7c1b681b375a$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "createElementBlock", function () { return $966c7c1b681b375a$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $966c7c1b681b375a$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createCommentVNode", function () { return $966c7c1b681b375a$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $966c7c1b681b375a$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $966c7c1b681b375a$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $966c7c1b681b375a$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $966c7c1b681b375a$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("eq3vT")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("eq3vT")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("jZXzE")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("jZXzE")).normalizeClass; });
/**
* @vue/runtime-core v3.4.30
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $eq3vT = parcelRequire("eq3vT");

var $jZXzE = parcelRequire("jZXzE");
const $966c7c1b681b375a$var$stack = [];
function $966c7c1b681b375a$var$pushWarningContext(vnode) {
    $966c7c1b681b375a$var$stack.push(vnode);
}
function $966c7c1b681b375a$var$popWarningContext() {
    $966c7c1b681b375a$var$stack.pop();
}
function $966c7c1b681b375a$var$warn$1(msg, ...args) {
    (0, $eq3vT.pauseTracking)();
    const instance = $966c7c1b681b375a$var$stack.length ? $966c7c1b681b375a$var$stack[$966c7c1b681b375a$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $966c7c1b681b375a$var$getComponentTrace();
    if (appWarnHandler) $966c7c1b681b375a$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$966c7c1b681b375a$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$966c7c1b681b375a$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $eq3vT.resetTracking)();
}
function $966c7c1b681b375a$var$getComponentTrace() {
    let currentVNode = $966c7c1b681b375a$var$stack[$966c7c1b681b375a$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $966c7c1b681b375a$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$966c7c1b681b375a$var$formatTraceEntry(entry));
    });
    return logs;
}
function $966c7c1b681b375a$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$966c7c1b681b375a$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$966c7c1b681b375a$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $966c7c1b681b375a$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$966c7c1b681b375a$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $966c7c1b681b375a$var$formatProp(key, value, raw) {
    if ((0, $jZXzE.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $eq3vT.isRef)(value)) {
        value = $966c7c1b681b375a$var$formatProp(key, (0, $eq3vT.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $jZXzE.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $eq3vT.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $966c7c1b681b375a$export$dfbcecb440255e4a(val, type) {
    return;
}
const $966c7c1b681b375a$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $966c7c1b681b375a$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $966c7c1b681b375a$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $966c7c1b681b375a$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $966c7c1b681b375a$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $jZXzE.isFunction)(fn)) {
        const res = $966c7c1b681b375a$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $jZXzE.isPromise)(res)) res.catch((err)=>{
            $966c7c1b681b375a$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $jZXzE.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($966c7c1b681b375a$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $966c7c1b681b375a$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $eq3vT.pauseTracking)();
            $966c7c1b681b375a$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $eq3vT.resetTracking)();
            return;
        }
    }
    $966c7c1b681b375a$var$logError(err, type, contextVNode, throwInDev);
}
function $966c7c1b681b375a$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $966c7c1b681b375a$var$isFlushing = false;
let $966c7c1b681b375a$var$isFlushPending = false;
const $966c7c1b681b375a$var$queue = [];
let $966c7c1b681b375a$var$flushIndex = 0;
const $966c7c1b681b375a$var$pendingPostFlushCbs = [];
let $966c7c1b681b375a$var$activePostFlushCbs = null;
let $966c7c1b681b375a$var$postFlushIndex = 0;
const $966c7c1b681b375a$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $966c7c1b681b375a$var$currentFlushPromise = null;
const $966c7c1b681b375a$var$RECURSION_LIMIT = 100;
function $966c7c1b681b375a$export$bdd553fddd433dcb(fn) {
    const p = $966c7c1b681b375a$var$currentFlushPromise || $966c7c1b681b375a$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $966c7c1b681b375a$var$findInsertionIndex(id) {
    let start = $966c7c1b681b375a$var$flushIndex + 1;
    let end = $966c7c1b681b375a$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $966c7c1b681b375a$var$queue[middle];
        const middleJobId = $966c7c1b681b375a$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $966c7c1b681b375a$var$queueJob(job) {
    if (!$966c7c1b681b375a$var$queue.length || !$966c7c1b681b375a$var$queue.includes(job, $966c7c1b681b375a$var$isFlushing && job.allowRecurse ? $966c7c1b681b375a$var$flushIndex + 1 : $966c7c1b681b375a$var$flushIndex)) {
        if (job.id == null) $966c7c1b681b375a$var$queue.push(job);
        else $966c7c1b681b375a$var$queue.splice($966c7c1b681b375a$var$findInsertionIndex(job.id), 0, job);
        $966c7c1b681b375a$var$queueFlush();
    }
}
function $966c7c1b681b375a$var$queueFlush() {
    if (!$966c7c1b681b375a$var$isFlushing && !$966c7c1b681b375a$var$isFlushPending) {
        $966c7c1b681b375a$var$isFlushPending = true;
        $966c7c1b681b375a$var$currentFlushPromise = $966c7c1b681b375a$var$resolvedPromise.then($966c7c1b681b375a$var$flushJobs);
    }
}
function $966c7c1b681b375a$var$invalidateJob(job) {
    const i = $966c7c1b681b375a$var$queue.indexOf(job);
    if (i > $966c7c1b681b375a$var$flushIndex) $966c7c1b681b375a$var$queue.splice(i, 1);
}
function $966c7c1b681b375a$export$59536a0199721cab(cb) {
    if (!(0, $jZXzE.isArray)(cb)) {
        if (!$966c7c1b681b375a$var$activePostFlushCbs || !$966c7c1b681b375a$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $966c7c1b681b375a$var$postFlushIndex + 1 : $966c7c1b681b375a$var$postFlushIndex)) $966c7c1b681b375a$var$pendingPostFlushCbs.push(cb);
    } else $966c7c1b681b375a$var$pendingPostFlushCbs.push(...cb);
    $966c7c1b681b375a$var$queueFlush();
}
function $966c7c1b681b375a$var$flushPreFlushCbs(instance, seen, i = $966c7c1b681b375a$var$isFlushing ? $966c7c1b681b375a$var$flushIndex + 1 : 0) {
    for(; i < $966c7c1b681b375a$var$queue.length; i++){
        const cb = $966c7c1b681b375a$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $966c7c1b681b375a$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $966c7c1b681b375a$var$flushPostFlushCbs(seen) {
    if ($966c7c1b681b375a$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($966c7c1b681b375a$var$pendingPostFlushCbs)
        ].sort((a, b)=>$966c7c1b681b375a$var$getId(a) - $966c7c1b681b375a$var$getId(b));
        $966c7c1b681b375a$var$pendingPostFlushCbs.length = 0;
        if ($966c7c1b681b375a$var$activePostFlushCbs) {
            $966c7c1b681b375a$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $966c7c1b681b375a$var$activePostFlushCbs = deduped;
        for($966c7c1b681b375a$var$postFlushIndex = 0; $966c7c1b681b375a$var$postFlushIndex < $966c7c1b681b375a$var$activePostFlushCbs.length; $966c7c1b681b375a$var$postFlushIndex++){
            const cb = $966c7c1b681b375a$var$activePostFlushCbs[$966c7c1b681b375a$var$postFlushIndex];
            if (cb.active !== false) cb();
        }
        $966c7c1b681b375a$var$activePostFlushCbs = null;
        $966c7c1b681b375a$var$postFlushIndex = 0;
    }
}
const $966c7c1b681b375a$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $966c7c1b681b375a$var$comparator = (a, b)=>{
    const diff = $966c7c1b681b375a$var$getId(a) - $966c7c1b681b375a$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $966c7c1b681b375a$var$flushJobs(seen) {
    $966c7c1b681b375a$var$isFlushPending = false;
    $966c7c1b681b375a$var$isFlushing = true;
    $966c7c1b681b375a$var$queue.sort($966c7c1b681b375a$var$comparator);
    const check = (0, $jZXzE.NOOP);
    try {
        for($966c7c1b681b375a$var$flushIndex = 0; $966c7c1b681b375a$var$flushIndex < $966c7c1b681b375a$var$queue.length; $966c7c1b681b375a$var$flushIndex++){
            const job = $966c7c1b681b375a$var$queue[$966c7c1b681b375a$var$flushIndex];
            if (job && job.active !== false) $966c7c1b681b375a$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $966c7c1b681b375a$var$flushIndex = 0;
        $966c7c1b681b375a$var$queue.length = 0;
        $966c7c1b681b375a$var$flushPostFlushCbs(seen);
        $966c7c1b681b375a$var$isFlushing = false;
        $966c7c1b681b375a$var$currentFlushPromise = null;
        if ($966c7c1b681b375a$var$queue.length || $966c7c1b681b375a$var$pendingPostFlushCbs.length) $966c7c1b681b375a$var$flushJobs(seen);
    }
}
function $966c7c1b681b375a$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $966c7c1b681b375a$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $966c7c1b681b375a$var$getComponentName(instance.type);
            $966c7c1b681b375a$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $966c7c1b681b375a$var$isHmrUpdating = false;
const $966c7c1b681b375a$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $966c7c1b681b375a$var$map = /* @__PURE__ */ new Map();
function $966c7c1b681b375a$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $966c7c1b681b375a$var$map.get(id);
    if (!record) {
        $966c7c1b681b375a$var$createRecord(id, instance.type);
        record = $966c7c1b681b375a$var$map.get(id);
    }
    record.instances.add(instance);
}
function $966c7c1b681b375a$var$unregisterHMR(instance) {
    $966c7c1b681b375a$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $966c7c1b681b375a$var$createRecord(id, initialDef) {
    if ($966c7c1b681b375a$var$map.has(id)) return false;
    $966c7c1b681b375a$var$map.set(id, {
        initialDef: $966c7c1b681b375a$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $966c7c1b681b375a$var$normalizeClassComponent(component) {
    return $966c7c1b681b375a$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $966c7c1b681b375a$var$rerender(id, newRender) {
    const record = $966c7c1b681b375a$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $966c7c1b681b375a$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $966c7c1b681b375a$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $966c7c1b681b375a$var$isHmrUpdating = false;
    });
}
function $966c7c1b681b375a$var$reload(id, newComp) {
    const record = $966c7c1b681b375a$var$map.get(id);
    if (!record) return;
    newComp = $966c7c1b681b375a$var$normalizeClassComponent(newComp);
    $966c7c1b681b375a$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $966c7c1b681b375a$var$normalizeClassComponent(instance.type);
        if (!$966c7c1b681b375a$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $966c7c1b681b375a$var$updateComponentDef(oldComp, newComp);
            $966c7c1b681b375a$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $966c7c1b681b375a$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $966c7c1b681b375a$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $966c7c1b681b375a$var$queueJob(()=>{
                instance.parent.update();
                $966c7c1b681b375a$var$hmrDirtyComponents.delete(oldComp);
            });
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $966c7c1b681b375a$export$59536a0199721cab(()=>{
        for (const instance of instances)$966c7c1b681b375a$var$hmrDirtyComponents.delete($966c7c1b681b375a$var$normalizeClassComponent(instance.type));
    });
}
function $966c7c1b681b375a$var$updateComponentDef(oldComp, newComp) {
    (0, $jZXzE.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $966c7c1b681b375a$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $966c7c1b681b375a$var$devtools$1;
let $966c7c1b681b375a$var$buffer = [];
let $966c7c1b681b375a$var$devtoolsNotInstalled = false;
function $966c7c1b681b375a$var$emit$1(event, ...args) {
    if ($966c7c1b681b375a$var$devtools$1) $966c7c1b681b375a$var$devtools$1.emit(event, ...args);
    else if (!$966c7c1b681b375a$var$devtoolsNotInstalled) $966c7c1b681b375a$var$buffer.push({
        event: event,
        args: args
    });
}
function $966c7c1b681b375a$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $966c7c1b681b375a$var$devtools$1 = hook;
    if ($966c7c1b681b375a$var$devtools$1) {
        $966c7c1b681b375a$var$devtools$1.enabled = true;
        $966c7c1b681b375a$var$buffer.forEach(({ event: event, args: args })=>$966c7c1b681b375a$var$devtools$1.emit(event, ...args));
        $966c7c1b681b375a$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $966c7c1b681b375a$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$966c7c1b681b375a$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $966c7c1b681b375a$var$devtoolsNotInstalled = true;
                $966c7c1b681b375a$var$buffer = [];
            }
        }, 3e3);
    } else {
        $966c7c1b681b375a$var$devtoolsNotInstalled = true;
        $966c7c1b681b375a$var$buffer = [];
    }
}
function $966c7c1b681b375a$var$devtoolsInitApp(app, version) {
    $966c7c1b681b375a$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $966c7c1b681b375a$export$ffb0004e005737fa,
        Text: $966c7c1b681b375a$export$5f1af8db9871e1d6,
        Comment: $966c7c1b681b375a$export$4d299b491347818a,
        Static: $966c7c1b681b375a$export$c1b9a1d3af45b7b6
    });
}
function $966c7c1b681b375a$var$devtoolsUnmountApp(app) {
    $966c7c1b681b375a$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $966c7c1b681b375a$var$devtoolsComponentAdded = /* @__PURE__ */ $966c7c1b681b375a$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $966c7c1b681b375a$var$devtoolsComponentUpdated = /* @__PURE__ */ $966c7c1b681b375a$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $966c7c1b681b375a$var$_devtoolsComponentRemoved = /* @__PURE__ */ $966c7c1b681b375a$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $966c7c1b681b375a$var$devtoolsComponentRemoved = (component)=>{
    if ($966c7c1b681b375a$var$devtools$1 && typeof $966c7c1b681b375a$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$966c7c1b681b375a$var$devtools$1.cleanupBuffer(component)) $966c7c1b681b375a$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $966c7c1b681b375a$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $966c7c1b681b375a$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $966c7c1b681b375a$var$devtoolsPerfStart = /* @__PURE__ */ $966c7c1b681b375a$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $966c7c1b681b375a$var$devtoolsPerfEnd = /* @__PURE__ */ $966c7c1b681b375a$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $966c7c1b681b375a$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $966c7c1b681b375a$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $966c7c1b681b375a$var$devtoolsComponentEmit(component, event, params) {
    $966c7c1b681b375a$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $966c7c1b681b375a$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $jZXzE.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $jZXzE.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $jZXzE.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $jZXzE.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $jZXzE.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $jZXzE.toHandlerKey)((0, $jZXzE.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $jZXzE.toHandlerKey)((0, $jZXzE.hyphenate)(event))];
    if (handler) $966c7c1b681b375a$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $966c7c1b681b375a$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $966c7c1b681b375a$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $jZXzE.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $966c7c1b681b375a$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $jZXzE.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $jZXzE.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $jZXzE.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $jZXzE.extend)(normalized, raw);
    if ((0, $jZXzE.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $966c7c1b681b375a$var$isEmitListener(options, key) {
    if (!options || !(0, $jZXzE.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $jZXzE.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $jZXzE.hasOwn)(options, (0, $jZXzE.hyphenate)(key)) || (0, $jZXzE.hasOwn)(options, key);
}
let $966c7c1b681b375a$var$currentRenderingInstance = null;
let $966c7c1b681b375a$var$currentScopeId = null;
function $966c7c1b681b375a$var$setCurrentRenderingInstance(instance) {
    const prev = $966c7c1b681b375a$var$currentRenderingInstance;
    $966c7c1b681b375a$var$currentRenderingInstance = instance;
    $966c7c1b681b375a$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $966c7c1b681b375a$export$ac020265ca2cc4cd(id) {
    $966c7c1b681b375a$var$currentScopeId = id;
}
function $966c7c1b681b375a$export$f2dc6805dc11834e() {
    $966c7c1b681b375a$var$currentScopeId = null;
}
const $966c7c1b681b375a$export$15ba313e13f3dd04 = (_id)=>$966c7c1b681b375a$export$694b237e827a3d23;
function $966c7c1b681b375a$export$694b237e827a3d23(fn, ctx = $966c7c1b681b375a$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $966c7c1b681b375a$export$c20bee82f26f1e27(-1);
        const prevInstance = $966c7c1b681b375a$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $966c7c1b681b375a$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $966c7c1b681b375a$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $966c7c1b681b375a$var$accessedAttrs = false;
function $966c7c1b681b375a$var$markAttrsAccessed() {
    $966c7c1b681b375a$var$accessedAttrs = true;
}
function $966c7c1b681b375a$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $966c7c1b681b375a$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $966c7c1b681b375a$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $966c7c1b681b375a$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $966c7c1b681b375a$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $966c7c1b681b375a$var$blockStack.length = 0;
        $966c7c1b681b375a$export$d3da1ecaf1206c58(err, instance, 1);
        result = $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $jZXzE.isModelListener))) fallthroughAttrs = $966c7c1b681b375a$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $966c7c1b681b375a$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $966c7c1b681b375a$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $966c7c1b681b375a$var$setCurrentRenderingInstance(prev);
    return result;
}
const $966c7c1b681b375a$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $966c7c1b681b375a$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $966c7c1b681b375a$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $966c7c1b681b375a$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($966c7c1b681b375a$export$3868d13f8734ae81(child)) {
            if (child.type !== $966c7c1b681b375a$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $966c7c1b681b375a$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $jZXzE.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $966c7c1b681b375a$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $jZXzE.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $966c7c1b681b375a$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $966c7c1b681b375a$export$4d299b491347818a;
};
function $966c7c1b681b375a$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $966c7c1b681b375a$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$966c7c1b681b375a$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $966c7c1b681b375a$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $966c7c1b681b375a$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$966c7c1b681b375a$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $966c7c1b681b375a$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $966c7c1b681b375a$var$COMPONENTS = "components";
const $966c7c1b681b375a$var$DIRECTIVES = "directives";
function $966c7c1b681b375a$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $966c7c1b681b375a$var$resolveAsset($966c7c1b681b375a$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $966c7c1b681b375a$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $966c7c1b681b375a$export$b44c564a05ca975(component) {
    if ((0, $jZXzE.isString)(component)) return $966c7c1b681b375a$var$resolveAsset($966c7c1b681b375a$var$COMPONENTS, component, false) || component;
    else return component || $966c7c1b681b375a$var$NULL_DYNAMIC_COMPONENT;
}
function $966c7c1b681b375a$export$a1989e995cd481be(name) {
    return $966c7c1b681b375a$var$resolveAsset($966c7c1b681b375a$var$DIRECTIVES, name);
}
function $966c7c1b681b375a$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $966c7c1b681b375a$var$currentRenderingInstance || $966c7c1b681b375a$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $966c7c1b681b375a$var$COMPONENTS) {
            const selfName = $966c7c1b681b375a$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $jZXzE.camelize)(name) || selfName === (0, $jZXzE.capitalize)((0, $jZXzE.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $966c7c1b681b375a$var$resolve(instance[type] || Component[type], name) || // global registration
        $966c7c1b681b375a$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $966c7c1b681b375a$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $jZXzE.camelize)(name)] || registry[(0, $jZXzE.capitalize)((0, $jZXzE.camelize)(name))]);
}
const $966c7c1b681b375a$var$isSuspense = (type)=>type.__isSuspense;
let $966c7c1b681b375a$var$suspenseId = 0;
const $966c7c1b681b375a$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $966c7c1b681b375a$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $966c7c1b681b375a$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $966c7c1b681b375a$var$hydrateSuspense,
    normalize: $966c7c1b681b375a$var$normalizeSuspenseChildren
};
const $966c7c1b681b375a$export$74bf444e3cd11ea5 = $966c7c1b681b375a$var$SuspenseImpl;
function $966c7c1b681b375a$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $jZXzE.isFunction)(eventListener)) eventListener();
}
function $966c7c1b681b375a$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $966c7c1b681b375a$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $966c7c1b681b375a$var$triggerEvent(vnode, "onPending");
        $966c7c1b681b375a$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $966c7c1b681b375a$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $966c7c1b681b375a$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($966c7c1b681b375a$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $966c7c1b681b375a$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $966c7c1b681b375a$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $966c7c1b681b375a$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $966c7c1b681b375a$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $966c7c1b681b375a$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $966c7c1b681b375a$var$setActiveBranch(suspense, newBranch);
    } else {
        $966c7c1b681b375a$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $966c7c1b681b375a$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $966c7c1b681b375a$var$hasWarned = false;
function $966c7c1b681b375a$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $966c7c1b681b375a$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $jZXzE.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $966c7c1b681b375a$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $966c7c1b681b375a$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $966c7c1b681b375a$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $966c7c1b681b375a$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $966c7c1b681b375a$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $966c7c1b681b375a$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $966c7c1b681b375a$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $966c7c1b681b375a$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $966c7c1b681b375a$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $966c7c1b681b375a$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $966c7c1b681b375a$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $966c7c1b681b375a$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $966c7c1b681b375a$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $966c7c1b681b375a$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $966c7c1b681b375a$var$normalizeSuspenseSlot(children.fallback) : $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$4d299b491347818a);
}
function $966c7c1b681b375a$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $jZXzE.isFunction)(s)) {
        const trackBlock = $966c7c1b681b375a$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $966c7c1b681b375a$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $966c7c1b681b375a$var$currentBlock;
            $966c7c1b681b375a$var$closeBlock();
        }
    }
    if ((0, $jZXzE.isArray)(s)) {
        const singleChild = $966c7c1b681b375a$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $966c7c1b681b375a$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $966c7c1b681b375a$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $jZXzE.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $966c7c1b681b375a$export$59536a0199721cab(fn);
}
function $966c7c1b681b375a$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $966c7c1b681b375a$var$updateHOCHostEl(parentComponent, el);
    }
}
function $966c7c1b681b375a$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
function $966c7c1b681b375a$var$injectHook(type, hook, target = $966c7c1b681b375a$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $eq3vT.pauseTracking)();
            const reset = $966c7c1b681b375a$var$setCurrentInstance(target);
            const res = $966c7c1b681b375a$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $eq3vT.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $966c7c1b681b375a$var$createHook = (lifecycle)=>(hook, target = $966c7c1b681b375a$var$currentInstance)=>{
        if (!$966c7c1b681b375a$var$isInSSRComponentSetup || lifecycle === "sp") $966c7c1b681b375a$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $966c7c1b681b375a$export$23b7aeb0d671f804 = $966c7c1b681b375a$var$createHook("bm");
const $966c7c1b681b375a$export$6d1641039221b5cb = $966c7c1b681b375a$var$createHook("m");
const $966c7c1b681b375a$export$ab91988a13872e4c = $966c7c1b681b375a$var$createHook("bu");
const $966c7c1b681b375a$export$5876c47052fb88b1 = $966c7c1b681b375a$var$createHook("u");
const $966c7c1b681b375a$export$40c420df62d2614 = $966c7c1b681b375a$var$createHook("bum");
const $966c7c1b681b375a$export$13348a43ccacfe58 = $966c7c1b681b375a$var$createHook("um");
const $966c7c1b681b375a$export$ebf0c601f267bceb = $966c7c1b681b375a$var$createHook("sp");
const $966c7c1b681b375a$export$898295a813d662eb = $966c7c1b681b375a$var$createHook("rtg");
const $966c7c1b681b375a$export$2b41f4235363e921 = $966c7c1b681b375a$var$createHook("rtc");
function $966c7c1b681b375a$export$6a3a15856e50ad19(hook, target = $966c7c1b681b375a$var$currentInstance) {
    $966c7c1b681b375a$var$injectHook("ec", hook, target);
}
function $966c7c1b681b375a$var$validateDirectiveName(name) {
    if ((0, $jZXzE.isBuiltInDirective)(name)) $966c7c1b681b375a$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $966c7c1b681b375a$export$49729353e7c1e6c5(vnode, directives) {
    if ($966c7c1b681b375a$var$currentRenderingInstance === null) return vnode;
    const instance = $966c7c1b681b375a$var$getComponentPublicInstance($966c7c1b681b375a$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $jZXzE.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $jZXzE.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $966c7c1b681b375a$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $966c7c1b681b375a$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $eq3vT.pauseTracking)();
            $966c7c1b681b375a$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $eq3vT.resetTracking)();
        }
    }
}
function $966c7c1b681b375a$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $jZXzE.isArray)(source) || (0, $jZXzE.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $jZXzE.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $966c7c1b681b375a$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $jZXzE.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $966c7c1b681b375a$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $jZXzE.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $jZXzE.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $966c7c1b681b375a$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $966c7c1b681b375a$export$d75d499b4c16cf21(source) {
    if ((0, $jZXzE.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $966c7c1b681b375a$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $966c7c1b681b375a$var$currentInstance;
            if (resolvedComp) return ()=>$966c7c1b681b375a$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $966c7c1b681b375a$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $966c7c1b681b375a$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$966c7c1b681b375a$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $966c7c1b681b375a$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $eq3vT.ref)(false);
            const error = (0, $eq3vT.ref)();
            const delayed = (0, $eq3vT.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $966c7c1b681b375a$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $966c7c1b681b375a$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $966c7c1b681b375a$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $966c7c1b681b375a$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $966c7c1b681b375a$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $966c7c1b681b375a$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $966c7c1b681b375a$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
function $966c7c1b681b375a$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($966c7c1b681b375a$var$currentRenderingInstance.isCE || $966c7c1b681b375a$var$currentRenderingInstance.parent && $966c7c1b681b375a$var$isAsyncWrapper($966c7c1b681b375a$var$currentRenderingInstance.parent) && $966c7c1b681b375a$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $966c7c1b681b375a$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $966c7c1b681b375a$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $966c7c1b681b375a$var$ensureValidVNode(slot(props));
    const rendered = $966c7c1b681b375a$export$9f2dfe8048dfb22b($966c7c1b681b375a$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $966c7c1b681b375a$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$966c7c1b681b375a$export$3868d13f8734ae81(child)) return true;
        if (child.type === $966c7c1b681b375a$export$4d299b491347818a) return false;
        if (child.type === $966c7c1b681b375a$export$ffb0004e005737fa && !$966c7c1b681b375a$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $966c7c1b681b375a$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $jZXzE.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $966c7c1b681b375a$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($966c7c1b681b375a$var$isStatefulComponent(i)) return $966c7c1b681b375a$var$getComponentPublicInstance(i);
    return $966c7c1b681b375a$var$getPublicInstance(i.parent);
};
const $966c7c1b681b375a$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $jZXzE.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$966c7c1b681b375a$var$getPublicInstance(i.parent),
    $root: (i)=>$966c7c1b681b375a$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $966c7c1b681b375a$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $966c7c1b681b375a$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $966c7c1b681b375a$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $966c7c1b681b375a$var$instanceWatch.bind(i) : (0, $jZXzE.NOOP)
});
const $966c7c1b681b375a$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $966c7c1b681b375a$var$hasSetupBinding = (state, key)=>state !== (0, $jZXzE.EMPTY_OBJ) && !state.__isScriptSetup && (0, $jZXzE.hasOwn)(state, key);
const $966c7c1b681b375a$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($966c7c1b681b375a$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $jZXzE.EMPTY_OBJ) && (0, $jZXzE.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $jZXzE.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $jZXzE.EMPTY_OBJ) && (0, $jZXzE.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $966c7c1b681b375a$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $966c7c1b681b375a$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $eq3vT.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $jZXzE.EMPTY_OBJ) && (0, $jZXzE.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $jZXzE.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($966c7c1b681b375a$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $jZXzE.EMPTY_OBJ) && (0, $jZXzE.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $jZXzE.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $jZXzE.EMPTY_OBJ) && (0, $jZXzE.hasOwn)(data, key) || $966c7c1b681b375a$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $jZXzE.hasOwn)(normalizedProps, key) || (0, $jZXzE.hasOwn)(ctx, key) || (0, $jZXzE.hasOwn)($966c7c1b681b375a$var$publicPropertiesMap, key) || (0, $jZXzE.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $jZXzE.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $966c7c1b681b375a$var$target;
const $966c7c1b681b375a$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $jZXzE.extend)({}, $966c7c1b681b375a$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $966c7c1b681b375a$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $jZXzE.isGloballyAllowed)(key);
        return has;
    }
});
function $966c7c1b681b375a$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($966c7c1b681b375a$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$966c7c1b681b375a$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $jZXzE.NOOP)
        });
    });
    return target;
}
function $966c7c1b681b375a$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $jZXzE.NOOP)
        });
    });
}
function $966c7c1b681b375a$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $eq3vT.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($966c7c1b681b375a$var$isReservedPrefix(key[0])) {
                $966c7c1b681b375a$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $jZXzE.NOOP)
            });
        }
    });
}
const $966c7c1b681b375a$var$warnRuntimeUsage = (method)=>$966c7c1b681b375a$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $966c7c1b681b375a$export$80b33eababae110e() {
    return null;
}
function $966c7c1b681b375a$export$51ecece22fc17ddc() {
    return null;
}
function $966c7c1b681b375a$export$da25b65ca24b518a(exposed) {}
function $966c7c1b681b375a$export$77e79129327f3d0d(options) {}
function $966c7c1b681b375a$export$1b3acd4bb805b712() {
    return null;
}
function $966c7c1b681b375a$export$acd55aa037e791bb() {}
function $966c7c1b681b375a$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $966c7c1b681b375a$export$9203a8e84125433c() {
    return $966c7c1b681b375a$var$getContext().slots;
}
function $966c7c1b681b375a$export$75e29435042cd2ea() {
    return $966c7c1b681b375a$var$getContext().attrs;
}
function $966c7c1b681b375a$var$getContext() {
    const i = $966c7c1b681b375a$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $966c7c1b681b375a$var$createSetupContext(i));
}
function $966c7c1b681b375a$var$normalizePropsOrEmits(props) {
    return (0, $jZXzE.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $966c7c1b681b375a$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $966c7c1b681b375a$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $jZXzE.isArray)(opt) || (0, $jZXzE.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $966c7c1b681b375a$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $jZXzE.isArray)(a) && (0, $jZXzE.isArray)(b)) return a.concat(b);
    return (0, $jZXzE.extend)({}, $966c7c1b681b375a$var$normalizePropsOrEmits(a), $966c7c1b681b375a$var$normalizePropsOrEmits(b));
}
function $966c7c1b681b375a$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $966c7c1b681b375a$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $966c7c1b681b375a$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $966c7c1b681b375a$var$unsetCurrentInstance();
    if ((0, $jZXzE.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $966c7c1b681b375a$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$966c7c1b681b375a$var$setCurrentInstance(ctx)
    ];
}
function $966c7c1b681b375a$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $966c7c1b681b375a$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $966c7c1b681b375a$var$shouldCacheAccess = true;
function $966c7c1b681b375a$var$applyOptions(instance) {
    const options = $966c7c1b681b375a$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $966c7c1b681b375a$var$shouldCacheAccess = false;
    if (options.beforeCreate) $966c7c1b681b375a$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $966c7c1b681b375a$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $jZXzE.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $jZXzE.isObject)(data)) ;
        else instance.data = (0, $eq3vT.reactive)(data);
    }
    $966c7c1b681b375a$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $jZXzE.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $jZXzE.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $jZXzE.NOOP);
        const set = !(0, $jZXzE.isFunction)(opt) && (0, $jZXzE.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $jZXzE.NOOP);
        const c = $966c7c1b681b375a$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$966c7c1b681b375a$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $jZXzE.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $966c7c1b681b375a$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $966c7c1b681b375a$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $jZXzE.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($966c7c1b681b375a$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($966c7c1b681b375a$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($966c7c1b681b375a$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($966c7c1b681b375a$export$5876c47052fb88b1, updated);
    registerLifecycleHook($966c7c1b681b375a$export$ba52d824b95a2154, activated);
    registerLifecycleHook($966c7c1b681b375a$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($966c7c1b681b375a$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($966c7c1b681b375a$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($966c7c1b681b375a$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($966c7c1b681b375a$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($966c7c1b681b375a$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($966c7c1b681b375a$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $jZXzE.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $jZXzE.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $966c7c1b681b375a$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $jZXzE.NOOP)) {
    if ((0, $jZXzE.isArray)(injectOptions)) injectOptions = $966c7c1b681b375a$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $jZXzE.isObject)(opt)) {
            if ("default" in opt) injected = $966c7c1b681b375a$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $966c7c1b681b375a$export$a976684a0efeb93f(opt.from || key);
        } else injected = $966c7c1b681b375a$export$a976684a0efeb93f(opt);
        if ((0, $eq3vT.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $966c7c1b681b375a$var$callHook(hook, instance, type) {
    $966c7c1b681b375a$export$dae85862a8d94378((0, $jZXzE.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $966c7c1b681b375a$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $966c7c1b681b375a$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $jZXzE.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $jZXzE.isFunction)(handler)) $966c7c1b681b375a$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $jZXzE.isFunction)(raw)) $966c7c1b681b375a$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $jZXzE.isObject)(raw)) {
        if ((0, $jZXzE.isArray)(raw)) raw.forEach((r)=>$966c7c1b681b375a$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $jZXzE.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $jZXzE.isFunction)(handler)) $966c7c1b681b375a$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $966c7c1b681b375a$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$966c7c1b681b375a$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $966c7c1b681b375a$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $jZXzE.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $966c7c1b681b375a$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $966c7c1b681b375a$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$966c7c1b681b375a$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $966c7c1b681b375a$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $966c7c1b681b375a$var$internalOptionMergeStrats = {
    data: $966c7c1b681b375a$var$mergeDataFn,
    props: $966c7c1b681b375a$var$mergeEmitsOrPropsOptions,
    emits: $966c7c1b681b375a$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $966c7c1b681b375a$var$mergeObjectOptions,
    computed: $966c7c1b681b375a$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $966c7c1b681b375a$var$mergeAsArray,
    created: $966c7c1b681b375a$var$mergeAsArray,
    beforeMount: $966c7c1b681b375a$var$mergeAsArray,
    mounted: $966c7c1b681b375a$var$mergeAsArray,
    beforeUpdate: $966c7c1b681b375a$var$mergeAsArray,
    updated: $966c7c1b681b375a$var$mergeAsArray,
    beforeDestroy: $966c7c1b681b375a$var$mergeAsArray,
    beforeUnmount: $966c7c1b681b375a$var$mergeAsArray,
    destroyed: $966c7c1b681b375a$var$mergeAsArray,
    unmounted: $966c7c1b681b375a$var$mergeAsArray,
    activated: $966c7c1b681b375a$var$mergeAsArray,
    deactivated: $966c7c1b681b375a$var$mergeAsArray,
    errorCaptured: $966c7c1b681b375a$var$mergeAsArray,
    serverPrefetch: $966c7c1b681b375a$var$mergeAsArray,
    // assets
    components: $966c7c1b681b375a$var$mergeObjectOptions,
    directives: $966c7c1b681b375a$var$mergeObjectOptions,
    // watch
    watch: $966c7c1b681b375a$var$mergeWatchOptions,
    // provide / inject
    provide: $966c7c1b681b375a$var$mergeDataFn,
    inject: $966c7c1b681b375a$var$mergeInject
};
function $966c7c1b681b375a$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $jZXzE.extend)((0, $jZXzE.isFunction)(to) ? to.call(this, this) : to, (0, $jZXzE.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $966c7c1b681b375a$var$mergeInject(to, from) {
    return $966c7c1b681b375a$var$mergeObjectOptions($966c7c1b681b375a$var$normalizeInject(to), $966c7c1b681b375a$var$normalizeInject(from));
}
function $966c7c1b681b375a$var$normalizeInject(raw) {
    if ((0, $jZXzE.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $966c7c1b681b375a$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $966c7c1b681b375a$var$mergeObjectOptions(to, from) {
    return to ? (0, $jZXzE.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $966c7c1b681b375a$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $jZXzE.isArray)(to) && (0, $jZXzE.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $jZXzE.extend)(/* @__PURE__ */ Object.create(null), $966c7c1b681b375a$var$normalizePropsOrEmits(to), $966c7c1b681b375a$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $966c7c1b681b375a$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $jZXzE.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $966c7c1b681b375a$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $966c7c1b681b375a$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $jZXzE.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $966c7c1b681b375a$var$uid$1 = 0;
function $966c7c1b681b375a$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $jZXzE.isFunction)(rootComponent)) rootComponent = (0, $jZXzE.extend)({}, rootComponent);
        if (rootProps != null && !(0, $jZXzE.isObject)(rootProps)) rootProps = null;
        const context = $966c7c1b681b375a$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $966c7c1b681b375a$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $966c7c1b681b375a$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $jZXzE.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $jZXzE.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $966c7c1b681b375a$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $966c7c1b681b375a$var$devtoolsInitApp(app, $966c7c1b681b375a$export$83d89fbfd8236492);
                    }
                    return $966c7c1b681b375a$var$getComponentPublicInstance(vnode.component);
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $966c7c1b681b375a$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $966c7c1b681b375a$var$currentApp;
                $966c7c1b681b375a$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $966c7c1b681b375a$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $966c7c1b681b375a$var$currentApp = null;
function $966c7c1b681b375a$export$abe1e183e22e10ad(key, value) {
    if (!$966c7c1b681b375a$var$currentInstance) ;
    else {
        let provides = $966c7c1b681b375a$var$currentInstance.provides;
        const parentProvides = $966c7c1b681b375a$var$currentInstance.parent && $966c7c1b681b375a$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $966c7c1b681b375a$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $966c7c1b681b375a$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $966c7c1b681b375a$var$currentInstance || $966c7c1b681b375a$var$currentRenderingInstance;
    if (instance || $966c7c1b681b375a$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $966c7c1b681b375a$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $jZXzE.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $966c7c1b681b375a$export$caf6761f24fc571a() {
    return !!($966c7c1b681b375a$var$currentInstance || $966c7c1b681b375a$var$currentRenderingInstance || $966c7c1b681b375a$var$currentApp);
}
const $966c7c1b681b375a$var$internalObjectProto = {};
const $966c7c1b681b375a$var$createInternalObject = ()=>Object.create($966c7c1b681b375a$var$internalObjectProto);
const $966c7c1b681b375a$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $966c7c1b681b375a$var$internalObjectProto;
function $966c7c1b681b375a$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $966c7c1b681b375a$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $966c7c1b681b375a$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $eq3vT.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $966c7c1b681b375a$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $966c7c1b681b375a$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $eq3vT.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($966c7c1b681b375a$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $jZXzE.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $jZXzE.camelize)(key);
                        props[camelizedKey] = $966c7c1b681b375a$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($966c7c1b681b375a$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $jZXzE.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $jZXzE.hyphenate)(key)) === key || !(0, $jZXzE.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $966c7c1b681b375a$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $jZXzE.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $eq3vT.trigger)(instance.attrs, "set", "");
}
function $966c7c1b681b375a$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $jZXzE.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $jZXzE.hasOwn)(options, camelKey = (0, $jZXzE.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$966c7c1b681b375a$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $eq3vT.toRaw)(props);
        const castValues = rawCastValues || (0, $jZXzE.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $966c7c1b681b375a$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $jZXzE.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $966c7c1b681b375a$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $jZXzE.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $jZXzE.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $966c7c1b681b375a$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $jZXzE.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $966c7c1b681b375a$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $jZXzE.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $966c7c1b681b375a$var$normalizePropsOptions(raw2, appContext, true);
            (0, $jZXzE.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $jZXzE.isObject)(comp)) cache.set(comp, (0, $jZXzE.EMPTY_ARR));
        return 0, $jZXzE.EMPTY_ARR;
    }
    if ((0, $jZXzE.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $jZXzE.camelize)(raw[i]);
        if ($966c7c1b681b375a$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $jZXzE.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $jZXzE.camelize)(key);
        if ($966c7c1b681b375a$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $jZXzE.isArray)(opt) || (0, $jZXzE.isFunction)(opt) ? {
                type: opt
            } : (0, $jZXzE.extend)({}, opt);
            if (prop) {
                const booleanIndex = $966c7c1b681b375a$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $966c7c1b681b375a$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $jZXzE.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $jZXzE.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $966c7c1b681b375a$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $jZXzE.isReservedProp)(key)) return true;
    return false;
}
function $966c7c1b681b375a$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $966c7c1b681b375a$var$isSameType(a, b) {
    return $966c7c1b681b375a$var$getType(a) === $966c7c1b681b375a$var$getType(b);
}
function $966c7c1b681b375a$var$getTypeIndex(type, expectedTypes) {
    if ((0, $jZXzE.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$966c7c1b681b375a$var$isSameType(t, type));
    else if ((0, $jZXzE.isFunction)(expectedTypes)) return $966c7c1b681b375a$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $966c7c1b681b375a$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $eq3vT.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $966c7c1b681b375a$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $jZXzE.hasOwn)(rawProps, key) && !(0, $jZXzE.hasOwn)(rawProps, (0, $jZXzE.hyphenate)(key)));
    }
}
function $966c7c1b681b375a$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $966c7c1b681b375a$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $jZXzE.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $966c7c1b681b375a$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $966c7c1b681b375a$var$warn$1($966c7c1b681b375a$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $966c7c1b681b375a$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $966c7c1b681b375a$var$isSimpleType = /* @__PURE__ */ (0, $jZXzE.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $966c7c1b681b375a$var$assertType(value, type) {
    let valid;
    const expectedType = $966c7c1b681b375a$var$getType(type);
    if ($966c7c1b681b375a$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $jZXzE.isObject)(value);
    else if (expectedType === "Array") valid = (0, $jZXzE.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $966c7c1b681b375a$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $jZXzE.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $jZXzE.toRawType)(value);
    const expectedValue = $966c7c1b681b375a$var$styleValue(value, expectedType);
    const receivedValue = $966c7c1b681b375a$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $966c7c1b681b375a$var$isExplicable(expectedType) && !$966c7c1b681b375a$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($966c7c1b681b375a$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $966c7c1b681b375a$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $966c7c1b681b375a$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $966c7c1b681b375a$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $966c7c1b681b375a$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $966c7c1b681b375a$var$normalizeSlotValue = (value)=>(0, $jZXzE.isArray)(value) ? value.map($966c7c1b681b375a$var$normalizeVNode) : [
        $966c7c1b681b375a$var$normalizeVNode(value)
    ];
const $966c7c1b681b375a$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $966c7c1b681b375a$export$694b237e827a3d23((...args)=>{
        return $966c7c1b681b375a$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $966c7c1b681b375a$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($966c7c1b681b375a$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $jZXzE.isFunction)(value)) slots[key] = $966c7c1b681b375a$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $966c7c1b681b375a$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $966c7c1b681b375a$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $966c7c1b681b375a$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $966c7c1b681b375a$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $966c7c1b681b375a$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $jZXzE.extend)(slots, children);
            (0, $jZXzE.def)(slots, "_", type, true);
        } else $966c7c1b681b375a$var$normalizeObjectSlots(children, slots);
    } else if (children) $966c7c1b681b375a$var$normalizeVNodeSlots(instance, children);
};
const $966c7c1b681b375a$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $jZXzE.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $jZXzE.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $966c7c1b681b375a$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $966c7c1b681b375a$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$966c7c1b681b375a$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $966c7c1b681b375a$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $jZXzE.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$966c7c1b681b375a$var$setRef(r, oldRawRef && ((0, $jZXzE.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($966c7c1b681b375a$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $966c7c1b681b375a$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $jZXzE.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $jZXzE.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $jZXzE.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $eq3vT.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $jZXzE.isFunction)(ref)) $966c7c1b681b375a$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $jZXzE.isString)(ref);
        const _isRef = (0, $eq3vT.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $jZXzE.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $jZXzE.isArray)(existing) && (0, $jZXzE.remove)(existing, refValue);
                    else {
                        if (!(0, $jZXzE.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $jZXzE.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $jZXzE.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $966c7c1b681b375a$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $966c7c1b681b375a$var$hasLoggedMismatchError = false;
const $966c7c1b681b375a$var$logMismatchError = ()=>{
    if ($966c7c1b681b375a$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $966c7c1b681b375a$var$hasLoggedMismatchError = true;
};
const $966c7c1b681b375a$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $966c7c1b681b375a$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $966c7c1b681b375a$var$getContainerType = (container)=>{
    if ($966c7c1b681b375a$var$isSVGContainer(container)) return "svg";
    if ($966c7c1b681b375a$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $966c7c1b681b375a$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $966c7c1b681b375a$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $966c7c1b681b375a$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $966c7c1b681b375a$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $966c7c1b681b375a$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $966c7c1b681b375a$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $jZXzE.def)(node, "__vnode", vnode, true);
            (0, $jZXzE.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $966c7c1b681b375a$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $966c7c1b681b375a$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $966c7c1b681b375a$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $966c7c1b681b375a$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $966c7c1b681b375a$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $966c7c1b681b375a$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($966c7c1b681b375a$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $966c7c1b681b375a$var$getContainerType(container), optimized);
                    if ($966c7c1b681b375a$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $966c7c1b681b375a$export$22f9b5ffd89dac9("") : $966c7c1b681b375a$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $966c7c1b681b375a$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $966c7c1b681b375a$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $966c7c1b681b375a$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $966c7c1b681b375a$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $966c7c1b681b375a$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $966c7c1b681b375a$var$logMismatchError();
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $966c7c1b681b375a$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    $966c7c1b681b375a$var$logMismatchError();
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                    // as it could have mutated the DOM in any possible way
                    !(dirs && dirs.some((d)=>d.dir.created)) && $966c7c1b681b375a$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $966c7c1b681b375a$var$logMismatchError();
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $jZXzE.isOn)(key) && !(0, $jZXzE.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $966c7c1b681b375a$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $966c7c1b681b375a$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $966c7c1b681b375a$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $966c7c1b681b375a$export$5f1af8db9871e1d6 && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $966c7c1b681b375a$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                $966c7c1b681b375a$var$logMismatchError();
                patch(null, vnode, container, null, parentComponent, parentSuspense, $966c7c1b681b375a$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $966c7c1b681b375a$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $966c7c1b681b375a$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $966c7c1b681b375a$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $966c7c1b681b375a$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        $966c7c1b681b375a$var$logMismatchError();
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $966c7c1b681b375a$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $966c7c1b681b375a$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $966c7c1b681b375a$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $jZXzE.normalizeClass)(clientValue);
        if (!$966c7c1b681b375a$var$isSetEqual($966c7c1b681b375a$var$toClassSet(actual || ""), $966c7c1b681b375a$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $jZXzE.isString)(clientValue) ? clientValue : (0, $jZXzE.stringifyStyle)((0, $jZXzE.normalizeStyle)(clientValue));
        const actualMap = $966c7c1b681b375a$var$toStyleMap(actual);
        const expectedMap = $966c7c1b681b375a$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $966c7c1b681b375a$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$966c7c1b681b375a$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $jZXzE.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $jZXzE.isBooleanAttr)(key) || (0, $jZXzE.isKnownHtmlAttr)(key))) {
        if ((0, $jZXzE.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $jZXzE.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $jZXzE.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $966c7c1b681b375a$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $966c7c1b681b375a$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $966c7c1b681b375a$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $966c7c1b681b375a$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $966c7c1b681b375a$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $966c7c1b681b375a$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $966c7c1b681b375a$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${key}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $966c7c1b681b375a$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
let $966c7c1b681b375a$var$supported;
let $966c7c1b681b375a$var$perf;
function $966c7c1b681b375a$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $966c7c1b681b375a$var$isSupported()) $966c7c1b681b375a$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsPerfStart(instance, type, $966c7c1b681b375a$var$isSupported() ? $966c7c1b681b375a$var$perf.now() : Date.now());
}
function $966c7c1b681b375a$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $966c7c1b681b375a$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $966c7c1b681b375a$var$perf.mark(endTag);
        $966c7c1b681b375a$var$perf.measure(`<${$966c7c1b681b375a$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $966c7c1b681b375a$var$perf.clearMarks(startTag);
        $966c7c1b681b375a$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsPerfEnd(instance, type, $966c7c1b681b375a$var$isSupported() ? $966c7c1b681b375a$var$perf.now() : Date.now());
}
function $966c7c1b681b375a$var$isSupported() {
    if ($966c7c1b681b375a$var$supported !== void 0) return $966c7c1b681b375a$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $966c7c1b681b375a$var$supported = true;
        $966c7c1b681b375a$var$perf = window.performance;
    } else $966c7c1b681b375a$var$supported = false;
    return $966c7c1b681b375a$var$supported;
}
function $966c7c1b681b375a$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $jZXzE.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $jZXzE.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $jZXzE.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $966c7c1b681b375a$var$queuePostRenderEffect = $966c7c1b681b375a$var$queueEffectWithSuspense;
function $966c7c1b681b375a$export$53ae2f996c64e9a(options) {
    return $966c7c1b681b375a$var$baseCreateRenderer(options);
}
function $966c7c1b681b375a$export$200524cf0d997ff0(options) {
    return $966c7c1b681b375a$var$baseCreateRenderer(options, $966c7c1b681b375a$var$createHydrationFunctions);
}
function $966c7c1b681b375a$var$baseCreateRenderer(options, createHydrationFns) {
    $966c7c1b681b375a$var$initFeatureFlags();
    const target = (0, $jZXzE.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $jZXzE.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$966c7c1b681b375a$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $966c7c1b681b375a$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $966c7c1b681b375a$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $966c7c1b681b375a$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $966c7c1b681b375a$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $966c7c1b681b375a$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $966c7c1b681b375a$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $jZXzE.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $jZXzE.def)(el, "__vnode", vnode, true);
            (0, $jZXzE.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $966c7c1b681b375a$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
            vnodeHook && $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $966c7c1b681b375a$var$cloneIfMounted(children[i]) : $966c7c1b681b375a$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $jZXzE.EMPTY_OBJ);
        const newProps = n2.props || (0, $jZXzE.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $966c7c1b681b375a$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $966c7c1b681b375a$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $966c7c1b681b375a$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $966c7c1b681b375a$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $966c7c1b681b375a$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
            vnodeHook && $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $966c7c1b681b375a$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $966c7c1b681b375a$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$966c7c1b681b375a$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $jZXzE.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $jZXzE.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $jZXzE.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $966c7c1b681b375a$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $966c7c1b681b375a$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($966c7c1b681b375a$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $966c7c1b681b375a$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($966c7c1b681b375a$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $966c7c1b681b375a$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $966c7c1b681b375a$var$isAsyncWrapper(initialVNode);
                $966c7c1b681b375a$var$toggleRecurse(instance, false);
                if (bm) (0, $jZXzE.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $966c7c1b681b375a$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $966c7c1b681b375a$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $966c7c1b681b375a$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $966c7c1b681b375a$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $966c7c1b681b375a$var$queuePostRenderEffect(()=>$966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $966c7c1b681b375a$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $966c7c1b681b375a$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $966c7c1b681b375a$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $966c7c1b681b375a$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $jZXzE.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $966c7c1b681b375a$var$toggleRecurse(instance, true);
                const nextTree = $966c7c1b681b375a$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $966c7c1b681b375a$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $966c7c1b681b375a$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $966c7c1b681b375a$var$queuePostRenderEffect(()=>$966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $eq3vT.ReactiveEffect)(componentUpdateFn, (0, $jZXzE.NOOP), ()=>$966c7c1b681b375a$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $966c7c1b681b375a$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $966c7c1b681b375a$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $966c7c1b681b375a$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $eq3vT.pauseTracking)();
        $966c7c1b681b375a$var$flushPreFlushCbs(instance);
        (0, $eq3vT.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $jZXzE.EMPTY_ARR);
        c2 = c2 || (0, $jZXzE.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $966c7c1b681b375a$var$cloneIfMounted(c2[i]) : $966c7c1b681b375a$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $966c7c1b681b375a$var$cloneIfMounted(c2[i]) : $966c7c1b681b375a$var$normalizeVNode(c2[i]);
            if ($966c7c1b681b375a$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $966c7c1b681b375a$var$cloneIfMounted(c2[e2]) : $966c7c1b681b375a$var$normalizeVNode(c2[e2]);
            if ($966c7c1b681b375a$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $966c7c1b681b375a$var$cloneIfMounted(c2[i]) : $966c7c1b681b375a$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $966c7c1b681b375a$var$cloneIfMounted(c2[i]) : $966c7c1b681b375a$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $966c7c1b681b375a$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $966c7c1b681b375a$var$getSequence(newIndexToOldIndexMap) : (0, $jZXzE.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $966c7c1b681b375a$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $966c7c1b681b375a$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $966c7c1b681b375a$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, memoIndex: memoIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) $966c7c1b681b375a$var$setRef(ref, null, parentSuspense, vnode, true);
        if (memoIndex != null) parentComponent.renderCache[memoIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$966c7c1b681b375a$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $966c7c1b681b375a$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $966c7c1b681b375a$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
            vnodeHook && $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $966c7c1b681b375a$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $966c7c1b681b375a$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $966c7c1b681b375a$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um, m: m, a: a } = instance;
        $966c7c1b681b375a$var$invalidateMount(m);
        $966c7c1b681b375a$var$invalidateMount(a);
        if (bum) (0, $jZXzE.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $966c7c1b681b375a$var$queuePostRenderEffect(um, parentSuspense);
        $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $966c7c1b681b375a$var$flushPreFlushCbs();
            $966c7c1b681b375a$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $966c7c1b681b375a$var$createAppAPI(render, hydrate)
    };
}
function $966c7c1b681b375a$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $966c7c1b681b375a$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $966c7c1b681b375a$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $966c7c1b681b375a$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $jZXzE.isArray)(ch1) && (0, $jZXzE.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $966c7c1b681b375a$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $966c7c1b681b375a$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $966c7c1b681b375a$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $966c7c1b681b375a$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $966c7c1b681b375a$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $966c7c1b681b375a$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $966c7c1b681b375a$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].active = false;
}
const $966c7c1b681b375a$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $966c7c1b681b375a$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $966c7c1b681b375a$export$a976684a0efeb93f($966c7c1b681b375a$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $966c7c1b681b375a$export$ede35fc0e5500309(effect, options) {
    return $966c7c1b681b375a$var$doWatch(effect, null, options);
}
function $966c7c1b681b375a$export$b7f27ea67102d543(effect, options) {
    return $966c7c1b681b375a$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $966c7c1b681b375a$export$2035654f31b0e555(effect, options) {
    return $966c7c1b681b375a$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $966c7c1b681b375a$var$INITIAL_WATCHER_VALUE = {};
function $966c7c1b681b375a$export$3db5d71bdb2d5499(source, cb, options) {
    return $966c7c1b681b375a$var$doWatch(source, cb, options);
}
function $966c7c1b681b375a$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $jZXzE.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $966c7c1b681b375a$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $966c7c1b681b375a$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $966c7c1b681b375a$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $eq3vT.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $eq3vT.isShallow)(source);
    } else if ((0, $eq3vT.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $jZXzE.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $eq3vT.isReactive)(s) || (0, $eq3vT.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $eq3vT.isRef)(s)) return s.value;
                else if ((0, $eq3vT.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $jZXzE.isFunction)(s)) return $966c7c1b681b375a$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $jZXzE.isFunction)(source)) {
        if (cb) getter = ()=>$966c7c1b681b375a$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $966c7c1b681b375a$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $jZXzE.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$966c7c1b681b375a$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $966c7c1b681b375a$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($966c7c1b681b375a$var$isInSSRComponentSetup) {
        onCleanup = (0, $jZXzE.NOOP);
        if (!cb) getter();
        else if (immediate) $966c7c1b681b375a$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $966c7c1b681b375a$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $jZXzE.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($966c7c1b681b375a$var$INITIAL_WATCHER_VALUE) : $966c7c1b681b375a$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $jZXzE.hasChanged)(v1, oldValue[i])) : (0, $jZXzE.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $966c7c1b681b375a$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $966c7c1b681b375a$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $966c7c1b681b375a$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$966c7c1b681b375a$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$966c7c1b681b375a$var$queueJob(job);
    }
    const effect = new (0, $eq3vT.ReactiveEffect)(getter, (0, $jZXzE.NOOP), scheduler);
    const scope = (0, $eq3vT.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $jZXzE.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $966c7c1b681b375a$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $966c7c1b681b375a$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $jZXzE.isString)(source) ? source.includes(".") ? $966c7c1b681b375a$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $jZXzE.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $966c7c1b681b375a$var$setCurrentInstance(this);
    const res = $966c7c1b681b375a$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $966c7c1b681b375a$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $966c7c1b681b375a$var$traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $jZXzE.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, $eq3vT.isRef)(value)) $966c7c1b681b375a$var$traverse(value.value, depth, seen);
    else if ((0, $jZXzE.isArray)(value)) for(let i = 0; i < value.length; i++)$966c7c1b681b375a$var$traverse(value[i], depth, seen);
    else if ((0, $jZXzE.isSet)(value) || (0, $jZXzE.isMap)(value)) value.forEach((v1)=>{
        $966c7c1b681b375a$var$traverse(v1, depth, seen);
    });
    else if ((0, $jZXzE.isPlainObject)(value)) {
        for(const key in value)$966c7c1b681b375a$var$traverse(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $966c7c1b681b375a$var$traverse(value[key], depth, seen);
    }
    return value;
}
const $966c7c1b681b375a$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $966c7c1b681b375a$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $966c7c1b681b375a$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $jZXzE.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $966c7c1b681b375a$var$invalidateMount(instance2.m);
            $966c7c1b681b375a$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $jZXzE.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $966c7c1b681b375a$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $966c7c1b681b375a$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $966c7c1b681b375a$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $966c7c1b681b375a$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$966c7c1b681b375a$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $966c7c1b681b375a$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $966c7c1b681b375a$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$966c7c1b681b375a$var$matches(include, name));
            exclude && pruneCache((name)=>!$966c7c1b681b375a$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($966c7c1b681b375a$var$isSuspense(instance.subTree.type)) $966c7c1b681b375a$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $966c7c1b681b375a$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $966c7c1b681b375a$var$getInnerChild(instance.subTree));
            }
        };
        $966c7c1b681b375a$export$6d1641039221b5cb(cacheSubtree);
        $966c7c1b681b375a$export$5876c47052fb88b1(cacheSubtree);
        $966c7c1b681b375a$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $966c7c1b681b375a$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $966c7c1b681b375a$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $966c7c1b681b375a$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$966c7c1b681b375a$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $966c7c1b681b375a$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $966c7c1b681b375a$var$getComponentName($966c7c1b681b375a$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$966c7c1b681b375a$var$matches(include, name)) || exclude && name && $966c7c1b681b375a$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $966c7c1b681b375a$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $966c7c1b681b375a$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $966c7c1b681b375a$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $966c7c1b681b375a$export$70eb8a58709972df = $966c7c1b681b375a$var$KeepAliveImpl;
function $966c7c1b681b375a$var$matches(pattern, name) {
    if ((0, $jZXzE.isArray)(pattern)) return pattern.some((p)=>$966c7c1b681b375a$var$matches(p, name));
    else if ((0, $jZXzE.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $jZXzE.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $966c7c1b681b375a$export$ba52d824b95a2154(hook, target) {
    $966c7c1b681b375a$var$registerKeepAliveHook(hook, "a", target);
}
function $966c7c1b681b375a$export$bf1440eeaf5fa709(hook, target) {
    $966c7c1b681b375a$var$registerKeepAliveHook(hook, "da", target);
}
function $966c7c1b681b375a$var$registerKeepAliveHook(hook, type, target = $966c7c1b681b375a$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $966c7c1b681b375a$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($966c7c1b681b375a$var$isKeepAlive(current.parent.vnode)) $966c7c1b681b375a$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $966c7c1b681b375a$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $966c7c1b681b375a$var$injectHook(type, hook, keepAliveRoot, true);
    $966c7c1b681b375a$export$13348a43ccacfe58(()=>{
        (0, $jZXzE.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $966c7c1b681b375a$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $966c7c1b681b375a$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
const $966c7c1b681b375a$var$leaveCbKey = Symbol("_leaveCb");
const $966c7c1b681b375a$var$enterCbKey = Symbol("_enterCb");
function $966c7c1b681b375a$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $966c7c1b681b375a$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $966c7c1b681b375a$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $966c7c1b681b375a$var$TransitionHookValidator = [
    Function,
    Array
];
const $966c7c1b681b375a$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $966c7c1b681b375a$var$TransitionHookValidator,
    onEnter: $966c7c1b681b375a$var$TransitionHookValidator,
    onAfterEnter: $966c7c1b681b375a$var$TransitionHookValidator,
    onEnterCancelled: $966c7c1b681b375a$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $966c7c1b681b375a$var$TransitionHookValidator,
    onLeave: $966c7c1b681b375a$var$TransitionHookValidator,
    onAfterLeave: $966c7c1b681b375a$var$TransitionHookValidator,
    onLeaveCancelled: $966c7c1b681b375a$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $966c7c1b681b375a$var$TransitionHookValidator,
    onAppear: $966c7c1b681b375a$var$TransitionHookValidator,
    onAfterAppear: $966c7c1b681b375a$var$TransitionHookValidator,
    onAppearCancelled: $966c7c1b681b375a$var$TransitionHookValidator
};
const $966c7c1b681b375a$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $966c7c1b681b375a$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $966c7c1b681b375a$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $966c7c1b681b375a$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $966c7c1b681b375a$export$f13e630aa3915748();
        const state = $966c7c1b681b375a$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $966c7c1b681b375a$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $966c7c1b681b375a$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $eq3vT.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $966c7c1b681b375a$var$emptyPlaceholder(child);
            const innerChild = $966c7c1b681b375a$var$getKeepAliveChild(child);
            if (!innerChild) return $966c7c1b681b375a$var$emptyPlaceholder(child);
            let enterHooks = $966c7c1b681b375a$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            $966c7c1b681b375a$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $966c7c1b681b375a$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $966c7c1b681b375a$export$4d299b491347818a && !$966c7c1b681b375a$var$isSameVNodeType(innerChild, oldInnerChild) && $966c7c1b681b375a$var$recursiveGetSubtree(instance).type !== $966c7c1b681b375a$export$4d299b491347818a) {
                const leavingHooks = $966c7c1b681b375a$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $966c7c1b681b375a$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $966c7c1b681b375a$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $966c7c1b681b375a$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $966c7c1b681b375a$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $966c7c1b681b375a$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$966c7c1b681b375a$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$966c7c1b681b375a$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $966c7c1b681b375a$export$abd95b5f5e8a8837 = $966c7c1b681b375a$var$BaseTransitionImpl;
function $966c7c1b681b375a$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $966c7c1b681b375a$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $966c7c1b681b375a$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $966c7c1b681b375a$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $jZXzE.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$966c7c1b681b375a$var$leaveCbKey]) el[$966c7c1b681b375a$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $966c7c1b681b375a$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$966c7c1b681b375a$var$leaveCbKey]) leavingVNode.el[$966c7c1b681b375a$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$966c7c1b681b375a$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$966c7c1b681b375a$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$966c7c1b681b375a$var$enterCbKey]) el[$966c7c1b681b375a$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$966c7c1b681b375a$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$966c7c1b681b375a$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $966c7c1b681b375a$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $966c7c1b681b375a$var$emptyPlaceholder(vnode) {
    if ($966c7c1b681b375a$var$isKeepAlive(vnode)) {
        vnode = $966c7c1b681b375a$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $966c7c1b681b375a$var$getKeepAliveChild(vnode) {
    if (!$966c7c1b681b375a$var$isKeepAlive(vnode)) return vnode;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $jZXzE.isFunction)(children.default)) return children.default();
    }
}
function $966c7c1b681b375a$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $966c7c1b681b375a$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $966c7c1b681b375a$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $966c7c1b681b375a$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($966c7c1b681b375a$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $966c7c1b681b375a$export$4d299b491347818a) ret.push(key != null ? $966c7c1b681b375a$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
const $966c7c1b681b375a$var$isTeleport = (type)=>type.__isTeleport;
const $966c7c1b681b375a$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $966c7c1b681b375a$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $966c7c1b681b375a$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $966c7c1b681b375a$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $jZXzE.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $966c7c1b681b375a$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $966c7c1b681b375a$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $966c7c1b681b375a$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $966c7c1b681b375a$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $966c7c1b681b375a$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $966c7c1b681b375a$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $966c7c1b681b375a$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $966c7c1b681b375a$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $966c7c1b681b375a$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $966c7c1b681b375a$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $966c7c1b681b375a$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $966c7c1b681b375a$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $966c7c1b681b375a$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $966c7c1b681b375a$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$966c7c1b681b375a$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $966c7c1b681b375a$var$moveTeleport,
    hydrate: $966c7c1b681b375a$var$hydrateTeleport
};
function $966c7c1b681b375a$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $966c7c1b681b375a$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $966c7c1b681b375a$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $966c7c1b681b375a$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($966c7c1b681b375a$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $966c7c1b681b375a$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $966c7c1b681b375a$export$76d55a0304a371f4 = $966c7c1b681b375a$var$TeleportImpl;
function $966c7c1b681b375a$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $966c7c1b681b375a$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $966c7c1b681b375a$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $966c7c1b681b375a$export$4d299b491347818a = Symbol.for("v-cmt");
const $966c7c1b681b375a$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $966c7c1b681b375a$var$blockStack = [];
let $966c7c1b681b375a$var$currentBlock = null;
function $966c7c1b681b375a$export$e7eaa45e502fe5cc(disableTracking = false) {
    $966c7c1b681b375a$var$blockStack.push($966c7c1b681b375a$var$currentBlock = disableTracking ? null : []);
}
function $966c7c1b681b375a$var$closeBlock() {
    $966c7c1b681b375a$var$blockStack.pop();
    $966c7c1b681b375a$var$currentBlock = $966c7c1b681b375a$var$blockStack[$966c7c1b681b375a$var$blockStack.length - 1] || null;
}
let $966c7c1b681b375a$var$isBlockTreeEnabled = 1;
function $966c7c1b681b375a$export$c20bee82f26f1e27(value) {
    $966c7c1b681b375a$var$isBlockTreeEnabled += value;
}
function $966c7c1b681b375a$var$setupBlock(vnode) {
    vnode.dynamicChildren = $966c7c1b681b375a$var$isBlockTreeEnabled > 0 ? $966c7c1b681b375a$var$currentBlock || (0, $jZXzE.EMPTY_ARR) : null;
    $966c7c1b681b375a$var$closeBlock();
    if ($966c7c1b681b375a$var$isBlockTreeEnabled > 0 && $966c7c1b681b375a$var$currentBlock) $966c7c1b681b375a$var$currentBlock.push(vnode);
    return vnode;
}
function $966c7c1b681b375a$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $966c7c1b681b375a$var$setupBlock($966c7c1b681b375a$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $966c7c1b681b375a$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $966c7c1b681b375a$var$setupBlock($966c7c1b681b375a$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $966c7c1b681b375a$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $966c7c1b681b375a$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $966c7c1b681b375a$var$vnodeArgsTransformer;
function $966c7c1b681b375a$export$83beccd3afeeb809(transformer) {
    $966c7c1b681b375a$var$vnodeArgsTransformer = transformer;
}
const $966c7c1b681b375a$var$createVNodeWithArgsTransform = (...args)=>{
    return $966c7c1b681b375a$var$_createVNode(...$966c7c1b681b375a$var$vnodeArgsTransformer ? $966c7c1b681b375a$var$vnodeArgsTransformer(args, $966c7c1b681b375a$var$currentRenderingInstance) : args);
};
const $966c7c1b681b375a$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $966c7c1b681b375a$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $jZXzE.isString)(ref) || (0, $eq3vT.isRef)(ref) || (0, $jZXzE.isFunction)(ref) ? {
        i: $966c7c1b681b375a$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $966c7c1b681b375a$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $966c7c1b681b375a$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $966c7c1b681b375a$var$normalizeKey(props),
        ref: props && $966c7c1b681b375a$var$normalizeRef(props),
        scopeId: $966c7c1b681b375a$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $966c7c1b681b375a$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $966c7c1b681b375a$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $jZXzE.isString)(children) ? 8 : 16;
    if ($966c7c1b681b375a$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $966c7c1b681b375a$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $966c7c1b681b375a$var$currentBlock.push(vnode);
    return vnode;
}
const $966c7c1b681b375a$export$bf5c4cf060303d58 = $966c7c1b681b375a$var$_createVNode;
function $966c7c1b681b375a$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $966c7c1b681b375a$var$NULL_DYNAMIC_COMPONENT) type = $966c7c1b681b375a$export$4d299b491347818a;
    if ($966c7c1b681b375a$export$3868d13f8734ae81(type)) {
        const cloned = $966c7c1b681b375a$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $966c7c1b681b375a$var$normalizeChildren(cloned, children);
        if ($966c7c1b681b375a$var$isBlockTreeEnabled > 0 && !isBlockNode && $966c7c1b681b375a$var$currentBlock) {
            if (cloned.shapeFlag & 6) $966c7c1b681b375a$var$currentBlock[$966c7c1b681b375a$var$currentBlock.indexOf(type)] = cloned;
            else $966c7c1b681b375a$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($966c7c1b681b375a$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $966c7c1b681b375a$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $jZXzE.isString)(klass)) props.class = (0, $jZXzE.normalizeClass)(klass);
        if ((0, $jZXzE.isObject)(style)) {
            if ((0, $eq3vT.isProxy)(style) && !(0, $jZXzE.isArray)(style)) style = (0, $jZXzE.extend)({}, style);
            props.style = (0, $jZXzE.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $jZXzE.isString)(type) ? 1 : $966c7c1b681b375a$var$isSuspense(type) ? 128 : $966c7c1b681b375a$var$isTeleport(type) ? 64 : (0, $jZXzE.isObject)(type) ? 4 : (0, $jZXzE.isFunction)(type) ? 2 : 0;
    return $966c7c1b681b375a$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $966c7c1b681b375a$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $eq3vT.isProxy)(props) || $966c7c1b681b375a$var$isInternalObject(props) ? (0, $jZXzE.extend)({}, props) : props;
}
function $966c7c1b681b375a$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $966c7c1b681b375a$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $966c7c1b681b375a$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $jZXzE.isArray)(ref) ? ref.concat($966c7c1b681b375a$var$normalizeRef(extraProps)) : [
            ref,
            $966c7c1b681b375a$var$normalizeRef(extraProps)
        ] : $966c7c1b681b375a$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $966c7c1b681b375a$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $966c7c1b681b375a$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $966c7c1b681b375a$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $966c7c1b681b375a$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $966c7c1b681b375a$var$deepCloneVNode(vnode) {
    const cloned = $966c7c1b681b375a$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $jZXzE.isArray)(vnode.children)) cloned.children = vnode.children.map($966c7c1b681b375a$var$deepCloneVNode);
    return cloned;
}
function $966c7c1b681b375a$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$5f1af8db9871e1d6, null, text, flag);
}
function $966c7c1b681b375a$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $966c7c1b681b375a$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($966c7c1b681b375a$export$e7eaa45e502fe5cc(), $966c7c1b681b375a$export$9f2dfe8048dfb22b($966c7c1b681b375a$export$4d299b491347818a, null, text)) : $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$4d299b491347818a, null, text);
}
function $966c7c1b681b375a$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$4d299b491347818a);
    else if ((0, $jZXzE.isArray)(child)) return $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $966c7c1b681b375a$var$cloneIfMounted(child);
    else return $966c7c1b681b375a$export$bf5c4cf060303d58($966c7c1b681b375a$export$5f1af8db9871e1d6, null, String(child));
}
function $966c7c1b681b375a$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $966c7c1b681b375a$export$ee4f9e12c0a92a1a(child);
}
function $966c7c1b681b375a$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $jZXzE.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $966c7c1b681b375a$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$966c7c1b681b375a$var$isInternalObject(children)) children._ctx = $966c7c1b681b375a$var$currentRenderingInstance;
            else if (slotFlag === 3 && $966c7c1b681b375a$var$currentRenderingInstance) {
                if ($966c7c1b681b375a$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $jZXzE.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $966c7c1b681b375a$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $966c7c1b681b375a$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $966c7c1b681b375a$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $jZXzE.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $jZXzE.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $jZXzE.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $jZXzE.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $966c7c1b681b375a$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $966c7c1b681b375a$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $966c7c1b681b375a$var$emptyAppContext = $966c7c1b681b375a$var$createAppContext();
let $966c7c1b681b375a$var$uid = 0;
function $966c7c1b681b375a$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $966c7c1b681b375a$var$emptyAppContext;
    const instance = {
        uid: $966c7c1b681b375a$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $eq3vT.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $966c7c1b681b375a$var$normalizePropsOptions(type, appContext),
        emitsOptions: $966c7c1b681b375a$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $jZXzE.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $jZXzE.EMPTY_OBJ),
        data: (0, $jZXzE.EMPTY_OBJ),
        props: (0, $jZXzE.EMPTY_OBJ),
        attrs: (0, $jZXzE.EMPTY_OBJ),
        slots: (0, $jZXzE.EMPTY_OBJ),
        refs: (0, $jZXzE.EMPTY_OBJ),
        setupState: (0, $jZXzE.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $966c7c1b681b375a$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $966c7c1b681b375a$var$currentInstance = null;
const $966c7c1b681b375a$export$f13e630aa3915748 = ()=>$966c7c1b681b375a$var$currentInstance || $966c7c1b681b375a$var$currentRenderingInstance;
let $966c7c1b681b375a$var$internalSetCurrentInstance;
let $966c7c1b681b375a$var$setInSSRSetupState;
{
    const g = (0, $jZXzE.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $966c7c1b681b375a$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$966c7c1b681b375a$var$currentInstance = v1);
    $966c7c1b681b375a$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$966c7c1b681b375a$var$isInSSRComponentSetup = v1);
}const $966c7c1b681b375a$var$setCurrentInstance = (instance)=>{
    const prev = $966c7c1b681b375a$var$currentInstance;
    $966c7c1b681b375a$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $966c7c1b681b375a$var$internalSetCurrentInstance(prev);
    };
};
const $966c7c1b681b375a$var$unsetCurrentInstance = ()=>{
    $966c7c1b681b375a$var$currentInstance && $966c7c1b681b375a$var$currentInstance.scope.off();
    $966c7c1b681b375a$var$internalSetCurrentInstance(null);
};
const $966c7c1b681b375a$var$isBuiltInTag = /* @__PURE__ */ (0, $jZXzE.makeMap)("slot,component");
function $966c7c1b681b375a$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($966c7c1b681b375a$var$isBuiltInTag(name) || isNativeTag(name)) $966c7c1b681b375a$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $966c7c1b681b375a$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $966c7c1b681b375a$var$isInSSRComponentSetup = false;
function $966c7c1b681b375a$var$setupComponent(instance, isSSR = false) {
    isSSR && $966c7c1b681b375a$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $966c7c1b681b375a$var$isStatefulComponent(instance);
    $966c7c1b681b375a$var$initProps(instance, props, isStateful, isSSR);
    $966c7c1b681b375a$var$initSlots(instance, children);
    const setupResult = isStateful ? $966c7c1b681b375a$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $966c7c1b681b375a$var$setInSSRSetupState(false);
    return setupResult;
}
function $966c7c1b681b375a$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $966c7c1b681b375a$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $966c7c1b681b375a$var$createSetupContext(instance) : null;
        const reset = $966c7c1b681b375a$var$setCurrentInstance(instance);
        (0, $eq3vT.pauseTracking)();
        const setupResult = $966c7c1b681b375a$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $eq3vT.resetTracking)();
        reset();
        if ((0, $jZXzE.isPromise)(setupResult)) {
            setupResult.then($966c7c1b681b375a$var$unsetCurrentInstance, $966c7c1b681b375a$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $966c7c1b681b375a$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $966c7c1b681b375a$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $966c7c1b681b375a$var$handleSetupResult(instance, setupResult, isSSR);
    } else $966c7c1b681b375a$var$finishComponentSetup(instance, isSSR);
}
function $966c7c1b681b375a$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $jZXzE.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $jZXzE.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $eq3vT.proxyRefs)(setupResult);
    }
    $966c7c1b681b375a$var$finishComponentSetup(instance, isSSR);
}
let $966c7c1b681b375a$var$compile;
let $966c7c1b681b375a$var$installWithProxy;
function $966c7c1b681b375a$export$667bb5a67822b941(_compile) {
    $966c7c1b681b375a$var$compile = _compile;
    $966c7c1b681b375a$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $966c7c1b681b375a$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $966c7c1b681b375a$export$c93a9c496c5211fa = ()=>!$966c7c1b681b375a$var$compile;
function $966c7c1b681b375a$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $966c7c1b681b375a$var$compile && !Component.render) {
            const template = Component.template || $966c7c1b681b375a$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $jZXzE.extend)((0, $jZXzE.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $966c7c1b681b375a$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $jZXzE.NOOP);
        if ($966c7c1b681b375a$var$installWithProxy) $966c7c1b681b375a$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $966c7c1b681b375a$var$setCurrentInstance(instance);
        (0, $eq3vT.pauseTracking)();
        try {
            $966c7c1b681b375a$var$applyOptions(instance);
        } finally{
            (0, $eq3vT.resetTracking)();
            reset();
        }
    }
}
const $966c7c1b681b375a$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $eq3vT.track)(target, "get", "");
        return target[key];
    }
};
function $966c7c1b681b375a$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $eq3vT.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $966c7c1b681b375a$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $966c7c1b681b375a$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $966c7c1b681b375a$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $eq3vT.proxyRefs)((0, $eq3vT.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $966c7c1b681b375a$var$publicPropertiesMap) return $966c7c1b681b375a$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $966c7c1b681b375a$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $966c7c1b681b375a$var$classifyRE = /(?:^|[-_])(\w)/g;
const $966c7c1b681b375a$var$classify = (str)=>str.replace($966c7c1b681b375a$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $966c7c1b681b375a$var$getComponentName(Component, includeInferred = true) {
    return (0, $jZXzE.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $966c7c1b681b375a$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $966c7c1b681b375a$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $966c7c1b681b375a$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $966c7c1b681b375a$var$isClassComponent(value) {
    return (0, $jZXzE.isFunction)(value) && "__vccOpts" in value;
}
const $966c7c1b681b375a$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $eq3vT.computed)(getterOrOptions, debugOptions, $966c7c1b681b375a$var$isInSSRComponentSetup);
    return c;
};
function $966c7c1b681b375a$export$fb78bd113157f1a1(props, name, options = (0, $jZXzE.EMPTY_OBJ)) {
    const i = $966c7c1b681b375a$export$f13e630aa3915748();
    const camelizedName = (0, $jZXzE.camelize)(name);
    const hyphenatedName = (0, $jZXzE.hyphenate)(name);
    const res = (0, $eq3vT.customRef)((track, trigger)=>{
        let localValue;
        $966c7c1b681b375a$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $jZXzE.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $jZXzE.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $966c7c1b681b375a$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $jZXzE.isObject)(propsOrChildren) && !(0, $jZXzE.isArray)(propsOrChildren)) {
            if ($966c7c1b681b375a$export$3868d13f8734ae81(propsOrChildren)) return $966c7c1b681b375a$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $966c7c1b681b375a$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $966c7c1b681b375a$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $966c7c1b681b375a$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $966c7c1b681b375a$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $966c7c1b681b375a$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $eq3vT.toRaw)(instance.props)));
        if (instance.setupState !== (0, $jZXzE.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $jZXzE.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $eq3vT.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $jZXzE.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $jZXzE.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $eq3vT.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $jZXzE.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $jZXzE.isArray)(opts) && opts.includes(key) || (0, $jZXzE.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $eq3vT.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $966c7c1b681b375a$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $966c7c1b681b375a$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.memoIndex = index;
    return cache[index] = ret;
}
function $966c7c1b681b375a$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $jZXzE.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($966c7c1b681b375a$var$isBlockTreeEnabled > 0 && $966c7c1b681b375a$var$currentBlock) $966c7c1b681b375a$var$currentBlock.push(cached);
    return true;
}
const $966c7c1b681b375a$export$83d89fbfd8236492 = "3.4.30";
const $966c7c1b681b375a$export$c106dd0671a0fc2d = (0, $jZXzE.NOOP);
const $966c7c1b681b375a$export$795e0ad4a0e2ed30 = $966c7c1b681b375a$var$ErrorTypeStrings$1;
const $966c7c1b681b375a$export$6922d3b3a607469e = $966c7c1b681b375a$var$devtools$1;
const $966c7c1b681b375a$export$b0c258b32c26c785 = $966c7c1b681b375a$var$setDevtoolsHook$1;
const $966c7c1b681b375a$var$_ssrUtils = {
    createComponentInstance: $966c7c1b681b375a$var$createComponentInstance,
    setupComponent: $966c7c1b681b375a$var$setupComponent,
    renderComponentRoot: $966c7c1b681b375a$var$renderComponentRoot,
    setCurrentRenderingInstance: $966c7c1b681b375a$var$setCurrentRenderingInstance,
    isVNode: $966c7c1b681b375a$export$3868d13f8734ae81,
    normalizeVNode: $966c7c1b681b375a$var$normalizeVNode,
    getComponentPublicInstance: $966c7c1b681b375a$var$getComponentPublicInstance
};
const $966c7c1b681b375a$export$a9679033567b336d = $966c7c1b681b375a$var$_ssrUtils;
const $966c7c1b681b375a$export$83cf26e06ea620e1 = null;
const $966c7c1b681b375a$export$dc678eddf276286e = null;
const $966c7c1b681b375a$export$22072a82865312f6 = null;

});
parcelRegister("eq3vT", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $a7f6381893df2910$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "getCurrentScope", function () { return $a7f6381893df2910$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $a7f6381893df2910$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $a7f6381893df2910$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $a7f6381893df2910$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $a7f6381893df2910$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $a7f6381893df2910$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $a7f6381893df2910$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $a7f6381893df2910$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $a7f6381893df2910$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $a7f6381893df2910$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $a7f6381893df2910$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $a7f6381893df2910$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $a7f6381893df2910$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $a7f6381893df2910$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "computed", function () { return $a7f6381893df2910$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "ref", function () { return $a7f6381893df2910$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "proxyRefs", function () { return $a7f6381893df2910$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $a7f6381893df2910$export$a20c2dd6199824cb; });
/**
* @vue/reactivity v3.4.30
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $jZXzE = parcelRequire("jZXzE");
function $a7f6381893df2910$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $a7f6381893df2910$var$activeEffectScope;
class $a7f6381893df2910$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $a7f6381893df2910$var$activeEffectScope;
        if (!detached && $a7f6381893df2910$var$activeEffectScope) this.index = ($a7f6381893df2910$var$activeEffectScope.scopes || ($a7f6381893df2910$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $a7f6381893df2910$var$activeEffectScope;
            try {
                $a7f6381893df2910$var$activeEffectScope = this;
                return fn();
            } finally{
                $a7f6381893df2910$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $a7f6381893df2910$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $a7f6381893df2910$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $a7f6381893df2910$export$7056603ea81600be(detached) {
    return new $a7f6381893df2910$export$1168ed9dbc71ddbd(detached);
}
function $a7f6381893df2910$var$recordEffectScope(effect, scope = $a7f6381893df2910$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $a7f6381893df2910$export$c7be4b0125a10cba() {
    return $a7f6381893df2910$var$activeEffectScope;
}
function $a7f6381893df2910$export$a780418acd4762da(fn) {
    if ($a7f6381893df2910$var$activeEffectScope) $a7f6381893df2910$var$activeEffectScope.cleanups.push(fn);
}
let $a7f6381893df2910$var$activeEffect;
class $a7f6381893df2910$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 5;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $a7f6381893df2910$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2) return false;
        if (this._dirtyLevel === 3 || this._dirtyLevel === 4) {
            this._dirtyLevel = 1;
            $a7f6381893df2910$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    if (dep.computed.effect._dirtyLevel === 2) {
                        $a7f6381893df2910$export$c39176b1babaa8b8();
                        return true;
                    }
                    $a7f6381893df2910$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 5) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $a7f6381893df2910$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 5;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 5 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $a7f6381893df2910$var$shouldTrack;
        let lastEffect = $a7f6381893df2910$var$activeEffect;
        try {
            $a7f6381893df2910$var$shouldTrack = true;
            $a7f6381893df2910$var$activeEffect = this;
            this._runnings++;
            $a7f6381893df2910$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $a7f6381893df2910$var$postCleanupEffect(this);
            this._runnings--;
            $a7f6381893df2910$var$activeEffect = lastEffect;
            $a7f6381893df2910$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            $a7f6381893df2910$var$preCleanupEffect(this);
            $a7f6381893df2910$var$postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function $a7f6381893df2910$var$triggerComputed(computed) {
    return computed.value;
}
function $a7f6381893df2910$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $a7f6381893df2910$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$a7f6381893df2910$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $a7f6381893df2910$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $a7f6381893df2910$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $a7f6381893df2910$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $a7f6381893df2910$export$28352bb4dd362521(fn, (0, $jZXzE.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $jZXzE.extend)(_effect, options);
        if (options.scope) $a7f6381893df2910$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $a7f6381893df2910$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $a7f6381893df2910$var$shouldTrack = true;
let $a7f6381893df2910$var$pauseScheduleStack = 0;
const $a7f6381893df2910$var$trackStack = [];
function $a7f6381893df2910$export$938a971395fef855() {
    $a7f6381893df2910$var$trackStack.push($a7f6381893df2910$var$shouldTrack);
    $a7f6381893df2910$var$shouldTrack = false;
}
function $a7f6381893df2910$export$1f8ffc6fd33b1d16() {
    $a7f6381893df2910$var$trackStack.push($a7f6381893df2910$var$shouldTrack);
    $a7f6381893df2910$var$shouldTrack = true;
}
function $a7f6381893df2910$export$c39176b1babaa8b8() {
    const last = $a7f6381893df2910$var$trackStack.pop();
    $a7f6381893df2910$var$shouldTrack = last === void 0 ? true : last;
}
function $a7f6381893df2910$export$262a949f95482a17() {
    $a7f6381893df2910$var$pauseScheduleStack++;
}
function $a7f6381893df2910$export$3539fa10306ef581() {
    $a7f6381893df2910$var$pauseScheduleStack--;
    while(!$a7f6381893df2910$var$pauseScheduleStack && $a7f6381893df2910$var$queueEffectSchedulers.length)$a7f6381893df2910$var$queueEffectSchedulers.shift()();
}
function $a7f6381893df2910$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $a7f6381893df2910$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $a7f6381893df2910$var$queueEffectSchedulers = [];
function $a7f6381893df2910$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $a7f6381893df2910$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (!dep.computed && effect2.computed) {
            if (effect2._runnings > 0 && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
                effect2._dirtyLevel = 2;
                continue;
            }
        }
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            if (effect2.computed && effect2._dirtyLevel === 2) effect2._shouldSchedule = true;
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 3) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $a7f6381893df2910$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $a7f6381893df2910$export$3539fa10306ef581();
}
const $a7f6381893df2910$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $a7f6381893df2910$var$targetMap = /* @__PURE__ */ new WeakMap();
const $a7f6381893df2910$export$3c41b1a4e06acc14 = Symbol("");
const $a7f6381893df2910$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $a7f6381893df2910$export$6b2a7d5132615086(target, type, key) {
    if ($a7f6381893df2910$var$shouldTrack && $a7f6381893df2910$var$activeEffect) {
        let depsMap = $a7f6381893df2910$var$targetMap.get(target);
        if (!depsMap) $a7f6381893df2910$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $a7f6381893df2910$var$createDep(()=>depsMap.delete(key)));
        $a7f6381893df2910$var$trackEffect($a7f6381893df2910$var$activeEffect, dep, void 0);
    }
}
function $a7f6381893df2910$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $a7f6381893df2910$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $jZXzE.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $jZXzE.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $jZXzE.isArray)(target)) {
                    deps.push(depsMap.get($a7f6381893df2910$export$3c41b1a4e06acc14));
                    if ((0, $jZXzE.isMap)(target)) deps.push(depsMap.get($a7f6381893df2910$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $jZXzE.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $jZXzE.isArray)(target)) {
                    deps.push(depsMap.get($a7f6381893df2910$export$3c41b1a4e06acc14));
                    if ((0, $jZXzE.isMap)(target)) deps.push(depsMap.get($a7f6381893df2910$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $jZXzE.isMap)(target)) deps.push(depsMap.get($a7f6381893df2910$export$3c41b1a4e06acc14));
                break;
        }
    }
    $a7f6381893df2910$export$262a949f95482a17();
    for (const dep of deps)if (dep) $a7f6381893df2910$var$triggerEffects(dep, 5, void 0);
    $a7f6381893df2910$export$3539fa10306ef581();
}
function $a7f6381893df2910$var$getDepFromReactive(object, key) {
    const depsMap = $a7f6381893df2910$var$targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const $a7f6381893df2910$var$isNonTrackableKeys = /* @__PURE__ */ (0, $jZXzE.makeMap)(`__proto__,__v_isRef,__isVue`);
const $a7f6381893df2910$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $jZXzE.isSymbol)));
const $a7f6381893df2910$var$arrayInstrumentations = /* @__PURE__ */ $a7f6381893df2910$var$createArrayInstrumentations();
function $a7f6381893df2910$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$a7f6381893df2910$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($a7f6381893df2910$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $a7f6381893df2910$export$938a971395fef855();
            $a7f6381893df2910$export$262a949f95482a17();
            const res = $a7f6381893df2910$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $a7f6381893df2910$export$3539fa10306ef581();
            $a7f6381893df2910$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $a7f6381893df2910$var$hasOwnProperty(key) {
    if (!(0, $jZXzE.isSymbol)(key)) key = String(key);
    const obj = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
    $a7f6381893df2910$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $a7f6381893df2910$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $a7f6381893df2910$var$shallowReadonlyMap : $a7f6381893df2910$var$readonlyMap : isShallow2 ? $a7f6381893df2910$var$shallowReactiveMap : $a7f6381893df2910$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $jZXzE.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $jZXzE.hasOwn)($a7f6381893df2910$var$arrayInstrumentations, key)) return Reflect.get($a7f6381893df2910$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $a7f6381893df2910$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $jZXzE.isSymbol)(key) ? $a7f6381893df2910$var$builtInSymbols.has(key) : $a7f6381893df2910$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $a7f6381893df2910$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($a7f6381893df2910$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $jZXzE.isIntegerKey)(key) ? res : res.value;
        if ((0, $jZXzE.isObject)(res)) return isReadonly2 ? $a7f6381893df2910$export$6ec456bd5b7b3c51(res) : $a7f6381893df2910$export$90a44edba14e47be(res);
        return res;
    }
}
class $a7f6381893df2910$var$MutableReactiveHandler extends $a7f6381893df2910$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $a7f6381893df2910$export$92d09b48637741e7(oldValue);
            if (!$a7f6381893df2910$export$7f3fe6025abfa26e(value) && !$a7f6381893df2910$export$92d09b48637741e7(value)) {
                oldValue = $a7f6381893df2910$export$ab18938b9fc5f28e(oldValue);
                value = $a7f6381893df2910$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $jZXzE.isArray)(target) && $a7f6381893df2910$export$4f9f5282de18fc69(oldValue) && !$a7f6381893df2910$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $jZXzE.isArray)(target) && (0, $jZXzE.isIntegerKey)(key) ? Number(key) < target.length : (0, $jZXzE.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $a7f6381893df2910$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $a7f6381893df2910$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $jZXzE.hasChanged)(value, oldValue)) $a7f6381893df2910$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $jZXzE.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $a7f6381893df2910$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $jZXzE.isSymbol)(key) || !$a7f6381893df2910$var$builtInSymbols.has(key)) $a7f6381893df2910$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $a7f6381893df2910$export$6b2a7d5132615086(target, "iterate", (0, $jZXzE.isArray)(target) ? "length" : $a7f6381893df2910$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $a7f6381893df2910$var$ReadonlyReactiveHandler extends $a7f6381893df2910$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $a7f6381893df2910$var$mutableHandlers = /* @__PURE__ */ new $a7f6381893df2910$var$MutableReactiveHandler();
const $a7f6381893df2910$var$readonlyHandlers = /* @__PURE__ */ new $a7f6381893df2910$var$ReadonlyReactiveHandler();
const $a7f6381893df2910$var$shallowReactiveHandlers = /* @__PURE__ */ new $a7f6381893df2910$var$MutableReactiveHandler(true);
const $a7f6381893df2910$var$shallowReadonlyHandlers = /* @__PURE__ */ new $a7f6381893df2910$var$ReadonlyReactiveHandler(true);
const $a7f6381893df2910$var$toShallow = (value)=>value;
const $a7f6381893df2910$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $a7f6381893df2910$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $a7f6381893df2910$export$ab18938b9fc5f28e(target);
    const rawKey = $a7f6381893df2910$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $jZXzE.hasChanged)(key, rawKey)) $a7f6381893df2910$export$6b2a7d5132615086(rawTarget, "get", key);
        $a7f6381893df2910$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $a7f6381893df2910$var$getProto(rawTarget);
    const wrap = isShallow ? $a7f6381893df2910$var$toShallow : isReadonly ? $a7f6381893df2910$var$toReadonly : $a7f6381893df2910$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $a7f6381893df2910$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $a7f6381893df2910$export$ab18938b9fc5f28e(target);
    const rawKey = $a7f6381893df2910$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $jZXzE.hasChanged)(key, rawKey)) $a7f6381893df2910$export$6b2a7d5132615086(rawTarget, "has", key);
        $a7f6381893df2910$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $a7f6381893df2910$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $a7f6381893df2910$export$6b2a7d5132615086($a7f6381893df2910$export$ab18938b9fc5f28e(target), "iterate", $a7f6381893df2910$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $a7f6381893df2910$var$add(value) {
    value = $a7f6381893df2910$export$ab18938b9fc5f28e(value);
    const target = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
    const proto = $a7f6381893df2910$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $a7f6381893df2910$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $a7f6381893df2910$var$set(key, value) {
    value = $a7f6381893df2910$export$ab18938b9fc5f28e(value);
    const target = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $a7f6381893df2910$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $a7f6381893df2910$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $a7f6381893df2910$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $jZXzE.hasChanged)(value, oldValue)) $a7f6381893df2910$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $a7f6381893df2910$var$deleteEntry(key) {
    const target = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $a7f6381893df2910$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $a7f6381893df2910$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $a7f6381893df2910$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $a7f6381893df2910$var$clear() {
    const target = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $a7f6381893df2910$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $a7f6381893df2910$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $a7f6381893df2910$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $a7f6381893df2910$var$toShallow : isReadonly ? $a7f6381893df2910$var$toReadonly : $a7f6381893df2910$var$toReactive;
        !isReadonly && $a7f6381893df2910$export$6b2a7d5132615086(rawTarget, "iterate", $a7f6381893df2910$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $a7f6381893df2910$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $a7f6381893df2910$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $jZXzE.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $a7f6381893df2910$var$toShallow : isReadonly ? $a7f6381893df2910$var$toReadonly : $a7f6381893df2910$var$toReactive;
        !isReadonly && $a7f6381893df2910$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $a7f6381893df2910$var$MAP_KEY_ITERATE_KEY : $a7f6381893df2910$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $a7f6381893df2910$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $a7f6381893df2910$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $a7f6381893df2910$var$get(this, key);
        },
        get size () {
            return $a7f6381893df2910$var$size(this);
        },
        has: $a7f6381893df2910$var$has,
        add: $a7f6381893df2910$var$add,
        set: $a7f6381893df2910$var$set,
        delete: $a7f6381893df2910$var$deleteEntry,
        clear: $a7f6381893df2910$var$clear,
        forEach: $a7f6381893df2910$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $a7f6381893df2910$var$get(this, key, false, true);
        },
        get size () {
            return $a7f6381893df2910$var$size(this);
        },
        has: $a7f6381893df2910$var$has,
        add: $a7f6381893df2910$var$add,
        set: $a7f6381893df2910$var$set,
        delete: $a7f6381893df2910$var$deleteEntry,
        clear: $a7f6381893df2910$var$clear,
        forEach: $a7f6381893df2910$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $a7f6381893df2910$var$get(this, key, true);
        },
        get size () {
            return $a7f6381893df2910$var$size(this, true);
        },
        has (key) {
            return $a7f6381893df2910$var$has.call(this, key, true);
        },
        add: $a7f6381893df2910$var$createReadonlyMethod("add"),
        set: $a7f6381893df2910$var$createReadonlyMethod("set"),
        delete: $a7f6381893df2910$var$createReadonlyMethod("delete"),
        clear: $a7f6381893df2910$var$createReadonlyMethod("clear"),
        forEach: $a7f6381893df2910$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $a7f6381893df2910$var$get(this, key, true, true);
        },
        get size () {
            return $a7f6381893df2910$var$size(this, true);
        },
        has (key) {
            return $a7f6381893df2910$var$has.call(this, key, true);
        },
        add: $a7f6381893df2910$var$createReadonlyMethod("add"),
        set: $a7f6381893df2910$var$createReadonlyMethod("set"),
        delete: $a7f6381893df2910$var$createReadonlyMethod("delete"),
        clear: $a7f6381893df2910$var$createReadonlyMethod("clear"),
        forEach: $a7f6381893df2910$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $a7f6381893df2910$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $a7f6381893df2910$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $a7f6381893df2910$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $a7f6381893df2910$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$a7f6381893df2910$var$mutableInstrumentations, $a7f6381893df2910$var$readonlyInstrumentations, $a7f6381893df2910$var$shallowInstrumentations, $a7f6381893df2910$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $a7f6381893df2910$var$createInstrumentations();
function $a7f6381893df2910$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $a7f6381893df2910$var$shallowReadonlyInstrumentations : $a7f6381893df2910$var$shallowInstrumentations : isReadonly ? $a7f6381893df2910$var$readonlyInstrumentations : $a7f6381893df2910$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $jZXzE.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $a7f6381893df2910$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $a7f6381893df2910$var$createInstrumentationGetter(false, false)
};
const $a7f6381893df2910$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $a7f6381893df2910$var$createInstrumentationGetter(false, true)
};
const $a7f6381893df2910$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $a7f6381893df2910$var$createInstrumentationGetter(true, false)
};
const $a7f6381893df2910$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $a7f6381893df2910$var$createInstrumentationGetter(true, true)
};
function $a7f6381893df2910$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $a7f6381893df2910$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $jZXzE.toRawType)(target);
        $a7f6381893df2910$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $a7f6381893df2910$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $a7f6381893df2910$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $a7f6381893df2910$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $a7f6381893df2910$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $a7f6381893df2910$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $a7f6381893df2910$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $a7f6381893df2910$var$targetTypeMap((0, $jZXzE.toRawType)(value));
}
function $a7f6381893df2910$export$90a44edba14e47be(target) {
    if ($a7f6381893df2910$export$92d09b48637741e7(target)) return target;
    return $a7f6381893df2910$var$createReactiveObject(target, false, $a7f6381893df2910$var$mutableHandlers, $a7f6381893df2910$var$mutableCollectionHandlers, $a7f6381893df2910$var$reactiveMap);
}
function $a7f6381893df2910$export$8d81cefd22d22260(target) {
    return $a7f6381893df2910$var$createReactiveObject(target, false, $a7f6381893df2910$var$shallowReactiveHandlers, $a7f6381893df2910$var$shallowCollectionHandlers, $a7f6381893df2910$var$shallowReactiveMap);
}
function $a7f6381893df2910$export$6ec456bd5b7b3c51(target) {
    return $a7f6381893df2910$var$createReactiveObject(target, true, $a7f6381893df2910$var$readonlyHandlers, $a7f6381893df2910$var$readonlyCollectionHandlers, $a7f6381893df2910$var$readonlyMap);
}
function $a7f6381893df2910$export$7c4b5f2b50f09f6b(target) {
    return $a7f6381893df2910$var$createReactiveObject(target, true, $a7f6381893df2910$var$shallowReadonlyHandlers, $a7f6381893df2910$var$shallowReadonlyCollectionHandlers, $a7f6381893df2910$var$shallowReadonlyMap);
}
function $a7f6381893df2910$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $jZXzE.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $a7f6381893df2910$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $a7f6381893df2910$export$352205f445242f02(value) {
    if ($a7f6381893df2910$export$92d09b48637741e7(value)) return $a7f6381893df2910$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $a7f6381893df2910$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $a7f6381893df2910$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $a7f6381893df2910$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $a7f6381893df2910$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $a7f6381893df2910$export$ab18938b9fc5f28e(raw) : observed;
}
function $a7f6381893df2910$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $jZXzE.def)(value, "__v_skip", true);
    return value;
}
const $a7f6381893df2910$var$toReactive = (value)=>(0, $jZXzE.isObject)(value) ? $a7f6381893df2910$export$90a44edba14e47be(value) : value;
const $a7f6381893df2910$var$toReadonly = (value)=>(0, $jZXzE.isObject)(value) ? $a7f6381893df2910$export$6ec456bd5b7b3c51(value) : value;
const $a7f6381893df2910$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $a7f6381893df2910$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $a7f6381893df2910$export$28352bb4dd362521(()=>getter(this._value), ()=>$a7f6381893df2910$var$triggerRefValue(this, this.effect._dirtyLevel === 3 ? 3 : 4));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $a7f6381893df2910$export$ab18938b9fc5f28e(this);
        const lastDirtyLevel = self.effect._dirtyLevel;
        if ((!self._cacheable || self.effect.dirty) && (0, $jZXzE.hasChanged)(self._value, self._value = self.effect.run())) {
            if (lastDirtyLevel !== 3) $a7f6381893df2910$var$triggerRefValue(self, 5);
        }
        $a7f6381893df2910$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $a7f6381893df2910$var$triggerRefValue(self, 3);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $a7f6381893df2910$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $jZXzE.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $jZXzE.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $a7f6381893df2910$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $a7f6381893df2910$var$trackRefValue(ref2) {
    var _a;
    if ($a7f6381893df2910$var$shouldTrack && $a7f6381893df2910$var$activeEffect) {
        ref2 = $a7f6381893df2910$export$ab18938b9fc5f28e(ref2);
        $a7f6381893df2910$var$trackEffect($a7f6381893df2910$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $a7f6381893df2910$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $a7f6381893df2910$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $a7f6381893df2910$var$triggerRefValue(ref2, dirtyLevel = 5, newVal, oldVal) {
    ref2 = $a7f6381893df2910$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $a7f6381893df2910$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $a7f6381893df2910$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $a7f6381893df2910$export$eff4d24c3ff7876e(value) {
    return $a7f6381893df2910$var$createRef(value, false);
}
function $a7f6381893df2910$export$9b7bc5fe3b17c8b3(value) {
    return $a7f6381893df2910$var$createRef(value, true);
}
function $a7f6381893df2910$var$createRef(rawValue, shallow) {
    if ($a7f6381893df2910$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $a7f6381893df2910$var$RefImpl(rawValue, shallow);
}
class $a7f6381893df2910$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $a7f6381893df2910$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $a7f6381893df2910$var$toReactive(value);
    }
    get value() {
        $a7f6381893df2910$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $a7f6381893df2910$export$7f3fe6025abfa26e(newVal) || $a7f6381893df2910$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $a7f6381893df2910$export$ab18938b9fc5f28e(newVal);
        if ((0, $jZXzE.hasChanged)(newVal, this._rawValue)) {
            const oldVal = this._rawValue;
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $a7f6381893df2910$var$toReactive(newVal);
            $a7f6381893df2910$var$triggerRefValue(this, 5, newVal, oldVal);
        }
    }
}
function $a7f6381893df2910$export$f402f86588575ccc(ref2) {
    $a7f6381893df2910$var$triggerRefValue(ref2, 5, void 0);
}
function $a7f6381893df2910$export$a239a76781616204(ref2) {
    return $a7f6381893df2910$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $a7f6381893df2910$export$30bdcc2218aa9458(source) {
    return (0, $jZXzE.isFunction)(source) ? source() : $a7f6381893df2910$export$a239a76781616204(source);
}
const $a7f6381893df2910$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$a7f6381893df2910$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($a7f6381893df2910$export$4f9f5282de18fc69(oldValue) && !$a7f6381893df2910$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $a7f6381893df2910$export$f353fd1b97db3fa0(objectWithRefs) {
    return $a7f6381893df2910$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $a7f6381893df2910$var$shallowUnwrapHandlers);
}
class $a7f6381893df2910$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$a7f6381893df2910$var$trackRefValue(this), ()=>$a7f6381893df2910$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $a7f6381893df2910$export$a20c2dd6199824cb(factory) {
    return new $a7f6381893df2910$var$CustomRefImpl(factory);
}
function $a7f6381893df2910$export$2e9533675e5e70e0(object) {
    const ret = (0, $jZXzE.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $a7f6381893df2910$var$propertyToRef(object, key);
    return ret;
}
class $a7f6381893df2910$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $a7f6381893df2910$var$getDepFromReactive($a7f6381893df2910$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $a7f6381893df2910$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $a7f6381893df2910$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($a7f6381893df2910$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $jZXzE.isFunction)(source)) return new $a7f6381893df2910$var$GetterRefImpl(source);
    else if ((0, $jZXzE.isObject)(source) && arguments.length > 1) return $a7f6381893df2910$var$propertyToRef(source, key, defaultValue);
    else return $a7f6381893df2910$export$eff4d24c3ff7876e(source);
}
function $a7f6381893df2910$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $a7f6381893df2910$export$4f9f5282de18fc69(val) ? val : new $a7f6381893df2910$var$ObjectRefImpl(source, key, defaultValue);
}
const $a7f6381893df2910$export$483264c4ec4c46ce = $a7f6381893df2910$export$2983e091f1a1e8e2;
const $a7f6381893df2910$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $a7f6381893df2910$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $a7f6381893df2910$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("jZXzE", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $e8f1ecf7a7536d6a$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $e8f1ecf7a7536d6a$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $e8f1ecf7a7536d6a$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $e8f1ecf7a7536d6a$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $e8f1ecf7a7536d6a$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $e8f1ecf7a7536d6a$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $e8f1ecf7a7536d6a$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $e8f1ecf7a7536d6a$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $e8f1ecf7a7536d6a$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $e8f1ecf7a7536d6a$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $e8f1ecf7a7536d6a$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $e8f1ecf7a7536d6a$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $e8f1ecf7a7536d6a$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $e8f1ecf7a7536d6a$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $e8f1ecf7a7536d6a$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $e8f1ecf7a7536d6a$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $e8f1ecf7a7536d6a$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $e8f1ecf7a7536d6a$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $e8f1ecf7a7536d6a$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $e8f1ecf7a7536d6a$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $e8f1ecf7a7536d6a$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $e8f1ecf7a7536d6a$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $e8f1ecf7a7536d6a$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $e8f1ecf7a7536d6a$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $e8f1ecf7a7536d6a$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $e8f1ecf7a7536d6a$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $e8f1ecf7a7536d6a$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $e8f1ecf7a7536d6a$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $e8f1ecf7a7536d6a$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $e8f1ecf7a7536d6a$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $e8f1ecf7a7536d6a$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $e8f1ecf7a7536d6a$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $e8f1ecf7a7536d6a$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $e8f1ecf7a7536d6a$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $e8f1ecf7a7536d6a$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $e8f1ecf7a7536d6a$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $e8f1ecf7a7536d6a$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $e8f1ecf7a7536d6a$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $e8f1ecf7a7536d6a$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $e8f1ecf7a7536d6a$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $e8f1ecf7a7536d6a$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $e8f1ecf7a7536d6a$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $e8f1ecf7a7536d6a$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $e8f1ecf7a7536d6a$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $e8f1ecf7a7536d6a$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $e8f1ecf7a7536d6a$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "looseEqual", function () { return $e8f1ecf7a7536d6a$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $e8f1ecf7a7536d6a$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $e8f1ecf7a7536d6a$export$b5b1545233b45293; });
/**
* @vue/shared v3.4.30
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $e8f1ecf7a7536d6a$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $e8f1ecf7a7536d6a$export$cf583d23ab39677c = {};
const $e8f1ecf7a7536d6a$export$6bd8558f433f1cc1 = [];
const $e8f1ecf7a7536d6a$export$5702a91a6f42969f = ()=>{};
const $e8f1ecf7a7536d6a$export$c01351c0af048e39 = ()=>false;
const $e8f1ecf7a7536d6a$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $e8f1ecf7a7536d6a$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $e8f1ecf7a7536d6a$export$8b58be045bf06082 = Object.assign;
const $e8f1ecf7a7536d6a$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $e8f1ecf7a7536d6a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $e8f1ecf7a7536d6a$export$b5a638e9b3fff9f3 = (val, key)=>$e8f1ecf7a7536d6a$var$hasOwnProperty.call(val, key);
const $e8f1ecf7a7536d6a$export$43bee75e5e14138e = Array.isArray;
const $e8f1ecf7a7536d6a$export$5c90113a285f2241 = (val)=>$e8f1ecf7a7536d6a$export$1dccc787cc36538b(val) === "[object Map]";
const $e8f1ecf7a7536d6a$export$6750766a7c7ec627 = (val)=>$e8f1ecf7a7536d6a$export$1dccc787cc36538b(val) === "[object Set]";
const $e8f1ecf7a7536d6a$export$871608497c498473 = (val)=>$e8f1ecf7a7536d6a$export$1dccc787cc36538b(val) === "[object Date]";
const $e8f1ecf7a7536d6a$export$49841c62b9eff15 = (val)=>$e8f1ecf7a7536d6a$export$1dccc787cc36538b(val) === "[object RegExp]";
const $e8f1ecf7a7536d6a$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $e8f1ecf7a7536d6a$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $e8f1ecf7a7536d6a$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $e8f1ecf7a7536d6a$export$4369c812aac99591 = (val)=>{
    return ($e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(val) || $e8f1ecf7a7536d6a$export$f6e2535fb5126e54(val)) && $e8f1ecf7a7536d6a$export$f6e2535fb5126e54(val.then) && $e8f1ecf7a7536d6a$export$f6e2535fb5126e54(val.catch);
};
const $e8f1ecf7a7536d6a$export$830c053460e5ddf6 = Object.prototype.toString;
const $e8f1ecf7a7536d6a$export$1dccc787cc36538b = (value)=>$e8f1ecf7a7536d6a$export$830c053460e5ddf6.call(value);
const $e8f1ecf7a7536d6a$export$5ad0a3c360b8fbb5 = (value)=>{
    return $e8f1ecf7a7536d6a$export$1dccc787cc36538b(value).slice(8, -1);
};
const $e8f1ecf7a7536d6a$export$53b83ca8eaab0383 = (val)=>$e8f1ecf7a7536d6a$export$1dccc787cc36538b(val) === "[object Object]";
const $e8f1ecf7a7536d6a$export$e2a2b93446ec9fe = (key)=>$e8f1ecf7a7536d6a$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $e8f1ecf7a7536d6a$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $e8f1ecf7a7536d6a$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $e8f1ecf7a7536d6a$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $e8f1ecf7a7536d6a$var$camelizeRE = /-(\w)/g;
const $e8f1ecf7a7536d6a$export$161d051f5dd25de7 = $e8f1ecf7a7536d6a$var$cacheStringFunction((str)=>{
    return str.replace($e8f1ecf7a7536d6a$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $e8f1ecf7a7536d6a$var$hyphenateRE = /\B([A-Z])/g;
const $e8f1ecf7a7536d6a$export$6e6a0a3676c4b8bb = $e8f1ecf7a7536d6a$var$cacheStringFunction((str)=>str.replace($e8f1ecf7a7536d6a$var$hyphenateRE, "-$1").toLowerCase());
const $e8f1ecf7a7536d6a$export$9a00dee1beb8f576 = $e8f1ecf7a7536d6a$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $e8f1ecf7a7536d6a$export$8c022799eeaaefcd = $e8f1ecf7a7536d6a$var$cacheStringFunction((str)=>{
    const s = str ? `on${$e8f1ecf7a7536d6a$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $e8f1ecf7a7536d6a$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $e8f1ecf7a7536d6a$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $e8f1ecf7a7536d6a$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $e8f1ecf7a7536d6a$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $e8f1ecf7a7536d6a$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $e8f1ecf7a7536d6a$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $e8f1ecf7a7536d6a$var$_globalThis;
const $e8f1ecf7a7536d6a$export$ff5f2eeb11fc7e14 = ()=>{
    return $e8f1ecf7a7536d6a$var$_globalThis || ($e8f1ecf7a7536d6a$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $e8f1ecf7a7536d6a$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $e8f1ecf7a7536d6a$export$53d5e12f9a1d3cde(name) {
    return $e8f1ecf7a7536d6a$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $e8f1ecf7a7536d6a$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $e8f1ecf7a7536d6a$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $e8f1ecf7a7536d6a$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $e8f1ecf7a7536d6a$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $e8f1ecf7a7536d6a$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $e8f1ecf7a7536d6a$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $e8f1ecf7a7536d6a$export$f73b8c13b7f97ebf = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$GLOBALS_ALLOWED);
const $e8f1ecf7a7536d6a$export$d6571a1911e4f27e = $e8f1ecf7a7536d6a$export$f73b8c13b7f97ebf;
const $e8f1ecf7a7536d6a$var$range = 2;
function $e8f1ecf7a7536d6a$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $e8f1ecf7a7536d6a$var$range; j <= i + $e8f1ecf7a7536d6a$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $e8f1ecf7a7536d6a$export$8756898546458274(value) {
    if ($e8f1ecf7a7536d6a$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $e8f1ecf7a7536d6a$export$844ec244b1367d54(item) ? $e8f1ecf7a7536d6a$export$76a205ce979d066a(item) : $e8f1ecf7a7536d6a$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($e8f1ecf7a7536d6a$export$844ec244b1367d54(value) || $e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(value)) return value;
}
const $e8f1ecf7a7536d6a$var$listDelimiterRE = /;(?![^(]*\))/g;
const $e8f1ecf7a7536d6a$var$propertyDelimiterRE = /:([^]+)/;
const $e8f1ecf7a7536d6a$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $e8f1ecf7a7536d6a$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($e8f1ecf7a7536d6a$var$styleCommentRE, "").split($e8f1ecf7a7536d6a$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($e8f1ecf7a7536d6a$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $e8f1ecf7a7536d6a$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $e8f1ecf7a7536d6a$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($e8f1ecf7a7536d6a$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $e8f1ecf7a7536d6a$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $e8f1ecf7a7536d6a$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($e8f1ecf7a7536d6a$export$844ec244b1367d54(value)) res = value;
    else if ($e8f1ecf7a7536d6a$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $e8f1ecf7a7536d6a$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $e8f1ecf7a7536d6a$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$e8f1ecf7a7536d6a$export$844ec244b1367d54(klass)) props.class = $e8f1ecf7a7536d6a$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $e8f1ecf7a7536d6a$export$8756898546458274(style);
    return props;
}
const $e8f1ecf7a7536d6a$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $e8f1ecf7a7536d6a$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $e8f1ecf7a7536d6a$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $e8f1ecf7a7536d6a$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $e8f1ecf7a7536d6a$export$1ccf854a0984f890 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$HTML_TAGS);
const $e8f1ecf7a7536d6a$export$6328ce7565ea1049 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$SVG_TAGS);
const $e8f1ecf7a7536d6a$export$4a46ca4c5be17b20 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$MATH_TAGS);
const $e8f1ecf7a7536d6a$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$VOID_TAGS);
const $e8f1ecf7a7536d6a$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $e8f1ecf7a7536d6a$export$d186f5eb2e810715 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$specialBooleanAttrs);
const $e8f1ecf7a7536d6a$export$f763ba3b84e9cd8c = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8($e8f1ecf7a7536d6a$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $e8f1ecf7a7536d6a$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $e8f1ecf7a7536d6a$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $e8f1ecf7a7536d6a$var$attrValidationCache = {};
function $e8f1ecf7a7536d6a$export$d55ef77660f30d12(name) {
    if ($e8f1ecf7a7536d6a$var$attrValidationCache.hasOwnProperty(name)) return $e8f1ecf7a7536d6a$var$attrValidationCache[name];
    const isUnsafe = $e8f1ecf7a7536d6a$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $e8f1ecf7a7536d6a$var$attrValidationCache[name] = !isUnsafe;
}
const $e8f1ecf7a7536d6a$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $e8f1ecf7a7536d6a$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $e8f1ecf7a7536d6a$export$80da416f43933831 = /* @__PURE__ */ $e8f1ecf7a7536d6a$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $e8f1ecf7a7536d6a$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $e8f1ecf7a7536d6a$var$escapeRE = /["'&<>]/;
function $e8f1ecf7a7536d6a$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $e8f1ecf7a7536d6a$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $e8f1ecf7a7536d6a$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $e8f1ecf7a7536d6a$export$7b105034a53bde5f(src) {
    return src.replace($e8f1ecf7a7536d6a$var$commentStripRE, "");
}
function $e8f1ecf7a7536d6a$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $e8f1ecf7a7536d6a$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $e8f1ecf7a7536d6a$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $e8f1ecf7a7536d6a$export$871608497c498473(a);
    let bValidType = $e8f1ecf7a7536d6a$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $e8f1ecf7a7536d6a$export$a244864fd9645c7f(a);
    bValidType = $e8f1ecf7a7536d6a$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $e8f1ecf7a7536d6a$export$43bee75e5e14138e(a);
    bValidType = $e8f1ecf7a7536d6a$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $e8f1ecf7a7536d6a$var$looseCompareArrays(a, b) : false;
    aValidType = $e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(a);
    bValidType = $e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$e8f1ecf7a7536d6a$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $e8f1ecf7a7536d6a$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$e8f1ecf7a7536d6a$export$ae8015769846262c(item, val));
}
const $e8f1ecf7a7536d6a$export$b5b1545233b45293 = (val)=>{
    return $e8f1ecf7a7536d6a$export$844ec244b1367d54(val) ? val : val == null ? "" : $e8f1ecf7a7536d6a$export$43bee75e5e14138e(val) || $e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(val) && (val.toString === $e8f1ecf7a7536d6a$export$830c053460e5ddf6 || !$e8f1ecf7a7536d6a$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $e8f1ecf7a7536d6a$var$replacer, 2) : String(val);
};
const $e8f1ecf7a7536d6a$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $e8f1ecf7a7536d6a$var$replacer(_key, val.value);
    else if ($e8f1ecf7a7536d6a$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$e8f1ecf7a7536d6a$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($e8f1ecf7a7536d6a$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$e8f1ecf7a7536d6a$var$stringifySymbol(v))
    };
    else if ($e8f1ecf7a7536d6a$export$a244864fd9645c7f(val)) return $e8f1ecf7a7536d6a$var$stringifySymbol(val);
    else if ($e8f1ecf7a7536d6a$export$a6cdc56e425d0d0a(val) && !$e8f1ecf7a7536d6a$export$43bee75e5e14138e(val) && !$e8f1ecf7a7536d6a$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $e8f1ecf7a7536d6a$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $e8f1ecf7a7536d6a$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});





parcelRegister("c9klK", function(module, exports) {

$parcel$export(module.exports, "withLoading", function () { return $a02d0e31fc3808ef$export$d3452e8982ce982d; });
async function $a02d0e31fc3808ef$export$d3452e8982ce982d(loading, callback) {
    loading.value = true;
    try {
        return await callback();
    } finally{
        loading.value = false;
    }
}

});

parcelRegister("ja4LQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df32a6d67408cf1f$export$2e2bcd8739ae039; });
let $df32a6d67408cf1f$var$script;



let $df32a6d67408cf1f$var$initialize = ()=>{
    $df32a6d67408cf1f$var$script = (parcelRequire("6Ceo1"));
    if ($df32a6d67408cf1f$var$script.__esModule) $df32a6d67408cf1f$var$script = $df32a6d67408cf1f$var$script.default;
    $df32a6d67408cf1f$var$script.render = (parcelRequire("isGAl")).render;
    (parcelRequire("3PS6T")).default($df32a6d67408cf1f$var$script);
    $df32a6d67408cf1f$var$script.__scopeId = "data-v-4f4ade";
    $df32a6d67408cf1f$var$script.__file = "data-selector.vue";
};
$df32a6d67408cf1f$var$initialize();
var $df32a6d67408cf1f$export$2e2bcd8739ae039 = $df32a6d67408cf1f$var$script;

});
parcelRegister("6Ceo1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $63751392f92422e6$export$2e2bcd8739ae039; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
var $eq3vT = parcelRequire("eq3vT");
var $63751392f92422e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cUHxd.defineComponent)({
    __name: "data-selector",
    props: {
        info: {},
        start: {},
        end: {},
        kind: {},
        stat: {}
    },
    emits: [
        "change"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const startRef = (0, $eq3vT.ref)(null);
        const endRef = (0, $eq3vT.ref)(null);
        const kindRef = (0, $eq3vT.ref)(null);
        const statRef = (0, $eq3vT.ref)(null);
        (0, $cUHxd.onMounted)(()=>{
            startRef.value.value = props.start;
            endRef.value.value = props.end;
            kindRef.value.value = props.kind;
            statRef.value.value = props.stat;
        });
        function submitSettings() {
            const start = startRef.value.value;
            const end = endRef.value.value;
            const kind = kindRef.value.value;
            const stat = statRef.value.value;
            const params = {
                start: start,
                end: end,
                kind: kind,
                stat: stat
            };
            emit("change", params);
        }
        const __returned__ = {
            props: props,
            emit: emit,
            startRef: startRef,
            endRef: endRef,
            kindRef: kindRef,
            statRef: statRef,
            submitSettings: submitSettings
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("isGAl", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d70be00cfca86552$export$b3890eb0ae9dca99; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
var $jZXzE = parcelRequire("jZXzE");
var $3gdWT = parcelRequire("3gdWT");
const $d70be00cfca86552$var$_hoisted_1 = {
    id: "settings"
};
const $d70be00cfca86552$var$_hoisted_2 = {
    placeholder: "yyyy-mm-dd or commit",
    ref: "startRef"
};
const $d70be00cfca86552$var$_hoisted_3 = {
    placeholder: "yyyy-mm-dd or commit",
    ref: "endRef"
};
const $d70be00cfca86552$var$_hoisted_4 = {
    ref: "kindRef"
};
const $d70be00cfca86552$var$_hoisted_5 = /*#__PURE__*/ (0, $cUHxd.createElementVNode)("option", {
    value: "raw"
}, "Raw", -1);
const $d70be00cfca86552$var$_hoisted_6 = /*#__PURE__*/ (0, $cUHxd.createElementVNode)("option", {
    value: "percentfromfirst"
}, "Percent Delta from First", -1);
const $d70be00cfca86552$var$_hoisted_7 = /*#__PURE__*/ (0, $cUHxd.createElementVNode)("option", {
    value: "percentrelative"
}, "Percent Delta from Previous", -1);
const $d70be00cfca86552$var$_hoisted_8 = [
    $d70be00cfca86552$var$_hoisted_5,
    $d70be00cfca86552$var$_hoisted_6,
    $d70be00cfca86552$var$_hoisted_7
];
const $d70be00cfca86552$var$_hoisted_9 = {
    ref: "statRef"
};
const $d70be00cfca86552$var$_hoisted_10 = [
    "value"
];
function $d70be00cfca86552$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)("div", $d70be00cfca86552$var$_hoisted_1, [
        (0, $cUHxd.createTextVNode)(" start: "),
        (0, $cUHxd.createElementVNode)("input", $d70be00cfca86552$var$_hoisted_2, null, 512),
        (0, $cUHxd.createTextVNode)(" end: "),
        (0, $cUHxd.createElementVNode)("input", $d70be00cfca86552$var$_hoisted_3, null, 512),
        (0, $cUHxd.createTextVNode)(" Graph kind: "),
        (0, $cUHxd.createElementVNode)("select", $d70be00cfca86552$var$_hoisted_4, $d70be00cfca86552$var$_hoisted_8, 512),
        (0, $cUHxd.createElementVNode)("select", $d70be00cfca86552$var$_hoisted_9, [
            ((0, $cUHxd.openBlock)(true), (0, $cUHxd.createElementBlock)((0, $cUHxd.Fragment), null, (0, $cUHxd.renderList)($props.info.compile_metrics, (value)=>{
                return (0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)("option", {
                    value: value
                }, (0, $jZXzE.toDisplayString)(value), 9, $d70be00cfca86552$var$_hoisted_10);
            }), 256))
        ], 512),
        (0, $cUHxd.createTextVNode)("\xa0"),
        (0, $cUHxd.createElementVNode)("a", {
            href: "#",
            onClick: (0, $3gdWT.withModifiers)($setup.submitSettings, [
                "prevent"
            ])
        }, "Submit")
    ]);
}

});

parcelRegister("3PS6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb01baeb0a0a3fa$export$2e2bcd8739ae039; });
let $2cb01baeb0a0a3fa$var$NOOP = ()=>{};
var $2cb01baeb0a0a3fa$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lkkMv", function(module, exports) {

$parcel$export(module.exports, "createUrlWithAppendedParams", function () { return $2cc234c48f1dd01e$export$61b2f765c6bb406d; });
$parcel$export(module.exports, "getUrlParams", function () { return $2cc234c48f1dd01e$export$1061071041ba84d4; });
$parcel$export(module.exports, "navigateToUrlParams", function () { return $2cc234c48f1dd01e$export$f34efdc6bcfd2339; });
$parcel$export(module.exports, "changeUrl", function () { return $2cc234c48f1dd01e$export$fa1032c55f003d2b; });
/**
 * Creates a URL with the current window location and current parameters, and adds
 * the passed parameters to the URL.
 */ function $2cc234c48f1dd01e$export$61b2f765c6bb406d(params) {
    const originalUrl = window.location.toString();
    const url = new URL(originalUrl);
    for (const [key, value] of Object.entries(params))if (value !== null && value !== undefined) {
        const stringified = value.toString();
        if (stringified !== "") url.searchParams.set(key, stringified);
        else url.searchParams.delete(key);
    }
    return url;
}
function $2cc234c48f1dd01e$export$4e2ea854afbc7949(params) {
    const url = new URL(window.location.toString());
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params))searchParams.set(key, value);
    url.search = searchParams.toString();
    return url;
}
function $2cc234c48f1dd01e$export$1061071041ba84d4() {
    const url = new URL(window.location.toString());
    const params = {};
    url.searchParams.forEach((value, key)=>{
        params[key] = value;
    });
    return params;
}
function $2cc234c48f1dd01e$export$f34efdc6bcfd2339(params) {
    window.location.search = params.toString();
}
function $2cc234c48f1dd01e$export$fa1032c55f003d2b(params) {
    if (history.replaceState) history.replaceState({}, null, $2cc234c48f1dd01e$export$4e2ea854afbc7949(params).toString()); // this seems to take about 1-200ms due to reflow
}

});

parcelRegister("bM33f", function(module, exports) {

$parcel$export(module.exports, "renderPlots", function () { return $55b51262fc77b7c9$export$2318b747caa9fd64; });

var $ahn3r = parcelRequire("ahn3r");
function $55b51262fc77b7c9$var$tooltipPlugin({ onclick: onclick, commits: commits, absoluteMode: absoluteMode, shiftX: shiftX = 10, shiftY: shiftY = 10 }) {
    let tooltipLeftOffset = 0;
    let tooltipTopOffset = 0;
    const tooltip = document.createElement("div");
    tooltip.className = "u-tooltip";
    let seriesIdx = null;
    let dataIdx = null;
    const fmtDate = (0, $ahn3r.default).fmtDate("{M}/{D}/{YY} {h}:{mm}:{ss} {AA}");
    let over;
    let tooltipVisible = false;
    function showTooltip() {
        if (!tooltipVisible) {
            tooltip.style.display = "block";
            over.style.cursor = "pointer";
            tooltipVisible = true;
        }
    }
    function hideTooltip() {
        if (tooltipVisible) {
            tooltip.style.display = "none";
            over.style.cursor = null;
            tooltipVisible = false;
        }
    }
    function setTooltip(u) {
        showTooltip();
        let top = u.valToPos(u.data[seriesIdx][dataIdx], "y");
        let lft = u.valToPos(u.data[0][dataIdx], "x");
        tooltip.style.top = tooltipTopOffset + top + shiftX + "px";
        tooltip.style.left = tooltipLeftOffset + lft + shiftY + "px";
        tooltip.style.borderColor = u.series[seriesIdx].stroke;
        let trailer = "";
        if (absoluteMode) {
            let pctSinceStart = ((u.data[seriesIdx][dataIdx] - u.data[seriesIdx][0]) / u.data[seriesIdx][0] * 100).toFixed(2);
            trailer = (0, $ahn3r.default).fmtNum(u.data[seriesIdx][dataIdx]) + " (" + pctSinceStart + "% since start)";
        } else trailer = (0, $ahn3r.default).fmtNum(u.data[seriesIdx][dataIdx]) + "% since start";
        tooltip.textContent = fmtDate(new Date(u.data[0][dataIdx] * 1e3)) + " - " + commits[dataIdx][1].slice(0, 10) + "\n" + trailer;
    }
    return {
        hooks: {
            ready: [
                (u)=>{
                    over = u.root.querySelector(".u-over");
                    tooltipLeftOffset = parseFloat(over.style.left);
                    tooltipTopOffset = parseFloat(over.style.top);
                    u.root.querySelector(".u-wrap").appendChild(tooltip);
                    let clientX;
                    let clientY;
                    over.addEventListener("mousedown", (e)=>{
                        clientX = e.clientX;
                        clientY = e.clientY;
                    });
                    over.addEventListener("mouseup", (e)=>{
                        // clicked in-place
                        if (e.clientX == clientX && e.clientY == clientY) {
                            if (seriesIdx != null && dataIdx != null) onclick(u, seriesIdx, dataIdx);
                        }
                    });
                }
            ],
            setCursor: [
                (u)=>{
                    let c = u.cursor;
                    if (dataIdx != c.idx) {
                        dataIdx = c.idx;
                        if (seriesIdx != null) setTooltip(u);
                    }
                }
            ],
            setSeries: [
                (u, sidx)=>{
                    if (seriesIdx != sidx) {
                        seriesIdx = sidx;
                        if (sidx == null) hideTooltip();
                        else if (dataIdx != null) setTooltip(u);
                    }
                }
            ]
        }
    };
}
// Taken from https://leeoniya.github.io/uPlot/demos/zoom-wheel.html
function $55b51262fc77b7c9$var$wheelZoomPlugin(opts) {
    let factor = opts.factor || 0.75;
    let xMin, xMax, yMin, yMax, xRange, yRange;
    function clamp(nRange, nMin, nMax, fRange, fMin, fMax) {
        if (nRange > fRange) {
            nMin = fMin;
            nMax = fMax;
        } else if (nMin < fMin) {
            nMin = fMin;
            nMax = fMin + nRange;
        } else if (nMax > fMax) {
            nMax = fMax;
            nMin = fMax - nRange;
        }
        return [
            nMin,
            nMax
        ];
    }
    return {
        hooks: {
            ready: (u)=>{
                xMin = u.scales.x.min;
                xMax = u.scales.x.max;
                yMin = u.scales.y.min;
                yMax = u.scales.y.max;
                xRange = xMax - xMin;
                yRange = yMax - yMin;
                let over = u.over;
                let rect = over.getBoundingClientRect();
                // wheel drag pan
                over.addEventListener("mousedown", (e)=>{
                    if (e.button == 1) {
                        //	plot.style.cursor = "move";
                        e.preventDefault();
                        let left0 = e.clientX;
                        //	let top0 = e.clientY;
                        let scXMin0 = u.scales.x.min;
                        let scXMax0 = u.scales.x.max;
                        let xUnitsPerPx = u.posToVal(1, "x") - u.posToVal(0, "x");
                        function onmove(e) {
                            e.preventDefault();
                            let left1 = e.clientX;
                            //	let top1 = e.clientY;
                            let dx = xUnitsPerPx * (left1 - left0);
                            u.setScale("x", {
                                min: scXMin0 - dx,
                                max: scXMax0 - dx
                            });
                        }
                        function onup(_e) {
                            document.removeEventListener("mousemove", onmove);
                            document.removeEventListener("mouseup", onup);
                        }
                        document.addEventListener("mousemove", onmove);
                        document.addEventListener("mouseup", onup);
                    }
                });
                // wheel scroll zoom
                over.addEventListener("wheel", (e)=>{
                    e.preventDefault();
                    let { left: left, top: top } = u.cursor;
                    let leftPct = left / rect.width;
                    let btmPct = 1 - top / rect.height;
                    let xVal = u.posToVal(left, "x");
                    let yVal = u.posToVal(top, "y");
                    let oxRange = u.scales.x.max - u.scales.x.min;
                    let oyRange = u.scales.y.max - u.scales.y.min;
                    let nxRange = e.deltaY < 0 ? oxRange * factor : oxRange / factor;
                    let nxMin = xVal - leftPct * nxRange;
                    let nxMax = nxMin + nxRange;
                    [nxMin, nxMax] = clamp(nxRange, nxMin, nxMax, xRange, xMin, xMax);
                    let nyRange = e.deltaY < 0 ? oyRange * factor : oyRange / factor;
                    let nyMin = yVal - btmPct * nyRange;
                    let nyMax = nyMin + nyRange;
                    [nyMin, nyMax] = clamp(nyRange, nyMin, nyMax, yRange, yMin, yMax);
                    u.batch(()=>{
                        u.setScale("x", {
                            min: nxMin,
                            max: nxMax
                        });
                        u.setScale("y", {
                            min: nyMin,
                            max: nyMax
                        });
                    });
                });
            }
        }
    };
}
function $55b51262fc77b7c9$var$genPlotOpts({ width: width, height: height, yAxisLabel: yAxisLabel, series: series, commits: commits, stat: stat, alpha: alpha = 0.3, prox: prox = 5, absoluteMode: absoluteMode, hooks: hooks }) {
    return {
        width: width,
        height: height,
        series: series,
        legend: {
            show: false,
            live: false
        },
        focus: {
            alpha: alpha
        },
        cursor: {
            focus: {
                prox: prox
            },
            drag: {
                x: true,
                y: true
            }
        },
        scales: {
            y: {
                range: (_self, dataMin, dataMax)=>(0, $ahn3r.default).rangeNum(absoluteMode ? 0 : dataMin, dataMax, 0.2, true)
            }
        },
        axes: [
            {
                grid: {
                    show: false
                }
            },
            {
                label: yAxisLabel,
                space: 24,
                values: (_self, splits)=>{
                    return splits.map((v)=>{
                        return v >= 1e12 ? v / 1e12 + "T" : v >= 1e9 ? v / 1e9 + "G" : v >= 1e6 ? v / 1e6 + "M" : v >= 1e3 ? v / 1e3 + "k" : v;
                    });
                }
            }
        ],
        plugins: [
            {
                hooks: {
                    ...hooks
                }
            },
            $55b51262fc77b7c9$var$tooltipPlugin({
                onclick (_u, _seriesIdx, dataIdx) {
                    // No earlier data to show
                    if (dataIdx == 0) return;
                    let thisCommit = commits[dataIdx][1];
                    let prevCommit = commits[dataIdx - 1][1];
                    const params = new URLSearchParams({
                        start: prevCommit,
                        end: thisCommit,
                        stat: stat
                    });
                    // In Iframe, redirect o/w open in new tab
                    const url = `/compare.html?${params.toString()}`;
                    if (window.parent === window) window.open(url);
                    else window.location.assign(url);
                },
                commits: commits,
                absoluteMode: absoluteMode
            }),
            $55b51262fc77b7c9$var$wheelZoomPlugin({
                factor: 0.75
            })
        ]
    };
}
function $55b51262fc77b7c9$var$intoSet(data) {
    for (const name of Object.keys(data.benchmarks))data.benchmarks[name].interpolated_indices = new Set(data.benchmarks[name].interpolated_indices);
}
function $55b51262fc77b7c9$export$2318b747caa9fd64(data, selector, plotElement, opts) {
    const renderTitle = opts.renderTitle ?? true;
    const hooks = opts.hooks ?? {};
    const { width: width, height: height } = opts;
    $55b51262fc77b7c9$var$intoSet(data);
    const benchNames = Object.keys(data.benchmarks).sort();
    for (const benchName of benchNames){
        let yAxis = selector.stat;
        let yAxisUnit = null;
        switch(selector.stat){
            case "instructions:u":
                yAxis = "CPU instructions";
                yAxisUnit = "count";
                break;
            case "cycles:u":
                yAxis = "CPU cycles";
                yAxisUnit = "count";
                break;
            case "cpu-clock":
                yAxis = "CPU clock";
                yAxisUnit = "seconds";
                break;
            case "task-clock":
                yAxis = "Task clock";
                yAxisUnit = "seconds";
                break;
            case "min-wall-time":
                yAxis = "Minimum wall time";
                yAxisUnit = "nanoseconds";
                break;
            case "median-wall-time":
                yAxis = "Median wall time";
                yAxisUnit = "nanoseconds";
                break;
            case "mean-wall-time":
                yAxis = "Mean wall time";
                yAxisUnit = "nanoseconds";
                break;
            case "max-rss":
                yAxis = "Maximum resident set size";
                yAxisUnit = "kB";
                break;
            case "faults":
                yAxis = "Faults";
                yAxisUnit = "count";
                break;
            case "allocs":
                yAxis = "Number of allocations";
                yAxisUnit = null;
                break;
            case "memory":
                yAxis = "Size of allocations";
                yAxisUnit = "bytes";
                break;
        }
        if (selector.kind == "raw" && benchName == "Summary") yAxisUnit = "relative";
        else if (selector.kind == "percentfromfirst") yAxisUnit = "% change from first";
        else if (selector.kind == "percentrelative") yAxisUnit = "% change from previous";
        yAxis = yAxisUnit ? `${yAxis} (${yAxisUnit})` : yAxis;
        let yAxisLabel = yAxis;
        let seriesOpts = [
            {}
        ];
        let xVals = data.commits.map((c)=>c[0]);
        let plotData = [
            xVals
        ];
        let yVals = data.benchmarks[benchName].points;
        let color = "#7cb5ec";
        plotData.push(yVals);
        seriesOpts.push({
            width: devicePixelRatio,
            stroke: color
        });
        let indices = data.benchmarks[benchName].interpolated_indices;
        plotData = plotData.map((x)=>x.filter((_, i)=>!indices.has(i)));
        let plotOpts = $55b51262fc77b7c9$var$genPlotOpts({
            width: width,
            height: height,
            yAxisLabel: yAxisLabel,
            series: seriesOpts,
            commits: data.commits.filter((_, i)=>!indices.has(i)),
            stat: selector.stat,
            absoluteMode: selector.kind == "raw",
            hooks: hooks
        });
        if (renderTitle) plotOpts["title"] = benchName;
        new (0, $ahn3r.default)(plotOpts, plotData, plotElement);
    }
}

});
parcelRegister("ahn3r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77bd600c8f878470$export$2e2bcd8739ae039; });
/**
* Copyright (c) 2024, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* uPlot.js (μPlot)
* A small, fast chart for time series, lines, areas, ohlc & bars
* https://github.com/leeoniya/uPlot (v1.6.30)
*/ const $77bd600c8f878470$var$FEAT_TIME = true;
const $77bd600c8f878470$var$pre = "u-";
const $77bd600c8f878470$var$UPLOT = "uplot";
const $77bd600c8f878470$var$ORI_HZ = $77bd600c8f878470$var$pre + "hz";
const $77bd600c8f878470$var$ORI_VT = $77bd600c8f878470$var$pre + "vt";
const $77bd600c8f878470$var$TITLE = $77bd600c8f878470$var$pre + "title";
const $77bd600c8f878470$var$WRAP = $77bd600c8f878470$var$pre + "wrap";
const $77bd600c8f878470$var$UNDER = $77bd600c8f878470$var$pre + "under";
const $77bd600c8f878470$var$OVER = $77bd600c8f878470$var$pre + "over";
const $77bd600c8f878470$var$AXIS = $77bd600c8f878470$var$pre + "axis";
const $77bd600c8f878470$var$OFF = $77bd600c8f878470$var$pre + "off";
const $77bd600c8f878470$var$SELECT = $77bd600c8f878470$var$pre + "select";
const $77bd600c8f878470$var$CURSOR_X = $77bd600c8f878470$var$pre + "cursor-x";
const $77bd600c8f878470$var$CURSOR_Y = $77bd600c8f878470$var$pre + "cursor-y";
const $77bd600c8f878470$var$CURSOR_PT = $77bd600c8f878470$var$pre + "cursor-pt";
const $77bd600c8f878470$var$LEGEND = $77bd600c8f878470$var$pre + "legend";
const $77bd600c8f878470$var$LEGEND_LIVE = $77bd600c8f878470$var$pre + "live";
const $77bd600c8f878470$var$LEGEND_INLINE = $77bd600c8f878470$var$pre + "inline";
const $77bd600c8f878470$var$LEGEND_SERIES = $77bd600c8f878470$var$pre + "series";
const $77bd600c8f878470$var$LEGEND_MARKER = $77bd600c8f878470$var$pre + "marker";
const $77bd600c8f878470$var$LEGEND_LABEL = $77bd600c8f878470$var$pre + "label";
const $77bd600c8f878470$var$LEGEND_VALUE = $77bd600c8f878470$var$pre + "value";
const $77bd600c8f878470$var$WIDTH = "width";
const $77bd600c8f878470$var$HEIGHT = "height";
const $77bd600c8f878470$var$TOP = "top";
const $77bd600c8f878470$var$BOTTOM = "bottom";
const $77bd600c8f878470$var$LEFT = "left";
const $77bd600c8f878470$var$RIGHT = "right";
const $77bd600c8f878470$var$hexBlack = "#000";
const $77bd600c8f878470$var$transparent = $77bd600c8f878470$var$hexBlack + "0";
const $77bd600c8f878470$var$mousemove = "mousemove";
const $77bd600c8f878470$var$mousedown = "mousedown";
const $77bd600c8f878470$var$mouseup = "mouseup";
const $77bd600c8f878470$var$mouseenter = "mouseenter";
const $77bd600c8f878470$var$mouseleave = "mouseleave";
const $77bd600c8f878470$var$dblclick = "dblclick";
const $77bd600c8f878470$var$resize = "resize";
const $77bd600c8f878470$var$scroll = "scroll";
const $77bd600c8f878470$var$change = "change";
const $77bd600c8f878470$var$dppxchange = "dppxchange";
const $77bd600c8f878470$var$LEGEND_DISP = "--";
const $77bd600c8f878470$var$domEnv = typeof window != "undefined";
const $77bd600c8f878470$var$doc = $77bd600c8f878470$var$domEnv ? document : null;
const $77bd600c8f878470$var$win = $77bd600c8f878470$var$domEnv ? window : null;
const $77bd600c8f878470$var$nav = $77bd600c8f878470$var$domEnv ? navigator : null;
let $77bd600c8f878470$var$pxRatio;
//export const canHover = domEnv && !win.matchMedia('(hover: none)').matches;
let $77bd600c8f878470$var$query;
function $77bd600c8f878470$var$setPxRatio() {
    let _pxRatio = devicePixelRatio;
    // during print preview, Chrome fires off these dppx queries even without changes
    if ($77bd600c8f878470$var$pxRatio != _pxRatio) {
        $77bd600c8f878470$var$pxRatio = _pxRatio;
        $77bd600c8f878470$var$query && $77bd600c8f878470$var$off($77bd600c8f878470$var$change, $77bd600c8f878470$var$query, $77bd600c8f878470$var$setPxRatio);
        $77bd600c8f878470$var$query = matchMedia(`(min-resolution: ${$77bd600c8f878470$var$pxRatio - 0.001}dppx) and (max-resolution: ${$77bd600c8f878470$var$pxRatio + 0.001}dppx)`);
        $77bd600c8f878470$var$on($77bd600c8f878470$var$change, $77bd600c8f878470$var$query, $77bd600c8f878470$var$setPxRatio);
        $77bd600c8f878470$var$win.dispatchEvent(new CustomEvent($77bd600c8f878470$var$dppxchange));
    }
}
function $77bd600c8f878470$var$addClass(el, c) {
    if (c != null) {
        let cl = el.classList;
        !cl.contains(c) && cl.add(c);
    }
}
function $77bd600c8f878470$var$remClass(el, c) {
    let cl = el.classList;
    cl.contains(c) && cl.remove(c);
}
function $77bd600c8f878470$var$setStylePx(el, name, value) {
    el.style[name] = value + "px";
}
function $77bd600c8f878470$var$placeTag(tag, cls, targ, refEl) {
    let el = $77bd600c8f878470$var$doc.createElement(tag);
    if (cls != null) $77bd600c8f878470$var$addClass(el, cls);
    if (targ != null) targ.insertBefore(el, refEl);
    return el;
}
function $77bd600c8f878470$var$placeDiv(cls, targ) {
    return $77bd600c8f878470$var$placeTag("div", cls, targ);
}
const $77bd600c8f878470$var$xformCache = new WeakMap();
function $77bd600c8f878470$var$elTrans(el, xPos, yPos, xMax, yMax) {
    let xform = "translate(" + xPos + "px," + yPos + "px)";
    let xformOld = $77bd600c8f878470$var$xformCache.get(el);
    if (xform != xformOld) {
        el.style.transform = xform;
        $77bd600c8f878470$var$xformCache.set(el, xform);
        if (xPos < 0 || yPos < 0 || xPos > xMax || yPos > yMax) $77bd600c8f878470$var$addClass(el, $77bd600c8f878470$var$OFF);
        else $77bd600c8f878470$var$remClass(el, $77bd600c8f878470$var$OFF);
    }
}
const $77bd600c8f878470$var$colorCache = new WeakMap();
function $77bd600c8f878470$var$elColor(el, background, borderColor) {
    let newColor = background + borderColor;
    let oldColor = $77bd600c8f878470$var$colorCache.get(el);
    if (newColor != oldColor) {
        $77bd600c8f878470$var$colorCache.set(el, newColor);
        el.style.background = background;
        el.style.borderColor = borderColor;
    }
}
const $77bd600c8f878470$var$sizeCache = new WeakMap();
function $77bd600c8f878470$var$elSize(el, newWid, newHgt, centered) {
    let newSize = newWid + "" + newHgt;
    let oldSize = $77bd600c8f878470$var$sizeCache.get(el);
    if (newSize != oldSize) {
        $77bd600c8f878470$var$sizeCache.set(el, newSize);
        el.style.height = newHgt + "px";
        el.style.width = newWid + "px";
        el.style.marginLeft = centered ? -newWid / 2 + "px" : 0;
        el.style.marginTop = centered ? -newHgt / 2 + "px" : 0;
    }
}
const $77bd600c8f878470$var$evOpts = {
    passive: true
};
const $77bd600c8f878470$var$evOpts2 = {
    ...$77bd600c8f878470$var$evOpts,
    capture: true
};
function $77bd600c8f878470$var$on(ev, el, cb, capt) {
    el.addEventListener(ev, cb, capt ? $77bd600c8f878470$var$evOpts2 : $77bd600c8f878470$var$evOpts);
}
function $77bd600c8f878470$var$off(ev, el, cb, capt) {
    el.removeEventListener(ev, cb, capt ? $77bd600c8f878470$var$evOpts2 : $77bd600c8f878470$var$evOpts);
}
$77bd600c8f878470$var$domEnv && $77bd600c8f878470$var$setPxRatio();
// binary search for index of closest value
function $77bd600c8f878470$var$closestIdx(num, arr, lo, hi) {
    let mid;
    lo = lo || 0;
    hi = hi || arr.length - 1;
    let bitwise = hi <= 2147483647;
    while(hi - lo > 1){
        mid = bitwise ? lo + hi >> 1 : $77bd600c8f878470$var$floor((lo + hi) / 2);
        if (arr[mid] < num) lo = mid;
        else hi = mid;
    }
    if (num - arr[lo] <= arr[hi] - num) return lo;
    return hi;
}
function $77bd600c8f878470$var$nonNullIdx(data, _i0, _i1, dir) {
    for(let i = dir == 1 ? _i0 : _i1; i >= _i0 && i <= _i1; i += dir){
        if (data[i] != null) return i;
    }
    return -1;
}
function $77bd600c8f878470$var$getMinMax(data, _i0, _i1, sorted) {
    //	console.log("getMinMax()");
    let _min = $77bd600c8f878470$var$inf;
    let _max = -$77bd600c8f878470$var$inf;
    if (sorted == 1) {
        _min = data[_i0];
        _max = data[_i1];
    } else if (sorted == -1) {
        _min = data[_i1];
        _max = data[_i0];
    } else for(let i = _i0; i <= _i1; i++){
        let v = data[i];
        if (v != null) {
            if (v < _min) _min = v;
            if (v > _max) _max = v;
        }
    }
    return [
        _min,
        _max
    ];
}
function $77bd600c8f878470$var$getMinMaxLog(data, _i0, _i1) {
    //	console.log("getMinMax()");
    let _min = $77bd600c8f878470$var$inf;
    let _max = -$77bd600c8f878470$var$inf;
    for(let i = _i0; i <= _i1; i++){
        let v = data[i];
        if (v != null && v > 0) {
            if (v < _min) _min = v;
            if (v > _max) _max = v;
        }
    }
    return [
        _min,
        _max
    ];
}
function $77bd600c8f878470$var$rangeLog(min, max, base, fullMags) {
    let minSign = $77bd600c8f878470$var$sign(min);
    let maxSign = $77bd600c8f878470$var$sign(max);
    if (min == max) {
        if (minSign == -1) {
            min *= base;
            max /= base;
        } else {
            min /= base;
            max *= base;
        }
    }
    let logFn = base == 10 ? $77bd600c8f878470$var$log10 : $77bd600c8f878470$var$log2;
    let growMinAbs = minSign == 1 ? $77bd600c8f878470$var$floor : $77bd600c8f878470$var$ceil;
    let growMaxAbs = maxSign == 1 ? $77bd600c8f878470$var$ceil : $77bd600c8f878470$var$floor;
    let minExp = growMinAbs(logFn($77bd600c8f878470$var$abs(min)));
    let maxExp = growMaxAbs(logFn($77bd600c8f878470$var$abs(max)));
    let minIncr = $77bd600c8f878470$var$pow(base, minExp);
    let maxIncr = $77bd600c8f878470$var$pow(base, maxExp);
    // fix values like Math.pow(10, -5) === 0.000009999999999999999
    if (base == 10) {
        if (minExp < 0) minIncr = $77bd600c8f878470$var$roundDec(minIncr, -minExp);
        if (maxExp < 0) maxIncr = $77bd600c8f878470$var$roundDec(maxIncr, -maxExp);
    }
    if (fullMags || base == 2) {
        min = minIncr * minSign;
        max = maxIncr * maxSign;
    } else {
        min = $77bd600c8f878470$var$incrRoundDn(min, minIncr);
        max = $77bd600c8f878470$var$incrRoundUp(max, maxIncr);
    }
    return [
        min,
        max
    ];
}
function $77bd600c8f878470$var$rangeAsinh(min, max, base, fullMags) {
    let minMax = $77bd600c8f878470$var$rangeLog(min, max, base, fullMags);
    if (min == 0) minMax[0] = 0;
    if (max == 0) minMax[1] = 0;
    return minMax;
}
const $77bd600c8f878470$var$rangePad = 0.1;
const $77bd600c8f878470$var$autoRangePart = {
    mode: 3,
    pad: $77bd600c8f878470$var$rangePad
};
const $77bd600c8f878470$var$_eqRangePart = {
    pad: 0,
    soft: null,
    mode: 0
};
const $77bd600c8f878470$var$_eqRange = {
    min: $77bd600c8f878470$var$_eqRangePart,
    max: $77bd600c8f878470$var$_eqRangePart
};
// this ensures that non-temporal/numeric y-axes get multiple-snapped padding added above/below
// TODO: also account for incrs when snapping to ensure top of axis gets a tick & value
function $77bd600c8f878470$var$rangeNum(_min, _max, mult, extra) {
    if ($77bd600c8f878470$var$isObj(mult)) return $77bd600c8f878470$var$_rangeNum(_min, _max, mult);
    $77bd600c8f878470$var$_eqRangePart.pad = mult;
    $77bd600c8f878470$var$_eqRangePart.soft = extra ? 0 : null;
    $77bd600c8f878470$var$_eqRangePart.mode = extra ? 3 : 0;
    return $77bd600c8f878470$var$_rangeNum(_min, _max, $77bd600c8f878470$var$_eqRange);
}
// nullish coalesce
function $77bd600c8f878470$var$ifNull(lh, rh) {
    return lh == null ? rh : lh;
}
// checks if given index range in an array contains a non-null value
// aka a range-bounded Array.some()
function $77bd600c8f878470$var$hasData(data, idx0, idx1) {
    idx0 = $77bd600c8f878470$var$ifNull(idx0, 0);
    idx1 = $77bd600c8f878470$var$ifNull(idx1, data.length - 1);
    while(idx0 <= idx1){
        if (data[idx0] != null) return true;
        idx0++;
    }
    return false;
}
function $77bd600c8f878470$var$_rangeNum(_min, _max, cfg) {
    let cmin = cfg.min;
    let cmax = cfg.max;
    let padMin = $77bd600c8f878470$var$ifNull(cmin.pad, 0);
    let padMax = $77bd600c8f878470$var$ifNull(cmax.pad, 0);
    let hardMin = $77bd600c8f878470$var$ifNull(cmin.hard, -$77bd600c8f878470$var$inf);
    let hardMax = $77bd600c8f878470$var$ifNull(cmax.hard, $77bd600c8f878470$var$inf);
    let softMin = $77bd600c8f878470$var$ifNull(cmin.soft, $77bd600c8f878470$var$inf);
    let softMax = $77bd600c8f878470$var$ifNull(cmax.soft, -$77bd600c8f878470$var$inf);
    let softMinMode = $77bd600c8f878470$var$ifNull(cmin.mode, 0);
    let softMaxMode = $77bd600c8f878470$var$ifNull(cmax.mode, 0);
    let delta = _max - _min;
    let deltaMag = $77bd600c8f878470$var$log10(delta);
    let scalarMax = $77bd600c8f878470$var$max($77bd600c8f878470$var$abs(_min), $77bd600c8f878470$var$abs(_max));
    let scalarMag = $77bd600c8f878470$var$log10(scalarMax);
    let scalarMagDelta = $77bd600c8f878470$var$abs(scalarMag - deltaMag);
    // this handles situations like 89.7, 89.69999999999999
    // by assuming 0.001x deltas are precision errors
    //	if (delta > 0 && delta < abs(_max) / 1e3)
    //		delta = 0;
    // treat data as flat if delta is less than 1 billionth
    // or range is 11+ orders of magnitude below raw values, e.g. 99999999.99999996 - 100000000.00000004
    if (delta < 1e-9 || scalarMagDelta > 10) {
        delta = 0;
        // if soft mode is 2 and all vals are flat at 0, avoid the 0.1 * 1e3 fallback
        // this prevents 0,0,0 from ranging to -100,100 when softMin/softMax are -1,1
        if (_min == 0 || _max == 0) {
            delta = 1e-9;
            if (softMinMode == 2 && softMin != $77bd600c8f878470$var$inf) padMin = 0;
            if (softMaxMode == 2 && softMax != -$77bd600c8f878470$var$inf) padMax = 0;
        }
    }
    let nonZeroDelta = delta || scalarMax || 1e3;
    let mag = $77bd600c8f878470$var$log10(nonZeroDelta);
    let base = $77bd600c8f878470$var$pow(10, $77bd600c8f878470$var$floor(mag));
    let _padMin = nonZeroDelta * (delta == 0 ? _min == 0 ? .1 : 1 : padMin);
    let _newMin = $77bd600c8f878470$var$roundDec($77bd600c8f878470$var$incrRoundDn(_min - _padMin, base / 10), 9);
    let _softMin = _min >= softMin && (softMinMode == 1 || softMinMode == 3 && _newMin <= softMin || softMinMode == 2 && _newMin >= softMin) ? softMin : $77bd600c8f878470$var$inf;
    let minLim = $77bd600c8f878470$var$max(hardMin, _newMin < _softMin && _min >= _softMin ? _softMin : $77bd600c8f878470$var$min(_softMin, _newMin));
    let _padMax = nonZeroDelta * (delta == 0 ? _max == 0 ? .1 : 1 : padMax);
    let _newMax = $77bd600c8f878470$var$roundDec($77bd600c8f878470$var$incrRoundUp(_max + _padMax, base / 10), 9);
    let _softMax = _max <= softMax && (softMaxMode == 1 || softMaxMode == 3 && _newMax >= softMax || softMaxMode == 2 && _newMax <= softMax) ? softMax : -$77bd600c8f878470$var$inf;
    let maxLim = $77bd600c8f878470$var$min(hardMax, _newMax > _softMax && _max <= _softMax ? _softMax : $77bd600c8f878470$var$max(_softMax, _newMax));
    if (minLim == maxLim && minLim == 0) maxLim = 100;
    return [
        minLim,
        maxLim
    ];
}
// alternative: https://stackoverflow.com/a/2254896
const $77bd600c8f878470$var$numFormatter = new Intl.NumberFormat($77bd600c8f878470$var$domEnv ? $77bd600c8f878470$var$nav.language : "en-US");
const $77bd600c8f878470$var$fmtNum = (val)=>$77bd600c8f878470$var$numFormatter.format(val);
const $77bd600c8f878470$var$M = Math;
const $77bd600c8f878470$var$PI = $77bd600c8f878470$var$M.PI;
const $77bd600c8f878470$var$abs = $77bd600c8f878470$var$M.abs;
const $77bd600c8f878470$var$floor = $77bd600c8f878470$var$M.floor;
const $77bd600c8f878470$var$round = $77bd600c8f878470$var$M.round;
const $77bd600c8f878470$var$ceil = $77bd600c8f878470$var$M.ceil;
const $77bd600c8f878470$var$min = $77bd600c8f878470$var$M.min;
const $77bd600c8f878470$var$max = $77bd600c8f878470$var$M.max;
const $77bd600c8f878470$var$pow = $77bd600c8f878470$var$M.pow;
const $77bd600c8f878470$var$sign = $77bd600c8f878470$var$M.sign;
const $77bd600c8f878470$var$log10 = $77bd600c8f878470$var$M.log10;
const $77bd600c8f878470$var$log2 = $77bd600c8f878470$var$M.log2;
// TODO: seems like this needs to match asinh impl if the passed v is tweaked?
const $77bd600c8f878470$var$sinh = (v, linthresh = 1)=>$77bd600c8f878470$var$M.sinh(v) * linthresh;
const $77bd600c8f878470$var$asinh = (v, linthresh = 1)=>$77bd600c8f878470$var$M.asinh(v / linthresh);
const $77bd600c8f878470$var$inf = Infinity;
function $77bd600c8f878470$var$numIntDigits(x) {
    return ($77bd600c8f878470$var$log10((x ^ x >> 31) - (x >> 31)) | 0) + 1;
}
function $77bd600c8f878470$var$clamp(num, _min, _max) {
    return $77bd600c8f878470$var$min($77bd600c8f878470$var$max(num, _min), _max);
}
function $77bd600c8f878470$var$fnOrSelf(v) {
    return typeof v == "function" ? v : ()=>v;
}
const $77bd600c8f878470$var$noop = ()=>{};
const $77bd600c8f878470$var$retArg0 = (_0)=>_0;
const $77bd600c8f878470$var$retArg1 = (_0, _1)=>_1;
const $77bd600c8f878470$var$retNull = (_)=>null;
const $77bd600c8f878470$var$retTrue = (_)=>true;
const $77bd600c8f878470$var$retEq = (a, b)=>a == b;
// this will probably prevent tick incrs > 14 decimal places
// (we generate up to 17 dec, see fixedDec const)
const $77bd600c8f878470$var$fixFloat = (v)=>$77bd600c8f878470$var$roundDec(v, 14);
function $77bd600c8f878470$var$incrRound(num, incr) {
    return $77bd600c8f878470$var$fixFloat($77bd600c8f878470$var$roundDec($77bd600c8f878470$var$fixFloat(num / incr)) * incr);
}
function $77bd600c8f878470$var$incrRoundUp(num, incr) {
    return $77bd600c8f878470$var$fixFloat($77bd600c8f878470$var$ceil($77bd600c8f878470$var$fixFloat(num / incr)) * incr);
}
function $77bd600c8f878470$var$incrRoundDn(num, incr) {
    return $77bd600c8f878470$var$fixFloat($77bd600c8f878470$var$floor($77bd600c8f878470$var$fixFloat(num / incr)) * incr);
}
// https://stackoverflow.com/a/48764436
// rounds half away from zero
function $77bd600c8f878470$var$roundDec(val, dec = 0) {
    if ($77bd600c8f878470$var$isInt(val)) return val;
    //	else if (dec == 0)
    //		return round(val);
    let p = 10 ** dec;
    let n = val * p * (1 + Number.EPSILON);
    return $77bd600c8f878470$var$round(n) / p;
}
const $77bd600c8f878470$var$fixedDec = new Map();
function $77bd600c8f878470$var$guessDec(num) {
    return (("" + num).split(".")[1] || "").length;
}
function $77bd600c8f878470$var$genIncrs(base, minExp, maxExp, mults) {
    let incrs = [];
    let multDec = mults.map($77bd600c8f878470$var$guessDec);
    for(let exp = minExp; exp < maxExp; exp++){
        let expa = $77bd600c8f878470$var$abs(exp);
        let mag = $77bd600c8f878470$var$roundDec($77bd600c8f878470$var$pow(base, exp), expa);
        for(let i = 0; i < mults.length; i++){
            let _incr = mults[i] * mag;
            let dec = (_incr >= 0 && exp >= 0 ? 0 : expa) + (exp >= multDec[i] ? 0 : multDec[i]);
            let incr = $77bd600c8f878470$var$roundDec(_incr, dec);
            incrs.push(incr);
            $77bd600c8f878470$var$fixedDec.set(incr, dec);
        }
    }
    return incrs;
}
//export const assign = Object.assign;
const $77bd600c8f878470$var$EMPTY_OBJ = {};
const $77bd600c8f878470$var$EMPTY_ARR = [];
const $77bd600c8f878470$var$nullNullTuple = [
    null,
    null
];
const $77bd600c8f878470$var$isArr = Array.isArray;
const $77bd600c8f878470$var$isInt = Number.isInteger;
const $77bd600c8f878470$var$isUndef = (v)=>v === void 0;
function $77bd600c8f878470$var$isStr(v) {
    return typeof v == "string";
}
function $77bd600c8f878470$var$isObj(v) {
    let is = false;
    if (v != null) {
        let c = v.constructor;
        is = c == null || c == Object;
    }
    return is;
}
function $77bd600c8f878470$var$fastIsObj(v) {
    return v != null && typeof v == "object";
}
const $77bd600c8f878470$var$TypedArray = Object.getPrototypeOf(Uint8Array);
function $77bd600c8f878470$var$copy(o, _isObj = $77bd600c8f878470$var$isObj) {
    let out;
    if ($77bd600c8f878470$var$isArr(o)) {
        let val = o.find((v)=>v != null);
        if ($77bd600c8f878470$var$isArr(val) || _isObj(val)) {
            out = Array(o.length);
            for(let i = 0; i < o.length; i++)out[i] = $77bd600c8f878470$var$copy(o[i], _isObj);
        } else out = o.slice();
    } else if (o instanceof $77bd600c8f878470$var$TypedArray) out = o.slice();
    else if (_isObj(o)) {
        out = {};
        for(let k in o)out[k] = $77bd600c8f878470$var$copy(o[k], _isObj);
    } else out = o;
    return out;
}
function $77bd600c8f878470$var$assign(targ) {
    let args = arguments;
    for(let i = 1; i < args.length; i++){
        let src = args[i];
        for(let key in src)if ($77bd600c8f878470$var$isObj(targ[key])) $77bd600c8f878470$var$assign(targ[key], $77bd600c8f878470$var$copy(src[key]));
        else targ[key] = $77bd600c8f878470$var$copy(src[key]);
    }
    return targ;
}
// nullModes
const $77bd600c8f878470$var$NULL_REMOVE = 0; // nulls are converted to undefined (e.g. for spanGaps: true)
const $77bd600c8f878470$var$NULL_RETAIN = 1; // nulls are retained, with alignment artifacts set to undefined (default)
const $77bd600c8f878470$var$NULL_EXPAND = 2; // nulls are expanded to include any adjacent alignment artifacts
// sets undefined values to nulls when adjacent to existing nulls (minesweeper)
function $77bd600c8f878470$var$nullExpand(yVals, nullIdxs, alignedLen) {
    for(let i = 0, xi, lastNullIdx = -1; i < nullIdxs.length; i++){
        let nullIdx = nullIdxs[i];
        if (nullIdx > lastNullIdx) {
            xi = nullIdx - 1;
            while(xi >= 0 && yVals[xi] == null)yVals[xi--] = null;
            xi = nullIdx + 1;
            while(xi < alignedLen && yVals[xi] == null)yVals[lastNullIdx = xi++] = null;
        }
    }
}
// nullModes is a tables-matched array indicating how to treat nulls in each series
// output is sorted ASC on the joined field (table[0]) and duplicate join values are collapsed
function $77bd600c8f878470$var$join(tables, nullModes) {
    if ($77bd600c8f878470$var$allHeadersSame(tables)) {
        //	console.log('cheap join!');
        let table = tables[0].slice();
        for(let i = 1; i < tables.length; i++)table.push(...tables[i].slice(1));
        if (!$77bd600c8f878470$var$isAsc(table[0])) table = $77bd600c8f878470$var$sortCols(table);
        return table;
    }
    let xVals = new Set();
    for(let ti = 0; ti < tables.length; ti++){
        let t = tables[ti];
        let xs = t[0];
        let len = xs.length;
        for(let i = 0; i < len; i++)xVals.add(xs[i]);
    }
    let data = [
        Array.from(xVals).sort((a, b)=>a - b)
    ];
    let alignedLen = data[0].length;
    let xIdxs = new Map();
    for(let i = 0; i < alignedLen; i++)xIdxs.set(data[0][i], i);
    for(let ti = 0; ti < tables.length; ti++){
        let t = tables[ti];
        let xs = t[0];
        for(let si = 1; si < t.length; si++){
            let ys = t[si];
            let yVals = Array(alignedLen).fill(undefined);
            let nullMode = nullModes ? nullModes[ti][si] : $77bd600c8f878470$var$NULL_RETAIN;
            let nullIdxs = [];
            for(let i = 0; i < ys.length; i++){
                let yVal = ys[i];
                let alignedIdx = xIdxs.get(xs[i]);
                if (yVal === null) {
                    if (nullMode != $77bd600c8f878470$var$NULL_REMOVE) {
                        yVals[alignedIdx] = yVal;
                        if (nullMode == $77bd600c8f878470$var$NULL_EXPAND) nullIdxs.push(alignedIdx);
                    }
                } else yVals[alignedIdx] = yVal;
            }
            $77bd600c8f878470$var$nullExpand(yVals, nullIdxs, alignedLen);
            data.push(yVals);
        }
    }
    return data;
}
const $77bd600c8f878470$var$microTask = typeof queueMicrotask == "undefined" ? (fn)=>Promise.resolve().then(fn) : queueMicrotask;
// TODO: https://github.com/dy/sort-ids (~2x faster for 1e5+ arrays)
function $77bd600c8f878470$var$sortCols(table) {
    let head = table[0];
    let rlen = head.length;
    let idxs = Array(rlen);
    for(let i = 0; i < idxs.length; i++)idxs[i] = i;
    idxs.sort((i0, i1)=>head[i0] - head[i1]);
    let table2 = [];
    for(let i = 0; i < table.length; i++){
        let row = table[i];
        let row2 = Array(rlen);
        for(let j = 0; j < rlen; j++)row2[j] = row[idxs[j]];
        table2.push(row2);
    }
    return table2;
}
// test if we can do cheap join (all join fields same)
function $77bd600c8f878470$var$allHeadersSame(tables) {
    let vals0 = tables[0][0];
    let len0 = vals0.length;
    for(let i = 1; i < tables.length; i++){
        let vals1 = tables[i][0];
        if (vals1.length != len0) return false;
        if (vals1 != vals0) for(let j = 0; j < len0; j++){
            if (vals1[j] != vals0[j]) return false;
        }
    }
    return true;
}
function $77bd600c8f878470$var$isAsc(vals, samples = 100) {
    const len = vals.length;
    // empty or single value
    if (len <= 1) return true;
    // skip leading & trailing nullish
    let firstIdx = 0;
    let lastIdx = len - 1;
    while(firstIdx <= lastIdx && vals[firstIdx] == null)firstIdx++;
    while(lastIdx >= firstIdx && vals[lastIdx] == null)lastIdx--;
    // all nullish or one value surrounded by nullish
    if (lastIdx <= firstIdx) return true;
    const stride = $77bd600c8f878470$var$max(1, $77bd600c8f878470$var$floor((lastIdx - firstIdx + 1) / samples));
    for(let prevVal = vals[firstIdx], i = firstIdx + stride; i <= lastIdx; i += stride){
        const v = vals[i];
        if (v != null) {
            if (v <= prevVal) return false;
            prevVal = v;
        }
    }
    return true;
}
const $77bd600c8f878470$var$months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $77bd600c8f878470$var$days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
function $77bd600c8f878470$var$slice3(str) {
    return str.slice(0, 3);
}
const $77bd600c8f878470$var$days3 = $77bd600c8f878470$var$days.map($77bd600c8f878470$var$slice3);
const $77bd600c8f878470$var$months3 = $77bd600c8f878470$var$months.map($77bd600c8f878470$var$slice3);
const $77bd600c8f878470$var$engNames = {
    MMMM: $77bd600c8f878470$var$months,
    MMM: $77bd600c8f878470$var$months3,
    WWWW: $77bd600c8f878470$var$days,
    WWW: $77bd600c8f878470$var$days3
};
function $77bd600c8f878470$var$zeroPad2(int) {
    return (int < 10 ? "0" : "") + int;
}
function $77bd600c8f878470$var$zeroPad3(int) {
    return (int < 10 ? "00" : int < 100 ? "0" : "") + int;
}
/*
function suffix(int) {
	let mod10 = int % 10;

	return int + (
		mod10 == 1 && int != 11 ? "st" :
		mod10 == 2 && int != 12 ? "nd" :
		mod10 == 3 && int != 13 ? "rd" : "th"
	);
}
*/ const $77bd600c8f878470$var$subs = {
    // 2019
    YYYY: (d)=>d.getFullYear(),
    // 19
    YY: (d)=>(d.getFullYear() + "").slice(2),
    // July
    MMMM: (d, names)=>names.MMMM[d.getMonth()],
    // Jul
    MMM: (d, names)=>names.MMM[d.getMonth()],
    // 07
    MM: (d)=>$77bd600c8f878470$var$zeroPad2(d.getMonth() + 1),
    // 7
    M: (d)=>d.getMonth() + 1,
    // 09
    DD: (d)=>$77bd600c8f878470$var$zeroPad2(d.getDate()),
    // 9
    D: (d)=>d.getDate(),
    // Monday
    WWWW: (d, names)=>names.WWWW[d.getDay()],
    // Mon
    WWW: (d, names)=>names.WWW[d.getDay()],
    // 03
    HH: (d)=>$77bd600c8f878470$var$zeroPad2(d.getHours()),
    // 3
    H: (d)=>d.getHours(),
    // 9 (12hr, unpadded)
    h: (d)=>{
        let h = d.getHours();
        return h == 0 ? 12 : h > 12 ? h - 12 : h;
    },
    // AM
    AA: (d)=>d.getHours() >= 12 ? "PM" : "AM",
    // am
    aa: (d)=>d.getHours() >= 12 ? "pm" : "am",
    // a
    a: (d)=>d.getHours() >= 12 ? "p" : "a",
    // 09
    mm: (d)=>$77bd600c8f878470$var$zeroPad2(d.getMinutes()),
    // 9
    m: (d)=>d.getMinutes(),
    // 09
    ss: (d)=>$77bd600c8f878470$var$zeroPad2(d.getSeconds()),
    // 9
    s: (d)=>d.getSeconds(),
    // 374
    fff: (d)=>$77bd600c8f878470$var$zeroPad3(d.getMilliseconds())
};
function $77bd600c8f878470$var$fmtDate(tpl, names) {
    names = names || $77bd600c8f878470$var$engNames;
    let parts = [];
    let R = /\{([a-z]+)\}|[^{]+/gi, m;
    while(m = R.exec(tpl))parts.push(m[0][0] == "{" ? $77bd600c8f878470$var$subs[m[1]] : m[0]);
    return (d)=>{
        let out = "";
        for(let i = 0; i < parts.length; i++)out += typeof parts[i] == "string" ? parts[i] : parts[i](d, names);
        return out;
    };
}
const $77bd600c8f878470$var$localTz = new Intl.DateTimeFormat().resolvedOptions().timeZone;
// https://stackoverflow.com/questions/15141762/how-to-initialize-a-javascript-date-to-a-particular-time-zone/53652131#53652131
function $77bd600c8f878470$var$tzDate(date, tz) {
    let date2;
    // perf optimization
    if (tz == "UTC" || tz == "Etc/UTC") date2 = new Date(+date + date.getTimezoneOffset() * 6e4);
    else if (tz == $77bd600c8f878470$var$localTz) date2 = date;
    else {
        date2 = new Date(date.toLocaleString("en-US", {
            timeZone: tz
        }));
        date2.setMilliseconds(date.getMilliseconds());
    }
    return date2;
}
//export const series = [];
// default formatters:
const $77bd600c8f878470$var$onlyWhole = (v)=>v % 1 == 0;
const $77bd600c8f878470$var$allMults = [
    1,
    2,
    2.5,
    5
];
// ...0.01, 0.02, 0.025, 0.05, 0.1, 0.2, 0.25, 0.5
const $77bd600c8f878470$var$decIncrs = $77bd600c8f878470$var$genIncrs(10, -16, 0, $77bd600c8f878470$var$allMults);
// 1, 2, 2.5, 5, 10, 20, 25, 50...
const $77bd600c8f878470$var$oneIncrs = $77bd600c8f878470$var$genIncrs(10, 0, 16, $77bd600c8f878470$var$allMults);
// 1, 2,      5, 10, 20, 25, 50...
const $77bd600c8f878470$var$wholeIncrs = $77bd600c8f878470$var$oneIncrs.filter($77bd600c8f878470$var$onlyWhole);
const $77bd600c8f878470$var$numIncrs = $77bd600c8f878470$var$decIncrs.concat($77bd600c8f878470$var$oneIncrs);
const $77bd600c8f878470$var$NL = "\n";
const $77bd600c8f878470$var$yyyy = "{YYYY}";
const $77bd600c8f878470$var$NLyyyy = $77bd600c8f878470$var$NL + $77bd600c8f878470$var$yyyy;
const $77bd600c8f878470$var$md = "{M}/{D}";
const $77bd600c8f878470$var$NLmd = $77bd600c8f878470$var$NL + $77bd600c8f878470$var$md;
const $77bd600c8f878470$var$NLmdyy = $77bd600c8f878470$var$NLmd + "/{YY}";
const $77bd600c8f878470$var$aa = "{aa}";
const $77bd600c8f878470$var$hmm = "{h}:{mm}";
const $77bd600c8f878470$var$hmmaa = $77bd600c8f878470$var$hmm + $77bd600c8f878470$var$aa;
const $77bd600c8f878470$var$NLhmmaa = $77bd600c8f878470$var$NL + $77bd600c8f878470$var$hmmaa;
const $77bd600c8f878470$var$ss = ":{ss}";
const $77bd600c8f878470$var$_ = null;
function $77bd600c8f878470$var$genTimeStuffs(ms) {
    let s = ms * 1e3, m = s * 60, h = m * 60, d = h * 24, mo = d * 30, y = d * 365;
    // min of 1e-3 prevents setting a temporal x ticks too small since Date objects cannot advance ticks smaller than 1ms
    let subSecIncrs = ms == 1 ? $77bd600c8f878470$var$genIncrs(10, 0, 3, $77bd600c8f878470$var$allMults).filter($77bd600c8f878470$var$onlyWhole) : $77bd600c8f878470$var$genIncrs(10, -3, 0, $77bd600c8f878470$var$allMults);
    let timeIncrs = subSecIncrs.concat([
        // minute divisors (# of secs)
        s,
        s * 5,
        s * 10,
        s * 15,
        s * 30,
        // hour divisors (# of mins)
        m,
        m * 5,
        m * 10,
        m * 15,
        m * 30,
        // day divisors (# of hrs)
        h,
        h * 2,
        h * 3,
        h * 4,
        h * 6,
        h * 8,
        h * 12,
        // month divisors TODO: need more?
        d,
        d * 2,
        d * 3,
        d * 4,
        d * 5,
        d * 6,
        d * 7,
        d * 8,
        d * 9,
        d * 10,
        d * 15,
        // year divisors (# months, approx)
        mo,
        mo * 2,
        mo * 3,
        mo * 4,
        mo * 6,
        // century divisors
        y,
        y * 2,
        y * 5,
        y * 10,
        y * 25,
        y * 50,
        y * 100
    ]);
    // [0]:   minimum num secs in the tick incr
    // [1]:   default tick format
    // [2-7]: rollover tick formats
    // [8]:   mode: 0: replace [1] -> [2-7], 1: concat [1] + [2-7]
    const _timeAxisStamps = [
        //   tick incr    default          year                    month   day                   hour    min       sec   mode
        [
            y,
            $77bd600c8f878470$var$yyyy,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            1
        ],
        [
            d * 28,
            "{MMM}",
            $77bd600c8f878470$var$NLyyyy,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            1
        ],
        [
            d,
            $77bd600c8f878470$var$md,
            $77bd600c8f878470$var$NLyyyy,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            1
        ],
        [
            h,
            "{h}" + $77bd600c8f878470$var$aa,
            $77bd600c8f878470$var$NLmdyy,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$NLmd,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            1
        ],
        [
            m,
            $77bd600c8f878470$var$hmmaa,
            $77bd600c8f878470$var$NLmdyy,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$NLmd,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$_,
            1
        ],
        [
            s,
            $77bd600c8f878470$var$ss,
            $77bd600c8f878470$var$NLmdyy + " " + $77bd600c8f878470$var$hmmaa,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$NLmd + " " + $77bd600c8f878470$var$hmmaa,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$NLhmmaa,
            $77bd600c8f878470$var$_,
            1
        ],
        [
            ms,
            $77bd600c8f878470$var$ss + ".{fff}",
            $77bd600c8f878470$var$NLmdyy + " " + $77bd600c8f878470$var$hmmaa,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$NLmd + " " + $77bd600c8f878470$var$hmmaa,
            $77bd600c8f878470$var$_,
            $77bd600c8f878470$var$NLhmmaa,
            $77bd600c8f878470$var$_,
            1
        ]
    ];
    // the ensures that axis ticks, values & grid are aligned to logical temporal breakpoints and not an arbitrary timestamp
    // https://www.timeanddate.com/time/dst/
    // https://www.timeanddate.com/time/dst/2019.html
    // https://www.epochconverter.com/timezones
    function timeAxisSplits(tzDate) {
        return (self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace)=>{
            let splits = [];
            let isYr = foundIncr >= y;
            let isMo = foundIncr >= mo && foundIncr < y;
            // get the timezone-adjusted date
            let minDate = tzDate(scaleMin);
            let minDateTs = $77bd600c8f878470$var$roundDec(minDate * ms, 3);
            // get ts of 12am (this lands us at or before the original scaleMin)
            let minMin = $77bd600c8f878470$var$mkDate(minDate.getFullYear(), isYr ? 0 : minDate.getMonth(), isMo || isYr ? 1 : minDate.getDate());
            let minMinTs = $77bd600c8f878470$var$roundDec(minMin * ms, 3);
            if (isMo || isYr) {
                let moIncr = isMo ? foundIncr / mo : 0;
                let yrIncr = isYr ? foundIncr / y : 0;
                //	let tzOffset = scaleMin - minDateTs;		// needed?
                let split = minDateTs == minMinTs ? minDateTs : $77bd600c8f878470$var$roundDec($77bd600c8f878470$var$mkDate(minMin.getFullYear() + yrIncr, minMin.getMonth() + moIncr, 1) * ms, 3);
                let splitDate = new Date($77bd600c8f878470$var$round(split / ms));
                let baseYear = splitDate.getFullYear();
                let baseMonth = splitDate.getMonth();
                for(let i = 0; split <= scaleMax; i++){
                    let next = $77bd600c8f878470$var$mkDate(baseYear + yrIncr * i, baseMonth + moIncr * i, 1);
                    let offs = next - tzDate($77bd600c8f878470$var$roundDec(next * ms, 3));
                    split = $77bd600c8f878470$var$roundDec((+next + offs) * ms, 3);
                    if (split <= scaleMax) splits.push(split);
                }
            } else {
                let incr0 = foundIncr >= d ? d : foundIncr;
                let tzOffset = $77bd600c8f878470$var$floor(scaleMin) - $77bd600c8f878470$var$floor(minDateTs);
                let split = minMinTs + tzOffset + $77bd600c8f878470$var$incrRoundUp(minDateTs - minMinTs, incr0);
                splits.push(split);
                let date0 = tzDate(split);
                let prevHour = date0.getHours() + date0.getMinutes() / m + date0.getSeconds() / h;
                let incrHours = foundIncr / h;
                let minSpace = self.axes[axisIdx]._space;
                let pctSpace = foundSpace / minSpace;
                while(true){
                    split = $77bd600c8f878470$var$roundDec(split + foundIncr, ms == 1 ? 0 : 3);
                    if (split > scaleMax) break;
                    if (incrHours > 1) {
                        let expectedHour = $77bd600c8f878470$var$floor($77bd600c8f878470$var$roundDec(prevHour + incrHours, 6)) % 24;
                        let splitDate = tzDate(split);
                        let actualHour = splitDate.getHours();
                        let dstShift = actualHour - expectedHour;
                        if (dstShift > 1) dstShift = -1;
                        split -= dstShift * h;
                        prevHour = (prevHour + incrHours) % 24;
                        // add a tick only if it's further than 70% of the min allowed label spacing
                        let prevSplit = splits[splits.length - 1];
                        let pctIncr = $77bd600c8f878470$var$roundDec((split - prevSplit) / foundIncr, 3);
                        if (pctIncr * pctSpace >= .7) splits.push(split);
                    } else splits.push(split);
                }
            }
            return splits;
        };
    }
    return [
        timeIncrs,
        _timeAxisStamps,
        timeAxisSplits
    ];
}
const [$77bd600c8f878470$var$timeIncrsMs, $77bd600c8f878470$var$_timeAxisStampsMs, $77bd600c8f878470$var$timeAxisSplitsMs] = $77bd600c8f878470$var$genTimeStuffs(1);
const [$77bd600c8f878470$var$timeIncrsS, $77bd600c8f878470$var$_timeAxisStampsS, $77bd600c8f878470$var$timeAxisSplitsS] = $77bd600c8f878470$var$genTimeStuffs(1e-3);
// base 2
$77bd600c8f878470$var$genIncrs(2, -53, 53, [
    1
]);
/*
console.log({
	decIncrs,
	oneIncrs,
	wholeIncrs,
	numIncrs,
	timeIncrs,
	fixedDec,
});
*/ function $77bd600c8f878470$var$timeAxisStamps(stampCfg, fmtDate) {
    return stampCfg.map((s)=>s.map((v, i)=>i == 0 || i == 8 || v == null ? v : fmtDate(i == 1 || s[8] == 0 ? v : s[1] + v)));
}
// TODO: will need to accept spaces[] and pull incr into the loop when grid will be non-uniform, eg for log scales.
// currently we ignore this for months since they're *nearly* uniform and the added complexity is not worth it
function $77bd600c8f878470$var$timeAxisVals(tzDate, stamps) {
    return (self, splits, axisIdx, foundSpace, foundIncr)=>{
        let s = stamps.find((s)=>foundIncr >= s[0]) || stamps[stamps.length - 1];
        // these track boundaries when a full label is needed again
        let prevYear;
        let prevMnth;
        let prevDate;
        let prevHour;
        let prevMins;
        let prevSecs;
        return splits.map((split)=>{
            let date = tzDate(split);
            let newYear = date.getFullYear();
            let newMnth = date.getMonth();
            let newDate = date.getDate();
            let newHour = date.getHours();
            let newMins = date.getMinutes();
            let newSecs = date.getSeconds();
            let stamp = newYear != prevYear && s[2] || newMnth != prevMnth && s[3] || newDate != prevDate && s[4] || newHour != prevHour && s[5] || newMins != prevMins && s[6] || newSecs != prevSecs && s[7] || s[1];
            prevYear = newYear;
            prevMnth = newMnth;
            prevDate = newDate;
            prevHour = newHour;
            prevMins = newMins;
            prevSecs = newSecs;
            return stamp(date);
        });
    };
}
// for when axis.values is defined as a static fmtDate template string
function $77bd600c8f878470$var$timeAxisVal(tzDate, dateTpl) {
    let stamp = $77bd600c8f878470$var$fmtDate(dateTpl);
    return (self, splits, axisIdx, foundSpace, foundIncr)=>splits.map((split)=>stamp(tzDate(split)));
}
function $77bd600c8f878470$var$mkDate(y, m, d) {
    return new Date(y, m, d);
}
function $77bd600c8f878470$var$timeSeriesStamp(stampCfg, fmtDate) {
    return fmtDate(stampCfg);
}
const $77bd600c8f878470$var$_timeSeriesStamp = "{YYYY}-{MM}-{DD} {h}:{mm}{aa}";
function $77bd600c8f878470$var$timeSeriesVal(tzDate, stamp) {
    return (self, val, seriesIdx, dataIdx)=>dataIdx == null ? $77bd600c8f878470$var$LEGEND_DISP : stamp(tzDate(val));
}
function $77bd600c8f878470$var$legendStroke(self, seriesIdx) {
    let s = self.series[seriesIdx];
    return s.width ? s.stroke(self, seriesIdx) : s.points.width ? s.points.stroke(self, seriesIdx) : null;
}
function $77bd600c8f878470$var$legendFill(self, seriesIdx) {
    return self.series[seriesIdx].fill(self, seriesIdx);
}
const $77bd600c8f878470$var$legendOpts = {
    show: true,
    live: true,
    isolate: false,
    mount: $77bd600c8f878470$var$noop,
    markers: {
        show: true,
        width: 2,
        stroke: $77bd600c8f878470$var$legendStroke,
        fill: $77bd600c8f878470$var$legendFill,
        dash: "solid"
    },
    idx: null,
    idxs: null,
    values: []
};
function $77bd600c8f878470$var$cursorPointShow(self, si) {
    let o = self.cursor.points;
    let pt = $77bd600c8f878470$var$placeDiv();
    let size = o.size(self, si);
    $77bd600c8f878470$var$setStylePx(pt, $77bd600c8f878470$var$WIDTH, size);
    $77bd600c8f878470$var$setStylePx(pt, $77bd600c8f878470$var$HEIGHT, size);
    let mar = size / -2;
    $77bd600c8f878470$var$setStylePx(pt, "marginLeft", mar);
    $77bd600c8f878470$var$setStylePx(pt, "marginTop", mar);
    let width = o.width(self, si, size);
    width && $77bd600c8f878470$var$setStylePx(pt, "borderWidth", width);
    return pt;
}
function $77bd600c8f878470$var$cursorPointFill(self, si) {
    let sp = self.series[si].points;
    return sp._fill || sp._stroke;
}
function $77bd600c8f878470$var$cursorPointStroke(self, si) {
    let sp = self.series[si].points;
    return sp._stroke || sp._fill;
}
function $77bd600c8f878470$var$cursorPointSize(self, si) {
    let sp = self.series[si].points;
    return sp.size;
}
const $77bd600c8f878470$var$moveTuple = [
    0,
    0
];
function $77bd600c8f878470$var$cursorMove(self, mouseLeft1, mouseTop1) {
    $77bd600c8f878470$var$moveTuple[0] = mouseLeft1;
    $77bd600c8f878470$var$moveTuple[1] = mouseTop1;
    return $77bd600c8f878470$var$moveTuple;
}
function $77bd600c8f878470$var$filtBtn0(self, targ, handle, onlyTarg = true) {
    return (e)=>{
        e.button == 0 && (!onlyTarg || e.target == targ) && handle(e);
    };
}
function $77bd600c8f878470$var$filtTarg(self, targ, handle, onlyTarg = true) {
    return (e)=>{
        (!onlyTarg || e.target == targ) && handle(e);
    };
}
const $77bd600c8f878470$var$cursorOpts = {
    show: true,
    x: true,
    y: true,
    lock: false,
    move: $77bd600c8f878470$var$cursorMove,
    points: {
        show: $77bd600c8f878470$var$cursorPointShow,
        size: $77bd600c8f878470$var$cursorPointSize,
        width: 0,
        stroke: $77bd600c8f878470$var$cursorPointStroke,
        fill: $77bd600c8f878470$var$cursorPointFill
    },
    bind: {
        mousedown: $77bd600c8f878470$var$filtBtn0,
        mouseup: $77bd600c8f878470$var$filtBtn0,
        click: $77bd600c8f878470$var$filtBtn0,
        dblclick: $77bd600c8f878470$var$filtBtn0,
        mousemove: $77bd600c8f878470$var$filtTarg,
        mouseleave: $77bd600c8f878470$var$filtTarg,
        mouseenter: $77bd600c8f878470$var$filtTarg
    },
    drag: {
        setScale: true,
        x: true,
        y: false,
        dist: 0,
        uni: null,
        click: (self, e)=>{
            //	e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        },
        _x: false,
        _y: false
    },
    focus: {
        dist: (self, seriesIdx, dataIdx, valPos, curPos)=>valPos - curPos,
        prox: -1,
        bias: 0
    },
    hover: {
        skip: [
            void 0
        ],
        prox: null,
        bias: 0
    },
    left: -10,
    top: -10,
    idx: null,
    dataIdx: null,
    idxs: null,
    event: null
};
const $77bd600c8f878470$var$axisLines = {
    show: true,
    stroke: "rgba(0,0,0,0.07)",
    width: 2
};
const $77bd600c8f878470$var$grid = $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$axisLines, {
    filter: $77bd600c8f878470$var$retArg1
});
const $77bd600c8f878470$var$ticks = $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$grid, {
    size: 10
});
const $77bd600c8f878470$var$border = $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$axisLines, {
    show: false
});
const $77bd600c8f878470$var$font = '12px system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
const $77bd600c8f878470$var$labelFont = "bold " + $77bd600c8f878470$var$font;
const $77bd600c8f878470$var$lineGap = 1.5; // font-size multiplier
const $77bd600c8f878470$var$xAxisOpts = {
    show: true,
    scale: "x",
    stroke: $77bd600c8f878470$var$hexBlack,
    space: 50,
    gap: 5,
    size: 50,
    labelGap: 0,
    labelSize: 30,
    labelFont: $77bd600c8f878470$var$labelFont,
    side: 2,
    grid: //	class: "x-vals",
    //	incrs: timeIncrs,
    //	values: timeVals,
    //	filter: retArg1,
    $77bd600c8f878470$var$grid,
    ticks: $77bd600c8f878470$var$ticks,
    border: $77bd600c8f878470$var$border,
    font: $77bd600c8f878470$var$font,
    lineGap: $77bd600c8f878470$var$lineGap,
    rotate: 0
};
const $77bd600c8f878470$var$numSeriesLabel = "Value";
const $77bd600c8f878470$var$timeSeriesLabel = "Time";
const $77bd600c8f878470$var$xSeriesOpts = {
    show: true,
    scale: "x",
    auto: false,
    sorted: 1,
    //	label: "Time",
    //	value: v => stamp(new Date(v * 1e3)),
    // internal caches
    min: $77bd600c8f878470$var$inf,
    max: -$77bd600c8f878470$var$inf,
    idxs: []
};
function $77bd600c8f878470$var$numAxisVals(self, splits, axisIdx, foundSpace, foundIncr) {
    return splits.map((v)=>v == null ? "" : $77bd600c8f878470$var$fmtNum(v));
}
function $77bd600c8f878470$var$numAxisSplits(self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace, forceMin) {
    let splits = [];
    let numDec = $77bd600c8f878470$var$fixedDec.get(foundIncr) || 0;
    scaleMin = forceMin ? scaleMin : $77bd600c8f878470$var$roundDec($77bd600c8f878470$var$incrRoundUp(scaleMin, foundIncr), numDec);
    for(let val = scaleMin; val <= scaleMax; val = $77bd600c8f878470$var$roundDec(val + foundIncr, numDec))splits.push(Object.is(val, -0) ? 0 : val); // coalesces -0
    return splits;
}
// this doesnt work for sin, which needs to come off from 0 independently in pos and neg dirs
function $77bd600c8f878470$var$logAxisSplits(self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace, forceMin) {
    const splits = [];
    const logBase = self.scales[self.axes[axisIdx].scale].log;
    const logFn = logBase == 10 ? $77bd600c8f878470$var$log10 : $77bd600c8f878470$var$log2;
    const exp = $77bd600c8f878470$var$floor(logFn(scaleMin));
    foundIncr = $77bd600c8f878470$var$pow(logBase, exp);
    if (logBase == 10 && exp < 0) foundIncr = $77bd600c8f878470$var$roundDec(foundIncr, -exp);
    let split = scaleMin;
    do {
        splits.push(split);
        split = split + foundIncr;
        if (logBase == 10) split = $77bd600c8f878470$var$roundDec(split, $77bd600c8f878470$var$fixedDec.get(foundIncr));
        if (split >= foundIncr * logBase) foundIncr = split;
    }while (split <= scaleMax);
    return splits;
}
function $77bd600c8f878470$var$asinhAxisSplits(self, axisIdx, scaleMin, scaleMax, foundIncr, foundSpace, forceMin) {
    let sc = self.scales[self.axes[axisIdx].scale];
    let linthresh = sc.asinh;
    let posSplits = scaleMax > linthresh ? $77bd600c8f878470$var$logAxisSplits(self, axisIdx, $77bd600c8f878470$var$max(linthresh, scaleMin), scaleMax, foundIncr) : [
        linthresh
    ];
    let zero = scaleMax >= 0 && scaleMin <= 0 ? [
        0
    ] : [];
    let negSplits = scaleMin < -linthresh ? $77bd600c8f878470$var$logAxisSplits(self, axisIdx, $77bd600c8f878470$var$max(linthresh, -scaleMax), -scaleMin, foundIncr) : [
        linthresh
    ];
    return negSplits.reverse().map((v)=>-v).concat(zero, posSplits);
}
const $77bd600c8f878470$var$RE_ALL = /./;
const $77bd600c8f878470$var$RE_12357 = /[12357]/;
const $77bd600c8f878470$var$RE_125 = /[125]/;
const $77bd600c8f878470$var$RE_1 = /1/;
const $77bd600c8f878470$var$_filt = (splits, distr, re, keepMod)=>splits.map((v, i)=>distr == 4 && v == 0 || i % keepMod == 0 && re.test(v.toExponential()[v < 0 ? 1 : 0]) ? v : null);
function $77bd600c8f878470$var$log10AxisValsFilt(self, splits, axisIdx, foundSpace, foundIncr) {
    let axis = self.axes[axisIdx];
    let scaleKey = axis.scale;
    let sc = self.scales[scaleKey];
    //	if (sc.distr == 3 && sc.log == 2)
    //		return splits;
    let valToPos = self.valToPos;
    let minSpace = axis._space;
    let _10 = valToPos(10, scaleKey);
    let re = valToPos(9, scaleKey) - _10 >= minSpace ? $77bd600c8f878470$var$RE_ALL : valToPos(7, scaleKey) - _10 >= minSpace ? $77bd600c8f878470$var$RE_12357 : valToPos(5, scaleKey) - _10 >= minSpace ? $77bd600c8f878470$var$RE_125 : $77bd600c8f878470$var$RE_1;
    if (re == $77bd600c8f878470$var$RE_1) {
        let magSpace = $77bd600c8f878470$var$abs(valToPos(1, scaleKey) - _10);
        if (magSpace < minSpace) return $77bd600c8f878470$var$_filt(splits.slice().reverse(), sc.distr, re, $77bd600c8f878470$var$ceil(minSpace / magSpace)).reverse(); // max->min skip
    }
    return $77bd600c8f878470$var$_filt(splits, sc.distr, re, 1);
}
function $77bd600c8f878470$var$log2AxisValsFilt(self, splits, axisIdx, foundSpace, foundIncr) {
    let axis = self.axes[axisIdx];
    let scaleKey = axis.scale;
    let minSpace = axis._space;
    let valToPos = self.valToPos;
    let magSpace = $77bd600c8f878470$var$abs(valToPos(1, scaleKey) - valToPos(2, scaleKey));
    if (magSpace < minSpace) return $77bd600c8f878470$var$_filt(splits.slice().reverse(), 3, $77bd600c8f878470$var$RE_ALL, $77bd600c8f878470$var$ceil(minSpace / magSpace)).reverse(); // max->min skip
    return splits;
}
function $77bd600c8f878470$var$numSeriesVal(self, val, seriesIdx, dataIdx) {
    return dataIdx == null ? $77bd600c8f878470$var$LEGEND_DISP : val == null ? "" : $77bd600c8f878470$var$fmtNum(val);
}
const $77bd600c8f878470$var$yAxisOpts = {
    show: true,
    scale: "y",
    stroke: $77bd600c8f878470$var$hexBlack,
    space: 30,
    gap: 5,
    size: 50,
    labelGap: 0,
    labelSize: 30,
    labelFont: $77bd600c8f878470$var$labelFont,
    side: 3,
    grid: //	class: "y-vals",
    //	incrs: numIncrs,
    //	values: (vals, space) => vals,
    //	filter: retArg1,
    $77bd600c8f878470$var$grid,
    ticks: $77bd600c8f878470$var$ticks,
    border: $77bd600c8f878470$var$border,
    font: $77bd600c8f878470$var$font,
    lineGap: $77bd600c8f878470$var$lineGap,
    rotate: 0
};
// takes stroke width
function $77bd600c8f878470$var$ptDia(width, mult) {
    let dia = 3 + (width || 1) * 2;
    return $77bd600c8f878470$var$roundDec(dia * mult, 3);
}
function $77bd600c8f878470$var$seriesPointsShow(self, si) {
    let { scale: scale, idxs: idxs } = self.series[0];
    let xData = self._data[0];
    let p0 = self.valToPos(xData[idxs[0]], scale, true);
    let p1 = self.valToPos(xData[idxs[1]], scale, true);
    let dim = $77bd600c8f878470$var$abs(p1 - p0);
    let s = self.series[si];
    //	const dia = ptDia(s.width, pxRatio);
    let maxPts = dim / (s.points.space * $77bd600c8f878470$var$pxRatio);
    return idxs[1] - idxs[0] <= maxPts;
}
const $77bd600c8f878470$var$facet = {
    scale: null,
    auto: true,
    sorted: 0,
    // internal caches
    min: $77bd600c8f878470$var$inf,
    max: -$77bd600c8f878470$var$inf
};
const $77bd600c8f878470$var$gaps = (self, seriesIdx, idx0, idx1, nullGaps)=>nullGaps;
const $77bd600c8f878470$var$xySeriesOpts = {
    show: true,
    auto: true,
    sorted: 0,
    gaps: $77bd600c8f878470$var$gaps,
    alpha: 1,
    facets: [
        $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$facet, {
            scale: "x"
        }),
        $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$facet, {
            scale: "y"
        })
    ]
};
const $77bd600c8f878470$var$ySeriesOpts = {
    scale: "y",
    auto: true,
    sorted: 0,
    show: true,
    spanGaps: false,
    gaps: $77bd600c8f878470$var$gaps,
    alpha: 1,
    points: {
        show: $77bd600c8f878470$var$seriesPointsShow,
        filter: null
    },
    //	label: "Value",
    //	value: v => v,
    values: null,
    // internal caches
    min: $77bd600c8f878470$var$inf,
    max: -$77bd600c8f878470$var$inf,
    idxs: [],
    path: null,
    clip: null
};
function $77bd600c8f878470$var$clampScale(self, val, scaleMin, scaleMax, scaleKey) {
    /*
	if (val < 0) {
		let cssHgt = self.bbox.height / pxRatio;
		let absPos = self.valToPos(abs(val), scaleKey);
		let fromBtm = cssHgt - absPos;
		return self.posToVal(cssHgt + fromBtm, scaleKey);
	}
*/ return scaleMin / 10;
}
const $77bd600c8f878470$var$xScaleOpts = {
    time: $77bd600c8f878470$var$FEAT_TIME,
    auto: true,
    distr: 1,
    log: 10,
    asinh: 1,
    min: null,
    max: null,
    dir: 1,
    ori: 0
};
const $77bd600c8f878470$var$yScaleOpts = $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$xScaleOpts, {
    time: false,
    ori: 1
});
const $77bd600c8f878470$var$syncs = {};
function $77bd600c8f878470$var$_sync(key, opts) {
    let s = $77bd600c8f878470$var$syncs[key];
    if (!s) {
        s = {
            key: key,
            plots: [],
            sub (plot) {
                s.plots.push(plot);
            },
            unsub (plot) {
                s.plots = s.plots.filter((c)=>c != plot);
            },
            pub (type, self, x, y, w, h, i) {
                for(let j = 0; j < s.plots.length; j++)s.plots[j] != self && s.plots[j].pub(type, self, x, y, w, h, i);
            }
        };
        if (key != null) $77bd600c8f878470$var$syncs[key] = s;
    }
    return s;
}
const $77bd600c8f878470$var$BAND_CLIP_FILL = 1;
const $77bd600c8f878470$var$BAND_CLIP_STROKE = 2;
function $77bd600c8f878470$var$orient(u, seriesIdx, cb) {
    const mode = u.mode;
    const series = u.series[seriesIdx];
    const data = mode == 2 ? u._data[seriesIdx] : u._data;
    const scales = u.scales;
    const bbox = u.bbox;
    let dx = data[0], dy = mode == 2 ? data[1] : data[seriesIdx], sx = mode == 2 ? scales[series.facets[0].scale] : scales[u.series[0].scale], sy = mode == 2 ? scales[series.facets[1].scale] : scales[series.scale], l = bbox.left, t = bbox.top, w = bbox.width, h = bbox.height, H = u.valToPosH, V = u.valToPosV;
    return sx.ori == 0 ? cb(series, dx, dy, sx, sy, H, V, l, t, w, h, $77bd600c8f878470$var$moveToH, $77bd600c8f878470$var$lineToH, $77bd600c8f878470$var$rectH, $77bd600c8f878470$var$arcH, $77bd600c8f878470$var$bezierCurveToH) : cb(series, dx, dy, sx, sy, V, H, t, l, h, w, $77bd600c8f878470$var$moveToV, $77bd600c8f878470$var$lineToV, $77bd600c8f878470$var$rectV, $77bd600c8f878470$var$arcV, $77bd600c8f878470$var$bezierCurveToV);
}
function $77bd600c8f878470$var$bandFillClipDirs(self, seriesIdx) {
    let fillDir = 0;
    // 2 bits, -1 | 1
    let clipDirs = 0;
    let bands = $77bd600c8f878470$var$ifNull(self.bands, $77bd600c8f878470$var$EMPTY_ARR);
    for(let i = 0; i < bands.length; i++){
        let b = bands[i];
        // is a "from" band edge
        if (b.series[0] == seriesIdx) fillDir = b.dir;
        else if (b.series[1] == seriesIdx) {
            if (b.dir == 1) clipDirs |= 1;
            else clipDirs |= 2;
        }
    }
    return [
        fillDir,
        clipDirs == 1 ? -1 : clipDirs == 2 ? 1 : clipDirs == 3 ? 2 : 0 // neither
    ];
}
function $77bd600c8f878470$var$seriesFillTo(self, seriesIdx, dataMin, dataMax, bandFillDir) {
    let mode = self.mode;
    let series = self.series[seriesIdx];
    let scaleKey = mode == 2 ? series.facets[1].scale : series.scale;
    let scale = self.scales[scaleKey];
    return bandFillDir == -1 ? scale.min : bandFillDir == 1 ? scale.max : scale.distr == 3 ? scale.dir == 1 ? scale.min : scale.max : 0;
}
// creates inverted band clip path (from stroke path -> yMax || yMin)
// clipDir is always inverse of fillDir
// default clip dir is upwards (1), since default band fill is downwards/fillBelowTo (-1) (highIdx -> lowIdx)
function $77bd600c8f878470$var$clipBandLine(self, seriesIdx, idx0, idx1, strokePath, clipDir) {
    return $77bd600c8f878470$var$orient(self, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
        let pxRound = series.pxRound;
        const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
        const lineTo = scaleX.ori == 0 ? $77bd600c8f878470$var$lineToH : $77bd600c8f878470$var$lineToV;
        let frIdx, toIdx;
        if (dir == 1) {
            frIdx = idx0;
            toIdx = idx1;
        } else {
            frIdx = idx1;
            toIdx = idx0;
        }
        // path start
        let x0 = pxRound(valToPosX(dataX[frIdx], scaleX, xDim, xOff));
        let y0 = pxRound(valToPosY(dataY[frIdx], scaleY, yDim, yOff));
        // path end x
        let x1 = pxRound(valToPosX(dataX[toIdx], scaleX, xDim, xOff));
        // upper or lower y limit
        let yLimit = pxRound(valToPosY(clipDir == 1 ? scaleY.max : scaleY.min, scaleY, yDim, yOff));
        let clip = new Path2D(strokePath);
        lineTo(clip, x1, yLimit);
        lineTo(clip, x0, yLimit);
        lineTo(clip, x0, y0);
        return clip;
    });
}
function $77bd600c8f878470$var$clipGaps(gaps, ori, plotLft, plotTop, plotWid, plotHgt) {
    let clip = null;
    // create clip path (invert gaps and non-gaps)
    if (gaps.length > 0) {
        clip = new Path2D();
        const rect = ori == 0 ? $77bd600c8f878470$var$rectH : $77bd600c8f878470$var$rectV;
        let prevGapEnd = plotLft;
        for(let i = 0; i < gaps.length; i++){
            let g = gaps[i];
            if (g[1] > g[0]) {
                let w = g[0] - prevGapEnd;
                w > 0 && rect(clip, prevGapEnd, plotTop, w, plotTop + plotHgt);
                prevGapEnd = g[1];
            }
        }
        let w = plotLft + plotWid - prevGapEnd;
        // hack to ensure we expand the clip enough to avoid cutting off strokes at edges
        let maxStrokeWidth = 10;
        w > 0 && rect(clip, prevGapEnd, plotTop - maxStrokeWidth / 2, w, plotTop + plotHgt + maxStrokeWidth);
    }
    return clip;
}
function $77bd600c8f878470$var$addGap(gaps, fromX, toX) {
    let prevGap = gaps[gaps.length - 1];
    if (prevGap && prevGap[0] == fromX) prevGap[1] = toX;
    else gaps.push([
        fromX,
        toX
    ]);
}
function $77bd600c8f878470$var$findGaps(xs, ys, idx0, idx1, dir, pixelForX, align) {
    let gaps = [];
    let len = xs.length;
    for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
        let yVal = ys[i];
        if (yVal === null) {
            let fr = i, to = i;
            if (dir == 1) while(++i <= idx1 && ys[i] === null)to = i;
            else while(--i >= idx0 && ys[i] === null)to = i;
            let frPx = pixelForX(xs[fr]);
            let toPx = to == fr ? frPx : pixelForX(xs[to]);
            // if value adjacent to edge null is same pixel, then it's partially
            // filled and gap should start at next pixel
            let fri2 = fr - dir;
            let frPx2 = align <= 0 && fri2 >= 0 && fri2 < len ? pixelForX(xs[fri2]) : frPx;
            //	if (frPx2 == frPx)
            //		frPx++;
            //	else
            frPx = frPx2;
            let toi2 = to + dir;
            let toPx2 = align >= 0 && toi2 >= 0 && toi2 < len ? pixelForX(xs[toi2]) : toPx;
            //	if (toPx2 == toPx)
            //		toPx--;
            //	else
            toPx = toPx2;
            if (toPx >= frPx) gaps.push([
                frPx,
                toPx
            ]); // addGap
        }
    }
    return gaps;
}
function $77bd600c8f878470$var$pxRoundGen(pxAlign) {
    return pxAlign == 0 ? $77bd600c8f878470$var$retArg0 : pxAlign == 1 ? $77bd600c8f878470$var$round : (v)=>$77bd600c8f878470$var$incrRound(v, pxAlign);
}
function $77bd600c8f878470$var$rect(ori) {
    let moveTo = ori == 0 ? $77bd600c8f878470$var$moveToH : $77bd600c8f878470$var$moveToV;
    let arcTo = ori == 0 ? (p, x1, y1, x2, y2, r)=>{
        p.arcTo(x1, y1, x2, y2, r);
    } : (p, y1, x1, y2, x2, r)=>{
        p.arcTo(x1, y1, x2, y2, r);
    };
    let rect = ori == 0 ? (p, x, y, w, h)=>{
        p.rect(x, y, w, h);
    } : (p, y, x, h, w)=>{
        p.rect(x, y, w, h);
    };
    // TODO (pending better browser support): https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/roundRect
    return (p, x, y, w, h, endRad = 0, baseRad = 0)=>{
        if (endRad == 0 && baseRad == 0) rect(p, x, y, w, h);
        else {
            endRad = $77bd600c8f878470$var$min(endRad, w / 2, h / 2);
            baseRad = $77bd600c8f878470$var$min(baseRad, w / 2, h / 2);
            // adapted from https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-using-html-canvas/7838871#7838871
            moveTo(p, x + endRad, y);
            arcTo(p, x + w, y, x + w, y + h, endRad);
            arcTo(p, x + w, y + h, x, y + h, baseRad);
            arcTo(p, x, y + h, x, y, baseRad);
            arcTo(p, x, y, x + w, y, endRad);
            p.closePath();
        }
    };
}
// orientation-inverting canvas functions
const $77bd600c8f878470$var$moveToH = (p, x, y)=>{
    p.moveTo(x, y);
};
const $77bd600c8f878470$var$moveToV = (p, y, x)=>{
    p.moveTo(x, y);
};
const $77bd600c8f878470$var$lineToH = (p, x, y)=>{
    p.lineTo(x, y);
};
const $77bd600c8f878470$var$lineToV = (p, y, x)=>{
    p.lineTo(x, y);
};
const $77bd600c8f878470$var$rectH = $77bd600c8f878470$var$rect(0);
const $77bd600c8f878470$var$rectV = $77bd600c8f878470$var$rect(1);
const $77bd600c8f878470$var$arcH = (p, x, y, r, startAngle, endAngle)=>{
    p.arc(x, y, r, startAngle, endAngle);
};
const $77bd600c8f878470$var$arcV = (p, y, x, r, startAngle, endAngle)=>{
    p.arc(x, y, r, startAngle, endAngle);
};
const $77bd600c8f878470$var$bezierCurveToH = (p, bp1x, bp1y, bp2x, bp2y, p2x, p2y)=>{
    p.bezierCurveTo(bp1x, bp1y, bp2x, bp2y, p2x, p2y);
};
const $77bd600c8f878470$var$bezierCurveToV = (p, bp1y, bp1x, bp2y, bp2x, p2y, p2x)=>{
    p.bezierCurveTo(bp1x, bp1y, bp2x, bp2y, p2x, p2y);
};
// TODO: drawWrap(seriesIdx, drawPoints) (save, restore, translate, clip)
function $77bd600c8f878470$var$points(opts) {
    return (u, seriesIdx, idx0, idx1, filtIdxs)=>{
        //	log("drawPoints()", arguments);
        return $77bd600c8f878470$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let { pxRound: pxRound, points: points } = series;
            let moveTo, arc;
            if (scaleX.ori == 0) {
                moveTo = $77bd600c8f878470$var$moveToH;
                arc = $77bd600c8f878470$var$arcH;
            } else {
                moveTo = $77bd600c8f878470$var$moveToV;
                arc = $77bd600c8f878470$var$arcV;
            }
            const width = $77bd600c8f878470$var$roundDec(points.width * $77bd600c8f878470$var$pxRatio, 3);
            let rad = (points.size - points.width) / 2 * $77bd600c8f878470$var$pxRatio;
            let dia = $77bd600c8f878470$var$roundDec(rad * 2, 3);
            let fill = new Path2D();
            let clip = new Path2D();
            let { left: lft, top: top, width: wid, height: hgt } = u.bbox;
            $77bd600c8f878470$var$rectH(clip, lft - dia, top - dia, wid + dia * 2, hgt + dia * 2);
            const drawPoint = (pi)=>{
                if (dataY[pi] != null) {
                    let x = pxRound(valToPosX(dataX[pi], scaleX, xDim, xOff));
                    let y = pxRound(valToPosY(dataY[pi], scaleY, yDim, yOff));
                    moveTo(fill, x + rad, y);
                    arc(fill, x, y, rad, 0, $77bd600c8f878470$var$PI * 2);
                }
            };
            if (filtIdxs) filtIdxs.forEach(drawPoint);
            else for(let pi = idx0; pi <= idx1; pi++)drawPoint(pi);
            return {
                stroke: width > 0 ? fill : null,
                fill: fill,
                clip: clip,
                flags: $77bd600c8f878470$var$BAND_CLIP_FILL | $77bd600c8f878470$var$BAND_CLIP_STROKE
            };
        });
    };
}
function $77bd600c8f878470$var$_drawAcc(lineTo) {
    return (stroke, accX, minY, maxY, inY, outY)=>{
        if (minY != maxY) {
            if (inY != minY && outY != minY) lineTo(stroke, accX, minY);
            if (inY != maxY && outY != maxY) lineTo(stroke, accX, maxY);
            lineTo(stroke, accX, outY);
        }
    };
}
const $77bd600c8f878470$var$drawAccH = $77bd600c8f878470$var$_drawAcc($77bd600c8f878470$var$lineToH);
const $77bd600c8f878470$var$drawAccV = $77bd600c8f878470$var$_drawAcc($77bd600c8f878470$var$lineToV);
function $77bd600c8f878470$var$linear(opts) {
    const alignGaps = $77bd600c8f878470$var$ifNull(opts?.alignGaps, 0);
    return (u, seriesIdx, idx0, idx1)=>{
        return $77bd600c8f878470$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let pxRound = series.pxRound;
            let pixelForX = (val)=>pxRound(valToPosX(val, scaleX, xDim, xOff));
            let pixelForY = (val)=>pxRound(valToPosY(val, scaleY, yDim, yOff));
            let lineTo, drawAcc;
            if (scaleX.ori == 0) {
                lineTo = $77bd600c8f878470$var$lineToH;
                drawAcc = $77bd600c8f878470$var$drawAccH;
            } else {
                lineTo = $77bd600c8f878470$var$lineToV;
                drawAcc = $77bd600c8f878470$var$drawAccV;
            }
            const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            const _paths = {
                stroke: new Path2D(),
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: $77bd600c8f878470$var$BAND_CLIP_FILL
            };
            const stroke = _paths.stroke;
            let minY = $77bd600c8f878470$var$inf, maxY = -$77bd600c8f878470$var$inf, inY, outY, drawnAtX;
            let accX = pixelForX(dataX[dir == 1 ? idx0 : idx1]);
            // data edges
            let lftIdx = $77bd600c8f878470$var$nonNullIdx(dataY, idx0, idx1, 1 * dir);
            let rgtIdx = $77bd600c8f878470$var$nonNullIdx(dataY, idx0, idx1, -1 * dir);
            let lftX = pixelForX(dataX[lftIdx]);
            let rgtX = pixelForX(dataX[rgtIdx]);
            let hasGap = false;
            for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                let x = pixelForX(dataX[i]);
                let yVal = dataY[i];
                if (x == accX) {
                    if (yVal != null) {
                        outY = pixelForY(yVal);
                        if (minY == $77bd600c8f878470$var$inf) {
                            lineTo(stroke, x, outY);
                            inY = outY;
                        }
                        minY = $77bd600c8f878470$var$min(outY, minY);
                        maxY = $77bd600c8f878470$var$max(outY, maxY);
                    } else if (yVal === null) hasGap = true;
                } else {
                    if (minY != $77bd600c8f878470$var$inf) {
                        drawAcc(stroke, accX, minY, maxY, inY, outY);
                        drawnAtX = accX;
                    }
                    if (yVal != null) {
                        outY = pixelForY(yVal);
                        lineTo(stroke, x, outY);
                        minY = maxY = inY = outY;
                    } else {
                        minY = $77bd600c8f878470$var$inf;
                        maxY = -$77bd600c8f878470$var$inf;
                        if (yVal === null) hasGap = true;
                    }
                    accX = x;
                }
            }
            if (minY != $77bd600c8f878470$var$inf && minY != maxY && drawnAtX != accX) drawAcc(stroke, accX, minY, maxY, inY, outY);
            let [bandFillDir, bandClipDir] = $77bd600c8f878470$var$bandFillClipDirs(u, seriesIdx);
            if (series.fill != null || bandFillDir != 0) {
                let fill = _paths.fill = new Path2D(stroke);
                let fillToVal = series.fillTo(u, seriesIdx, series.min, series.max, bandFillDir);
                let fillToY = pixelForY(fillToVal);
                lineTo(fill, rgtX, fillToY);
                lineTo(fill, lftX, fillToY);
            }
            if (!series.spanGaps) {
                //	console.time('gaps');
                let gaps = [];
                hasGap && gaps.push(...$77bd600c8f878470$var$findGaps(dataX, dataY, idx0, idx1, dir, pixelForX, alignGaps));
                //	console.timeEnd('gaps');
                //	console.log('gaps', JSON.stringify(gaps));
                _paths.gaps = gaps = series.gaps(u, seriesIdx, idx0, idx1, gaps);
                _paths.clip = $77bd600c8f878470$var$clipGaps(gaps, scaleX.ori, xOff, yOff, xDim, yDim);
            }
            if (bandClipDir != 0) _paths.band = bandClipDir == 2 ? [
                $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, -1),
                $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, 1)
            ] : $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, bandClipDir);
            return _paths;
        });
    };
}
// BUG: align: -1 behaves like align: 1 when scale.dir: -1
function $77bd600c8f878470$var$stepped(opts) {
    const align = $77bd600c8f878470$var$ifNull(opts.align, 1);
    // whether to draw ascenders/descenders at null/gap bondaries
    const ascDesc = $77bd600c8f878470$var$ifNull(opts.ascDesc, false);
    const alignGaps = $77bd600c8f878470$var$ifNull(opts.alignGaps, 0);
    const extend = $77bd600c8f878470$var$ifNull(opts.extend, false);
    return (u, seriesIdx, idx0, idx1)=>{
        return $77bd600c8f878470$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let pxRound = series.pxRound;
            let { left: left, width: width } = u.bbox;
            let pixelForX = (val)=>pxRound(valToPosX(val, scaleX, xDim, xOff));
            let pixelForY = (val)=>pxRound(valToPosY(val, scaleY, yDim, yOff));
            let lineTo = scaleX.ori == 0 ? $77bd600c8f878470$var$lineToH : $77bd600c8f878470$var$lineToV;
            const _paths = {
                stroke: new Path2D(),
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: $77bd600c8f878470$var$BAND_CLIP_FILL
            };
            const stroke = _paths.stroke;
            const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            idx0 = $77bd600c8f878470$var$nonNullIdx(dataY, idx0, idx1, 1);
            idx1 = $77bd600c8f878470$var$nonNullIdx(dataY, idx0, idx1, -1);
            let prevYPos = pixelForY(dataY[dir == 1 ? idx0 : idx1]);
            let firstXPos = pixelForX(dataX[dir == 1 ? idx0 : idx1]);
            let prevXPos = firstXPos;
            let firstXPosExt = firstXPos;
            if (extend && align == -1) {
                firstXPosExt = left;
                lineTo(stroke, firstXPosExt, prevYPos);
            }
            lineTo(stroke, firstXPos, prevYPos);
            for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                let yVal1 = dataY[i];
                if (yVal1 == null) continue;
                let x1 = pixelForX(dataX[i]);
                let y1 = pixelForY(yVal1);
                if (align == 1) lineTo(stroke, x1, prevYPos);
                else lineTo(stroke, prevXPos, y1);
                lineTo(stroke, x1, y1);
                prevYPos = y1;
                prevXPos = x1;
            }
            let prevXPosExt = prevXPos;
            if (extend && align == 1) {
                prevXPosExt = left + width;
                lineTo(stroke, prevXPosExt, prevYPos);
            }
            let [bandFillDir, bandClipDir] = $77bd600c8f878470$var$bandFillClipDirs(u, seriesIdx);
            if (series.fill != null || bandFillDir != 0) {
                let fill = _paths.fill = new Path2D(stroke);
                let fillTo = series.fillTo(u, seriesIdx, series.min, series.max, bandFillDir);
                let fillToY = pixelForY(fillTo);
                lineTo(fill, prevXPosExt, fillToY);
                lineTo(fill, firstXPosExt, fillToY);
            }
            if (!series.spanGaps) {
                //	console.time('gaps');
                let gaps = [];
                gaps.push(...$77bd600c8f878470$var$findGaps(dataX, dataY, idx0, idx1, dir, pixelForX, alignGaps));
                //	console.timeEnd('gaps');
                //	console.log('gaps', JSON.stringify(gaps));
                // expand/contract clips for ascenders/descenders
                let halfStroke = series.width * $77bd600c8f878470$var$pxRatio / 2;
                let startsOffset = ascDesc || align == 1 ? halfStroke : -halfStroke;
                let endsOffset = ascDesc || align == -1 ? -halfStroke : halfStroke;
                gaps.forEach((g)=>{
                    g[0] += startsOffset;
                    g[1] += endsOffset;
                });
                _paths.gaps = gaps = series.gaps(u, seriesIdx, idx0, idx1, gaps);
                _paths.clip = $77bd600c8f878470$var$clipGaps(gaps, scaleX.ori, xOff, yOff, xDim, yDim);
            }
            if (bandClipDir != 0) _paths.band = bandClipDir == 2 ? [
                $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, -1),
                $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, 1)
            ] : $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, bandClipDir);
            return _paths;
        });
    };
}
function $77bd600c8f878470$var$findColWidth(dataX, dataY, valToPosX, scaleX, xDim, xOff, colWid = $77bd600c8f878470$var$inf) {
    if (dataX.length > 1) {
        // prior index with non-undefined y data
        let prevIdx = null;
        // scan full dataset for smallest adjacent delta
        // will not work properly for non-linear x scales, since does not do expensive valToPosX calcs till end
        for(let i = 0, minDelta = Infinity; i < dataX.length; i++)if (dataY[i] !== undefined) {
            if (prevIdx != null) {
                let delta = $77bd600c8f878470$var$abs(dataX[i] - dataX[prevIdx]);
                if (delta < minDelta) {
                    minDelta = delta;
                    colWid = $77bd600c8f878470$var$abs(valToPosX(dataX[i], scaleX, xDim, xOff) - valToPosX(dataX[prevIdx], scaleX, xDim, xOff));
                }
            }
            prevIdx = i;
        }
    }
    return colWid;
}
function $77bd600c8f878470$var$bars(opts) {
    opts = opts || $77bd600c8f878470$var$EMPTY_OBJ;
    const size = $77bd600c8f878470$var$ifNull(opts.size, [
        0.6,
        $77bd600c8f878470$var$inf,
        1
    ]);
    const align = opts.align || 0;
    const _extraGap = opts.gap || 0;
    let ro = opts.radius;
    ro = // [valueRadius, baselineRadius]
    ro == null ? [
        0,
        0
    ] : typeof ro == "number" ? [
        ro,
        0
    ] : ro;
    const radiusFn = $77bd600c8f878470$var$fnOrSelf(ro);
    const gapFactor = 1 - size[0];
    const _maxWidth = $77bd600c8f878470$var$ifNull(size[1], $77bd600c8f878470$var$inf);
    const _minWidth = $77bd600c8f878470$var$ifNull(size[2], 1);
    const disp = $77bd600c8f878470$var$ifNull(opts.disp, $77bd600c8f878470$var$EMPTY_OBJ);
    const _each = $77bd600c8f878470$var$ifNull(opts.each, (_)=>{});
    const { fill: dispFills, stroke: dispStrokes } = disp;
    return (u, seriesIdx, idx0, idx1)=>{
        return $77bd600c8f878470$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let pxRound = series.pxRound;
            let _align = align;
            let extraGap = _extraGap * $77bd600c8f878470$var$pxRatio;
            let maxWidth = _maxWidth * $77bd600c8f878470$var$pxRatio;
            let minWidth = _minWidth * $77bd600c8f878470$var$pxRatio;
            let valRadius, baseRadius;
            if (scaleX.ori == 0) [valRadius, baseRadius] = radiusFn(u, seriesIdx);
            else [baseRadius, valRadius] = radiusFn(u, seriesIdx);
            const _dirX = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            //	const _dirY = scaleY.dir * (scaleY.ori == 1 ? 1 : -1);
            let rect = scaleX.ori == 0 ? $77bd600c8f878470$var$rectH : $77bd600c8f878470$var$rectV;
            let each = scaleX.ori == 0 ? _each : (u, seriesIdx, i, top, lft, hgt, wid)=>{
                _each(u, seriesIdx, i, lft, top, wid, hgt);
            };
            // band where this series is the "from" edge
            let band = $77bd600c8f878470$var$ifNull(u.bands, $77bd600c8f878470$var$EMPTY_ARR).find((b)=>b.series[0] == seriesIdx);
            let fillDir = band != null ? band.dir : 0;
            let fillTo = series.fillTo(u, seriesIdx, series.min, series.max, fillDir);
            let fillToY = pxRound(valToPosY(fillTo, scaleY, yDim, yOff));
            // barWid is to center of stroke
            let xShift, barWid, fullGap, colWid = xDim;
            let strokeWidth = pxRound(series.width * $77bd600c8f878470$var$pxRatio);
            let multiPath = false;
            let fillColors = null;
            let fillPaths = null;
            let strokeColors = null;
            let strokePaths = null;
            if (dispFills != null && (strokeWidth == 0 || dispStrokes != null)) {
                multiPath = true;
                fillColors = dispFills.values(u, seriesIdx, idx0, idx1);
                fillPaths = new Map();
                new Set(fillColors).forEach((color)=>{
                    if (color != null) fillPaths.set(color, new Path2D());
                });
                if (strokeWidth > 0) {
                    strokeColors = dispStrokes.values(u, seriesIdx, idx0, idx1);
                    strokePaths = new Map();
                    new Set(strokeColors).forEach((color)=>{
                        if (color != null) strokePaths.set(color, new Path2D());
                    });
                }
            }
            let { x0: x0, size: size } = disp;
            if (x0 != null && size != null) {
                _align = 1;
                dataX = x0.values(u, seriesIdx, idx0, idx1);
                if (x0.unit == 2) dataX = dataX.map((pct)=>u.posToVal(xOff + pct * xDim, scaleX.key, true));
                // assumes uniform sizes, for now
                let sizes = size.values(u, seriesIdx, idx0, idx1);
                if (size.unit == 2) barWid = sizes[0] * xDim;
                else barWid = valToPosX(sizes[0], scaleX, xDim, xOff) - valToPosX(0, scaleX, xDim, xOff); // assumes linear scale (delta from 0)
                colWid = $77bd600c8f878470$var$findColWidth(dataX, dataY, valToPosX, scaleX, xDim, xOff, colWid);
                let gapWid = colWid - barWid;
                fullGap = gapWid + extraGap;
            } else {
                colWid = $77bd600c8f878470$var$findColWidth(dataX, dataY, valToPosX, scaleX, xDim, xOff, colWid);
                let gapWid = colWid * gapFactor;
                fullGap = gapWid + extraGap;
                barWid = colWid - fullGap;
            }
            if (fullGap < 1) fullGap = 0;
            if (strokeWidth >= barWid / 2) strokeWidth = 0;
            // for small gaps, disable pixel snapping since gap inconsistencies become noticible and annoying
            if (fullGap < 5) pxRound = $77bd600c8f878470$var$retArg0;
            let insetStroke = fullGap > 0;
            let rawBarWid = colWid - fullGap - (insetStroke ? strokeWidth : 0);
            barWid = pxRound($77bd600c8f878470$var$clamp(rawBarWid, minWidth, maxWidth));
            xShift = (_align == 0 ? barWid / 2 : _align == _dirX ? 0 : barWid) - _align * _dirX * ((_align == 0 ? extraGap / 2 : 0) + (insetStroke ? strokeWidth / 2 : 0));
            const _paths = {
                stroke: null,
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: 0
            }; // disp, geom
            const stroke = multiPath ? null : new Path2D();
            let dataY0 = null;
            if (band != null) dataY0 = u.data[band.series[1]];
            else {
                let { y0: y0, y1: y1 } = disp;
                if (y0 != null && y1 != null) {
                    dataY = y1.values(u, seriesIdx, idx0, idx1);
                    dataY0 = y0.values(u, seriesIdx, idx0, idx1);
                }
            }
            let radVal = valRadius * barWid;
            let radBase = baseRadius * barWid;
            for(let i = _dirX == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += _dirX){
                let yVal = dataY[i];
                if (yVal == null) continue;
                if (dataY0 != null) {
                    let yVal0 = dataY0[i] ?? 0;
                    if (yVal - yVal0 == 0) continue;
                    fillToY = valToPosY(yVal0, scaleY, yDim, yOff);
                }
                let xVal = scaleX.distr != 2 || disp != null ? dataX[i] : i;
                // TODO: all xPos can be pre-computed once for all series in aligned set
                let xPos = valToPosX(xVal, scaleX, xDim, xOff);
                let yPos = valToPosY($77bd600c8f878470$var$ifNull(yVal, fillTo), scaleY, yDim, yOff);
                let lft = pxRound(xPos - xShift);
                let btm = pxRound($77bd600c8f878470$var$max(yPos, fillToY));
                let top = pxRound($77bd600c8f878470$var$min(yPos, fillToY));
                // this includes the stroke
                let barHgt = btm - top;
                if (yVal != null) {
                    let rv = yVal < 0 ? radBase : radVal;
                    let rb = yVal < 0 ? radVal : radBase;
                    if (multiPath) {
                        if (strokeWidth > 0 && strokeColors[i] != null) rect(strokePaths.get(strokeColors[i]), lft, top + $77bd600c8f878470$var$floor(strokeWidth / 2), barWid, $77bd600c8f878470$var$max(0, barHgt - strokeWidth), rv, rb);
                        if (fillColors[i] != null) rect(fillPaths.get(fillColors[i]), lft, top + $77bd600c8f878470$var$floor(strokeWidth / 2), barWid, $77bd600c8f878470$var$max(0, barHgt - strokeWidth), rv, rb);
                    } else rect(stroke, lft, top + $77bd600c8f878470$var$floor(strokeWidth / 2), barWid, $77bd600c8f878470$var$max(0, barHgt - strokeWidth), rv, rb);
                    each(u, seriesIdx, i, lft - strokeWidth / 2, top, barWid + strokeWidth, barHgt);
                }
            }
            if (strokeWidth > 0) _paths.stroke = multiPath ? strokePaths : stroke;
            else if (!multiPath) {
                _paths._fill = series.width == 0 ? series._fill : series._stroke ?? series._fill;
                _paths.width = 0;
            }
            _paths.fill = multiPath ? fillPaths : stroke;
            return _paths;
        });
    };
}
function $77bd600c8f878470$var$splineInterp(interp, opts) {
    const alignGaps = $77bd600c8f878470$var$ifNull(opts?.alignGaps, 0);
    return (u, seriesIdx, idx0, idx1)=>{
        return $77bd600c8f878470$var$orient(u, seriesIdx, (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim)=>{
            let pxRound = series.pxRound;
            let pixelForX = (val)=>pxRound(valToPosX(val, scaleX, xDim, xOff));
            let pixelForY = (val)=>pxRound(valToPosY(val, scaleY, yDim, yOff));
            let moveTo, bezierCurveTo, lineTo;
            if (scaleX.ori == 0) {
                moveTo = $77bd600c8f878470$var$moveToH;
                lineTo = $77bd600c8f878470$var$lineToH;
                bezierCurveTo = $77bd600c8f878470$var$bezierCurveToH;
            } else {
                moveTo = $77bd600c8f878470$var$moveToV;
                lineTo = $77bd600c8f878470$var$lineToV;
                bezierCurveTo = $77bd600c8f878470$var$bezierCurveToV;
            }
            const dir = scaleX.dir * (scaleX.ori == 0 ? 1 : -1);
            idx0 = $77bd600c8f878470$var$nonNullIdx(dataY, idx0, idx1, 1);
            idx1 = $77bd600c8f878470$var$nonNullIdx(dataY, idx0, idx1, -1);
            let firstXPos = pixelForX(dataX[dir == 1 ? idx0 : idx1]);
            let prevXPos = firstXPos;
            let xCoords = [];
            let yCoords = [];
            for(let i = dir == 1 ? idx0 : idx1; i >= idx0 && i <= idx1; i += dir){
                let yVal = dataY[i];
                if (yVal != null) {
                    let xVal = dataX[i];
                    let xPos = pixelForX(xVal);
                    xCoords.push(prevXPos = xPos);
                    yCoords.push(pixelForY(dataY[i]));
                }
            }
            const _paths = {
                stroke: interp(xCoords, yCoords, moveTo, lineTo, bezierCurveTo, pxRound),
                fill: null,
                clip: null,
                band: null,
                gaps: null,
                flags: $77bd600c8f878470$var$BAND_CLIP_FILL
            };
            const stroke = _paths.stroke;
            let [bandFillDir, bandClipDir] = $77bd600c8f878470$var$bandFillClipDirs(u, seriesIdx);
            if (series.fill != null || bandFillDir != 0) {
                let fill = _paths.fill = new Path2D(stroke);
                let fillTo = series.fillTo(u, seriesIdx, series.min, series.max, bandFillDir);
                let fillToY = pixelForY(fillTo);
                lineTo(fill, prevXPos, fillToY);
                lineTo(fill, firstXPos, fillToY);
            }
            if (!series.spanGaps) {
                //	console.time('gaps');
                let gaps = [];
                gaps.push(...$77bd600c8f878470$var$findGaps(dataX, dataY, idx0, idx1, dir, pixelForX, alignGaps));
                //	console.timeEnd('gaps');
                //	console.log('gaps', JSON.stringify(gaps));
                _paths.gaps = gaps = series.gaps(u, seriesIdx, idx0, idx1, gaps);
                _paths.clip = $77bd600c8f878470$var$clipGaps(gaps, scaleX.ori, xOff, yOff, xDim, yDim);
            }
            if (bandClipDir != 0) _paths.band = bandClipDir == 2 ? [
                $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, -1),
                $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, 1)
            ] : $77bd600c8f878470$var$clipBandLine(u, seriesIdx, idx0, idx1, stroke, bandClipDir);
            return _paths;
        //  if FEAT_PATHS: false in rollup.config.js
        //	u.ctx.save();
        //	u.ctx.beginPath();
        //	u.ctx.rect(u.bbox.left, u.bbox.top, u.bbox.width, u.bbox.height);
        //	u.ctx.clip();
        //	u.ctx.strokeStyle = u.series[sidx].stroke;
        //	u.ctx.stroke(stroke);
        //	u.ctx.fillStyle = u.series[sidx].fill;
        //	u.ctx.fill(fill);
        //	u.ctx.restore();
        //	return null;
        });
    };
}
function $77bd600c8f878470$var$monotoneCubic(opts) {
    return $77bd600c8f878470$var$splineInterp($77bd600c8f878470$var$_monotoneCubic, opts);
}
// Monotone Cubic Spline interpolation, adapted from the Chartist.js implementation:
// https://github.com/gionkunz/chartist-js/blob/e7e78201bffe9609915e5e53cfafa29a5d6c49f9/src/scripts/interpolation.js#L240-L369
function $77bd600c8f878470$var$_monotoneCubic(xs, ys, moveTo, lineTo, bezierCurveTo, pxRound) {
    const n = xs.length;
    if (n < 2) return null;
    const path = new Path2D();
    moveTo(path, xs[0], ys[0]);
    if (n == 2) lineTo(path, xs[1], ys[1]);
    else {
        let ms = Array(n), ds = Array(n - 1), dys = Array(n - 1), dxs = Array(n - 1);
        // calc deltas and derivative
        for(let i = 0; i < n - 1; i++){
            dys[i] = ys[i + 1] - ys[i];
            dxs[i] = xs[i + 1] - xs[i];
            ds[i] = dys[i] / dxs[i];
        }
        // determine desired slope (m) at each point using Fritsch-Carlson method
        // http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation
        ms[0] = ds[0];
        for(let i = 1; i < n - 1; i++)if (ds[i] === 0 || ds[i - 1] === 0 || ds[i - 1] > 0 !== ds[i] > 0) ms[i] = 0;
        else {
            ms[i] = 3 * (dxs[i - 1] + dxs[i]) / ((2 * dxs[i] + dxs[i - 1]) / ds[i - 1] + (dxs[i] + 2 * dxs[i - 1]) / ds[i]);
            if (!isFinite(ms[i])) ms[i] = 0;
        }
        ms[n - 1] = ds[n - 2];
        for(let i = 0; i < n - 1; i++)bezierCurveTo(path, xs[i] + dxs[i] / 3, ys[i] + ms[i] * dxs[i] / 3, xs[i + 1] - dxs[i] / 3, ys[i + 1] - ms[i + 1] * dxs[i] / 3, xs[i + 1], ys[i + 1]);
    }
    return path;
}
const $77bd600c8f878470$var$cursorPlots = new Set();
function $77bd600c8f878470$var$invalidateRects() {
    for (let u of $77bd600c8f878470$var$cursorPlots)u.syncRect(true);
}
if ($77bd600c8f878470$var$domEnv) {
    $77bd600c8f878470$var$on($77bd600c8f878470$var$resize, $77bd600c8f878470$var$win, $77bd600c8f878470$var$invalidateRects);
    $77bd600c8f878470$var$on($77bd600c8f878470$var$scroll, $77bd600c8f878470$var$win, $77bd600c8f878470$var$invalidateRects, true);
    $77bd600c8f878470$var$on($77bd600c8f878470$var$dppxchange, $77bd600c8f878470$var$win, ()=>{
        $77bd600c8f878470$export$2e2bcd8739ae039.pxRatio = $77bd600c8f878470$var$pxRatio;
    });
}
const $77bd600c8f878470$var$linearPath = $77bd600c8f878470$var$linear();
const $77bd600c8f878470$var$pointsPath = $77bd600c8f878470$var$points();
function $77bd600c8f878470$var$setDefaults(d, xo, yo, initY) {
    let d2 = initY ? [
        d[0],
        d[1]
    ].concat(d.slice(2)) : [
        d[0]
    ].concat(d.slice(1));
    return d2.map((o, i)=>$77bd600c8f878470$var$setDefault(o, i, xo, yo));
}
function $77bd600c8f878470$var$setDefaults2(d, xyo) {
    return d.map((o, i)=>i == 0 ? null : $77bd600c8f878470$var$assign({}, xyo, o)); // todo: assign() will not merge facet arrays
}
function $77bd600c8f878470$var$setDefault(o, i, xo, yo) {
    return $77bd600c8f878470$var$assign({}, i == 0 ? xo : yo, o);
}
function $77bd600c8f878470$var$snapNumX(self, dataMin, dataMax) {
    return dataMin == null ? $77bd600c8f878470$var$nullNullTuple : [
        dataMin,
        dataMax
    ];
}
const $77bd600c8f878470$var$snapTimeX = $77bd600c8f878470$var$snapNumX;
// this ensures that non-temporal/numeric y-axes get multiple-snapped padding added above/below
// TODO: also account for incrs when snapping to ensure top of axis gets a tick & value
function $77bd600c8f878470$var$snapNumY(self, dataMin, dataMax) {
    return dataMin == null ? $77bd600c8f878470$var$nullNullTuple : $77bd600c8f878470$var$rangeNum(dataMin, dataMax, $77bd600c8f878470$var$rangePad, true);
}
function $77bd600c8f878470$var$snapLogY(self, dataMin, dataMax, scale) {
    return dataMin == null ? $77bd600c8f878470$var$nullNullTuple : $77bd600c8f878470$var$rangeLog(dataMin, dataMax, self.scales[scale].log, false);
}
const $77bd600c8f878470$var$snapLogX = $77bd600c8f878470$var$snapLogY;
function $77bd600c8f878470$var$snapAsinhY(self, dataMin, dataMax, scale) {
    return dataMin == null ? $77bd600c8f878470$var$nullNullTuple : $77bd600c8f878470$var$rangeAsinh(dataMin, dataMax, self.scales[scale].log, false);
}
const $77bd600c8f878470$var$snapAsinhX = $77bd600c8f878470$var$snapAsinhY;
// dim is logical (getClientBoundingRect) pixels, not canvas pixels
function $77bd600c8f878470$var$findIncr(minVal, maxVal, incrs, dim, minSpace) {
    let intDigits = $77bd600c8f878470$var$max($77bd600c8f878470$var$numIntDigits(minVal), $77bd600c8f878470$var$numIntDigits(maxVal));
    let delta = maxVal - minVal;
    let incrIdx = $77bd600c8f878470$var$closestIdx(minSpace / dim * delta, incrs);
    do {
        let foundIncr = incrs[incrIdx];
        let foundSpace = dim * foundIncr / delta;
        if (foundSpace >= minSpace && intDigits + (foundIncr < 5 ? $77bd600c8f878470$var$fixedDec.get(foundIncr) : 0) <= 17) return [
            foundIncr,
            foundSpace
        ];
    }while (++incrIdx < incrs.length);
    return [
        0,
        0
    ];
}
function $77bd600c8f878470$var$pxRatioFont(font) {
    let fontSize, fontSizeCss;
    font = font.replace(/(\d+)px/, (m, p1)=>(fontSize = $77bd600c8f878470$var$round((fontSizeCss = +p1) * $77bd600c8f878470$var$pxRatio)) + "px");
    return [
        font,
        fontSize,
        fontSizeCss
    ];
}
function $77bd600c8f878470$var$syncFontSize(axis) {
    if (axis.show) [
        axis.font,
        axis.labelFont
    ].forEach((f)=>{
        let size = $77bd600c8f878470$var$roundDec(f[2] * $77bd600c8f878470$var$pxRatio, 1);
        f[0] = f[0].replace(/[0-9.]+px/, size + "px");
        f[1] = size;
    });
}
function $77bd600c8f878470$export$2e2bcd8739ae039(opts, data, then) {
    const self = {
        mode: $77bd600c8f878470$var$ifNull(opts.mode, 1)
    };
    const mode = self.mode;
    // TODO: cache denoms & mins scale.cache = {r, min, }
    function getValPct(val, scale) {
        let _val = scale.distr == 3 ? $77bd600c8f878470$var$log10(val > 0 ? val : scale.clamp(self, val, scale.min, scale.max, scale.key)) : scale.distr == 4 ? $77bd600c8f878470$var$asinh(val, scale.asinh) : val;
        return (_val - scale._min) / (scale._max - scale._min);
    }
    function getHPos(val, scale, dim, off) {
        let pct = getValPct(val, scale);
        return off + dim * (scale.dir == -1 ? 1 - pct : pct);
    }
    function getVPos(val, scale, dim, off) {
        let pct = getValPct(val, scale);
        return off + dim * (scale.dir == -1 ? pct : 1 - pct);
    }
    function getPos(val, scale, dim, off) {
        return scale.ori == 0 ? getHPos(val, scale, dim, off) : getVPos(val, scale, dim, off);
    }
    self.valToPosH = getHPos;
    self.valToPosV = getVPos;
    let ready = false;
    self.status = 0;
    const root = self.root = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$UPLOT);
    if (opts.id != null) root.id = opts.id;
    $77bd600c8f878470$var$addClass(root, opts.class);
    if (opts.title) {
        let title = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$TITLE, root);
        title.textContent = opts.title;
    }
    const can = $77bd600c8f878470$var$placeTag("canvas");
    const ctx = self.ctx = can.getContext("2d");
    const wrap = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$WRAP, root);
    $77bd600c8f878470$var$on("click", wrap, (e)=>{
        if (e.target === over) {
            let didDrag = mouseLeft1 != mouseLeft0 || mouseTop1 != mouseTop0;
            didDrag && drag.click(self, e);
        }
    }, true);
    const under = self.under = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$UNDER, wrap);
    wrap.appendChild(can);
    const over = self.over = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$OVER, wrap);
    opts = $77bd600c8f878470$var$copy(opts);
    const pxAlign = +$77bd600c8f878470$var$ifNull(opts.pxAlign, 1);
    const pxRound = $77bd600c8f878470$var$pxRoundGen(pxAlign);
    (opts.plugins || []).forEach((p)=>{
        if (p.opts) opts = p.opts(self, opts) || opts;
    });
    const ms = opts.ms || 1e-3;
    const series = self.series = mode == 1 ? $77bd600c8f878470$var$setDefaults(opts.series || [], $77bd600c8f878470$var$xSeriesOpts, $77bd600c8f878470$var$ySeriesOpts, false) : $77bd600c8f878470$var$setDefaults2(opts.series || [
        null
    ], $77bd600c8f878470$var$xySeriesOpts);
    const axes = self.axes = $77bd600c8f878470$var$setDefaults(opts.axes || [], $77bd600c8f878470$var$xAxisOpts, $77bd600c8f878470$var$yAxisOpts, true);
    const scales = self.scales = {};
    const bands = self.bands = opts.bands || [];
    bands.forEach((b)=>{
        b.fill = $77bd600c8f878470$var$fnOrSelf(b.fill || null);
        b.dir = $77bd600c8f878470$var$ifNull(b.dir, -1);
    });
    const xScaleKey = mode == 2 ? series[1].facets[0].scale : series[0].scale;
    const drawOrderMap = {
        axes: drawAxesGrid,
        series: drawSeries
    };
    const drawOrder = (opts.drawOrder || [
        "axes",
        "series"
    ]).map((key)=>drawOrderMap[key]);
    function initScale(scaleKey) {
        let sc = scales[scaleKey];
        if (sc == null) {
            let scaleOpts = (opts.scales || $77bd600c8f878470$var$EMPTY_OBJ)[scaleKey] || $77bd600c8f878470$var$EMPTY_OBJ;
            if (scaleOpts.from != null) {
                // ensure parent is initialized
                initScale(scaleOpts.from);
                // dependent scales inherit
                scales[scaleKey] = $77bd600c8f878470$var$assign({}, scales[scaleOpts.from], scaleOpts, {
                    key: scaleKey
                });
            } else {
                sc = scales[scaleKey] = $77bd600c8f878470$var$assign({}, scaleKey == xScaleKey ? $77bd600c8f878470$var$xScaleOpts : $77bd600c8f878470$var$yScaleOpts, scaleOpts);
                sc.key = scaleKey;
                let isTime = sc.time;
                let rn = sc.range;
                let rangeIsArr = $77bd600c8f878470$var$isArr(rn);
                if (scaleKey != xScaleKey || mode == 2 && !isTime) {
                    // if range array has null limits, it should be auto
                    if (rangeIsArr && (rn[0] == null || rn[1] == null)) {
                        rn = {
                            min: rn[0] == null ? $77bd600c8f878470$var$autoRangePart : {
                                mode: 1,
                                hard: rn[0],
                                soft: rn[0]
                            },
                            max: rn[1] == null ? $77bd600c8f878470$var$autoRangePart : {
                                mode: 1,
                                hard: rn[1],
                                soft: rn[1]
                            }
                        };
                        rangeIsArr = false;
                    }
                    if (!rangeIsArr && $77bd600c8f878470$var$isObj(rn)) {
                        let cfg = rn;
                        // this is similar to snapNumY
                        rn = (self, dataMin, dataMax)=>dataMin == null ? $77bd600c8f878470$var$nullNullTuple : $77bd600c8f878470$var$rangeNum(dataMin, dataMax, cfg);
                    }
                }
                sc.range = $77bd600c8f878470$var$fnOrSelf(rn || (isTime ? $77bd600c8f878470$var$snapTimeX : scaleKey == xScaleKey ? sc.distr == 3 ? $77bd600c8f878470$var$snapLogX : sc.distr == 4 ? $77bd600c8f878470$var$snapAsinhX : $77bd600c8f878470$var$snapNumX : sc.distr == 3 ? $77bd600c8f878470$var$snapLogY : sc.distr == 4 ? $77bd600c8f878470$var$snapAsinhY : $77bd600c8f878470$var$snapNumY));
                sc.auto = $77bd600c8f878470$var$fnOrSelf(rangeIsArr ? false : sc.auto);
                sc.clamp = $77bd600c8f878470$var$fnOrSelf(sc.clamp || $77bd600c8f878470$var$clampScale);
                // caches for expensive ops like asinh() & log()
                sc._min = sc._max = null;
            }
        }
    }
    initScale("x");
    initScale("y");
    // TODO: init scales from facets in mode: 2
    if (mode == 1) series.forEach((s)=>{
        initScale(s.scale);
    });
    axes.forEach((a)=>{
        initScale(a.scale);
    });
    for(let k in opts.scales)initScale(k);
    const scaleX = scales[xScaleKey];
    const xScaleDistr = scaleX.distr;
    let valToPosX, valToPosY;
    if (scaleX.ori == 0) {
        $77bd600c8f878470$var$addClass(root, $77bd600c8f878470$var$ORI_HZ);
        valToPosX = getHPos;
        valToPosY = getVPos;
    /*
		updOriDims = () => {
			xDimCan = plotWid;
			xOffCan = plotLft;
			yDimCan = plotHgt;
			yOffCan = plotTop;

			xDimCss = plotWidCss;
			xOffCss = plotLftCss;
			yDimCss = plotHgtCss;
			yOffCss = plotTopCss;
		};
		*/ } else {
        $77bd600c8f878470$var$addClass(root, $77bd600c8f878470$var$ORI_VT);
        valToPosX = getVPos;
        valToPosY = getHPos;
    /*
		updOriDims = () => {
			xDimCan = plotHgt;
			xOffCan = plotTop;
			yDimCan = plotWid;
			yOffCan = plotLft;

			xDimCss = plotHgtCss;
			xOffCss = plotTopCss;
			yDimCss = plotWidCss;
			yOffCss = plotLftCss;
		};
		*/ }
    const pendScales = {};
    // explicitly-set initial scales
    for(let k in scales){
        let sc = scales[k];
        if (sc.min != null || sc.max != null) {
            pendScales[k] = {
                min: sc.min,
                max: sc.max
            };
            sc.min = sc.max = null;
        }
    }
    //	self.tz = opts.tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const _tzDate = opts.tzDate || ((ts)=>new Date($77bd600c8f878470$var$round(ts / ms)));
    const _fmtDate = opts.fmtDate || $77bd600c8f878470$var$fmtDate;
    const _timeAxisSplits = ms == 1 ? $77bd600c8f878470$var$timeAxisSplitsMs(_tzDate) : $77bd600c8f878470$var$timeAxisSplitsS(_tzDate);
    const _timeAxisVals = $77bd600c8f878470$var$timeAxisVals(_tzDate, $77bd600c8f878470$var$timeAxisStamps(ms == 1 ? $77bd600c8f878470$var$_timeAxisStampsMs : $77bd600c8f878470$var$_timeAxisStampsS, _fmtDate));
    const _timeSeriesVal = $77bd600c8f878470$var$timeSeriesVal(_tzDate, $77bd600c8f878470$var$timeSeriesStamp($77bd600c8f878470$var$_timeSeriesStamp, _fmtDate));
    const activeIdxs = [];
    const legend = self.legend = $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$legendOpts, opts.legend);
    const showLegend = legend.show;
    const markers = legend.markers;
    legend.idxs = activeIdxs;
    markers.width = $77bd600c8f878470$var$fnOrSelf(markers.width);
    markers.dash = $77bd600c8f878470$var$fnOrSelf(markers.dash);
    markers.stroke = $77bd600c8f878470$var$fnOrSelf(markers.stroke);
    markers.fill = $77bd600c8f878470$var$fnOrSelf(markers.fill);
    let legendTable;
    let legendHead;
    let legendBody;
    let legendRows = [];
    let legendCells = [];
    let legendCols;
    let multiValLegend = false;
    let NULL_LEGEND_VALUES = {};
    if (legend.live) {
        const getMultiVals = series[1] ? series[1].values : null;
        multiValLegend = getMultiVals != null;
        legendCols = multiValLegend ? getMultiVals(self, 1, 0) : {
            _: 0
        };
        for(let k in legendCols)NULL_LEGEND_VALUES[k] = $77bd600c8f878470$var$LEGEND_DISP;
    }
    if (showLegend) {
        legendTable = $77bd600c8f878470$var$placeTag("table", $77bd600c8f878470$var$LEGEND, root);
        legendBody = $77bd600c8f878470$var$placeTag("tbody", null, legendTable);
        // allows legend to be moved out of root
        legend.mount(self, legendTable);
        if (multiValLegend) {
            legendHead = $77bd600c8f878470$var$placeTag("thead", null, legendTable, legendBody);
            let head = $77bd600c8f878470$var$placeTag("tr", null, legendHead);
            $77bd600c8f878470$var$placeTag("th", null, head);
            for(var key in legendCols)$77bd600c8f878470$var$placeTag("th", $77bd600c8f878470$var$LEGEND_LABEL, head).textContent = key;
        } else {
            $77bd600c8f878470$var$addClass(legendTable, $77bd600c8f878470$var$LEGEND_INLINE);
            legend.live && $77bd600c8f878470$var$addClass(legendTable, $77bd600c8f878470$var$LEGEND_LIVE);
        }
    }
    const son = {
        show: true
    };
    const soff = {
        show: false
    };
    function initLegendRow(s, i) {
        if (i == 0 && (multiValLegend || !legend.live || mode == 2)) return $77bd600c8f878470$var$nullNullTuple;
        let cells = [];
        let row = $77bd600c8f878470$var$placeTag("tr", $77bd600c8f878470$var$LEGEND_SERIES, legendBody, legendBody.childNodes[i]);
        $77bd600c8f878470$var$addClass(row, s.class);
        if (!s.show) $77bd600c8f878470$var$addClass(row, $77bd600c8f878470$var$OFF);
        let label = $77bd600c8f878470$var$placeTag("th", null, row);
        if (markers.show) {
            let indic = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$LEGEND_MARKER, label);
            if (i > 0) {
                let width = markers.width(self, i);
                if (width) indic.style.border = width + "px " + markers.dash(self, i) + " " + markers.stroke(self, i);
                indic.style.background = markers.fill(self, i);
            }
        }
        let text = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$LEGEND_LABEL, label);
        text.textContent = s.label;
        if (i > 0) {
            if (!markers.show) text.style.color = s.width > 0 ? markers.stroke(self, i) : markers.fill(self, i);
            onMouse("click", label, (e)=>{
                if (cursor._lock) return;
                setCursorEvent(e);
                let seriesIdx = series.indexOf(s);
                if ((e.ctrlKey || e.metaKey) != legend.isolate) {
                    // if any other series is shown, isolate this one. else show all
                    let isolate = series.some((s, i)=>i > 0 && i != seriesIdx && s.show);
                    series.forEach((s, i)=>{
                        i > 0 && setSeries(i, isolate ? i == seriesIdx ? son : soff : son, true, syncOpts.setSeries);
                    });
                } else setSeries(seriesIdx, {
                    show: !s.show
                }, true, syncOpts.setSeries);
            }, false);
            if (cursorFocus) onMouse($77bd600c8f878470$var$mouseenter, label, (e)=>{
                if (cursor._lock) return;
                setCursorEvent(e);
                setSeries(series.indexOf(s), FOCUS_TRUE, true, syncOpts.setSeries);
            }, false);
        }
        for(var key in legendCols){
            let v = $77bd600c8f878470$var$placeTag("td", $77bd600c8f878470$var$LEGEND_VALUE, row);
            v.textContent = "--";
            cells.push(v);
        }
        return [
            row,
            cells
        ];
    }
    const mouseListeners = new Map();
    function onMouse(ev, targ, fn, onlyTarg = true) {
        const targListeners = mouseListeners.get(targ) || {};
        const listener = cursor.bind[ev](self, targ, fn, onlyTarg);
        if (listener) {
            $77bd600c8f878470$var$on(ev, targ, targListeners[ev] = listener);
            mouseListeners.set(targ, targListeners);
        }
    }
    function offMouse(ev, targ, fn) {
        const targListeners = mouseListeners.get(targ) || {};
        for(let k in targListeners)if (ev == null || k == ev) {
            $77bd600c8f878470$var$off(k, targ, targListeners[k]);
            delete targListeners[k];
        }
        if (ev == null) mouseListeners.delete(targ);
    }
    let fullWidCss = 0;
    let fullHgtCss = 0;
    let plotWidCss = 0;
    let plotHgtCss = 0;
    // plot margins to account for axes
    let plotLftCss = 0;
    let plotTopCss = 0;
    // previous values for diffing
    let _plotLftCss = plotLftCss;
    let _plotTopCss = plotTopCss;
    let _plotWidCss = plotWidCss;
    let _plotHgtCss = plotHgtCss;
    let plotLft = 0;
    let plotTop = 0;
    let plotWid = 0;
    let plotHgt = 0;
    self.bbox = {};
    let shouldSetScales = false;
    let shouldSetSize = false;
    let shouldConvergeSize = false;
    let shouldSetCursor = false;
    let shouldSetSelect = false;
    let shouldSetLegend = false;
    function _setSize(width, height, force) {
        if (force || width != self.width || height != self.height) calcSize(width, height);
        resetYSeries(false);
        shouldConvergeSize = true;
        shouldSetSize = true;
        commit();
    }
    function calcSize(width, height) {
        //	log("calcSize()", arguments);
        self.width = fullWidCss = plotWidCss = width;
        self.height = fullHgtCss = plotHgtCss = height;
        plotLftCss = plotTopCss = 0;
        calcPlotRect();
        calcAxesRects();
        let bb = self.bbox;
        plotLft = bb.left = $77bd600c8f878470$var$incrRound(plotLftCss * $77bd600c8f878470$var$pxRatio, 0.5);
        plotTop = bb.top = $77bd600c8f878470$var$incrRound(plotTopCss * $77bd600c8f878470$var$pxRatio, 0.5);
        plotWid = bb.width = $77bd600c8f878470$var$incrRound(plotWidCss * $77bd600c8f878470$var$pxRatio, 0.5);
        plotHgt = bb.height = $77bd600c8f878470$var$incrRound(plotHgtCss * $77bd600c8f878470$var$pxRatio, 0.5);
    //	updOriDims();
    }
    // ensures size calc convergence
    const CYCLE_LIMIT = 3;
    function convergeSize() {
        let converged = false;
        let cycleNum = 0;
        while(!converged){
            cycleNum++;
            let axesConverged = axesCalc(cycleNum);
            let paddingConverged = paddingCalc(cycleNum);
            converged = cycleNum == CYCLE_LIMIT || axesConverged && paddingConverged;
            if (!converged) {
                calcSize(self.width, self.height);
                shouldSetSize = true;
            }
        }
    }
    function setSize({ width: width, height: height }) {
        _setSize(width, height);
    }
    self.setSize = setSize;
    // accumulate axis offsets, reduce canvas width
    function calcPlotRect() {
        // easements for edge labels
        let hasTopAxis = false;
        let hasBtmAxis = false;
        let hasRgtAxis = false;
        let hasLftAxis = false;
        axes.forEach((axis, i)=>{
            if (axis.show && axis._show) {
                let { side: side, _size: _size } = axis;
                let isVt = side % 2;
                let labelSize = axis.label != null ? axis.labelSize : 0;
                let fullSize = _size + labelSize;
                if (fullSize > 0) {
                    if (isVt) {
                        plotWidCss -= fullSize;
                        if (side == 3) {
                            plotLftCss += fullSize;
                            hasLftAxis = true;
                        } else hasRgtAxis = true;
                    } else {
                        plotHgtCss -= fullSize;
                        if (side == 0) {
                            plotTopCss += fullSize;
                            hasTopAxis = true;
                        } else hasBtmAxis = true;
                    }
                }
            }
        });
        sidesWithAxes[0] = hasTopAxis;
        sidesWithAxes[1] = hasRgtAxis;
        sidesWithAxes[2] = hasBtmAxis;
        sidesWithAxes[3] = hasLftAxis;
        // hz padding
        plotWidCss -= _padding[1] + _padding[3];
        plotLftCss += _padding[3];
        // vt padding
        plotHgtCss -= _padding[2] + _padding[0];
        plotTopCss += _padding[0];
    }
    function calcAxesRects() {
        // will accum +
        let off1 = plotLftCss + plotWidCss;
        let off2 = plotTopCss + plotHgtCss;
        // will accum -
        let off3 = plotLftCss;
        let off0 = plotTopCss;
        function incrOffset(side, size) {
            switch(side){
                case 1:
                    off1 += size;
                    return off1 - size;
                case 2:
                    off2 += size;
                    return off2 - size;
                case 3:
                    off3 -= size;
                    return off3 + size;
                case 0:
                    off0 -= size;
                    return off0 + size;
            }
        }
        axes.forEach((axis, i)=>{
            if (axis.show && axis._show) {
                let side = axis.side;
                axis._pos = incrOffset(side, axis._size);
                if (axis.label != null) axis._lpos = incrOffset(side, axis.labelSize);
            }
        });
    }
    const cursor = self.cursor = $77bd600c8f878470$var$assign({}, $77bd600c8f878470$var$cursorOpts, {
        drag: {
            y: mode == 2
        }
    }, opts.cursor);
    if (cursor.dataIdx == null) {
        let hov = cursor.hover;
        let skip = hov.skip = new Set(hov.skip ?? []);
        skip.add(void 0); // alignment artifacts
        let prox = hov.prox = $77bd600c8f878470$var$fnOrSelf(hov.prox);
        let bias = hov.bias ??= 0;
        // TODO: only scan between in-view idxs (i0, i1)
        cursor.dataIdx = (self, seriesIdx, cursorIdx, valAtPosX)=>{
            if (seriesIdx == 0) return cursorIdx;
            let idx2 = cursorIdx;
            let _prox = prox(self, seriesIdx, cursorIdx, valAtPosX) ?? $77bd600c8f878470$var$inf;
            let withProx = _prox >= 0 && _prox < $77bd600c8f878470$var$inf;
            let xDim = scaleX.ori == 0 ? plotWidCss : plotHgtCss;
            let cursorLft = cursor.left;
            let xValues = data[0];
            let yValues = data[seriesIdx];
            if (skip.has(yValues[cursorIdx])) {
                idx2 = null;
                let nonNullLft = null, nonNullRgt = null, j;
                if (bias == 0 || bias == -1) {
                    j = cursorIdx;
                    while(nonNullLft == null && j-- > 0)if (!skip.has(yValues[j])) nonNullLft = j;
                }
                if (bias == 0 || bias == 1) {
                    j = cursorIdx;
                    while(nonNullRgt == null && j++ < yValues.length)if (!skip.has(yValues[j])) nonNullRgt = j;
                }
                if (nonNullLft != null || nonNullRgt != null) {
                    if (withProx) {
                        let lftPos = nonNullLft == null ? -Infinity : valToPosX(xValues[nonNullLft], scaleX, xDim, 0);
                        let rgtPos = nonNullRgt == null ? Infinity : valToPosX(xValues[nonNullRgt], scaleX, xDim, 0);
                        let lftDelta = cursorLft - lftPos;
                        let rgtDelta = rgtPos - cursorLft;
                        if (lftDelta <= rgtDelta) {
                            if (lftDelta <= _prox) idx2 = nonNullLft;
                        } else if (rgtDelta <= _prox) idx2 = nonNullRgt;
                    } else idx2 = nonNullRgt == null ? nonNullLft : nonNullLft == null ? nonNullRgt : cursorIdx - nonNullLft <= nonNullRgt - cursorIdx ? nonNullLft : nonNullRgt;
                }
            } else if (withProx) {
                let dist = $77bd600c8f878470$var$abs(cursorLft - valToPosX(xValues[cursorIdx], scaleX, xDim, 0));
                if (dist > _prox) idx2 = null;
            }
            return idx2;
        };
    }
    const setCursorEvent = (e)=>{
        cursor.event = e;
    };
    cursor.idxs = activeIdxs;
    cursor._lock = false;
    let points = cursor.points;
    points.show = $77bd600c8f878470$var$fnOrSelf(points.show);
    points.size = $77bd600c8f878470$var$fnOrSelf(points.size);
    points.stroke = $77bd600c8f878470$var$fnOrSelf(points.stroke);
    points.width = $77bd600c8f878470$var$fnOrSelf(points.width);
    points.fill = $77bd600c8f878470$var$fnOrSelf(points.fill);
    const focus = self.focus = $77bd600c8f878470$var$assign({}, opts.focus || {
        alpha: 0.3
    }, cursor.focus);
    const cursorFocus = focus.prox >= 0;
    // series-intersection markers
    let cursorPts = [
        null
    ];
    // position caches in CSS pixels
    let cursorPtsLft = [
        null
    ];
    let cursorPtsTop = [
        null
    ];
    function initCursorPt(s, si) {
        if (si > 0) {
            let pt = cursor.points.show(self, si);
            if (pt) {
                $77bd600c8f878470$var$addClass(pt, $77bd600c8f878470$var$CURSOR_PT);
                $77bd600c8f878470$var$addClass(pt, s.class);
                $77bd600c8f878470$var$elTrans(pt, -10, -10, plotWidCss, plotHgtCss);
                over.insertBefore(pt, cursorPts[si]);
                return pt;
            }
        }
    }
    function initSeries(s, i) {
        if (mode == 1 || i > 0) {
            let isTime = mode == 1 && scales[s.scale].time;
            let sv = s.value;
            s.value = isTime ? $77bd600c8f878470$var$isStr(sv) ? $77bd600c8f878470$var$timeSeriesVal(_tzDate, $77bd600c8f878470$var$timeSeriesStamp(sv, _fmtDate)) : sv || _timeSeriesVal : sv || $77bd600c8f878470$var$numSeriesVal;
            s.label = s.label || (isTime ? $77bd600c8f878470$var$timeSeriesLabel : $77bd600c8f878470$var$numSeriesLabel);
        }
        if (i > 0) {
            s.width = s.width == null ? 1 : s.width;
            s.paths = s.paths || $77bd600c8f878470$var$linearPath || $77bd600c8f878470$var$retNull;
            s.fillTo = $77bd600c8f878470$var$fnOrSelf(s.fillTo || $77bd600c8f878470$var$seriesFillTo);
            s.pxAlign = +$77bd600c8f878470$var$ifNull(s.pxAlign, pxAlign);
            s.pxRound = $77bd600c8f878470$var$pxRoundGen(s.pxAlign);
            s.stroke = $77bd600c8f878470$var$fnOrSelf(s.stroke || null);
            s.fill = $77bd600c8f878470$var$fnOrSelf(s.fill || null);
            s._stroke = s._fill = s._paths = s._focus = null;
            let _ptDia = $77bd600c8f878470$var$ptDia($77bd600c8f878470$var$max(1, s.width), 1);
            let points = s.points = $77bd600c8f878470$var$assign({}, {
                size: _ptDia,
                width: $77bd600c8f878470$var$max(1, _ptDia * .2),
                stroke: s.stroke,
                space: _ptDia * 2,
                paths: $77bd600c8f878470$var$pointsPath,
                _stroke: null,
                _fill: null
            }, s.points);
            points.show = $77bd600c8f878470$var$fnOrSelf(points.show);
            points.filter = $77bd600c8f878470$var$fnOrSelf(points.filter);
            points.fill = $77bd600c8f878470$var$fnOrSelf(points.fill);
            points.stroke = $77bd600c8f878470$var$fnOrSelf(points.stroke);
            points.paths = $77bd600c8f878470$var$fnOrSelf(points.paths);
            points.pxAlign = s.pxAlign;
        }
        if (showLegend) {
            let rowCells = initLegendRow(s, i);
            legendRows.splice(i, 0, rowCells[0]);
            legendCells.splice(i, 0, rowCells[1]);
            legend.values.push(null); // NULL_LEGEND_VALS not yet avil here :(
        }
        if (cursor.show) {
            activeIdxs.splice(i, 0, null);
            let pt = initCursorPt(s, i);
            if (pt != null) {
                cursorPts.splice(i, 0, pt);
                cursorPtsLft.splice(i, 0, 0);
                cursorPtsTop.splice(i, 0, 0);
            }
        }
        fire("addSeries", i);
    }
    function addSeries(opts, si) {
        si = si == null ? series.length : si;
        opts = mode == 1 ? $77bd600c8f878470$var$setDefault(opts, si, $77bd600c8f878470$var$xSeriesOpts, $77bd600c8f878470$var$ySeriesOpts) : $77bd600c8f878470$var$setDefault(opts, si, null, $77bd600c8f878470$var$xySeriesOpts);
        series.splice(si, 0, opts);
        initSeries(series[si], si);
    }
    self.addSeries = addSeries;
    function delSeries(i) {
        series.splice(i, 1);
        if (showLegend) {
            legend.values.splice(i, 1);
            legendCells.splice(i, 1);
            let tr = legendRows.splice(i, 1)[0];
            offMouse(null, tr.firstChild);
            tr.remove();
        }
        if (cursor.show) {
            activeIdxs.splice(i, 1);
            if (cursorPts.length > 1) {
                cursorPts.splice(i, 1)[0].remove();
                cursorPtsLft.splice(i, 1);
                cursorPtsTop.splice(i, 1);
            }
        }
        // TODO: de-init no-longer-needed scales?
        fire("delSeries", i);
    }
    self.delSeries = delSeries;
    const sidesWithAxes = [
        false,
        false,
        false,
        false
    ];
    function initAxis(axis, i) {
        axis._show = axis.show;
        if (axis.show) {
            let isVt = axis.side % 2;
            let sc = scales[axis.scale];
            // this can occur if all series specify non-default scales
            if (sc == null) {
                axis.scale = isVt ? series[1].scale : xScaleKey;
                sc = scales[axis.scale];
            }
            // also set defaults for incrs & values based on axis distr
            let isTime = sc.time;
            axis.size = $77bd600c8f878470$var$fnOrSelf(axis.size);
            axis.space = $77bd600c8f878470$var$fnOrSelf(axis.space);
            axis.rotate = $77bd600c8f878470$var$fnOrSelf(axis.rotate);
            if ($77bd600c8f878470$var$isArr(axis.incrs)) axis.incrs.forEach((incr)=>{
                !$77bd600c8f878470$var$fixedDec.has(incr) && $77bd600c8f878470$var$fixedDec.set(incr, $77bd600c8f878470$var$guessDec(incr));
            });
            axis.incrs = $77bd600c8f878470$var$fnOrSelf(axis.incrs || (sc.distr == 2 ? $77bd600c8f878470$var$wholeIncrs : isTime ? ms == 1 ? $77bd600c8f878470$var$timeIncrsMs : $77bd600c8f878470$var$timeIncrsS : $77bd600c8f878470$var$numIncrs));
            axis.splits = $77bd600c8f878470$var$fnOrSelf(axis.splits || (isTime && sc.distr == 1 ? _timeAxisSplits : sc.distr == 3 ? $77bd600c8f878470$var$logAxisSplits : sc.distr == 4 ? $77bd600c8f878470$var$asinhAxisSplits : $77bd600c8f878470$var$numAxisSplits));
            axis.stroke = $77bd600c8f878470$var$fnOrSelf(axis.stroke);
            axis.grid.stroke = $77bd600c8f878470$var$fnOrSelf(axis.grid.stroke);
            axis.ticks.stroke = $77bd600c8f878470$var$fnOrSelf(axis.ticks.stroke);
            axis.border.stroke = $77bd600c8f878470$var$fnOrSelf(axis.border.stroke);
            let av = axis.values;
            axis.values = // static array of tick values
            $77bd600c8f878470$var$isArr(av) && !$77bd600c8f878470$var$isArr(av[0]) ? $77bd600c8f878470$var$fnOrSelf(av) : // temporal
            isTime ? // config array of fmtDate string tpls
            $77bd600c8f878470$var$isArr(av) ? $77bd600c8f878470$var$timeAxisVals(_tzDate, $77bd600c8f878470$var$timeAxisStamps(av, _fmtDate)) : // fmtDate string tpl
            $77bd600c8f878470$var$isStr(av) ? $77bd600c8f878470$var$timeAxisVal(_tzDate, av) : av || _timeAxisVals : av || $77bd600c8f878470$var$numAxisVals;
            axis.filter = $77bd600c8f878470$var$fnOrSelf(axis.filter || (sc.distr >= 3 && sc.log == 10 ? $77bd600c8f878470$var$log10AxisValsFilt : sc.distr == 3 && sc.log == 2 ? $77bd600c8f878470$var$log2AxisValsFilt : $77bd600c8f878470$var$retArg1));
            axis.font = $77bd600c8f878470$var$pxRatioFont(axis.font);
            axis.labelFont = $77bd600c8f878470$var$pxRatioFont(axis.labelFont);
            axis._size = axis.size(self, null, i, 0);
            axis._space = axis._rotate = axis._incrs = axis._found = axis._splits = axis._values = null;
            if (axis._size > 0) {
                sidesWithAxes[i] = true;
                axis._el = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$AXIS, wrap);
            }
        // debug
        //	axis._el.style.background = "#"  + Math.floor(Math.random()*16777215).toString(16) + '80';
        }
    }
    function autoPadSide(self, side, sidesWithAxes, cycleNum) {
        let [hasTopAxis, hasRgtAxis, hasBtmAxis, hasLftAxis] = sidesWithAxes;
        let ori = side % 2;
        let size = 0;
        if (ori == 0 && (hasLftAxis || hasRgtAxis)) size = side == 0 && !hasTopAxis || side == 2 && !hasBtmAxis ? $77bd600c8f878470$var$round($77bd600c8f878470$var$xAxisOpts.size / 3) : 0;
        if (ori == 1 && (hasTopAxis || hasBtmAxis)) size = side == 1 && !hasRgtAxis || side == 3 && !hasLftAxis ? $77bd600c8f878470$var$round($77bd600c8f878470$var$yAxisOpts.size / 2) : 0;
        return size;
    }
    const padding = self.padding = (opts.padding || [
        autoPadSide,
        autoPadSide,
        autoPadSide,
        autoPadSide
    ]).map((p)=>$77bd600c8f878470$var$fnOrSelf($77bd600c8f878470$var$ifNull(p, autoPadSide)));
    const _padding = self._padding = padding.map((p, i)=>p(self, i, sidesWithAxes, 0));
    let dataLen;
    // rendered data window
    let i0 = null;
    let i1 = null;
    const idxs = mode == 1 ? series[0].idxs : null;
    let data0 = null;
    let viaAutoScaleX = false;
    function setData(_data, _resetScales) {
        data = _data == null ? [] : _data;
        self.data = self._data = data;
        if (mode == 2) {
            dataLen = 0;
            for(let i = 1; i < series.length; i++)dataLen += data[i][0].length;
        } else {
            if (data.length == 0) self.data = self._data = data = [
                []
            ];
            data0 = data[0];
            dataLen = data0.length;
            let scaleData = data;
            if (xScaleDistr == 2) {
                scaleData = data.slice();
                let _data0 = scaleData[0] = Array(dataLen);
                for(let i = 0; i < dataLen; i++)_data0[i] = i;
            }
            self._data = data = scaleData;
        }
        resetYSeries(true);
        fire("setData");
        // forces x axis tick values to re-generate when neither x scale nor y scale changes
        // in ordinal mode, scale range is by index, so will not change if new data has same length, but tick values are from data
        if (xScaleDistr == 2) shouldConvergeSize = true;
        if (_resetScales !== false) {
            let xsc = scaleX;
            if (xsc.auto(self, viaAutoScaleX)) autoScaleX();
            else _setScale(xScaleKey, xsc.min, xsc.max);
            shouldSetCursor = shouldSetCursor || cursor.left >= 0;
            shouldSetLegend = true;
            commit();
        }
    }
    self.setData = setData;
    function autoScaleX() {
        viaAutoScaleX = true;
        let _min, _max;
        if (mode == 1) {
            if (dataLen > 0) {
                i0 = idxs[0] = 0;
                i1 = idxs[1] = dataLen - 1;
                _min = data[0][i0];
                _max = data[0][i1];
                if (xScaleDistr == 2) {
                    _min = i0;
                    _max = i1;
                } else if (_min == _max) {
                    if (xScaleDistr == 3) [_min, _max] = $77bd600c8f878470$var$rangeLog(_min, _min, scaleX.log, false);
                    else if (xScaleDistr == 4) [_min, _max] = $77bd600c8f878470$var$rangeAsinh(_min, _min, scaleX.log, false);
                    else if (scaleX.time) _max = _min + $77bd600c8f878470$var$round(86400 / ms);
                    else [_min, _max] = $77bd600c8f878470$var$rangeNum(_min, _max, $77bd600c8f878470$var$rangePad, true);
                }
            } else {
                i0 = idxs[0] = _min = null;
                i1 = idxs[1] = _max = null;
            }
        }
        _setScale(xScaleKey, _min, _max);
    }
    let ctxStroke, ctxFill, ctxWidth, ctxDash, ctxJoin, ctxCap, ctxFont, ctxAlign, ctxBaseline;
    let ctxAlpha;
    function setCtxStyle(stroke, width, dash, cap, fill, join) {
        stroke ??= $77bd600c8f878470$var$transparent;
        dash ??= $77bd600c8f878470$var$EMPTY_ARR;
        cap ??= "butt"; // (‿|‿)
        fill ??= $77bd600c8f878470$var$transparent;
        join ??= "round";
        if (stroke != ctxStroke) ctx.strokeStyle = ctxStroke = stroke;
        if (fill != ctxFill) ctx.fillStyle = ctxFill = fill;
        if (width != ctxWidth) ctx.lineWidth = ctxWidth = width;
        if (join != ctxJoin) ctx.lineJoin = ctxJoin = join;
        if (cap != ctxCap) ctx.lineCap = ctxCap = cap;
        if (dash != ctxDash) ctx.setLineDash(ctxDash = dash);
    }
    function setFontStyle(font, fill, align, baseline) {
        if (fill != ctxFill) ctx.fillStyle = ctxFill = fill;
        if (font != ctxFont) ctx.font = ctxFont = font;
        if (align != ctxAlign) ctx.textAlign = ctxAlign = align;
        if (baseline != ctxBaseline) ctx.textBaseline = ctxBaseline = baseline;
    }
    function accScale(wsc, psc, facet, data, sorted = 0) {
        if (data.length > 0 && wsc.auto(self, viaAutoScaleX) && (psc == null || psc.min == null)) {
            let _i0 = $77bd600c8f878470$var$ifNull(i0, 0);
            let _i1 = $77bd600c8f878470$var$ifNull(i1, data.length - 1);
            // only run getMinMax() for invalidated series data, else reuse
            let minMax = facet.min == null ? wsc.distr == 3 ? $77bd600c8f878470$var$getMinMaxLog(data, _i0, _i1) : $77bd600c8f878470$var$getMinMax(data, _i0, _i1, sorted) : [
                facet.min,
                facet.max
            ];
            // initial min/max
            wsc.min = $77bd600c8f878470$var$min(wsc.min, facet.min = minMax[0]);
            wsc.max = $77bd600c8f878470$var$max(wsc.max, facet.max = minMax[1]);
        }
    }
    const AUTOSCALE = {
        min: null,
        max: null
    };
    function setScales() {
        //	log("setScales()", arguments);
        // implicitly add auto scales, and unranged scales
        for(let k in scales){
            let sc = scales[k];
            if (pendScales[k] == null && // scales that have never been set (on init)
            (sc.min == null || // or auto scales when the x scale was explicitly set
            pendScales[xScaleKey] != null && sc.auto(self, viaAutoScaleX))) pendScales[k] = AUTOSCALE;
        }
        // implicitly add dependent scales
        for(let k in scales){
            let sc = scales[k];
            if (pendScales[k] == null && sc.from != null && pendScales[sc.from] != null) pendScales[k] = AUTOSCALE;
        }
        // explicitly setting the x-scale invalidates everything (acts as redraw)
        if (pendScales[xScaleKey] != null) resetYSeries(true); // TODO: only reset series on auto scales?
        let wipScales = {};
        for(let k in pendScales){
            let psc = pendScales[k];
            if (psc != null) {
                let wsc = wipScales[k] = $77bd600c8f878470$var$copy(scales[k], $77bd600c8f878470$var$fastIsObj);
                if (psc.min != null) $77bd600c8f878470$var$assign(wsc, psc);
                else if (k != xScaleKey || mode == 2) {
                    if (dataLen == 0 && wsc.from == null) {
                        let minMax = wsc.range(self, null, null, k);
                        wsc.min = minMax[0];
                        wsc.max = minMax[1];
                    } else {
                        wsc.min = $77bd600c8f878470$var$inf;
                        wsc.max = -$77bd600c8f878470$var$inf;
                    }
                }
            }
        }
        if (dataLen > 0) {
            // pre-range y-scales from y series' data values
            series.forEach((s, i)=>{
                if (mode == 1) {
                    let k = s.scale;
                    let psc = pendScales[k];
                    if (psc == null) return;
                    let wsc = wipScales[k];
                    if (i == 0) {
                        let minMax = wsc.range(self, wsc.min, wsc.max, k);
                        wsc.min = minMax[0];
                        wsc.max = minMax[1];
                        i0 = $77bd600c8f878470$var$closestIdx(wsc.min, data[0]);
                        i1 = $77bd600c8f878470$var$closestIdx(wsc.max, data[0]);
                        // don't try to contract same or adjacent idxs
                        if (i1 - i0 > 1) {
                            // closest indices can be outside of view
                            if (data[0][i0] < wsc.min) i0++;
                            if (data[0][i1] > wsc.max) i1--;
                        }
                        s.min = data0[i0];
                        s.max = data0[i1];
                    } else if (s.show && s.auto) accScale(wsc, psc, s, data[i], s.sorted);
                    s.idxs[0] = i0;
                    s.idxs[1] = i1;
                } else {
                    if (i > 0) {
                        if (s.show && s.auto) {
                            // TODO: only handles, assumes and requires facets[0] / 'x' scale, and facets[1] / 'y' scale
                            let [xFacet, yFacet] = s.facets;
                            let xScaleKey = xFacet.scale;
                            let yScaleKey = yFacet.scale;
                            let [xData, yData] = data[i];
                            let wscx = wipScales[xScaleKey];
                            let wscy = wipScales[yScaleKey];
                            // null can happen when only x is zoomed, but y has static range and doesnt get auto-added to pending
                            wscx != null && accScale(wscx, pendScales[xScaleKey], xFacet, xData, xFacet.sorted);
                            wscy != null && accScale(wscy, pendScales[yScaleKey], yFacet, yData, yFacet.sorted);
                            // temp
                            s.min = yFacet.min;
                            s.max = yFacet.max;
                        }
                    }
                }
            });
            // range independent scales
            for(let k in wipScales){
                let wsc = wipScales[k];
                let psc = pendScales[k];
                if (wsc.from == null && (psc == null || psc.min == null)) {
                    let minMax = wsc.range(self, wsc.min == $77bd600c8f878470$var$inf ? null : wsc.min, wsc.max == -$77bd600c8f878470$var$inf ? null : wsc.max, k);
                    wsc.min = minMax[0];
                    wsc.max = minMax[1];
                }
            }
        }
        // range dependent scales
        for(let k in wipScales){
            let wsc = wipScales[k];
            if (wsc.from != null) {
                let base = wipScales[wsc.from];
                if (base.min == null) wsc.min = wsc.max = null;
                else {
                    let minMax = wsc.range(self, base.min, base.max, k);
                    wsc.min = minMax[0];
                    wsc.max = minMax[1];
                }
            }
        }
        let changed = {};
        let anyChanged = false;
        for(let k in wipScales){
            let wsc = wipScales[k];
            let sc = scales[k];
            if (sc.min != wsc.min || sc.max != wsc.max) {
                sc.min = wsc.min;
                sc.max = wsc.max;
                let distr = sc.distr;
                sc._min = distr == 3 ? $77bd600c8f878470$var$log10(sc.min) : distr == 4 ? $77bd600c8f878470$var$asinh(sc.min, sc.asinh) : sc.min;
                sc._max = distr == 3 ? $77bd600c8f878470$var$log10(sc.max) : distr == 4 ? $77bd600c8f878470$var$asinh(sc.max, sc.asinh) : sc.max;
                changed[k] = anyChanged = true;
            }
        }
        if (anyChanged) {
            // invalidate paths of all series on changed scales
            series.forEach((s, i)=>{
                if (mode == 2) {
                    if (i > 0 && changed.y) s._paths = null;
                } else if (changed[s.scale]) s._paths = null;
            });
            for(let k in changed){
                shouldConvergeSize = true;
                fire("setScale", k);
            }
            if (cursor.show && cursor.left >= 0) shouldSetCursor = shouldSetLegend = true;
        }
        for(let k in pendScales)pendScales[k] = null;
    }
    // grabs the nearest indices with y data outside of x-scale limits
    function getOuterIdxs(ydata) {
        let _i0 = $77bd600c8f878470$var$clamp(i0 - 1, 0, dataLen - 1);
        let _i1 = $77bd600c8f878470$var$clamp(i1 + 1, 0, dataLen - 1);
        while(ydata[_i0] == null && _i0 > 0)_i0--;
        while(ydata[_i1] == null && _i1 < dataLen - 1)_i1++;
        return [
            _i0,
            _i1
        ];
    }
    function drawSeries() {
        if (dataLen > 0) {
            series.forEach((s, i)=>{
                if (i > 0 && s.show) {
                    cacheStrokeFill(i, false);
                    cacheStrokeFill(i, true);
                    if (s._paths == null) {
                        if (ctxAlpha != s.alpha) ctx.globalAlpha = ctxAlpha = s.alpha;
                        let _idxs = mode == 2 ? [
                            0,
                            data[i][0].length - 1
                        ] : getOuterIdxs(data[i]);
                        s._paths = s.paths(self, i, _idxs[0], _idxs[1]);
                        if (ctxAlpha != 1) ctx.globalAlpha = ctxAlpha = 1;
                    }
                }
            });
            series.forEach((s, i)=>{
                if (i > 0 && s.show) {
                    if (ctxAlpha != s.alpha) ctx.globalAlpha = ctxAlpha = s.alpha;
                    s._paths != null && drawPath(i, false);
                    {
                        let _gaps = s._paths != null ? s._paths.gaps : null;
                        let show = s.points.show(self, i, i0, i1, _gaps);
                        let idxs = s.points.filter(self, i, show, _gaps);
                        if (show || idxs) {
                            s.points._paths = s.points.paths(self, i, i0, i1, idxs);
                            drawPath(i, true);
                        }
                    }
                    if (ctxAlpha != 1) ctx.globalAlpha = ctxAlpha = 1;
                    fire("drawSeries", i);
                }
            });
        }
    }
    function cacheStrokeFill(si, _points) {
        let s = _points ? series[si].points : series[si];
        s._stroke = s.stroke(self, si);
        s._fill = s.fill(self, si);
    }
    function drawPath(si, _points) {
        let s = _points ? series[si].points : series[si];
        let { stroke: stroke, fill: fill, clip: gapsClip, flags: flags, _stroke: strokeStyle = s._stroke, _fill: fillStyle = s._fill, _width: width = s.width } = s._paths;
        width = $77bd600c8f878470$var$roundDec(width * $77bd600c8f878470$var$pxRatio, 3);
        let boundsClip = null;
        let offset = width % 2 / 2;
        if (_points && fillStyle == null) fillStyle = width > 0 ? "#fff" : strokeStyle;
        let _pxAlign = s.pxAlign == 1 && offset > 0;
        _pxAlign && ctx.translate(offset, offset);
        if (!_points) {
            let lft = plotLft - width / 2, top = plotTop - width / 2, wid = plotWid + width, hgt = plotHgt + width;
            boundsClip = new Path2D();
            boundsClip.rect(lft, top, wid, hgt);
        }
        // the points pathbuilder's gapsClip is its boundsClip, since points dont need gaps clipping, and bounds depend on point size
        if (_points) strokeFill(strokeStyle, width, s.dash, s.cap, fillStyle, stroke, fill, flags, gapsClip);
        else fillStroke(si, strokeStyle, width, s.dash, s.cap, fillStyle, stroke, fill, flags, boundsClip, gapsClip);
        _pxAlign && ctx.translate(-offset, -offset);
    }
    function fillStroke(si, strokeStyle, lineWidth, lineDash, lineCap, fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip) {
        let didStrokeFill = false;
        // for all bands where this series is the top edge, create upwards clips using the bottom edges
        // and apply clips + fill with band fill or dfltFill
        flags != 0 && bands.forEach((b, bi)=>{
            // isUpperEdge?
            if (b.series[0] == si) {
                let lowerEdge = series[b.series[1]];
                let lowerData = data[b.series[1]];
                let bandClip = (lowerEdge._paths || $77bd600c8f878470$var$EMPTY_OBJ).band;
                if ($77bd600c8f878470$var$isArr(bandClip)) bandClip = b.dir == 1 ? bandClip[0] : bandClip[1];
                let gapsClip2;
                let _fillStyle = null;
                // hasLowerEdge?
                if (lowerEdge.show && bandClip && $77bd600c8f878470$var$hasData(lowerData, i0, i1)) {
                    _fillStyle = b.fill(self, bi) || fillStyle;
                    gapsClip2 = lowerEdge._paths.clip;
                } else bandClip = null;
                strokeFill(strokeStyle, lineWidth, lineDash, lineCap, _fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip, gapsClip2, bandClip);
                didStrokeFill = true;
            }
        });
        if (!didStrokeFill) strokeFill(strokeStyle, lineWidth, lineDash, lineCap, fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip);
    }
    const CLIP_FILL_STROKE = $77bd600c8f878470$var$BAND_CLIP_FILL | $77bd600c8f878470$var$BAND_CLIP_STROKE;
    function strokeFill(strokeStyle, lineWidth, lineDash, lineCap, fillStyle, strokePath, fillPath, flags, boundsClip, gapsClip, gapsClip2, bandClip) {
        setCtxStyle(strokeStyle, lineWidth, lineDash, lineCap, fillStyle);
        if (boundsClip || gapsClip || bandClip) {
            ctx.save();
            boundsClip && ctx.clip(boundsClip);
            gapsClip && ctx.clip(gapsClip);
        }
        if (bandClip) {
            if ((flags & CLIP_FILL_STROKE) == CLIP_FILL_STROKE) {
                ctx.clip(bandClip);
                gapsClip2 && ctx.clip(gapsClip2);
                doFill(fillStyle, fillPath);
                doStroke(strokeStyle, strokePath, lineWidth);
            } else if (flags & $77bd600c8f878470$var$BAND_CLIP_STROKE) {
                doFill(fillStyle, fillPath);
                ctx.clip(bandClip);
                doStroke(strokeStyle, strokePath, lineWidth);
            } else if (flags & $77bd600c8f878470$var$BAND_CLIP_FILL) {
                ctx.save();
                ctx.clip(bandClip);
                gapsClip2 && ctx.clip(gapsClip2);
                doFill(fillStyle, fillPath);
                ctx.restore();
                doStroke(strokeStyle, strokePath, lineWidth);
            }
        } else {
            doFill(fillStyle, fillPath);
            doStroke(strokeStyle, strokePath, lineWidth);
        }
        if (boundsClip || gapsClip || bandClip) ctx.restore();
    }
    function doStroke(strokeStyle, strokePath, lineWidth) {
        if (lineWidth > 0) {
            if (strokePath instanceof Map) strokePath.forEach((strokePath, strokeStyle)=>{
                ctx.strokeStyle = ctxStroke = strokeStyle;
                ctx.stroke(strokePath);
            });
            else strokePath != null && strokeStyle && ctx.stroke(strokePath);
        }
    }
    function doFill(fillStyle, fillPath) {
        if (fillPath instanceof Map) fillPath.forEach((fillPath, fillStyle)=>{
            ctx.fillStyle = ctxFill = fillStyle;
            ctx.fill(fillPath);
        });
        else fillPath != null && fillStyle && ctx.fill(fillPath);
    }
    function getIncrSpace(axisIdx, min, max, fullDim) {
        let axis = axes[axisIdx];
        let incrSpace;
        if (fullDim <= 0) incrSpace = [
            0,
            0
        ];
        else {
            let minSpace = axis._space = axis.space(self, axisIdx, min, max, fullDim);
            let incrs = axis._incrs = axis.incrs(self, axisIdx, min, max, fullDim, minSpace);
            incrSpace = $77bd600c8f878470$var$findIncr(min, max, incrs, fullDim, minSpace);
        }
        return axis._found = incrSpace;
    }
    function drawOrthoLines(offs, filts, ori, side, pos0, len, width, stroke, dash, cap) {
        let offset = width % 2 / 2;
        pxAlign == 1 && ctx.translate(offset, offset);
        setCtxStyle(stroke, width, dash, cap, stroke);
        ctx.beginPath();
        let x0, y0, x1, y1, pos1 = pos0 + (side == 0 || side == 3 ? -len : len);
        if (ori == 0) {
            y0 = pos0;
            y1 = pos1;
        } else {
            x0 = pos0;
            x1 = pos1;
        }
        for(let i = 0; i < offs.length; i++)if (filts[i] != null) {
            if (ori == 0) x0 = x1 = offs[i];
            else y0 = y1 = offs[i];
            ctx.moveTo(x0, y0);
            ctx.lineTo(x1, y1);
        }
        ctx.stroke();
        pxAlign == 1 && ctx.translate(-offset, -offset);
    }
    function axesCalc(cycleNum) {
        //	log("axesCalc()", arguments);
        let converged = true;
        axes.forEach((axis, i)=>{
            if (!axis.show) return;
            let scale = scales[axis.scale];
            if (scale.min == null) {
                if (axis._show) {
                    converged = false;
                    axis._show = false;
                    resetYSeries(false);
                }
                return;
            } else if (!axis._show) {
                converged = false;
                axis._show = true;
                resetYSeries(false);
            }
            let side = axis.side;
            let ori = side % 2;
            let { min: min, max: max } = scale; // 		// should this toggle them ._show = false
            let [_incr, _space] = getIncrSpace(i, min, max, ori == 0 ? plotWidCss : plotHgtCss);
            if (_space == 0) return;
            // if we're using index positions, force first tick to match passed index
            let forceMin = scale.distr == 2;
            let _splits = axis._splits = axis.splits(self, i, min, max, _incr, _space, forceMin);
            // tick labels
            // BOO this assumes a specific data/series
            let splits = scale.distr == 2 ? _splits.map((i)=>data0[i]) : _splits;
            let incr = scale.distr == 2 ? data0[_splits[1]] - data0[_splits[0]] : _incr;
            let values = axis._values = axis.values(self, axis.filter(self, splits, i, _space, incr), i, _space, incr);
            // rotating of labels only supported on bottom x axis
            axis._rotate = side == 2 ? axis.rotate(self, values, i, _space) : 0;
            let oldSize = axis._size;
            axis._size = $77bd600c8f878470$var$ceil(axis.size(self, values, i, cycleNum));
            if (oldSize != null && axis._size != oldSize) converged = false;
        });
        return converged;
    }
    function paddingCalc(cycleNum) {
        let converged = true;
        padding.forEach((p, i)=>{
            let _p = p(self, i, sidesWithAxes, cycleNum);
            if (_p != _padding[i]) converged = false;
            _padding[i] = _p;
        });
        return converged;
    }
    function drawAxesGrid() {
        for(let i = 0; i < axes.length; i++){
            let axis = axes[i];
            if (!axis.show || !axis._show) continue;
            let side = axis.side;
            let ori = side % 2;
            let x, y;
            let fillStyle = axis.stroke(self, i);
            let shiftDir = side == 0 || side == 3 ? -1 : 1;
            // axis label
            if (axis.label) {
                let shiftAmt = axis.labelGap * shiftDir;
                let baseLpos = $77bd600c8f878470$var$round((axis._lpos + shiftAmt) * $77bd600c8f878470$var$pxRatio);
                setFontStyle(axis.labelFont[0], fillStyle, "center", side == 2 ? $77bd600c8f878470$var$TOP : $77bd600c8f878470$var$BOTTOM);
                ctx.save();
                if (ori == 1) {
                    x = y = 0;
                    ctx.translate(baseLpos, $77bd600c8f878470$var$round(plotTop + plotHgt / 2));
                    ctx.rotate((side == 3 ? -$77bd600c8f878470$var$PI : $77bd600c8f878470$var$PI) / 2);
                } else {
                    x = $77bd600c8f878470$var$round(plotLft + plotWid / 2);
                    y = baseLpos;
                }
                ctx.fillText(axis.label, x, y);
                ctx.restore();
            }
            let [_incr, _space] = axis._found;
            if (_space == 0) continue;
            let scale = scales[axis.scale];
            let plotDim = ori == 0 ? plotWid : plotHgt;
            let plotOff = ori == 0 ? plotLft : plotTop;
            let axisGap = $77bd600c8f878470$var$round(axis.gap * $77bd600c8f878470$var$pxRatio);
            let _splits = axis._splits;
            // tick labels
            // BOO this assumes a specific data/series
            let splits = scale.distr == 2 ? _splits.map((i)=>data0[i]) : _splits;
            let incr = scale.distr == 2 ? data0[_splits[1]] - data0[_splits[0]] : _incr;
            let ticks = axis.ticks;
            let border = axis.border;
            let tickSize = ticks.show ? $77bd600c8f878470$var$round(ticks.size * $77bd600c8f878470$var$pxRatio) : 0;
            // rotating of labels only supported on bottom x axis
            let angle = axis._rotate * -$77bd600c8f878470$var$PI / 180;
            let basePos = pxRound(axis._pos * $77bd600c8f878470$var$pxRatio);
            let shiftAmt = (tickSize + axisGap) * shiftDir;
            let finalPos = basePos + shiftAmt;
            y = ori == 0 ? finalPos : 0;
            x = ori == 1 ? finalPos : 0;
            let font = axis.font[0];
            let textAlign = axis.align == 1 ? $77bd600c8f878470$var$LEFT : axis.align == 2 ? $77bd600c8f878470$var$RIGHT : angle > 0 ? $77bd600c8f878470$var$LEFT : angle < 0 ? $77bd600c8f878470$var$RIGHT : ori == 0 ? "center" : side == 3 ? $77bd600c8f878470$var$RIGHT : $77bd600c8f878470$var$LEFT;
            let textBaseline = angle || ori == 1 ? "middle" : side == 2 ? $77bd600c8f878470$var$TOP : $77bd600c8f878470$var$BOTTOM;
            setFontStyle(font, fillStyle, textAlign, textBaseline);
            let lineHeight = axis.font[1] * axis.lineGap;
            let canOffs = _splits.map((val)=>pxRound(getPos(val, scale, plotDim, plotOff)));
            let _values = axis._values;
            for(let i = 0; i < _values.length; i++){
                let val = _values[i];
                if (val != null) {
                    if (ori == 0) x = canOffs[i];
                    else y = canOffs[i];
                    val = "" + val;
                    let _parts = val.indexOf("\n") == -1 ? [
                        val
                    ] : val.split(/\n/gm);
                    for(let j = 0; j < _parts.length; j++){
                        let text = _parts[j];
                        if (angle) {
                            ctx.save();
                            ctx.translate(x, y + j * lineHeight); // can this be replaced with position math?
                            ctx.rotate(angle); // can this be done once?
                            ctx.fillText(text, 0, 0);
                            ctx.restore();
                        } else ctx.fillText(text, x, y + j * lineHeight);
                    }
                }
            }
            // ticks
            if (ticks.show) drawOrthoLines(canOffs, ticks.filter(self, splits, i, _space, incr), ori, side, basePos, tickSize, $77bd600c8f878470$var$roundDec(ticks.width * $77bd600c8f878470$var$pxRatio, 3), ticks.stroke(self, i), ticks.dash, ticks.cap);
            // grid
            let grid = axis.grid;
            if (grid.show) drawOrthoLines(canOffs, grid.filter(self, splits, i, _space, incr), ori, ori == 0 ? 2 : 1, ori == 0 ? plotTop : plotLft, ori == 0 ? plotHgt : plotWid, $77bd600c8f878470$var$roundDec(grid.width * $77bd600c8f878470$var$pxRatio, 3), grid.stroke(self, i), grid.dash, grid.cap);
            if (border.show) drawOrthoLines([
                basePos
            ], [
                1
            ], ori == 0 ? 1 : 0, ori == 0 ? 1 : 2, ori == 1 ? plotTop : plotLft, ori == 1 ? plotHgt : plotWid, $77bd600c8f878470$var$roundDec(border.width * $77bd600c8f878470$var$pxRatio, 3), border.stroke(self, i), border.dash, border.cap);
        }
        fire("drawAxes");
    }
    function resetYSeries(minMax) {
        //	log("resetYSeries()", arguments);
        series.forEach((s, i)=>{
            if (i > 0) {
                s._paths = null;
                if (minMax) {
                    if (mode == 1) {
                        s.min = null;
                        s.max = null;
                    } else s.facets.forEach((f)=>{
                        f.min = null;
                        f.max = null;
                    });
                }
            }
        });
    }
    let queuedCommit = false;
    let deferHooks = false;
    let hooksQueue = [];
    function flushHooks() {
        deferHooks = false;
        for(let i = 0; i < hooksQueue.length; i++)fire(...hooksQueue[i]);
        hooksQueue.length = 0;
    }
    function commit() {
        if (!queuedCommit) {
            $77bd600c8f878470$var$microTask(_commit);
            queuedCommit = true;
        }
    }
    // manual batching (aka immediate mode), skips microtask queue
    function batch(fn, _deferHooks = false) {
        queuedCommit = true;
        deferHooks = _deferHooks;
        fn(self);
        _commit();
        if (_deferHooks && hooksQueue.length > 0) queueMicrotask(flushHooks);
    }
    self.batch = batch;
    function _commit() {
        //	log("_commit()", arguments);
        if (shouldSetScales) {
            setScales();
            shouldSetScales = false;
        }
        if (shouldConvergeSize) {
            convergeSize();
            shouldConvergeSize = false;
        }
        if (shouldSetSize) {
            $77bd600c8f878470$var$setStylePx(under, $77bd600c8f878470$var$LEFT, plotLftCss);
            $77bd600c8f878470$var$setStylePx(under, $77bd600c8f878470$var$TOP, plotTopCss);
            $77bd600c8f878470$var$setStylePx(under, $77bd600c8f878470$var$WIDTH, plotWidCss);
            $77bd600c8f878470$var$setStylePx(under, $77bd600c8f878470$var$HEIGHT, plotHgtCss);
            $77bd600c8f878470$var$setStylePx(over, $77bd600c8f878470$var$LEFT, plotLftCss);
            $77bd600c8f878470$var$setStylePx(over, $77bd600c8f878470$var$TOP, plotTopCss);
            $77bd600c8f878470$var$setStylePx(over, $77bd600c8f878470$var$WIDTH, plotWidCss);
            $77bd600c8f878470$var$setStylePx(over, $77bd600c8f878470$var$HEIGHT, plotHgtCss);
            $77bd600c8f878470$var$setStylePx(wrap, $77bd600c8f878470$var$WIDTH, fullWidCss);
            $77bd600c8f878470$var$setStylePx(wrap, $77bd600c8f878470$var$HEIGHT, fullHgtCss);
            // NOTE: mutating this during print preview in Chrome forces transparent
            // canvas pixels to white, even when followed up with clearRect() below
            can.width = $77bd600c8f878470$var$round(fullWidCss * $77bd600c8f878470$var$pxRatio);
            can.height = $77bd600c8f878470$var$round(fullHgtCss * $77bd600c8f878470$var$pxRatio);
            axes.forEach(({ _el: _el, _show: _show, _size: _size, _pos: _pos, side: side })=>{
                if (_el != null) {
                    if (_show) {
                        let posOffset = side === 3 || side === 0 ? _size : 0;
                        let isVt = side % 2 == 1;
                        $77bd600c8f878470$var$setStylePx(_el, isVt ? "left" : "top", _pos - posOffset);
                        $77bd600c8f878470$var$setStylePx(_el, isVt ? "width" : "height", _size);
                        $77bd600c8f878470$var$setStylePx(_el, isVt ? "top" : "left", isVt ? plotTopCss : plotLftCss);
                        $77bd600c8f878470$var$setStylePx(_el, isVt ? "height" : "width", isVt ? plotHgtCss : plotWidCss);
                        $77bd600c8f878470$var$remClass(_el, $77bd600c8f878470$var$OFF);
                    } else $77bd600c8f878470$var$addClass(_el, $77bd600c8f878470$var$OFF);
                }
            });
            // invalidate ctx style cache
            ctxStroke = ctxFill = ctxWidth = ctxJoin = ctxCap = ctxFont = ctxAlign = ctxBaseline = ctxDash = null;
            ctxAlpha = 1;
            syncRect(true);
            if (plotLftCss != _plotLftCss || plotTopCss != _plotTopCss || plotWidCss != _plotWidCss || plotHgtCss != _plotHgtCss) {
                resetYSeries(false);
                let pctWid = plotWidCss / _plotWidCss;
                let pctHgt = plotHgtCss / _plotHgtCss;
                if (cursor.show && !shouldSetCursor && cursor.left >= 0) {
                    cursor.left *= pctWid;
                    cursor.top *= pctHgt;
                    vCursor && $77bd600c8f878470$var$elTrans(vCursor, $77bd600c8f878470$var$round(cursor.left), 0, plotWidCss, plotHgtCss);
                    hCursor && $77bd600c8f878470$var$elTrans(hCursor, 0, $77bd600c8f878470$var$round(cursor.top), plotWidCss, plotHgtCss);
                    for(let i = 1; i < cursorPts.length; i++){
                        cursorPtsLft[i] *= pctWid;
                        cursorPtsTop[i] *= pctHgt;
                        $77bd600c8f878470$var$elTrans(cursorPts[i], $77bd600c8f878470$var$incrRoundUp(cursorPtsLft[i], 1), $77bd600c8f878470$var$incrRoundUp(cursorPtsTop[i], 1), plotWidCss, plotHgtCss);
                    }
                }
                if (select.show && !shouldSetSelect && select.left >= 0 && select.width > 0) {
                    select.left *= pctWid;
                    select.width *= pctWid;
                    select.top *= pctHgt;
                    select.height *= pctHgt;
                    for(let prop in _hideProps)$77bd600c8f878470$var$setStylePx(selectDiv, prop, select[prop]);
                }
                _plotLftCss = plotLftCss;
                _plotTopCss = plotTopCss;
                _plotWidCss = plotWidCss;
                _plotHgtCss = plotHgtCss;
            }
            fire("setSize");
            shouldSetSize = false;
        }
        if (fullWidCss > 0 && fullHgtCss > 0) {
            ctx.clearRect(0, 0, can.width, can.height);
            fire("drawClear");
            drawOrder.forEach((fn)=>fn());
            fire("draw");
        }
        if (select.show && shouldSetSelect) {
            setSelect(select);
            shouldSetSelect = false;
        }
        if (cursor.show && shouldSetCursor) {
            updateCursor(null, true, false);
            shouldSetCursor = false;
        }
        if (legend.show && legend.live && shouldSetLegend) {
            setLegend();
            shouldSetLegend = false; // redundant currently
        }
        if (!ready) {
            ready = true;
            self.status = 1;
            fire("ready");
        }
        viaAutoScaleX = false;
        queuedCommit = false;
    }
    self.redraw = (rebuildPaths, recalcAxes)=>{
        shouldConvergeSize = recalcAxes || false;
        if (rebuildPaths !== false) _setScale(xScaleKey, scaleX.min, scaleX.max);
        else commit();
    };
    // redraw() => setScale('x', scales.x.min, scales.x.max);
    // explicit, never re-ranged (is this actually true? for x and y)
    function setScale(key, opts) {
        let sc = scales[key];
        if (sc.from == null) {
            if (dataLen == 0) {
                let minMax = sc.range(self, opts.min, opts.max, key);
                opts.min = minMax[0];
                opts.max = minMax[1];
            }
            if (opts.min > opts.max) {
                let _min = opts.min;
                opts.min = opts.max;
                opts.max = _min;
            }
            if (dataLen > 1 && opts.min != null && opts.max != null && opts.max - opts.min < 1e-16) return;
            if (key == xScaleKey) {
                if (sc.distr == 2 && dataLen > 0) {
                    opts.min = $77bd600c8f878470$var$closestIdx(opts.min, data[0]);
                    opts.max = $77bd600c8f878470$var$closestIdx(opts.max, data[0]);
                    if (opts.min == opts.max) opts.max++;
                }
            }
            //	log("setScale()", arguments);
            pendScales[key] = opts;
            shouldSetScales = true;
            commit();
        }
    }
    self.setScale = setScale;
    //	INTERACTION
    let xCursor;
    let yCursor;
    let vCursor;
    let hCursor;
    // starting position before cursor.move
    let rawMouseLeft0;
    let rawMouseTop0;
    // starting position
    let mouseLeft0;
    let mouseTop0;
    // current position before cursor.move
    let rawMouseLeft1;
    let rawMouseTop1;
    // current position
    let mouseLeft1;
    let mouseTop1;
    let dragging = false;
    const drag = cursor.drag;
    let dragX = drag.x;
    let dragY = drag.y;
    if (cursor.show) {
        if (cursor.x) xCursor = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$CURSOR_X, over);
        if (cursor.y) yCursor = $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$CURSOR_Y, over);
        if (scaleX.ori == 0) {
            vCursor = xCursor;
            hCursor = yCursor;
        } else {
            vCursor = yCursor;
            hCursor = xCursor;
        }
        mouseLeft1 = cursor.left;
        mouseTop1 = cursor.top;
    }
    const select = self.select = $77bd600c8f878470$var$assign({
        show: true,
        over: true,
        left: 0,
        width: 0,
        top: 0,
        height: 0
    }, opts.select);
    const selectDiv = select.show ? $77bd600c8f878470$var$placeDiv($77bd600c8f878470$var$SELECT, select.over ? over : under) : null;
    function setSelect(opts, _fire) {
        if (select.show) {
            for(let prop in opts){
                select[prop] = opts[prop];
                if (prop in _hideProps) $77bd600c8f878470$var$setStylePx(selectDiv, prop, opts[prop]);
            }
            _fire !== false && fire("setSelect");
        }
    }
    self.setSelect = setSelect;
    function toggleDOM(i, onOff) {
        let s = series[i];
        let label = showLegend ? legendRows[i] : null;
        if (s.show) label && $77bd600c8f878470$var$remClass(label, $77bd600c8f878470$var$OFF);
        else {
            label && $77bd600c8f878470$var$addClass(label, $77bd600c8f878470$var$OFF);
            cursorPts.length > 1 && $77bd600c8f878470$var$elTrans(cursorPts[i], -10, -10, plotWidCss, plotHgtCss);
        }
    }
    function _setScale(key, min, max) {
        setScale(key, {
            min: min,
            max: max
        });
    }
    function setSeries(i, opts, _fire, _pub) {
        //	log("setSeries()", arguments);
        if (opts.focus != null) setFocus(i);
        if (opts.show != null) series.forEach((s, si)=>{
            if (si > 0 && (i == si || i == null)) {
                s.show = opts.show;
                toggleDOM(si, opts.show);
                if (mode == 2) {
                    _setScale(s.facets[0].scale, null, null);
                    _setScale(s.facets[1].scale, null, null);
                } else _setScale(s.scale, null, null);
                commit();
            }
        });
        _fire !== false && fire("setSeries", i, opts);
        _pub && pubSync("setSeries", self, i, opts);
    }
    self.setSeries = setSeries;
    function setBand(bi, opts) {
        $77bd600c8f878470$var$assign(bands[bi], opts);
    }
    function addBand(opts, bi) {
        opts.fill = $77bd600c8f878470$var$fnOrSelf(opts.fill || null);
        opts.dir = $77bd600c8f878470$var$ifNull(opts.dir, -1);
        bi = bi == null ? bands.length : bi;
        bands.splice(bi, 0, opts);
    }
    function delBand(bi) {
        if (bi == null) bands.length = 0;
        else bands.splice(bi, 1);
    }
    self.addBand = addBand;
    self.setBand = setBand;
    self.delBand = delBand;
    function setAlpha(i, value) {
        series[i].alpha = value;
        if (cursor.show && cursorPts[i]) cursorPts[i].style.opacity = value;
        if (showLegend && legendRows[i]) legendRows[i].style.opacity = value;
    }
    // y-distance
    let closestDist;
    let closestSeries;
    let focusedSeries;
    const FOCUS_TRUE = {
        focus: true
    };
    function setFocus(i) {
        if (i != focusedSeries) {
            //	log("setFocus()", arguments);
            let allFocused = i == null;
            let _setAlpha = focus.alpha != 1;
            series.forEach((s, i2)=>{
                if (mode == 1 || i2 > 0) {
                    let isFocused = allFocused || i2 == 0 || i2 == i;
                    s._focus = allFocused ? null : isFocused;
                    _setAlpha && setAlpha(i2, isFocused ? 1 : focus.alpha);
                }
            });
            focusedSeries = i;
            _setAlpha && commit();
        }
    }
    if (showLegend && cursorFocus) onMouse($77bd600c8f878470$var$mouseleave, legendTable, (e)=>{
        if (cursor._lock) return;
        setCursorEvent(e);
        if (focusedSeries != null) setSeries(null, FOCUS_TRUE, true, syncOpts.setSeries);
    });
    function posToVal(pos, scale, can) {
        let sc = scales[scale];
        if (can) pos = pos / $77bd600c8f878470$var$pxRatio - (sc.ori == 1 ? plotTopCss : plotLftCss);
        let dim = plotWidCss;
        if (sc.ori == 1) {
            dim = plotHgtCss;
            pos = dim - pos;
        }
        if (sc.dir == -1) pos = dim - pos;
        let _min = sc._min, _max = sc._max, pct = pos / dim;
        let sv = _min + (_max - _min) * pct;
        let distr = sc.distr;
        return distr == 3 ? $77bd600c8f878470$var$pow(10, sv) : distr == 4 ? $77bd600c8f878470$var$sinh(sv, sc.asinh) : sv;
    }
    function closestIdxFromXpos(pos, can) {
        let v = posToVal(pos, xScaleKey, can);
        return $77bd600c8f878470$var$closestIdx(v, data[0], i0, i1);
    }
    self.valToIdx = (val)=>$77bd600c8f878470$var$closestIdx(val, data[0]);
    self.posToIdx = closestIdxFromXpos;
    self.posToVal = posToVal;
    self.valToPos = (val, scale, can)=>scales[scale].ori == 0 ? getHPos(val, scales[scale], can ? plotWid : plotWidCss, can ? plotLft : 0) : getVPos(val, scales[scale], can ? plotHgt : plotHgtCss, can ? plotTop : 0);
    self.setCursor = (opts, _fire, _pub)=>{
        mouseLeft1 = opts.left;
        mouseTop1 = opts.top;
        //	assign(cursor, opts);
        updateCursor(null, _fire, _pub);
    };
    function setSelH(off, dim) {
        $77bd600c8f878470$var$setStylePx(selectDiv, $77bd600c8f878470$var$LEFT, select.left = off);
        $77bd600c8f878470$var$setStylePx(selectDiv, $77bd600c8f878470$var$WIDTH, select.width = dim);
    }
    function setSelV(off, dim) {
        $77bd600c8f878470$var$setStylePx(selectDiv, $77bd600c8f878470$var$TOP, select.top = off);
        $77bd600c8f878470$var$setStylePx(selectDiv, $77bd600c8f878470$var$HEIGHT, select.height = dim);
    }
    let setSelX = scaleX.ori == 0 ? setSelH : setSelV;
    let setSelY = scaleX.ori == 1 ? setSelH : setSelV;
    function syncLegend() {
        if (showLegend && legend.live) for(let i = mode == 2 ? 1 : 0; i < series.length; i++){
            if (i == 0 && multiValLegend) continue;
            let vals = legend.values[i];
            let j = 0;
            for(let k in vals)legendCells[i][j++].firstChild.nodeValue = vals[k];
        }
    }
    function setLegend(opts, _fire) {
        if (opts != null) {
            if (opts.idxs) opts.idxs.forEach((didx, sidx)=>{
                activeIdxs[sidx] = didx;
            });
            else if (!$77bd600c8f878470$var$isUndef(opts.idx)) activeIdxs.fill(opts.idx);
            legend.idx = activeIdxs[0];
        }
        for(let sidx = 0; sidx < series.length; sidx++)if (sidx > 0 || mode == 1 && !multiValLegend) setLegendValues(sidx, activeIdxs[sidx]);
        if (showLegend && legend.live) syncLegend();
        shouldSetLegend = false;
        _fire !== false && fire("setLegend");
    }
    self.setLegend = setLegend;
    function setLegendValues(sidx, idx) {
        let s = series[sidx];
        let src = sidx == 0 && xScaleDistr == 2 ? data0 : data[sidx];
        let val;
        if (multiValLegend) val = s.values(self, sidx, idx) ?? NULL_LEGEND_VALUES;
        else {
            val = s.value(self, idx == null ? null : src[idx], sidx, idx);
            val = val == null ? NULL_LEGEND_VALUES : {
                _: val
            };
        }
        legend.values[sidx] = val;
    }
    function updateCursor(src, _fire, _pub) {
        //	ts == null && log("updateCursor()", arguments);
        rawMouseLeft1 = mouseLeft1;
        rawMouseTop1 = mouseTop1;
        [mouseLeft1, mouseTop1] = cursor.move(self, mouseLeft1, mouseTop1);
        cursor.left = mouseLeft1;
        cursor.top = mouseTop1;
        if (cursor.show) {
            vCursor && $77bd600c8f878470$var$elTrans(vCursor, $77bd600c8f878470$var$round(mouseLeft1), 0, plotWidCss, plotHgtCss);
            hCursor && $77bd600c8f878470$var$elTrans(hCursor, 0, $77bd600c8f878470$var$round(mouseTop1), plotWidCss, plotHgtCss);
        }
        let idx;
        // when zooming to an x scale range between datapoints the binary search
        // for nearest min/max indices results in this condition. cheap hack :D
        let noDataInRange = i0 > i1; // works for mode 1 only
        closestDist = $77bd600c8f878470$var$inf;
        // TODO: extract
        let xDim = scaleX.ori == 0 ? plotWidCss : plotHgtCss;
        let yDim = scaleX.ori == 1 ? plotWidCss : plotHgtCss;
        // if cursor hidden, hide points & clear legend vals
        if (mouseLeft1 < 0 || dataLen == 0 || noDataInRange) {
            idx = cursor.idx = null;
            for(let i = 0; i < series.length; i++)if (i > 0) cursorPts.length > 1 && $77bd600c8f878470$var$elTrans(cursorPts[i], -10, -10, plotWidCss, plotHgtCss);
            if (cursorFocus) setSeries(null, FOCUS_TRUE, true, src == null && syncOpts.setSeries);
            if (legend.live) {
                activeIdxs.fill(idx);
                shouldSetLegend = true;
            }
        } else {
            //	let pctY = 1 - (y / rect.height);
            let mouseXPos, valAtPosX, xPos;
            if (mode == 1) {
                mouseXPos = scaleX.ori == 0 ? mouseLeft1 : mouseTop1;
                valAtPosX = posToVal(mouseXPos, xScaleKey);
                idx = cursor.idx = $77bd600c8f878470$var$closestIdx(valAtPosX, data[0], i0, i1);
                xPos = valToPosX(data[0][idx], scaleX, xDim, 0);
            }
            for(let i = mode == 2 ? 1 : 0; i < series.length; i++){
                let s = series[i];
                let idx1 = activeIdxs[i];
                let yVal1 = idx1 == null ? null : mode == 1 ? data[i][idx1] : data[i][1][idx1];
                let idx2 = cursor.dataIdx(self, i, idx, valAtPosX);
                let yVal2 = idx2 == null ? null : mode == 1 ? data[i][idx2] : data[i][1][idx2];
                shouldSetLegend = shouldSetLegend || yVal2 != yVal1 || idx2 != idx1;
                activeIdxs[i] = idx2;
                let xPos2 = idx2 == idx ? xPos : valToPosX(mode == 1 ? data[0][idx2] : data[i][0][idx2], scaleX, xDim, 0);
                if (i > 0 && s.show) {
                    // this doesnt really work for state timeline, heatmap, status history (where the value maps to color, not y coords)
                    let yPos = yVal2 == null ? -10 : valToPosY(yVal2, mode == 1 ? scales[s.scale] : scales[s.facets[1].scale], yDim, 0);
                    if (cursorFocus && yVal2 != null) {
                        let mouseYPos = scaleX.ori == 1 ? mouseLeft1 : mouseTop1;
                        let dist = $77bd600c8f878470$var$abs(focus.dist(self, i, idx2, yPos, mouseYPos));
                        if (dist < closestDist) {
                            let bias = focus.bias;
                            if (bias != 0) {
                                let mouseYVal = posToVal(mouseYPos, s.scale);
                                let seriesYValSign = yVal2 >= 0 ? 1 : -1;
                                let mouseYValSign = mouseYVal >= 0 ? 1 : -1;
                                // with a focus bias, we will never cross zero when prox testing
                                // it's either closest towards zero, or closest away from zero
                                if (mouseYValSign == seriesYValSign && (mouseYValSign == 1 ? bias == 1 ? yVal2 >= mouseYVal : yVal2 <= mouseYVal : bias == 1 ? yVal2 <= mouseYVal : yVal2 >= mouseYVal //  < 0
                                )) {
                                    closestDist = dist;
                                    closestSeries = i;
                                }
                            } else {
                                closestDist = dist;
                                closestSeries = i;
                            }
                        }
                    }
                    let hPos, vPos;
                    if (scaleX.ori == 0) {
                        hPos = xPos2;
                        vPos = yPos;
                    } else {
                        hPos = yPos;
                        vPos = xPos2;
                    }
                    if (shouldSetLegend && cursorPts.length > 1) {
                        $77bd600c8f878470$var$elColor(cursorPts[i], cursor.points.fill(self, i), cursor.points.stroke(self, i));
                        let ptWid, ptHgt, ptLft, ptTop, centered = true, getBBox = cursor.points.bbox;
                        if (getBBox != null) {
                            centered = false;
                            let bbox = getBBox(self, i);
                            ptLft = bbox.left;
                            ptTop = bbox.top;
                            ptWid = bbox.width;
                            ptHgt = bbox.height;
                        } else {
                            ptLft = hPos;
                            ptTop = vPos;
                            ptWid = ptHgt = cursor.points.size(self, i);
                        }
                        $77bd600c8f878470$var$elSize(cursorPts[i], ptWid, ptHgt, centered);
                        cursorPtsLft[i] = ptLft;
                        cursorPtsTop[i] = ptTop;
                        $77bd600c8f878470$var$elTrans(cursorPts[i], $77bd600c8f878470$var$incrRoundUp(ptLft, 1), $77bd600c8f878470$var$incrRoundUp(ptTop, 1), plotWidCss, plotHgtCss);
                    }
                }
            }
        }
        // nit: cursor.drag.setSelect is assumed always true
        if (select.show && dragging) {
            if (src != null) {
                let [xKey, yKey] = syncOpts.scales;
                let [matchXKeys, matchYKeys] = syncOpts.match;
                let [xKeySrc, yKeySrc] = src.cursor.sync.scales;
                // match the dragX/dragY implicitness/explicitness of src
                let sdrag = src.cursor.drag;
                dragX = sdrag._x;
                dragY = sdrag._y;
                if (dragX || dragY) {
                    let { left: left, top: top, width: width, height: height } = src.select;
                    let sori = src.scales[xKey].ori;
                    let sPosToVal = src.posToVal;
                    let sOff, sDim, sc, a, b;
                    let matchingX = xKey != null && matchXKeys(xKey, xKeySrc);
                    let matchingY = yKey != null && matchYKeys(yKey, yKeySrc);
                    if (matchingX && dragX) {
                        if (sori == 0) {
                            sOff = left;
                            sDim = width;
                        } else {
                            sOff = top;
                            sDim = height;
                        }
                        sc = scales[xKey];
                        a = valToPosX(sPosToVal(sOff, xKeySrc), sc, xDim, 0);
                        b = valToPosX(sPosToVal(sOff + sDim, xKeySrc), sc, xDim, 0);
                        setSelX($77bd600c8f878470$var$min(a, b), $77bd600c8f878470$var$abs(b - a));
                    } else setSelX(0, xDim);
                    if (matchingY && dragY) {
                        if (sori == 1) {
                            sOff = left;
                            sDim = width;
                        } else {
                            sOff = top;
                            sDim = height;
                        }
                        sc = scales[yKey];
                        a = valToPosY(sPosToVal(sOff, yKeySrc), sc, yDim, 0);
                        b = valToPosY(sPosToVal(sOff + sDim, yKeySrc), sc, yDim, 0);
                        setSelY($77bd600c8f878470$var$min(a, b), $77bd600c8f878470$var$abs(b - a));
                    } else setSelY(0, yDim);
                } else hideSelect();
            } else {
                let rawDX = $77bd600c8f878470$var$abs(rawMouseLeft1 - rawMouseLeft0);
                let rawDY = $77bd600c8f878470$var$abs(rawMouseTop1 - rawMouseTop0);
                if (scaleX.ori == 1) {
                    let _rawDX = rawDX;
                    rawDX = rawDY;
                    rawDY = _rawDX;
                }
                dragX = drag.x && rawDX >= drag.dist;
                dragY = drag.y && rawDY >= drag.dist;
                let uni = drag.uni;
                if (uni != null) // only calc drag status if they pass the dist thresh
                {
                    if (dragX && dragY) {
                        dragX = rawDX >= uni;
                        dragY = rawDY >= uni;
                        // force unidirectionality when both are under uni limit
                        if (!dragX && !dragY) {
                            if (rawDY > rawDX) dragY = true;
                            else dragX = true;
                        }
                    }
                } else if (drag.x && drag.y && (dragX || dragY)) // if omni with no uni then both dragX / dragY should be true if either is true
                dragX = dragY = true;
                let p0, p1;
                if (dragX) {
                    if (scaleX.ori == 0) {
                        p0 = mouseLeft0;
                        p1 = mouseLeft1;
                    } else {
                        p0 = mouseTop0;
                        p1 = mouseTop1;
                    }
                    setSelX($77bd600c8f878470$var$min(p0, p1), $77bd600c8f878470$var$abs(p1 - p0));
                    if (!dragY) setSelY(0, yDim);
                }
                if (dragY) {
                    if (scaleX.ori == 1) {
                        p0 = mouseLeft0;
                        p1 = mouseLeft1;
                    } else {
                        p0 = mouseTop0;
                        p1 = mouseTop1;
                    }
                    setSelY($77bd600c8f878470$var$min(p0, p1), $77bd600c8f878470$var$abs(p1 - p0));
                    if (!dragX) setSelX(0, xDim);
                }
                // the drag didn't pass the dist requirement
                if (!dragX && !dragY) {
                    setSelX(0, 0);
                    setSelY(0, 0);
                }
            }
        }
        drag._x = dragX;
        drag._y = dragY;
        if (src == null) {
            if (_pub) {
                if (syncKey != null) {
                    let [xSyncKey, ySyncKey] = syncOpts.scales;
                    syncOpts.values[0] = xSyncKey != null ? posToVal(scaleX.ori == 0 ? mouseLeft1 : mouseTop1, xSyncKey) : null;
                    syncOpts.values[1] = ySyncKey != null ? posToVal(scaleX.ori == 1 ? mouseLeft1 : mouseTop1, ySyncKey) : null;
                }
                pubSync($77bd600c8f878470$var$mousemove, self, mouseLeft1, mouseTop1, plotWidCss, plotHgtCss, idx);
            }
            if (cursorFocus) {
                let shouldPub = _pub && syncOpts.setSeries;
                let p = focus.prox;
                if (focusedSeries == null) {
                    if (closestDist <= p) setSeries(closestSeries, FOCUS_TRUE, true, shouldPub);
                } else {
                    if (closestDist > p) setSeries(null, FOCUS_TRUE, true, shouldPub);
                    else if (closestSeries != focusedSeries) setSeries(closestSeries, FOCUS_TRUE, true, shouldPub);
                }
            }
        }
        if (shouldSetLegend) {
            legend.idx = idx;
            setLegend();
        }
        _fire !== false && fire("setCursor");
    }
    let rect = null;
    Object.defineProperty(self, "rect", {
        get () {
            if (rect == null) syncRect(false);
            return rect;
        }
    });
    function syncRect(defer = false) {
        if (defer) rect = null;
        else {
            rect = over.getBoundingClientRect();
            fire("syncRect", rect);
        }
    }
    function mouseMove(e, src, _l, _t, _w, _h, _i) {
        if (cursor._lock) return;
        // Chrome on Windows has a bug which triggers a stray mousemove event after an initial mousedown event
        // when clicking into a plot as part of re-focusing the browser window.
        // we gotta ignore it to avoid triggering a phantom drag / setSelect
        // However, on touch-only devices Chrome-based browsers trigger a 0-distance mousemove before mousedown
        // so we don't ignore it when mousedown has set the dragging flag
        if (dragging && e != null && e.movementX == 0 && e.movementY == 0) return;
        cacheMouse(e, src, _l, _t, _w, _h, _i, false, e != null);
        if (e != null) updateCursor(null, true, true);
        else updateCursor(src, true, false);
    }
    function cacheMouse(e, src, _l, _t, _w, _h, _i, initial, snap) {
        if (rect == null) syncRect(false);
        setCursorEvent(e);
        if (e != null) {
            _l = e.clientX - rect.left;
            _t = e.clientY - rect.top;
        } else {
            if (_l < 0 || _t < 0) {
                mouseLeft1 = -10;
                mouseTop1 = -10;
                return;
            }
            let [xKey, yKey] = syncOpts.scales;
            let syncOptsSrc = src.cursor.sync;
            let [xValSrc, yValSrc] = syncOptsSrc.values;
            let [xKeySrc, yKeySrc] = syncOptsSrc.scales;
            let [matchXKeys, matchYKeys] = syncOpts.match;
            let rotSrc = src.axes[0].side % 2 == 1;
            let xDim = scaleX.ori == 0 ? plotWidCss : plotHgtCss, yDim = scaleX.ori == 1 ? plotWidCss : plotHgtCss, _xDim = rotSrc ? _h : _w, _yDim = rotSrc ? _w : _h, _xPos = rotSrc ? _t : _l, _yPos = rotSrc ? _l : _t;
            if (xKeySrc != null) _l = matchXKeys(xKey, xKeySrc) ? getPos(xValSrc, scales[xKey], xDim, 0) : -10;
            else _l = xDim * (_xPos / _xDim);
            if (yKeySrc != null) _t = matchYKeys(yKey, yKeySrc) ? getPos(yValSrc, scales[yKey], yDim, 0) : -10;
            else _t = yDim * (_yPos / _yDim);
            if (scaleX.ori == 1) {
                let __l = _l;
                _l = _t;
                _t = __l;
            }
        }
        if (snap) {
            if (_l <= 1 || _l >= plotWidCss - 1) _l = $77bd600c8f878470$var$incrRound(_l, plotWidCss);
            if (_t <= 1 || _t >= plotHgtCss - 1) _t = $77bd600c8f878470$var$incrRound(_t, plotHgtCss);
        }
        if (initial) {
            rawMouseLeft0 = _l;
            rawMouseTop0 = _t;
            [mouseLeft0, mouseTop0] = cursor.move(self, _l, _t);
        } else {
            mouseLeft1 = _l;
            mouseTop1 = _t;
        }
    }
    const _hideProps = {
        width: 0,
        height: 0,
        left: 0,
        top: 0
    };
    function hideSelect() {
        setSelect(_hideProps, false);
    }
    let downSelectLeft;
    let downSelectTop;
    let downSelectWidth;
    let downSelectHeight;
    function mouseDown(e, src, _l, _t, _w, _h, _i) {
        dragging = true;
        dragX = dragY = drag._x = drag._y = false;
        cacheMouse(e, src, _l, _t, _w, _h, _i, true, false);
        if (e != null) {
            onMouse($77bd600c8f878470$var$mouseup, $77bd600c8f878470$var$doc, mouseUp, false);
            pubSync($77bd600c8f878470$var$mousedown, self, mouseLeft0, mouseTop0, plotWidCss, plotHgtCss, null);
        }
        let { left: left, top: top, width: width, height: height } = select;
        downSelectLeft = left;
        downSelectTop = top;
        downSelectWidth = width;
        downSelectHeight = height;
        hideSelect();
    }
    function mouseUp(e, src, _l, _t, _w, _h, _i) {
        dragging = drag._x = drag._y = false;
        cacheMouse(e, src, _l, _t, _w, _h, _i, false, true);
        let { left: left, top: top, width: width, height: height } = select;
        let hasSelect = width > 0 || height > 0;
        let chgSelect = downSelectLeft != left || downSelectTop != top || downSelectWidth != width || downSelectHeight != height;
        hasSelect && chgSelect && setSelect(select);
        if (drag.setScale && hasSelect && chgSelect) {
            //	if (syncKey != null) {
            //		dragX = drag.x;
            //		dragY = drag.y;
            //	}
            let xOff = left, xDim = width, yOff = top, yDim = height;
            if (scaleX.ori == 1) xOff = top, xDim = height, yOff = left, yDim = width;
            if (dragX) _setScale(xScaleKey, posToVal(xOff, xScaleKey), posToVal(xOff + xDim, xScaleKey));
            if (dragY) for(let k in scales){
                let sc = scales[k];
                if (k != xScaleKey && sc.from == null && sc.min != $77bd600c8f878470$var$inf) _setScale(k, posToVal(yOff + yDim, k), posToVal(yOff, k));
            }
            hideSelect();
        } else if (cursor.lock) {
            cursor._lock = !cursor._lock;
            if (!cursor._lock) updateCursor(null, true, false);
        }
        if (e != null) {
            offMouse($77bd600c8f878470$var$mouseup, $77bd600c8f878470$var$doc);
            pubSync($77bd600c8f878470$var$mouseup, self, mouseLeft1, mouseTop1, plotWidCss, plotHgtCss, null);
        }
    }
    function mouseLeave(e, src, _l, _t, _w, _h, _i) {
        if (cursor._lock) return;
        setCursorEvent(e);
        let _dragging = dragging;
        if (dragging) {
            // handle case when mousemove aren't fired all the way to edges by browser
            let snapH = true;
            let snapV = true;
            let snapProx = 10;
            let dragH, dragV;
            if (scaleX.ori == 0) {
                dragH = dragX;
                dragV = dragY;
            } else {
                dragH = dragY;
                dragV = dragX;
            }
            if (dragH && dragV) {
                // maybe omni corner snap
                snapH = mouseLeft1 <= snapProx || mouseLeft1 >= plotWidCss - snapProx;
                snapV = mouseTop1 <= snapProx || mouseTop1 >= plotHgtCss - snapProx;
            }
            if (dragH && snapH) mouseLeft1 = mouseLeft1 < mouseLeft0 ? 0 : plotWidCss;
            if (dragV && snapV) mouseTop1 = mouseTop1 < mouseTop0 ? 0 : plotHgtCss;
            updateCursor(null, true, true);
            dragging = false;
        }
        mouseLeft1 = -10;
        mouseTop1 = -10;
        // passing a non-null timestamp to force sync/mousemove event
        updateCursor(null, true, true);
        if (_dragging) dragging = _dragging;
    }
    function dblClick(e, src, _l, _t, _w, _h, _i) {
        if (cursor._lock) return;
        setCursorEvent(e);
        autoScaleX();
        hideSelect();
        if (e != null) pubSync($77bd600c8f878470$var$dblclick, self, mouseLeft1, mouseTop1, plotWidCss, plotHgtCss, null);
    }
    function syncPxRatio() {
        axes.forEach($77bd600c8f878470$var$syncFontSize);
        _setSize(self.width, self.height, true);
    }
    $77bd600c8f878470$var$on($77bd600c8f878470$var$dppxchange, $77bd600c8f878470$var$win, syncPxRatio);
    // internal pub/sub
    const events = {};
    events.mousedown = mouseDown;
    events.mousemove = mouseMove;
    events.mouseup = mouseUp;
    events.dblclick = dblClick;
    events["setSeries"] = (e, src, idx, opts)=>{
        let seriesIdxMatcher = syncOpts.match[2];
        idx = seriesIdxMatcher(self, src, idx);
        idx != -1 && setSeries(idx, opts, true, false);
    };
    if (cursor.show) {
        onMouse($77bd600c8f878470$var$mousedown, over, mouseDown);
        onMouse($77bd600c8f878470$var$mousemove, over, mouseMove);
        onMouse($77bd600c8f878470$var$mouseenter, over, (e)=>{
            setCursorEvent(e);
            syncRect(false);
        });
        onMouse($77bd600c8f878470$var$mouseleave, over, mouseLeave);
        onMouse($77bd600c8f878470$var$dblclick, over, dblClick);
        $77bd600c8f878470$var$cursorPlots.add(self);
        self.syncRect = syncRect;
    }
    // external on/off
    const hooks = self.hooks = opts.hooks || {};
    function fire(evName, a1, a2) {
        if (deferHooks) hooksQueue.push([
            evName,
            a1,
            a2
        ]);
        else if (evName in hooks) hooks[evName].forEach((fn)=>{
            fn.call(null, self, a1, a2);
        });
    }
    (opts.plugins || []).forEach((p)=>{
        for(let evName in p.hooks)hooks[evName] = (hooks[evName] || []).concat(p.hooks[evName]);
    });
    const seriesIdxMatcher = (self, src, srcSeriesIdx)=>srcSeriesIdx;
    const syncOpts = $77bd600c8f878470$var$assign({
        key: null,
        setSeries: false,
        filters: {
            pub: $77bd600c8f878470$var$retTrue,
            sub: $77bd600c8f878470$var$retTrue
        },
        scales: [
            xScaleKey,
            series[1] ? series[1].scale : null
        ],
        match: [
            $77bd600c8f878470$var$retEq,
            $77bd600c8f878470$var$retEq,
            seriesIdxMatcher
        ],
        values: [
            null,
            null
        ]
    }, cursor.sync);
    if (syncOpts.match.length == 2) syncOpts.match.push(seriesIdxMatcher);
    cursor.sync = syncOpts;
    const syncKey = syncOpts.key;
    const sync = $77bd600c8f878470$var$_sync(syncKey);
    function pubSync(type, src, x, y, w, h, i) {
        if (syncOpts.filters.pub(type, src, x, y, w, h, i)) sync.pub(type, src, x, y, w, h, i);
    }
    sync.sub(self);
    function pub(type, src, x, y, w, h, i) {
        if (syncOpts.filters.sub(type, src, x, y, w, h, i)) events[type](null, src, x, y, w, h, i);
    }
    self.pub = pub;
    function destroy() {
        sync.unsub(self);
        $77bd600c8f878470$var$cursorPlots.delete(self);
        mouseListeners.clear();
        $77bd600c8f878470$var$off($77bd600c8f878470$var$dppxchange, $77bd600c8f878470$var$win, syncPxRatio);
        root.remove();
        legendTable?.remove(); // in case mounted outside of root
        fire("destroy");
    }
    self.destroy = destroy;
    function _init() {
        fire("init", opts, data);
        setData(data || opts.data, false);
        if (pendScales[xScaleKey]) setScale(xScaleKey, pendScales[xScaleKey]);
        else autoScaleX();
        shouldSetSelect = select.show && (select.width > 0 || select.height > 0);
        shouldSetCursor = shouldSetLegend = true;
        _setSize(opts.width, opts.height);
    }
    series.forEach(initSeries);
    axes.forEach(initAxis);
    if (then) {
        if (then instanceof HTMLElement) {
            then.appendChild(root);
            _init();
        } else then(self, _init);
    } else _init();
    return self;
}
$77bd600c8f878470$export$2e2bcd8739ae039.assign = $77bd600c8f878470$var$assign;
$77bd600c8f878470$export$2e2bcd8739ae039.fmtNum = $77bd600c8f878470$var$fmtNum;
$77bd600c8f878470$export$2e2bcd8739ae039.rangeNum = $77bd600c8f878470$var$rangeNum;
$77bd600c8f878470$export$2e2bcd8739ae039.rangeLog = $77bd600c8f878470$var$rangeLog;
$77bd600c8f878470$export$2e2bcd8739ae039.rangeAsinh = $77bd600c8f878470$var$rangeAsinh;
$77bd600c8f878470$export$2e2bcd8739ae039.orient = $77bd600c8f878470$var$orient;
$77bd600c8f878470$export$2e2bcd8739ae039.pxRatio = $77bd600c8f878470$var$pxRatio;
$77bd600c8f878470$export$2e2bcd8739ae039.join = $77bd600c8f878470$var$join;
$77bd600c8f878470$export$2e2bcd8739ae039.fmtDate = $77bd600c8f878470$var$fmtDate;
$77bd600c8f878470$export$2e2bcd8739ae039.tzDate = $77bd600c8f878470$var$tzDate;
$77bd600c8f878470$export$2e2bcd8739ae039.sync = $77bd600c8f878470$var$_sync;
{
    $77bd600c8f878470$export$2e2bcd8739ae039.addGap = $77bd600c8f878470$var$addGap;
    $77bd600c8f878470$export$2e2bcd8739ae039.clipGaps = $77bd600c8f878470$var$clipGaps;
    let paths = $77bd600c8f878470$export$2e2bcd8739ae039.paths = {
        points: $77bd600c8f878470$var$points
    };
    paths.linear = $77bd600c8f878470$var$linear;
    paths.stepped = $77bd600c8f878470$var$stepped;
    paths.bars = $77bd600c8f878470$var$bars;
    paths.spline = $77bd600c8f878470$var$monotoneCubic;
}
});


parcelRegister("7iwy4", function(module, exports) {

$parcel$export(module.exports, "loadBenchmarkInfo", function () { return $1b7c8b72704ee35c$export$aac5c121ddd0e4fb; });

var $bsDwv = parcelRequire("bsDwv");

var $lQe6V = parcelRequire("lQe6V");
async function $1b7c8b72704ee35c$export$aac5c121ddd0e4fb() {
    return await (0, $bsDwv.getJson)((0, $lQe6V.INFO_URL));
}

});
parcelRegister("bsDwv", function(module, exports) {

$parcel$export(module.exports, "getJson", function () { return $1afd1feee3f97bd3$export$a75c676177490cac; });
$parcel$export(module.exports, "postMsgpack", function () { return $1afd1feee3f97bd3$export$8f038e625c5cab95; });

var $26FSz = parcelRequire("26FSz");
async function $1afd1feee3f97bd3$export$c776284ef4b1209a(path, body) {
    const response = await fetch(path, {
        method: "POST",
        body: JSON.stringify(body)
    });
    return await response.json();
}
async function $1afd1feee3f97bd3$export$a75c676177490cac(path, params = {}) {
    let url = path;
    if (Object.keys(params).length > 0) {
        const urlParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params))if (value !== null) urlParams.set(key, value);
        url = `${path}?${urlParams}`;
    }
    const response = await fetch(url, {});
    return await response.json();
}
async function $1afd1feee3f97bd3$export$8f038e625c5cab95(path, body) {
    const response = await (window.__DATA_LOADER_CACHE__ || fetch(path, {
        method: "POST",
        body: JSON.stringify(body),
        mode: "cors"
    }));
    if (response.ok) return await (0, $26FSz.decodeAsync)(response.body);
    else {
        const text = await response.text();
        alert(text);
        throw new Error(`Invalid response from server: ${text}`);
    }
}

});
parcelRegister("26FSz", function(module, exports) {

$parcel$export(module.exports, "decodeAsync", function () { return $4aa0a66a38b238d9$export$e4c183687a6ff9b; });

var $2RBfd = parcelRequire("2RBfd");

var $ae6HD = parcelRequire("ae6HD");
var $4aa0a66a38b238d9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4aa0a66a38b238d9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $4aa0a66a38b238d9$export$e4c183687a6ff9b(streamLike, options) {
    return $4aa0a66a38b238d9$var$__awaiter(this, void 0, void 0, function() {
        var stream, decoder;
        return $4aa0a66a38b238d9$var$__generator(this, function(_a) {
            stream = (0, $ae6HD.ensureAsyncIterable)(streamLike);
            decoder = new (0, $2RBfd.Decoder)(options);
            return [
                2 /*return*/ ,
                decoder.decodeAsync(stream)
            ];
        });
    });
}
function $4aa0a66a38b238d9$export$b1b94ac44d9853a4(streamLike, options) {
    var stream = (0, $ae6HD.ensureAsyncIterable)(streamLike);
    var decoder = new (0, $2RBfd.Decoder)(options);
    return decoder.decodeArrayStream(stream);
}
function $4aa0a66a38b238d9$export$bf87d8a088c760fb(streamLike, options) {
    var stream = (0, $ae6HD.ensureAsyncIterable)(streamLike);
    var decoder = new (0, $2RBfd.Decoder)(options);
    return decoder.decodeStream(stream);
}
var $4aa0a66a38b238d9$export$7fb0f205e4fd0bbe = undefined;

});
parcelRegister("2RBfd", function(module, exports) {

$parcel$export(module.exports, "Decoder", function () { return $2d1cbcc4b3c9a6da$export$f9de6ca0bc043724; });

var $9rE70 = parcelRequire("9rE70");

var $1MqjX = parcelRequire("1MqjX");

var $gOhlN = parcelRequire("gOhlN");

var $lkny0 = parcelRequire("lkny0");

var $6IB1f = parcelRequire("6IB1f");

var $68lJp = parcelRequire("68lJp");

var $hsd5B = parcelRequire("hsd5B");
var $2d1cbcc4b3c9a6da$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2d1cbcc4b3c9a6da$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2d1cbcc4b3c9a6da$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $2d1cbcc4b3c9a6da$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $2d1cbcc4b3c9a6da$var$__await ? (this.v = v, this) : new $2d1cbcc4b3c9a6da$var$__await(v);
};
var $2d1cbcc4b3c9a6da$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2d1cbcc4b3c9a6da$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $2d1cbcc4b3c9a6da$var$STATE_ARRAY = "array";
var $2d1cbcc4b3c9a6da$var$STATE_MAP_KEY = "map_key";
var $2d1cbcc4b3c9a6da$var$STATE_MAP_VALUE = "map_value";
var $2d1cbcc4b3c9a6da$var$isValidMapKeyType = function(key) {
    return typeof key === "string" || typeof key === "number";
};
var $2d1cbcc4b3c9a6da$var$HEAD_BYTE_REQUIRED = -1;
var $2d1cbcc4b3c9a6da$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
var $2d1cbcc4b3c9a6da$var$EMPTY_BYTES = new Uint8Array($2d1cbcc4b3c9a6da$var$EMPTY_VIEW.buffer);
try {
    // IE11: The spec says it should throw RangeError,
    // IE11: but in IE11 it throws TypeError.
    $2d1cbcc4b3c9a6da$var$EMPTY_VIEW.getInt8(0);
} catch (e) {
    if (!(e instanceof RangeError)) throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
var $2d1cbcc4b3c9a6da$export$449c37eaf7093493 = RangeError;
var $2d1cbcc4b3c9a6da$var$MORE_DATA = new $2d1cbcc4b3c9a6da$export$449c37eaf7093493("Insufficient data");
var $2d1cbcc4b3c9a6da$var$sharedCachedKeyDecoder = new (0, $68lJp.CachedKeyDecoder)();
var $2d1cbcc4b3c9a6da$export$f9de6ca0bc043724 = /** @class */ function() {
    function Decoder(options) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.totalPos = 0;
        this.pos = 0;
        this.view = $2d1cbcc4b3c9a6da$var$EMPTY_VIEW;
        this.bytes = $2d1cbcc4b3c9a6da$var$EMPTY_BYTES;
        this.headByte = $2d1cbcc4b3c9a6da$var$HEAD_BYTE_REQUIRED;
        this.stack = [];
        this.extensionCodec = (_a = options === null || options === void 0 ? void 0 : options.extensionCodec) !== null && _a !== void 0 ? _a : (0, $1MqjX.ExtensionCodec).defaultCodec;
        this.context = options === null || options === void 0 ? void 0 : options.context; // needs a type assertion because EncoderOptions has no context property when ContextType is undefined
        this.useBigInt64 = (_b = options === null || options === void 0 ? void 0 : options.useBigInt64) !== null && _b !== void 0 ? _b : false;
        this.maxStrLength = (_c = options === null || options === void 0 ? void 0 : options.maxStrLength) !== null && _c !== void 0 ? _c : (0, $gOhlN.UINT32_MAX);
        this.maxBinLength = (_d = options === null || options === void 0 ? void 0 : options.maxBinLength) !== null && _d !== void 0 ? _d : (0, $gOhlN.UINT32_MAX);
        this.maxArrayLength = (_e = options === null || options === void 0 ? void 0 : options.maxArrayLength) !== null && _e !== void 0 ? _e : (0, $gOhlN.UINT32_MAX);
        this.maxMapLength = (_f = options === null || options === void 0 ? void 0 : options.maxMapLength) !== null && _f !== void 0 ? _f : (0, $gOhlN.UINT32_MAX);
        this.maxExtLength = (_g = options === null || options === void 0 ? void 0 : options.maxExtLength) !== null && _g !== void 0 ? _g : (0, $gOhlN.UINT32_MAX);
        this.keyDecoder = (options === null || options === void 0 ? void 0 : options.keyDecoder) !== undefined ? options.keyDecoder : $2d1cbcc4b3c9a6da$var$sharedCachedKeyDecoder;
    }
    Decoder.prototype.reinitializeState = function() {
        this.totalPos = 0;
        this.headByte = $2d1cbcc4b3c9a6da$var$HEAD_BYTE_REQUIRED;
        this.stack.length = 0;
    // view, bytes, and pos will be re-initialized in setBuffer()
    };
    Decoder.prototype.setBuffer = function(buffer) {
        this.bytes = (0, $6IB1f.ensureUint8Array)(buffer);
        this.view = (0, $6IB1f.createDataView)(this.bytes);
        this.pos = 0;
    };
    Decoder.prototype.appendBuffer = function(buffer) {
        if (this.headByte === $2d1cbcc4b3c9a6da$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            var remainingData = this.bytes.subarray(this.pos);
            var newData = (0, $6IB1f.ensureUint8Array)(buffer);
            // concat remainingData + newData
            var newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    };
    Decoder.prototype.hasRemaining = function(size) {
        return this.view.byteLength - this.pos >= size;
    };
    Decoder.prototype.createExtraByteError = function(posToShow) {
        var _a = this, view = _a.view, pos = _a.pos;
        return new RangeError("Extra ".concat(view.byteLength - pos, " of ").concat(view.byteLength, " byte(s) found at buffer[").concat(posToShow, "]"));
    };
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ Decoder.prototype.decode = function(buffer) {
        this.reinitializeState();
        this.setBuffer(buffer);
        var object = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return object;
    };
    Decoder.prototype.decodeMulti = function(buffer) {
        return $2d1cbcc4b3c9a6da$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    this.reinitializeState();
                    this.setBuffer(buffer);
                    _a.label = 1;
                case 1:
                    if (!this.hasRemaining(1)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        this.doDecodeSync()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    Decoder.prototype.decodeAsync = function(stream) {
        var _a, stream_1, stream_1_1;
        var _b, e_1, _c, _d;
        return $2d1cbcc4b3c9a6da$var$__awaiter(this, void 0, void 0, function() {
            var decoded, object, buffer, e_1_1, _e, headByte, pos, totalPos;
            return $2d1cbcc4b3c9a6da$var$__generator(this, function(_f) {
                switch(_f.label){
                    case 0:
                        decoded = false;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        _a = true, stream_1 = $2d1cbcc4b3c9a6da$var$__asyncValues(stream);
                        _f.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            stream_1.next()
                        ];
                    case 3:
                        if (!(stream_1_1 = _f.sent(), _b = stream_1_1.done, !_b)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _d = stream_1_1.value;
                        _a = false;
                        try {
                            buffer = _d;
                            if (decoded) throw this.createExtraByteError(this.totalPos);
                            this.appendBuffer(buffer);
                            try {
                                object = this.doDecodeSync();
                                decoded = true;
                            } catch (e) {
                                if (!(e instanceof $2d1cbcc4b3c9a6da$export$449c37eaf7093493)) throw e; // rethrow
                            // fallthrough
                            }
                            this.totalPos += this.pos;
                        } finally{
                            _a = true;
                        }
                        _f.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_1_1 = _f.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _f.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(!_a && !_b && (_c = stream_1.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _c.call(stream_1)
                        ];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (decoded) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2 /*return*/ ,
                                object
                            ];
                        }
                        _e = this, headByte = _e.headByte, pos = _e.pos, totalPos = _e.totalPos;
                        throw new RangeError("Insufficient data in parsing ".concat((0, $9rE70.prettyByte)(headByte), " at ").concat(totalPos, " (").concat(pos, " in the current buffer)"));
                }
            });
        });
    };
    Decoder.prototype.decodeArrayStream = function(stream) {
        return this.decodeMultiAsync(stream, true);
    };
    Decoder.prototype.decodeStream = function(stream) {
        return this.decodeMultiAsync(stream, false);
    };
    Decoder.prototype.decodeMultiAsync = function(stream, isArray) {
        return $2d1cbcc4b3c9a6da$var$__asyncGenerator(this, arguments, function decodeMultiAsync_1() {
            var isArrayHeaderRequired, arrayItemsLeft, _a, stream_2, stream_2_1, buffer, e_2, e_3_1;
            var _b, e_3, _c, _d;
            return $2d1cbcc4b3c9a6da$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        isArrayHeaderRequired = isArray;
                        arrayItemsLeft = -1;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            15,
                            16,
                            21
                        ]);
                        _a = true, stream_2 = $2d1cbcc4b3c9a6da$var$__asyncValues(stream);
                        _e.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $2d1cbcc4b3c9a6da$var$__await(stream_2.next())
                        ];
                    case 3:
                        if (!(stream_2_1 = _e.sent(), _b = stream_2_1.done, !_b)) return [
                            3 /*break*/ ,
                            14
                        ];
                        _d = stream_2_1.value;
                        _a = false;
                        _e.label = 4;
                    case 4:
                        _e.trys.push([
                            4,
                            ,
                            12,
                            13
                        ]);
                        buffer = _d;
                        if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        if (isArrayHeaderRequired) {
                            arrayItemsLeft = this.readArraySize();
                            isArrayHeaderRequired = false;
                            this.complete();
                        }
                        _e.label = 5;
                    case 5:
                        _e.trys.push([
                            5,
                            10,
                            ,
                            11
                        ]);
                        _e.label = 6;
                    case 6:
                        return [
                            4 /*yield*/ ,
                            $2d1cbcc4b3c9a6da$var$__await(this.doDecodeSync())
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _e.sent()
                        ];
                    case 8:
                        _e.sent();
                        if (--arrayItemsLeft === 0) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        e_2 = _e.sent();
                        if (!(e_2 instanceof $2d1cbcc4b3c9a6da$export$449c37eaf7093493)) throw e_2; // rethrow
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        this.totalPos += this.pos;
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 12:
                        _a = true;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 14:
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 15:
                        e_3_1 = _e.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 16:
                        _e.trys.push([
                            16,
                            ,
                            19,
                            20
                        ]);
                        if (!(!_a && !_b && (_c = stream_2.return))) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            4 /*yield*/ ,
                            $2d1cbcc4b3c9a6da$var$__await(_c.call(stream_2))
                        ];
                    case 17:
                        _e.sent();
                        _e.label = 18;
                    case 18:
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 19:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 20:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 21:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Decoder.prototype.doDecodeSync = function() {
        DECODE: while(true){
            var headByte = this.readHeadByte();
            var object = void 0;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    var size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    var size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    var byteLength = headByte - 0xa0;
                    object = this.decodeUtf8String(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) {
                // uint 64
                if (this.useBigInt64) object = this.readU64AsBigInt();
                else object = this.readU64();
            } else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) {
                // int 64
                if (this.useBigInt64) object = this.readI64AsBigInt();
                else object = this.readI64();
            } else if (headByte === 0xd9) {
                // str 8
                var byteLength = this.lookU8();
                object = this.decodeUtf8String(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                var byteLength = this.lookU16();
                object = this.decodeUtf8String(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                var byteLength = this.lookU32();
                object = this.decodeUtf8String(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                var size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                var size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                var size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                var size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                var size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                var size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $hsd5B.DecodeError)("Unrecognized type byte: ".concat((0, $9rE70.prettyByte)(headByte)));
            this.complete();
            var stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                var state = stack[stack.length - 1];
                if (state.type === $2d1cbcc4b3c9a6da$var$STATE_ARRAY) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        stack.pop();
                        object = state.array;
                    } else continue DECODE;
                } else if (state.type === $2d1cbcc4b3c9a6da$var$STATE_MAP_KEY) {
                    if (!$2d1cbcc4b3c9a6da$var$isValidMapKeyType(object)) throw new (0, $hsd5B.DecodeError)("The type of key must be string or number but " + typeof object);
                    if (object === "__proto__") throw new (0, $hsd5B.DecodeError)("The key __proto__ is not allowed");
                    state.key = object;
                    state.type = $2d1cbcc4b3c9a6da$var$STATE_MAP_VALUE;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        stack.pop();
                        object = state.map;
                    } else {
                        state.key = null;
                        state.type = $2d1cbcc4b3c9a6da$var$STATE_MAP_KEY;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    };
    Decoder.prototype.readHeadByte = function() {
        if (this.headByte === $2d1cbcc4b3c9a6da$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    };
    Decoder.prototype.complete = function() {
        this.headByte = $2d1cbcc4b3c9a6da$var$HEAD_BYTE_REQUIRED;
    };
    Decoder.prototype.readArraySize = function() {
        var headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $hsd5B.DecodeError)("Unrecognized array type byte: ".concat((0, $9rE70.prettyByte)(headByte)));
        }
    };
    Decoder.prototype.pushMapState = function(size) {
        if (size > this.maxMapLength) throw new (0, $hsd5B.DecodeError)("Max length exceeded: map length (".concat(size, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: $2d1cbcc4b3c9a6da$var$STATE_MAP_KEY,
            size: size,
            key: null,
            readCount: 0,
            map: {}
        });
    };
    Decoder.prototype.pushArrayState = function(size) {
        if (size > this.maxArrayLength) throw new (0, $hsd5B.DecodeError)("Max length exceeded: array length (".concat(size, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: $2d1cbcc4b3c9a6da$var$STATE_ARRAY,
            size: size,
            array: new Array(size),
            position: 0
        });
    };
    Decoder.prototype.decodeUtf8String = function(byteLength, headerOffset) {
        var _a;
        if (byteLength > this.maxStrLength) throw new (0, $hsd5B.DecodeError)("Max length exceeded: UTF-8 byte length (".concat(byteLength, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $2d1cbcc4b3c9a6da$var$MORE_DATA;
        var offset = this.pos + headerOffset;
        var object;
        if (this.stateIsMapKey() && ((_a = this.keyDecoder) === null || _a === void 0 ? void 0 : _a.canBeCached(byteLength))) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else object = (0, $lkny0.utf8Decode)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    };
    Decoder.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var state = this.stack[this.stack.length - 1];
            return state.type === $2d1cbcc4b3c9a6da$var$STATE_MAP_KEY;
        }
        return false;
    };
    Decoder.prototype.decodeBinary = function(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $hsd5B.DecodeError)("Max length exceeded: bin length (".concat(byteLength, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(byteLength + headOffset)) throw $2d1cbcc4b3c9a6da$var$MORE_DATA;
        var offset = this.pos + headOffset;
        var object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    };
    Decoder.prototype.decodeExtension = function(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $hsd5B.DecodeError)("Max length exceeded: ext length (".concat(size, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var extType = this.view.getInt8(this.pos + headOffset);
        var data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    };
    Decoder.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    };
    Decoder.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    };
    Decoder.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    };
    Decoder.prototype.readU8 = function() {
        var value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readI8 = function() {
        var value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readU16 = function() {
        var value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readI16 = function() {
        var value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readU32 = function() {
        var value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readI32 = function() {
        var value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readU64 = function() {
        var value = (0, $gOhlN.getUint64)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64 = function() {
        var value = (0, $gOhlN.getInt64)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readU64AsBigInt = function() {
        var value = this.view.getBigUint64(this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64AsBigInt = function() {
        var value = this.view.getBigInt64(this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readF32 = function() {
        var value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readF64 = function() {
        var value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    };
    return Decoder;
}();

});
parcelRegister("9rE70", function(module, exports) {

$parcel$export(module.exports, "prettyByte", function () { return $977eb16b95dc5e70$export$78406e843f5312da; });
function $977eb16b95dc5e70$export$78406e843f5312da(byte) {
    return "".concat(byte < 0 ? "-" : "", "0x").concat(Math.abs(byte).toString(16).padStart(2, "0"));
}

});

parcelRegister("1MqjX", function(module, exports) {

$parcel$export(module.exports, "ExtensionCodec", function () { return $9f85c4645821c235$export$12677a794dbd89d7; });
// ExtensionCodec to handle MessagePack extensions

var $kXDhK = parcelRequire("kXDhK");

var $9xVDb = parcelRequire("9xVDb");
var $9f85c4645821c235$export$12677a794dbd89d7 = /** @class */ function() {
    function ExtensionCodec() {
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $9xVDb.timestampExtension));
    }
    ExtensionCodec.prototype.register = function(_a) {
        var type = _a.type, encode = _a.encode, decode = _a.decode;
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            var index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    };
    ExtensionCodec.prototype.tryToEncode = function(object, context) {
        // built-in extensions
        for(var i = 0; i < this.builtInEncoders.length; i++){
            var encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = -1 - i;
                    return new (0, $kXDhK.ExtData)(type, data);
                }
            }
        }
        // custom extensions
        for(var i = 0; i < this.encoders.length; i++){
            var encodeExt = this.encoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = i;
                    return new (0, $kXDhK.ExtData)(type, data);
                }
            }
        }
        if (object instanceof (0, $kXDhK.ExtData)) // to keep ExtData as is
        return object;
        return null;
    };
    ExtensionCodec.prototype.decode = function(data, type, context) {
        var decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $kXDhK.ExtData)(type, data);
    };
    ExtensionCodec.defaultCodec = new ExtensionCodec();
    return ExtensionCodec;
}();

});
parcelRegister("kXDhK", function(module, exports) {

$parcel$export(module.exports, "ExtData", function () { return $a6884f78f629f003$export$bcbeb236456bc779; });
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ var $a6884f78f629f003$export$bcbeb236456bc779 = /** @class */ function() {
    function ExtData(type, data) {
        this.type = type;
        this.data = data;
    }
    return ExtData;
}();

});

parcelRegister("9xVDb", function(module, exports) {

$parcel$export(module.exports, "timestampExtension", function () { return $a574edba42080fde$export$8654479533463da1; });
// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type

var $hsd5B = parcelRequire("hsd5B");

var $gOhlN = parcelRequire("gOhlN");
var $a574edba42080fde$export$f18369fc203f4e13 = -1;
var $a574edba42080fde$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
var $a574edba42080fde$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $a574edba42080fde$export$2fd05b828dd81159(_a) {
    var sec = _a.sec, nsec = _a.nsec;
    if (sec >= 0 && nsec >= 0 && sec <= $a574edba42080fde$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $a574edba42080fde$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            var rv = new Uint8Array(4);
            var view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            var secHigh = sec / 0x100000000;
            var secLow = sec & 0xffffffff;
            var rv = new Uint8Array(8);
            var view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        var rv = new Uint8Array(12);
        var view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $gOhlN.setInt64)(view, 4, sec);
        return rv;
    }
}
function $a574edba42080fde$export$221d97b3b00b03c2(date) {
    var msec = date.getTime();
    var sec = Math.floor(msec / 1e3);
    var nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    var nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $a574edba42080fde$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        var timeSpec = $a574edba42080fde$export$221d97b3b00b03c2(object);
        return $a574edba42080fde$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $a574edba42080fde$export$abfc8800a5159711(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            // timestamp 32 = { sec32 }
            var sec = view.getUint32(0);
            var nsec = 0;
            return {
                sec: sec,
                nsec: nsec
            };
        case 8:
            // timestamp 64 = { nsec30, sec34 }
            var nsec30AndSecHigh2 = view.getUint32(0);
            var secLow32 = view.getUint32(4);
            var sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
            var nsec = nsec30AndSecHigh2 >>> 2;
            return {
                sec: sec,
                nsec: nsec
            };
        case 12:
            // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
            var sec = (0, $gOhlN.getInt64)(view, 4);
            var nsec = view.getUint32(0);
            return {
                sec: sec,
                nsec: nsec
            };
        default:
            throw new (0, $hsd5B.DecodeError)("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(data.length));
    }
}
function $a574edba42080fde$export$80b8ff9315e4298f(data) {
    var timeSpec = $a574edba42080fde$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
var $a574edba42080fde$export$8654479533463da1 = {
    type: $a574edba42080fde$export$f18369fc203f4e13,
    encode: $a574edba42080fde$export$32420f352fe0fc83,
    decode: $a574edba42080fde$export$80b8ff9315e4298f
};

});
parcelRegister("hsd5B", function(module, exports) {

$parcel$export(module.exports, "DecodeError", function () { return $834f80ae5c0648ff$export$ef3eed12d06c0285; });
var $834f80ae5c0648ff$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $834f80ae5c0648ff$export$ef3eed12d06c0285 = /** @class */ function(_super) {
    $834f80ae5c0648ff$var$__extends(DecodeError, _super);
    function DecodeError(message) {
        var _this = _super.call(this, message) || this;
        // fix the prototype chain in a cross-platform way
        var proto = Object.create(DecodeError.prototype);
        Object.setPrototypeOf(_this, proto);
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: DecodeError.name
        });
        return _this;
    }
    return DecodeError;
}(Error);

});

parcelRegister("gOhlN", function(module, exports) {

$parcel$export(module.exports, "UINT32_MAX", function () { return $466b0dd090907737$export$3314b2c271c86d70; });
$parcel$export(module.exports, "setInt64", function () { return $466b0dd090907737$export$8532a5209571c04a; });
$parcel$export(module.exports, "getInt64", function () { return $466b0dd090907737$export$69825c7adcc820c6; });
$parcel$export(module.exports, "getUint64", function () { return $466b0dd090907737$export$59a2dbf579ff9568; });
// Integer Utility
var $466b0dd090907737$export$3314b2c271c86d70 = 4294967295;
function $466b0dd090907737$export$20f71c4c8b0f96c3(view, offset, value) {
    var high = value / 4294967296;
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $466b0dd090907737$export$8532a5209571c04a(view, offset, value) {
    var high = Math.floor(value / 4294967296);
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $466b0dd090907737$export$69825c7adcc820c6(view, offset) {
    var high = view.getInt32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $466b0dd090907737$export$59a2dbf579ff9568(view, offset) {
    var high = view.getUint32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}

});



parcelRegister("lkny0", function(module, exports) {

$parcel$export(module.exports, "utf8DecodeJs", function () { return $d02df5f5a10a50a8$export$551117984c2adf4f; });
$parcel$export(module.exports, "utf8Decode", function () { return $d02df5f5a10a50a8$export$db70ef86b2db322a; });
function $d02df5f5a10a50a8$export$b61de95301265227(str) {
    var strLength = str.length;
    var byteLength = 0;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $d02df5f5a10a50a8$export$1042e4338f1ef853(str, output, outputOffset) {
    var strLength = str.length;
    var offset = outputOffset;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
// TextEncoder and TextDecoder are standardized in whatwg encoding:
// https://encoding.spec.whatwg.org/
// and available in all the modern browsers:
// https://caniuse.com/textencoder
// They are available in Node.js since v12 LTS as well:
// https://nodejs.org/api/globals.html#textencoder
var $d02df5f5a10a50a8$var$sharedTextEncoder = new TextEncoder();
// This threshold should be determined by benchmarking, which might vary in engines and input data.
// Run `npx ts-node benchmark/encode-string.ts` for details.
var $d02df5f5a10a50a8$var$TEXT_ENCODER_THRESHOLD = 50;
function $d02df5f5a10a50a8$export$34cfdc82d430524(str, output, outputOffset) {
    $d02df5f5a10a50a8$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
function $d02df5f5a10a50a8$export$e1b32e613f230dc6(str, output, outputOffset) {
    if (str.length > $d02df5f5a10a50a8$var$TEXT_ENCODER_THRESHOLD) $d02df5f5a10a50a8$export$34cfdc82d430524(str, output, outputOffset);
    else $d02df5f5a10a50a8$export$1042e4338f1ef853(str, output, outputOffset);
}
var $d02df5f5a10a50a8$var$CHUNK_SIZE = 4096;
function $d02df5f5a10a50a8$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    var offset = inputOffset;
    var end = offset + byteLength;
    var units = [];
    var result = "";
    while(offset < end){
        var byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            var byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            var byte4 = bytes[offset++] & 0x3f;
            var unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $d02df5f5a10a50a8$var$CHUNK_SIZE) {
            result += String.fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode.apply(String, units);
    return result;
}
var $d02df5f5a10a50a8$var$sharedTextDecoder = new TextDecoder();
// This threshold should be determined by benchmarking, which might vary in engines and input data.
// Run `npx ts-node benchmark/decode-string.ts` for details.
var $d02df5f5a10a50a8$var$TEXT_DECODER_THRESHOLD = 200;
function $d02df5f5a10a50a8$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    var stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $d02df5f5a10a50a8$var$sharedTextDecoder.decode(stringBytes);
}
function $d02df5f5a10a50a8$export$db70ef86b2db322a(bytes, inputOffset, byteLength) {
    if (byteLength > $d02df5f5a10a50a8$var$TEXT_DECODER_THRESHOLD) return $d02df5f5a10a50a8$export$6ed79e41309992dc(bytes, inputOffset, byteLength);
    else return $d02df5f5a10a50a8$export$551117984c2adf4f(bytes, inputOffset, byteLength);
}

});

parcelRegister("6IB1f", function(module, exports) {

$parcel$export(module.exports, "ensureUint8Array", function () { return $1828a298486b93c4$export$f8d669c2a17882f2; });
$parcel$export(module.exports, "createDataView", function () { return $1828a298486b93c4$export$7277868462c1ba02; });
function $1828a298486b93c4$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $1828a298486b93c4$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    var bufferView = $1828a298486b93c4$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}

});

parcelRegister("68lJp", function(module, exports) {

$parcel$export(module.exports, "CachedKeyDecoder", function () { return $2eda338cbebc6792$export$529b830450faf29c; });

var $lkny0 = parcelRequire("lkny0");
var $2eda338cbebc6792$var$DEFAULT_MAX_KEY_LENGTH = 16;
var $2eda338cbebc6792$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
var $2eda338cbebc6792$export$529b830450faf29c = /** @class */ function() {
    function CachedKeyDecoder(maxKeyLength, maxLengthPerKey) {
        if (maxKeyLength === void 0) maxKeyLength = $2eda338cbebc6792$var$DEFAULT_MAX_KEY_LENGTH;
        if (maxLengthPerKey === void 0) maxLengthPerKey = $2eda338cbebc6792$var$DEFAULT_MAX_LENGTH_PER_KEY;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        this.hit = 0;
        this.miss = 0;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(var i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    CachedKeyDecoder.prototype.canBeCached = function(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    };
    CachedKeyDecoder.prototype.find = function(bytes, inputOffset, byteLength) {
        var records = this.caches[byteLength - 1];
        FIND_CHUNK: for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var recordBytes = record.bytes;
            for(var j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    };
    CachedKeyDecoder.prototype.store = function(bytes, value) {
        var records = this.caches[bytes.length - 1];
        var record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    };
    CachedKeyDecoder.prototype.decode = function(bytes, inputOffset, byteLength) {
        var cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        var str = (0, $lkny0.utf8DecodeJs)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the byte may be NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        var slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    };
    return CachedKeyDecoder;
}();

});


parcelRegister("ae6HD", function(module, exports) {

$parcel$export(module.exports, "ensureAsyncIterable", function () { return $9fbf2ebbf92b4132$export$bf99ef56e8bd104; });
// utility for whatwg streams
var $9fbf2ebbf92b4132$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9fbf2ebbf92b4132$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $9fbf2ebbf92b4132$var$__await ? (this.v = v, this) : new $9fbf2ebbf92b4132$var$__await(v);
};
var $9fbf2ebbf92b4132$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9fbf2ebbf92b4132$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $9fbf2ebbf92b4132$export$edb10ab8dd75a915(object) {
    return object[Symbol.asyncIterator] != null;
}
function $9fbf2ebbf92b4132$var$assertNonNull(value) {
    if (value == null) throw new Error("Assertion Failure: value must not be null nor undefined");
}
function $9fbf2ebbf92b4132$export$f62cf0e66867a58e(stream) {
    return $9fbf2ebbf92b4132$var$__asyncGenerator(this, arguments, function asyncIterableFromStream_1() {
        var reader, _a, done, value;
        return $9fbf2ebbf92b4132$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = stream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        $9fbf2ebbf92b4132$var$__await(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (!done) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        $9fbf2ebbf92b4132$var$__await(void 0)
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
                case 5:
                    $9fbf2ebbf92b4132$var$assertNonNull(value);
                    return [
                        4 /*yield*/ ,
                        $9fbf2ebbf92b4132$var$__await(value)
                    ];
                case 6:
                    return [
                        4 /*yield*/ ,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 10:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $9fbf2ebbf92b4132$export$bf99ef56e8bd104(streamLike) {
    if ($9fbf2ebbf92b4132$export$edb10ab8dd75a915(streamLike)) return streamLike;
    else return $9fbf2ebbf92b4132$export$f62cf0e66867a58e(streamLike);
}

});



parcelRegister("lQe6V", function(module, exports) {

$parcel$export(module.exports, "INFO_URL", function () { return $075cffbd6b9d9872$export$7c0d545b458db990; });
$parcel$export(module.exports, "GRAPH_DATA_URL", function () { return $075cffbd6b9d9872$export$db5deb3537a86e46; });
$parcel$export(module.exports, "COMPARE_DATA_URL", function () { return $075cffbd6b9d9872$export$3f5cbecbeaeb64b6; });
$parcel$export(module.exports, "COMPARE_COMPILE_DETAIL_GRAPHS_DATA_URL", function () { return $075cffbd6b9d9872$export$6c04259360eb7beb; });
$parcel$export(module.exports, "COMPARE_COMPILE_DETAIL_SECTIONS_DATA_URL", function () { return $075cffbd6b9d9872$export$fb83cff94236eaa; });
const $075cffbd6b9d9872$var$BASE_URL = window.location.origin + "/perf";
const $075cffbd6b9d9872$export$7c0d545b458db990 = `${$075cffbd6b9d9872$var$BASE_URL}/info`;
const $075cffbd6b9d9872$export$1eeeb7ea0e9c0c1c = `${$075cffbd6b9d9872$var$BASE_URL}/dashboard`;
const $075cffbd6b9d9872$export$1b7daea53f626f37 = `${$075cffbd6b9d9872$var$BASE_URL}/status_page`;
const $075cffbd6b9d9872$export$e81529d50221006f = `${$075cffbd6b9d9872$var$BASE_URL}/bootstrap`;
const $075cffbd6b9d9872$export$db5deb3537a86e46 = `${$075cffbd6b9d9872$var$BASE_URL}/graphs`;
const $075cffbd6b9d9872$export$3f5cbecbeaeb64b6 = `${$075cffbd6b9d9872$var$BASE_URL}/get`;
const $075cffbd6b9d9872$export$6c04259360eb7beb = `${$075cffbd6b9d9872$var$BASE_URL}/compare-compile-detail-graphs`;
const $075cffbd6b9d9872$export$ad885e9b6536c499 = `${$075cffbd6b9d9872$var$BASE_URL}/compare-runtime-detail-graphs`;
const $075cffbd6b9d9872$export$fb83cff94236eaa = `${$075cffbd6b9d9872$var$BASE_URL}/compare-compile-detail-sections`;
const $075cffbd6b9d9872$export$ef7ab08a0aea518f = `${$075cffbd6b9d9872$var$BASE_URL}/self-profile`;

});


parcelRegister("iuFuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d76b37894a4e95f8$export$2e2bcd8739ae039; });
let $d76b37894a4e95f8$var$script;



let $d76b37894a4e95f8$var$initialize = ()=>{
    $d76b37894a4e95f8$var$script = (parcelRequire("gy5aj"));
    if ($d76b37894a4e95f8$var$script.__esModule) $d76b37894a4e95f8$var$script = $d76b37894a4e95f8$var$script.default;
    $d76b37894a4e95f8$var$script.render = (parcelRequire("dkN3P")).render;
    (parcelRequire("8xddw")).default($d76b37894a4e95f8$var$script);
    $d76b37894a4e95f8$var$script.__scopeId = "data-v-859181";
    $d76b37894a4e95f8$var$script.__file = "as-of.vue";
};
$d76b37894a4e95f8$var$initialize();
var $d76b37894a4e95f8$export$2e2bcd8739ae039 = $d76b37894a4e95f8$var$script;

});
parcelRegister("gy5aj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e3fd335214672d4a$export$2e2bcd8739ae039; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
var $e3fd335214672d4a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cUHxd.defineComponent)({
    __name: "as-of",
    props: {
        info: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("dkN3P", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9b53330980c5e2db$export$b3890eb0ae9dca99; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
var $jZXzE = parcelRequire("jZXzE");
const $9b53330980c5e2db$var$_hoisted_1 = {
    id: "as-of"
};
function $9b53330980c5e2db$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)("div", $9b53330980c5e2db$var$_hoisted_1, " Updated as of: " + (0, $jZXzE.toDisplayString)(new Date($setup.props.info.as_of).toLocaleString()), 1);
}

});

parcelRegister("8xddw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $636ba87437f03b0a$export$2e2bcd8739ae039; });
let $636ba87437f03b0a$var$NOOP = ()=>{};
var $636ba87437f03b0a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lFFGq", function(module, exports) {

$parcel$export(module.exports, "loadGraphs", function () { return $dcaa5651f71fc72c$export$6d016b30f531826e; });

var $bsDwv = parcelRequire("bsDwv");

var $lQe6V = parcelRequire("lQe6V");
async function $dcaa5651f71fc72c$export$6d016b30f531826e(selector) {
    const params = {
        start: selector.start,
        end: selector.end,
        kind: selector.kind,
        stat: selector.stat,
        benchmark: selector.benchmark
    };
    return await (0, $bsDwv.getJson)((0, $lQe6V.GRAPH_DATA_URL), params);
}

});


parcelRegister("lxasY", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $fad4cc6e2fa52e3d$export$b3890eb0ae9dca99; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
const $fad4cc6e2fa52e3d$var$_withScopeId = (n)=>((0, $cUHxd.pushScopeId)("data-v-498bca"), n = n(), (0, $cUHxd.popScopeId)(), n);
const $fad4cc6e2fa52e3d$var$_hoisted_1 = /*#__PURE__*/ $fad4cc6e2fa52e3d$var$_withScopeId(()=>/*#__PURE__*/ (0, $cUHxd.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cUHxd.createTextVNode)(" See "),
        /*#__PURE__*/ (0, $cUHxd.createElementVNode)("a", {
            href: "/"
        }, "compare page"),
        /*#__PURE__*/ (0, $cUHxd.createTextVNode)(" for descriptions of what the names mean. ")
    ], -1));
const $fad4cc6e2fa52e3d$var$_hoisted_2 = /*#__PURE__*/ $fad4cc6e2fa52e3d$var$_withScopeId(()=>/*#__PURE__*/ (0, $cUHxd.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cUHxd.createElementVNode)("strong", null, "Note:"),
        /*#__PURE__*/ (0, $cUHxd.createTextVNode)(" pink in the graphs represent data points that are interpolated due to missing data. Interpolated data is simply the last known data point repeated until another known data point is found. ")
    ], -1));
const $fad4cc6e2fa52e3d$var$_hoisted_3 = {
    class: "wrapper",
    ref: "wrapperRef"
};
const $fad4cc6e2fa52e3d$var$_hoisted_4 = {
    key: 0
};
const $fad4cc6e2fa52e3d$var$_hoisted_5 = /*#__PURE__*/ $fad4cc6e2fa52e3d$var$_withScopeId(()=>/*#__PURE__*/ (0, $cUHxd.createElementVNode)("h2", null, "Loading & rendering data..", -1));
const $fad4cc6e2fa52e3d$var$_hoisted_6 = /*#__PURE__*/ $fad4cc6e2fa52e3d$var$_withScopeId(()=>/*#__PURE__*/ (0, $cUHxd.createElementVNode)("h3", null, "This may take a while!", -1));
const $fad4cc6e2fa52e3d$var$_hoisted_7 = [
    $fad4cc6e2fa52e3d$var$_hoisted_5,
    $fad4cc6e2fa52e3d$var$_hoisted_6
];
const $fad4cc6e2fa52e3d$var$_hoisted_8 = {
    key: 1
};
const $fad4cc6e2fa52e3d$var$_hoisted_9 = /*#__PURE__*/ $fad4cc6e2fa52e3d$var$_withScopeId(()=>/*#__PURE__*/ (0, $cUHxd.createElementVNode)("div", {
        id: "charts"
    }, null, -1));
const $fad4cc6e2fa52e3d$var$_hoisted_10 = {
    key: 0,
    style: {
        "margin-top": "50px",
        "border-top": "1px solid #ccc"
    }
};
function $fad4cc6e2fa52e3d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)((0, $cUHxd.Fragment), null, [
        (0, $cUHxd.createVNode)($setup["DataSelector"], {
            start: $setup.selector.start,
            end: $setup.selector.end,
            kind: $setup.selector.kind,
            stat: $setup.selector.stat,
            info: $setup.info,
            onChange: $setup.updateSelection
        }, null, 8, [
            "start",
            "end",
            "kind",
            "stat",
            "info"
        ]),
        $fad4cc6e2fa52e3d$var$_hoisted_1,
        $fad4cc6e2fa52e3d$var$_hoisted_2,
        (0, $cUHxd.createElementVNode)("div", $fad4cc6e2fa52e3d$var$_hoisted_3, [
            $setup.loading ? ((0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)("div", $fad4cc6e2fa52e3d$var$_hoisted_4, $fad4cc6e2fa52e3d$var$_hoisted_7)) : ((0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)("div", $fad4cc6e2fa52e3d$var$_hoisted_8, [
                $fad4cc6e2fa52e3d$var$_hoisted_9,
                !$setup.hasSpecificSelection($setup.selector) ? ((0, $cUHxd.openBlock)(), (0, $cUHxd.createElementBlock)("div", $fad4cc6e2fa52e3d$var$_hoisted_10)) : (0, $cUHxd.createCommentVNode)("", true),
                (0, $cUHxd.createVNode)($setup["AsOf"], {
                    info: $setup.info
                }, null, 8, [
                    "info"
                ])
            ]))
        ], 512)
    ], 64);
}

});

parcelRegister("9eqG7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b8a1da09c3e4d45$export$2e2bcd8739ae039; });
let $6b8a1da09c3e4d45$var$NOOP = ()=>{};
var $6b8a1da09c3e4d45$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lsnHt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ee98d748ea20c8$export$2e2bcd8739ae039; });
let $f9ee98d748ea20c8$var$script;



let $f9ee98d748ea20c8$var$initialize = ()=>{
    $f9ee98d748ea20c8$var$script = (parcelRequire("gPSF4"));
    if ($f9ee98d748ea20c8$var$script.__esModule) $f9ee98d748ea20c8$var$script = $f9ee98d748ea20c8$var$script.default;
    $f9ee98d748ea20c8$var$script.render = (parcelRequire("du0zS")).render;
    (parcelRequire("lFtwI")).default($f9ee98d748ea20c8$var$script);
    $f9ee98d748ea20c8$var$script.__scopeId = "data-v-5e0358";
    $f9ee98d748ea20c8$var$script.__file = "with-suspense.vue";
};
$f9ee98d748ea20c8$var$initialize();
var $f9ee98d748ea20c8$export$2e2bcd8739ae039 = $f9ee98d748ea20c8$var$script;

});
parcelRegister("gPSF4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $322f35dedb4cd265$export$2e2bcd8739ae039; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
var $322f35dedb4cd265$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cUHxd.defineComponent)({
    __name: "with-suspense",
    props: {
        component: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const component = props.component;
        const __returned__ = {
            props: props,
            component: component,
            Suspense: $cUHxd.Suspense
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("du0zS", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9d0e8664bd5be840$export$b3890eb0ae9dca99; });
parcelRequire("VxqKT");
var $cUHxd = parcelRequire("cUHxd");
function $9d0e8664bd5be840$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cUHxd.openBlock)(), (0, $cUHxd.createBlock)((0, $cUHxd.Suspense), null, {
        default: (0, $cUHxd.withCtx)(()=>[
                ((0, $cUHxd.openBlock)(), (0, $cUHxd.createBlock)((0, $cUHxd.resolveDynamicComponent)($setup.component)))
            ]),
        _: 1
    });
}

});

parcelRegister("lFtwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc6454b397210216$export$2e2bcd8739ae039; });
let $fc6454b397210216$var$NOOP = ()=>{};
var $fc6454b397210216$export$2e2bcd8739ae039 = (script)=>{};

});


let $e1755d4fc1365b0c$var$script;




let $e1755d4fc1365b0c$var$initialize = ()=>{
    $e1755d4fc1365b0c$var$script = (parcelRequire("asv94"));
    if ($e1755d4fc1365b0c$var$script.__esModule) $e1755d4fc1365b0c$var$script = $e1755d4fc1365b0c$var$script.default;
    $e1755d4fc1365b0c$var$script.render = (parcelRequire("lxasY")).render;
    $e1755d4fc1365b0c$var$script.__cssModules = {};
    (parcelRequire("9eqG7")).default($e1755d4fc1365b0c$var$script);
    $e1755d4fc1365b0c$var$script.__scopeId = "data-v-498bca";
    $e1755d4fc1365b0c$var$script.__file = "page.vue";
};
$e1755d4fc1365b0c$var$initialize();
var $e1755d4fc1365b0c$export$2e2bcd8739ae039 = $e1755d4fc1365b0c$var$script;


parcelRequire("VxqKT");
var $3gdWT = parcelRequire("3gdWT");

var $lsnHt = parcelRequire("lsnHt");
const $970c8f55d1b3dac8$var$app = (0, $3gdWT.createApp)((0, $lsnHt.default), {
    component: (0, $e1755d4fc1365b0c$export$2e2bcd8739ae039)
});
$970c8f55d1b3dac8$var$app.mount("#app");

})();
//# sourceMappingURL=graphs.js.map
